import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from 'state/graphql/hooks/use-sanity-query';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  DateTime: any,
  Date: any,
  JSON: any,
}

export interface IAccordionEntry {
  readonly __typename?: 'AccordionEntry',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly collapsedContent: Maybe<ILocaleString>,
  readonly expandedContent: Maybe<ILocaleString>,
}

export interface IAccordionWidget {
  readonly __typename?: 'AccordionWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly accordionContent: Maybe<ReadonlyArray<Maybe<IAccordionEntry>>>,
  readonly accordionTitle: Maybe<ILocaleString>,
}

export type IAccordionWidgetOrAnchorLinksWidgetOrAnchorWidgetOrCallToActionWidgetOrDoubleImageWidgetOrHeaderWidgetOrImageWidgetOrLocaleBlockTextWidgetOrMultiWidgetOrNutritionExplorerWidgetOrNutritionInfoWidgetOrPreviewWidgetOrQuoteWidgetOrVideoWidgetOrYoutubeWidget = IAccordionWidget | IAnchorLinksWidget | IAnchorWidget | ICallToActionWidget | IDoubleImageWidget | IHeaderWidget | IImageWidget | ILocaleBlockTextWidget | IMultiWidget | INutritionExplorerWidget | INutritionInfoWidget | IPreviewWidget | IQuoteWidget | IVideoWidget | IYoutubeWidget;

export interface IActionButton {
  readonly __typename?: 'ActionButton',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly buttonPath: Maybe<ILocaleString>,
  readonly buttonText: Maybe<ILocaleString>,
}

export interface IAdditionalItemInformation {
  readonly __typename?: 'AdditionalItemInformation',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly additives: Maybe<ILocaleString>,
  readonly ingredients: Maybe<ILocaleString>,
  readonly producerDetails: Maybe<ILocaleString>,
}

export interface IAddOnSection  extends IDocument {
  readonly __typename?: 'AddOnSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly maxAmount: Maybe<Scalars['Float']>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IAddOnSectionOption>>>,
}

export interface IAddOnSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly maxAmount?: Maybe<Scalars['Float']>,
  readonly maxAmount_gt?: Maybe<Scalars['Float']>,
  readonly maxAmount_gte?: Maybe<Scalars['Float']>,
  readonly maxAmount_lt?: Maybe<Scalars['Float']>,
  readonly maxAmount_lte?: Maybe<Scalars['Float']>,
  readonly maxAmount_not?: Maybe<Scalars['Float']>,
}

export interface IAddOnSectionOption {
  readonly __typename?: 'AddOnSectionOption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly maxAmount: Maybe<Scalars['Float']>,
  readonly option: Maybe<IItem>,
}

export interface IAddress {
  readonly __typename?: 'Address',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly address1: Maybe<Scalars['String']>,
  readonly address2: Maybe<Scalars['String']>,
  readonly city: Maybe<Scalars['String']>,
  readonly country: Maybe<Scalars['String']>,
  readonly postalCode: Maybe<Scalars['String']>,
  readonly stateProvince: Maybe<Scalars['String']>,
  readonly stateProvinceShort: Maybe<Scalars['String']>,
}

export interface IAdminToolReleaseNotes  extends IDocument {
  readonly __typename?: 'AdminToolReleaseNotes',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly releaseDate: Maybe<Scalars['Date']>,
  readonly releaseNotesRaw: Maybe<Scalars['JSON']>,
  readonly releaseNotesTitle: Maybe<Scalars['String']>,
  readonly syncReleaseNotes: Maybe<Scalars['String']>,
}

export interface IAdminToolReleaseNotesFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly releaseDate?: Maybe<Scalars['Date']>,
  readonly releaseDate_gt?: Maybe<Scalars['Date']>,
  readonly releaseDate_gte?: Maybe<Scalars['Date']>,
  readonly releaseDate_lt?: Maybe<Scalars['Date']>,
  readonly releaseDate_lte?: Maybe<Scalars['Date']>,
  readonly releaseDate_not?: Maybe<Scalars['Date']>,
  readonly releaseNotesTitle?: Maybe<Scalars['String']>,
  readonly releaseNotesTitle_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly releaseNotesTitle_matches?: Maybe<Scalars['String']>,
  readonly releaseNotesTitle_not?: Maybe<Scalars['String']>,
  readonly releaseNotesTitle_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly syncReleaseNotes?: Maybe<Scalars['String']>,
  readonly syncReleaseNotes_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly syncReleaseNotes_matches?: Maybe<Scalars['String']>,
  readonly syncReleaseNotes_not?: Maybe<Scalars['String']>,
  readonly syncReleaseNotes_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IAdyenConfig {
  readonly __typename?: 'AdyenConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly clientKey: Maybe<Scalars['String']>,
  readonly environment: Maybe<Scalars['String']>,
  readonly urlPrefix: Maybe<Scalars['String']>,
}

export interface IAlert  extends IDocument {
  readonly __typename?: 'Alert',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly body: Maybe<ILocaleString>,
  readonly heading: Maybe<ILocaleString>,
  readonly learnMoreText: Maybe<ILocaleString>,
  readonly learnMoreUrl: Maybe<ILocaleString>,
}

export interface IAlertFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export type IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrGoogleAdSlotOrHeroOrLockedOffersOrMainHeroOrMarketingCardGroupOrMarketingTileCarouselOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrRewardsSectionOrRollUpTheRimSectionOrScanForRewardsOrTrending = IAlert | IAppDownload | IBrazeContentCards | IFanFavorites | IGoogleAdSlot | IHero | ILockedOffers | IMainHero | IMarketingCardGroup | IMarketingTileCarousel | IMarketingTileGroup | IOffersSection | IOurServices | IRecentItems | IRewardsSection | IRollUpTheRimSection | IScanForRewards | ITrending;

export type IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrLockedOffersOrMainHeroOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrTrending = IAlert | IAppDownload | IBrazeContentCards | IFanFavorites | ILockedOffers | IMainHero | IMarketingTileGroup | IOffersSection | IOurServices | IRecentItems | ITrending;

export interface IAllowRedemptionWithoutLogin {
  readonly __typename?: 'AllowRedemptionWithoutLogin',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly allowRedemptionWithoutLogin: Maybe<Scalars['String']>,
}

export type IAllowRedemptionWithoutLoginOrAndOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrOrOrOrderHistoryOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions = IAllowRedemptionWithoutLogin | IAnd | IBetweenDates | IBetweenTimes | ICartContainsPlu | ICartProperty | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | ILimit | IOr | IOrderHistory | IPaymentCardType | IPurchase | IRequiresAssignment | IRestaurantGroupRestrictions;

export type IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIsStackableOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions = IAllowRedemptionWithoutLogin | IBetweenDates | IBetweenTimes | ICartContainsPlu | ICartProperty | ICartRequirement | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | IIsStackable | ILimit | IPaymentCardType | IPurchase | IRequiresAssignment | IRestaurantGroupRestrictions;

export type IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions = IAllowRedemptionWithoutLogin | IBetweenDates | IBetweenTimes | ICartContainsPlu | ICartProperty | ICartRequirement | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | ILimit | IPaymentCardType | IPurchase | IRequiresAssignment | IRestaurantGroupRestrictions;

export interface IAnchorLinksWidget {
  readonly __typename?: 'AnchorLinksWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface IAnchorWidget {
  readonly __typename?: 'AnchorWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly anchorName: Maybe<ILocaleString>,
}

export interface IAnd {
  readonly __typename?: 'And',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIsStackableOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>,
}

export type IAndOrBetweenTimesOrCartContainsPluOrCartPropertyOrDayOfWeekBandOrOrOrPaymentCardTypeOrPurchase = IAnd | IBetweenTimes | ICartContainsPlu | ICartProperty | IDayOfWeekBand | IOr | IPaymentCardType | IPurchase;

export interface IApiKeysConfig {
  readonly __typename?: 'ApiKeysConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly amplitude: Maybe<Scalars['String']>,
  readonly branch: Maybe<Scalars['String']>,
  readonly braze: Maybe<Scalars['String']>,
  readonly bringg: Maybe<Scalars['String']>,
  readonly googleAnalytics: Maybe<Scalars['String']>,
  readonly googleMaps: Maybe<Scalars['String']>,
  readonly launchDarkly: Maybe<Scalars['String']>,
  readonly launchDarklyMobileKey: Maybe<Scalars['String']>,
  readonly logRocket: Maybe<Scalars['String']>,
  readonly mParticle: Maybe<Scalars['String']>,
  readonly radar: Maybe<Scalars['String']>,
}

export interface IAppData  extends IDocument {
  readonly __typename?: 'AppData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly aboutMenuEntries: Maybe<INavigationSection>,
  readonly appDownloadSection: Maybe<IAppDownloadSection>,
  readonly appHeaderText: Maybe<Scalars['String']>,
  readonly appImage: Maybe<IImage>,
  readonly appImageLocale: Maybe<ILocaleImage>,
  readonly appVersion: Maybe<IAppVersion>,
  readonly appleWalletImage: Maybe<ILocaleImage>,
  readonly calorieDisclaimer: Maybe<ILocaleBlockContent>,
  readonly cateringMenu: Maybe<IMenu>,
  readonly cateringSection: Maybe<ISection>,
  readonly communicationPreferencesDisclaimer: Maybe<ILocaleString>,
  readonly communicationPreferencesDisclaimerBlock: Maybe<ILocaleBlockContent>,
  readonly contentCardsHeader: Maybe<ILocaleString>,
  readonly contentCardsSubheader: Maybe<ILocaleString>,
  readonly copyrightAndTrademarkDisclaimer: Maybe<ILocaleString>,
  readonly countryDisclaimer: Maybe<ILocaleString>,
  readonly dayParts: Maybe<ReadonlyArray<Maybe<IDayPart>>>,
  readonly defaultHeroImage: Maybe<IImage>,
  readonly defaultHeroImageLocale: Maybe<ILocaleImage>,
  readonly defaultMenu: Maybe<IMenu>,
  readonly emailAndPushOptInSettings: Maybe<ReadonlyArray<Maybe<IOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum>>>,
  readonly fanFavoriteItems: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>,
  readonly favoriteSection: Maybe<IFavoriteSection>,
  readonly geolocationModalImage: Maybe<IImage>,
  readonly geolocationModalImageUseLocale: Maybe<ILocaleImage>,
  readonly giftCardImage: Maybe<ILocaleImage>,
  readonly giftCardTextImage: Maybe<ILocaleImage>,
  readonly googlePayImage: Maybe<ILocaleImage>,
  readonly headerText: Maybe<Scalars['String']>,
  readonly heroAction: Maybe<ILinkAction>,
  readonly heroActionAuthenticated: Maybe<ILinkAction>,
  readonly heroActionLeft: Maybe<ILinkAction>,
  readonly heroActionLeftIcon: Maybe<ILocaleImage>,
  readonly heroActionRight: Maybe<ILinkAction>,
  readonly heroActionRightIcon: Maybe<ILocaleImage>,
  readonly heroMaskCards: Maybe<ReadonlyArray<Maybe<ISimpleCard>>>,
  readonly heroSubText: Maybe<ILocaleString>,
  readonly heroSubTextAuthenticated: Maybe<ILocaleString>,
  readonly heroSuperText: Maybe<ILocaleString>,
  readonly heroSuperTextAuthenticated: Maybe<ILocaleString>,
  readonly heroText: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated: Maybe<Scalars['String']>,
  readonly heroTextAuthenticatedLocale: Maybe<ILocaleString>,
  readonly heroTextColor: Maybe<Scalars['String']>,
  readonly heroTextLocale: Maybe<ILocaleString>,
  readonly homeGraphic: Maybe<IHomeGraphic>,
  readonly imagesDisclaimer: Maybe<ILocaleString>,
  readonly kioskAppData: Maybe<IKioskAppData>,
  readonly kioskAttractLoopImage: Maybe<IImage>,
  readonly kioskAttractLoopImageLocale: Maybe<ILocaleImage>,
  readonly loadingGraphics: Maybe<ILoadingGraphics>,
  readonly loyaltyCardImage: Maybe<ILocaleImage>,
  readonly loyaltyHeaderBackgroundImage: Maybe<IImage>,
  readonly loyaltyHeroAction: Maybe<ILinkAction>,
  readonly loyaltyHeroSubText: Maybe<ILocaleString>,
  readonly loyaltyHeroSuperText: Maybe<ILocaleString>,
  readonly loyaltyInfoImage: Maybe<ILocaleImage>,
  readonly mainHeroImage: Maybe<IImage>,
  readonly mainHeroImageAuthenticated: Maybe<IImage>,
  readonly mainHeroImageAuthenticatedLocale: Maybe<ILocaleImage>,
  readonly mainHeroImageLocale: Maybe<ILocaleImage>,
  readonly mainHeroMobileImage: Maybe<IImage>,
  readonly mainHeroMobileImageLocale: Maybe<ILocaleImage>,
  readonly menuHeroImage: Maybe<IImage>,
  readonly menuHeroImageLocale: Maybe<ILocaleImage>,
  readonly menuHeroText: Maybe<Scalars['String']>,
  readonly menuHeroTextLocale: Maybe<ILocaleString>,
  readonly offersDisclaimer: Maybe<ILocaleString>,
  readonly ourAppHeroImage: Maybe<IImage>,
  readonly ourAppHeroImageLocale: Maybe<ILocaleImage>,
  readonly ourServicesHeroImage: Maybe<IImage>,
  readonly ourServicesHeroImageLocale: Maybe<ILocaleImage>,
  readonly phoneNumberDisclaimer: Maybe<ILocaleString>,
  readonly priceDisclaimer: Maybe<ILocaleString>,
  readonly promotions: Maybe<ReadonlyArray<Maybe<IComboOrExternalLinkOrItemOrOfferOrPickerOrSection>>>,
  readonly recentOrderHeroText: Maybe<Scalars['String']>,
  readonly recentOrderHeroTextLocale: Maybe<ILocaleString>,
  readonly reservedRightsDisclaimer: Maybe<ILocaleString>,
  readonly rewardsMainImage: Maybe<IImage>,
  readonly rewardsMainImageLocale: Maybe<ILocaleImage>,
  readonly servicesHeaderText: Maybe<Scalars['String']>,
  readonly servicesHeaderTextLocale: Maybe<ILocaleString>,
  readonly servicesHeroText: Maybe<Scalars['String']>,
  readonly servicesHeroTextLocale: Maybe<ILocaleString>,
  readonly siteAlert: Maybe<IAlert>,
  readonly sodiumDisclaimer: Maybe<ILocaleBlockContent>,
  readonly sortedOffers: Maybe<ReadonlyArray<Maybe<IOffer>>>,
  readonly storeLocatorContent: Maybe<IStoreLocatorContent>,
  readonly superUpsellDisclaimer: Maybe<ILocaleBlockContent>,
  readonly upsellItemAtCheckout: Maybe<IItem>,
  readonly upsellItemsAtCheckout: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutCatering: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutDelivery: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutRestaurant: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly useSideBySideHeroButtons: Maybe<Scalars['Boolean']>,
}

export interface IAppDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly appHeaderText?: Maybe<Scalars['String']>,
  readonly appHeaderText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly appHeaderText_matches?: Maybe<Scalars['String']>,
  readonly appHeaderText_not?: Maybe<Scalars['String']>,
  readonly appHeaderText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly appVersion?: Maybe<Scalars['ID']>,
  readonly cateringMenu?: Maybe<Scalars['ID']>,
  readonly cateringSection?: Maybe<Scalars['ID']>,
  readonly defaultMenu?: Maybe<Scalars['ID']>,
  readonly headerText?: Maybe<Scalars['String']>,
  readonly headerText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly headerText_matches?: Maybe<Scalars['String']>,
  readonly headerText_not?: Maybe<Scalars['String']>,
  readonly headerText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroText?: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated?: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroTextAuthenticated_matches?: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated_not?: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroTextColor?: Maybe<Scalars['String']>,
  readonly heroTextColor_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroTextColor_matches?: Maybe<Scalars['String']>,
  readonly heroTextColor_not?: Maybe<Scalars['String']>,
  readonly heroTextColor_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroText_matches?: Maybe<Scalars['String']>,
  readonly heroText_not?: Maybe<Scalars['String']>,
  readonly heroText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly kioskAppData?: Maybe<Scalars['ID']>,
  readonly menuHeroText?: Maybe<Scalars['String']>,
  readonly menuHeroText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly menuHeroText_matches?: Maybe<Scalars['String']>,
  readonly menuHeroText_not?: Maybe<Scalars['String']>,
  readonly menuHeroText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly recentOrderHeroText?: Maybe<Scalars['String']>,
  readonly recentOrderHeroText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly recentOrderHeroText_matches?: Maybe<Scalars['String']>,
  readonly recentOrderHeroText_not?: Maybe<Scalars['String']>,
  readonly recentOrderHeroText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly servicesHeaderText?: Maybe<Scalars['String']>,
  readonly servicesHeaderText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly servicesHeaderText_matches?: Maybe<Scalars['String']>,
  readonly servicesHeaderText_not?: Maybe<Scalars['String']>,
  readonly servicesHeaderText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly servicesHeroText?: Maybe<Scalars['String']>,
  readonly servicesHeroText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly servicesHeroText_matches?: Maybe<Scalars['String']>,
  readonly servicesHeroText_not?: Maybe<Scalars['String']>,
  readonly servicesHeroText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly siteAlert?: Maybe<Scalars['ID']>,
  readonly upsellItemAtCheckout?: Maybe<Scalars['ID']>,
  readonly useSideBySideHeroButtons?: Maybe<Scalars['Boolean']>,
  readonly useSideBySideHeroButtons_not?: Maybe<Scalars['Boolean']>,
}

export interface IAppDownload  extends IDocument {
  readonly __typename?: 'AppDownload',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly details: Maybe<IAppDownloadSection>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IAppDownloadFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IAppDownloadSection {
  readonly __typename?: 'AppDownloadSection',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly androidDownloadImage: Maybe<ILocaleImage>,
  readonly androidDownloadLink: Maybe<Scalars['String']>,
  readonly backgroundImage: Maybe<IImage>,
  readonly copy: Maybe<ILocaleString>,
  readonly header: Maybe<ILocaleString>,
  readonly headerSuperText: Maybe<ILocaleString>,
  readonly iOSDownloadImage: Maybe<ILocaleImage>,
  readonly iOSDownloadLink: Maybe<Scalars['String']>,
  readonly primaryImage: Maybe<ILocaleImage>,
  readonly submitButtonText: Maybe<ILocaleString>,
  readonly textDecorationLeft: Maybe<IImage>,
  readonly textDecorationRight: Maybe<IImage>,
}

export interface IAppleConfig {
  readonly __typename?: 'AppleConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly merchantId: Maybe<Scalars['String']>,
  readonly paymentsNetworks: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly prepaidMerchantId: Maybe<Scalars['String']>,
}

export interface IAppVersion  extends IDocument {
  readonly __typename?: 'AppVersion',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly kioskVersionName: Maybe<Scalars['String']>,
  readonly nativeVersionName: Maybe<Scalars['String']>,
  readonly nativeVersionNumber: Maybe<Scalars['Float']>,
}

export interface IAppVersionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly kioskVersionName?: Maybe<Scalars['String']>,
  readonly kioskVersionName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly kioskVersionName_matches?: Maybe<Scalars['String']>,
  readonly kioskVersionName_not?: Maybe<Scalars['String']>,
  readonly kioskVersionName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly nativeVersionName?: Maybe<Scalars['String']>,
  readonly nativeVersionName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly nativeVersionName_matches?: Maybe<Scalars['String']>,
  readonly nativeVersionName_not?: Maybe<Scalars['String']>,
  readonly nativeVersionName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly nativeVersionNumber?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_gt?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_gte?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_lt?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_lte?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_not?: Maybe<Scalars['Float']>,
}

export interface IAwsConfig {
  readonly __typename?: 'AwsConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly gqlApiUrl: Maybe<Scalars['String']>,
  readonly gqlGatewayApiUrl: Maybe<Scalars['String']>,
  readonly region: Maybe<Scalars['String']>,
  readonly userPoolClientId: Maybe<Scalars['String']>,
  readonly userPoolId: Maybe<Scalars['String']>,
}

export interface IBarcodes  extends IDocument {
  readonly __typename?: 'Barcodes',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly endDate: Maybe<Scalars['Date']>,
  readonly name: Maybe<Scalars['String']>,
  readonly offers: Maybe<ReadonlyArray<Maybe<IOffer>>>,
  readonly prefix: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Float']>,
  readonly startDate: Maybe<Scalars['Date']>,
}

export interface IBarcodesFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly endDate?: Maybe<Scalars['Date']>,
  readonly endDate_gt?: Maybe<Scalars['Date']>,
  readonly endDate_gte?: Maybe<Scalars['Date']>,
  readonly endDate_lt?: Maybe<Scalars['Date']>,
  readonly endDate_lte?: Maybe<Scalars['Date']>,
  readonly endDate_not?: Maybe<Scalars['Date']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly prefix?: Maybe<Scalars['String']>,
  readonly prefix_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly prefix_matches?: Maybe<Scalars['String']>,
  readonly prefix_not?: Maybe<Scalars['String']>,
  readonly prefix_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly quantity?: Maybe<Scalars['Float']>,
  readonly quantity_gt?: Maybe<Scalars['Float']>,
  readonly quantity_gte?: Maybe<Scalars['Float']>,
  readonly quantity_lt?: Maybe<Scalars['Float']>,
  readonly quantity_lte?: Maybe<Scalars['Float']>,
  readonly quantity_not?: Maybe<Scalars['Float']>,
  readonly startDate?: Maybe<Scalars['Date']>,
  readonly startDate_gt?: Maybe<Scalars['Date']>,
  readonly startDate_gte?: Maybe<Scalars['Date']>,
  readonly startDate_lt?: Maybe<Scalars['Date']>,
  readonly startDate_lte?: Maybe<Scalars['Date']>,
  readonly startDate_not?: Maybe<Scalars['Date']>,
}

export interface IBetweenDates {
  readonly __typename?: 'BetweenDates',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly endDate: Maybe<Scalars['DateTime']>,
  readonly startDate: Maybe<Scalars['DateTime']>,
}

export type IBetweenDatesOrBirthdayMultiplierOrCartLimitOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIncentiveRequirementOrLimitOrLoyaltyBetweenTimesOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated = IBetweenDates | IBirthdayMultiplier | ICartLimit | ICartRequirement | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | IIncentiveRequirement | ILimit | ILoyaltyBetweenTimes | IPaymentMethod | IRestaurantGroupRestrictions | IServiceModeRestrictions | ISubtotalSpend | ITransactionCount | IUserCreated;

export type IBetweenDatesOrCartLimitOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIsStackableOrLimitOrLoyaltyBetweenTimesOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated = IBetweenDates | ICartLimit | ICartRequirement | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | IIsStackable | ILimit | ILoyaltyBetweenTimes | IPaymentMethod | IRestaurantGroupRestrictions | IServiceModeRestrictions | ISubtotalSpend | ITransactionCount | IUserCreated;

export type IBetweenDatesOrCartLimitOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrLoyaltyBetweenTimesOrLoyaltyPointsOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated = IBetweenDates | ICartLimit | ICartRequirement | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | ILimit | ILoyaltyBetweenTimes | ILoyaltyPoints | IPaymentMethod | IRestaurantGroupRestrictions | IServiceModeRestrictions | ISubtotalSpend | ITransactionCount | IUserCreated;

export type IBetweenDatesOrCartRequirementOrDayOfWeekBandOrIncentiveRequirementOrLoyaltyBetweenTimesOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpend = IBetweenDates | ICartRequirement | IDayOfWeekBand | IIncentiveRequirement | ILoyaltyBetweenTimes | IPaymentMethod | IRestaurantGroupRestrictions | IServiceModeRestrictions | ISubtotalSpend;

export type IBetweenDatesOrLimitOrUserCreated = IBetweenDates | ILimit | IUserCreated;

export interface IBetweenTimes {
  readonly __typename?: 'BetweenTimes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly endTime: Maybe<Scalars['String']>,
  readonly startTime: Maybe<Scalars['String']>,
}

export interface IBirthdayMultiplier {
  readonly __typename?: 'BirthdayMultiplier',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly duration: Maybe<Scalars['String']>,
}

export interface IBlacklistCharacterReplaceRule {
  readonly __typename?: 'BlacklistCharacterReplaceRule',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly filter: Maybe<Scalars['String']>,
  readonly replace: Maybe<Scalars['String']>,
}

export interface IBlock {
  readonly __typename?: 'Block',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly children: Maybe<ReadonlyArray<Maybe<ISpan>>>,
  readonly list: Maybe<Scalars['String']>,
  readonly style: Maybe<Scalars['String']>,
}

export interface IBlockContentImage {
  readonly __typename?: 'BlockContentImage',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly asset: Maybe<ISanityImageAsset>,
  readonly caption: Maybe<Scalars['String']>,
  readonly crop: Maybe<ISanityImageCrop>,
  readonly hotspot: Maybe<ISanityImageHotspot>,
}

export type IBlockOrBlockContentImage = IBlock | IBlockContentImage;

export type IBlockOrBlockContentImageOrPlaceholderField = IBlock | IBlockContentImage | IPlaceholderField;

export interface IBrand {
  readonly __typename?: 'Brand',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly logo: Maybe<IImage>,
}

export interface IBrazeContentCards  extends IDocument {
  readonly __typename?: 'BrazeContentCards',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly sectionSubheader: Maybe<ILocaleString>,
  readonly sectionheader: Maybe<ILocaleString>,
}

export interface IBrazeContentCardsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IBringgConfig {
  readonly __typename?: 'BringgConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly region: Maybe<Scalars['String']>,
}

export interface IBuildConfiguration  extends IDocument {
  readonly __typename?: 'BuildConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly ionic: Maybe<IIonicConfig>,
}

export interface IBuildConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ICallToAction {
  readonly __typename?: 'CallToAction',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly buttonLink: Maybe<Scalars['String']>,
  readonly buttonText: Maybe<ILocaleString>,
  readonly heading: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly link: Maybe<ILocaleUrl>,
  readonly subheading: Maybe<ILocaleString>,
}

export interface ICallToActionWidget {
  readonly __typename?: 'CallToActionWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly callToActionContent: Maybe<ReadonlyArray<Maybe<ICallToAction>>>,
}

export interface ICartContainsPlu {
  readonly __typename?: 'CartContainsPlu',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly hdxPLUs: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly qstPLUs: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly quantity: Maybe<Scalars['Float']>,
  readonly sicomPLUs: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface ICartLimit {
  readonly __typename?: 'CartLimit',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly maximumRedemptions: Maybe<Scalars['Float']>,
}

export interface ICartProperty {
  readonly __typename?: 'CartProperty',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly key: Maybe<Scalars['String']>,
  readonly negated: Maybe<Scalars['Boolean']>,
  readonly operator: Maybe<Scalars['String']>,
  readonly value: Maybe<Scalars['String']>,
}

export interface ICartRequirement {
  readonly __typename?: 'CartRequirement',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly cartRequirement: Maybe<ReadonlyArray<Maybe<ICartRequirementEntry>>>,
}

export interface ICartRequirementEntry {
  readonly __typename?: 'CartRequirementEntry',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly item: Maybe<IComboOrItemOrPickerOrProductCategory>,
  readonly quantity: Maybe<Scalars['Float']>,
}

export interface ICategory  extends IDocument {
  readonly __typename?: 'Category',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleBlockContent>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<ITier>>>,
}

export interface ICategoryFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ICateringPageConfiguration  extends IDocument {
  readonly __typename?: 'CateringPageConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly components: Maybe<ReadonlyArray<Maybe<IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrLockedOffersOrMainHeroOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrTrending>>>,
}

export interface ICateringPageConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IChannelExclusions {
  readonly __typename?: 'ChannelExclusions',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly delivery: Maybe<Scalars['Boolean']>,
  readonly googleFoodOrdering: Maybe<Scalars['Boolean']>,
  readonly kiosk: Maybe<Scalars['Boolean']>,
  readonly mobile: Maybe<Scalars['Boolean']>,
  readonly pickup: Maybe<Scalars['Boolean']>,
  readonly web: Maybe<Scalars['Boolean']>,
}

export interface IClaimOnHistory {
  readonly __typename?: 'ClaimOnHistory',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly linkText: Maybe<ILocaleBlockContent>,
}

export interface IClaimPointsFailedSubmissionContent {
  readonly __typename?: 'ClaimPointsFailedSubmissionContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly buttonTitle: Maybe<ILocaleString>,
  readonly buttonUrl: Maybe<ILocaleUrl>,
  readonly failureTextBlock: Maybe<ILocaleBlockContent>,
  readonly screenTitle: Maybe<ILocaleString>,
}

export interface IClaimPointsScreenContent {
  readonly __typename?: 'ClaimPointsScreenContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bottomButtonTitle: Maybe<ILocaleString>,
  readonly bottomButtonUrl: Maybe<ILocaleUrl>,
  readonly instructionsTextBlock: Maybe<ILocaleBlockContent>,
  readonly rewardsIcon: Maybe<ILocaleImage>,
  readonly screenTitle: Maybe<ILocaleString>,
  readonly secondImage: Maybe<ILocaleImage>,
  readonly topButtonTitle: Maybe<ILocaleString>,
  readonly topButtonUrl: Maybe<ILocaleUrl>,
}

export interface IClaimPointsSurveyScreenContent {
  readonly __typename?: 'ClaimPointsSurveyScreenContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bottomButtonTitle: Maybe<ILocaleString>,
  readonly bottomButtonUrl: Maybe<ILocaleUrl>,
  readonly expirationDateInstructionsTextBlock: Maybe<ILocaleBlockContent>,
  readonly expirationTimeReceipts: Maybe<Scalars['Float']>,
  readonly inputBoxExpirationDatePlaceholder: Maybe<ILocaleString>,
  readonly instructionsTextBlock: Maybe<ILocaleBlockContent>,
  readonly rewardsIcon: Maybe<ILocaleImage>,
  readonly screenTitle: Maybe<ILocaleString>,
  readonly secondImage: Maybe<ILocaleImage>,
  readonly topButtonTitle: Maybe<ILocaleString>,
  readonly topButtonUrl: Maybe<ILocaleUrl>,
}

export interface IClaimPointsUi  extends IDocument {
  readonly __typename?: 'ClaimPointsUI',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly claimOnHistory: Maybe<IClaimOnHistory>,
  readonly claimPointsAlreadyClaimedContent: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimPointsDailyAmountExceededContent: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimPointsDuplicateTransactionId: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimPointsExpiredContent: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimPointsHomeScreenContent: Maybe<IClaimPointsScreenContent>,
  readonly claimPointsInvalidCodeContent: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimPointsInvalidRestaurantContent: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimPointsPendingContent: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimPointsSuccessfulSubmissionScreenContent: Maybe<IClaimPointsScreenContent>,
  readonly claimPointsSurveyContent: Maybe<IClaimPointsSurveyScreenContent>,
  readonly claimPointsSurveyScreenContent: Maybe<IClaimPointsScreenContent>,
  readonly claimPointsTooManyRequests: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimPointsTransactionNotFoundContent: Maybe<IClaimPointsFailedSubmissionContent>,
  readonly claimQrCode: Maybe<IClaimQrCode>,
}

export interface IClaimPointsUiFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IClaimQrCode {
  readonly __typename?: 'ClaimQrCode',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleBlockContent>,
  readonly link: Maybe<ILinkWidget>,
  readonly title: Maybe<ILocaleString>,
}

export interface ICode {
  readonly __typename?: 'Code',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly code: Maybe<Scalars['String']>,
  readonly filename: Maybe<Scalars['String']>,
  readonly highlightedLines: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>,
  readonly language: Maybe<Scalars['String']>,
}

export interface IColor {
  readonly __typename?: 'Color',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly alpha: Maybe<Scalars['Float']>,
  readonly hex: Maybe<Scalars['String']>,
  readonly hsl: Maybe<IHslaColor>,
  readonly hsv: Maybe<IHsvaColor>,
  readonly rgb: Maybe<IRgbaColor>,
}

export interface IColumn {
  readonly __typename?: 'Column',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly options: Maybe<ReadonlyArray<Maybe<ICopyrightAndLanguageSelectorOrHighlightedVerticalLinkListWidgetOrHorizontalLinkListWidgetOrImageWidgetOrSocialIconsWithHeaderWidgetOrTextWidgetOrVerticalLinkListWidgetOrVerticalLinkListWithHeaderWidgetOrWordmarkAndSocialIcons>>>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface ICombo  extends IDocument {
  readonly __typename?: 'Combo',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly activationDate: Maybe<Scalars['Date']>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly deactivationDate: Maybe<Scalars['Date']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly forceModifiersToBottom: Maybe<Scalars['Boolean']>,
  readonly hideMainItemDescription: Maybe<Scalars['Boolean']>,
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly internalName: Maybe<Scalars['String']>,
  readonly labelAsPerPerson: Maybe<Scalars['Boolean']>,
  readonly mainItem: Maybe<IItem>,
  readonly menuObjectSettings: Maybe<IMenuObjectSettings>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IComboSlot>>>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
  readonly promotion: Maybe<ISystemwidePromotion>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IComboFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly activationDate?: Maybe<Scalars['Date']>,
  readonly activationDate_gt?: Maybe<Scalars['Date']>,
  readonly activationDate_gte?: Maybe<Scalars['Date']>,
  readonly activationDate_lt?: Maybe<Scalars['Date']>,
  readonly activationDate_lte?: Maybe<Scalars['Date']>,
  readonly activationDate_not?: Maybe<Scalars['Date']>,
  readonly deactivationDate?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_not?: Maybe<Scalars['Date']>,
  readonly forceModifiersToBottom?: Maybe<Scalars['Boolean']>,
  readonly forceModifiersToBottom_not?: Maybe<Scalars['Boolean']>,
  readonly hideMainItemDescription?: Maybe<Scalars['Boolean']>,
  readonly hideMainItemDescription_not?: Maybe<Scalars['Boolean']>,
  readonly internalName?: Maybe<Scalars['String']>,
  readonly internalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly internalName_matches?: Maybe<Scalars['String']>,
  readonly internalName_not?: Maybe<Scalars['String']>,
  readonly internalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly labelAsPerPerson?: Maybe<Scalars['Boolean']>,
  readonly labelAsPerPerson_not?: Maybe<Scalars['Boolean']>,
  readonly mainItem?: Maybe<Scalars['ID']>,
  readonly promotion?: Maybe<Scalars['ID']>,
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export type IComboOrExternalLinkOrItemOrOfferOrPickerOrSection = ICombo | IExternalLink | IItem | IOffer | IPicker | ISection;

export type IComboOrItem = ICombo | IItem;

export type IComboOrItemOrOfferActivationOrOfferDiscountOrOfferItemDiscountOrOfferLoyaltyActionOrPicker = ICombo | IItem | IOfferActivation | IOfferDiscount | IOfferItemDiscount | IOfferLoyaltyAction | IPicker;

export type IComboOrItemOrOfferActivationOrOfferDiscountOrOfferLoyaltyActionOrPicker = ICombo | IItem | IOfferActivation | IOfferDiscount | IOfferLoyaltyAction | IPicker;

export type IComboOrItemOrOfferActivationOrOfferDiscountOrPickerOrSwapMapping = ICombo | IItem | IOfferActivation | IOfferDiscount | IPicker | ISwapMapping;

export type IComboOrItemOrOfferDiscountOrPicker = ICombo | IItem | IOfferDiscount | IPicker;

export type IComboOrItemOrOfferOrPickerOrSection = ICombo | IItem | IOffer | IPicker | ISection;

export type IComboOrItemOrPicker = ICombo | IItem | IPicker;

export type IComboOrItemOrPickerOrProductCategory = ICombo | IItem | IPicker | IProductCategory;

export type IComboOrItemOrPickerOrSection = ICombo | IItem | IPicker | ISection;

export interface IComboSlot  extends IDocument {
  readonly __typename?: 'ComboSlot',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<IImage>,
  readonly images: Maybe<IImages>,
  readonly internalName: Maybe<Scalars['String']>,
  readonly maxAmount: Maybe<Scalars['Float']>,
  readonly minAmount: Maybe<Scalars['Float']>,
  readonly name: Maybe<ILocaleString>,
  readonly optionVisibilitySettings: Maybe<IOptionVisibilitySettings>,
  readonly options: Maybe<ReadonlyArray<Maybe<IComboSlotOption>>>,
  readonly respectMaximum: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IComboSlotFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly internalName?: Maybe<Scalars['String']>,
  readonly internalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly internalName_matches?: Maybe<Scalars['String']>,
  readonly internalName_not?: Maybe<Scalars['String']>,
  readonly internalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly maxAmount?: Maybe<Scalars['Float']>,
  readonly maxAmount_gt?: Maybe<Scalars['Float']>,
  readonly maxAmount_gte?: Maybe<Scalars['Float']>,
  readonly maxAmount_lt?: Maybe<Scalars['Float']>,
  readonly maxAmount_lte?: Maybe<Scalars['Float']>,
  readonly maxAmount_not?: Maybe<Scalars['Float']>,
  readonly minAmount?: Maybe<Scalars['Float']>,
  readonly minAmount_gt?: Maybe<Scalars['Float']>,
  readonly minAmount_gte?: Maybe<Scalars['Float']>,
  readonly minAmount_lt?: Maybe<Scalars['Float']>,
  readonly minAmount_lte?: Maybe<Scalars['Float']>,
  readonly minAmount_not?: Maybe<Scalars['Float']>,
  readonly respectMaximum?: Maybe<Scalars['Boolean']>,
  readonly respectMaximum_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IComboSlotOption {
  readonly __typename?: 'ComboSlotOption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly defaultAmount: Maybe<Scalars['Float']>,
  readonly isPremium: Maybe<Scalars['Boolean']>,
  readonly maxAmount: Maybe<Scalars['Float']>,
  readonly minAmount: Maybe<Scalars['Float']>,
  readonly option: Maybe<IItemOrPickerOrSection>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
}

export interface ICompletedState {
  readonly __typename?: 'CompletedState',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly header: Maybe<ILocaleString>,
}

export interface IConditionAllergen {
  readonly __typename?: 'ConditionAllergen',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly allergenIdentifier: Maybe<Scalars['String']>,
  readonly comparisonOperator: Maybe<Scalars['String']>,
  readonly comparisonValue: Maybe<Scalars['Float']>,
}

export type IConditionAllergenOrConditionItemOneOfOrConditionNutritionOrConditionParentCategory = IConditionAllergen | IConditionItemOneOf | IConditionNutrition | IConditionParentCategory;

export interface IConditionItemOneOf {
  readonly __typename?: 'ConditionItemOneOf',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly items: Maybe<ReadonlyArray<Maybe<IItem>>>,
}

export interface IConditionNutrition {
  readonly __typename?: 'ConditionNutrition',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly comparisonOperator: Maybe<Scalars['String']>,
  readonly comparisonValue: Maybe<Scalars['Float']>,
  readonly nutritionIdentifier: Maybe<Scalars['String']>,
}

export interface IConditionParentCategory {
  readonly __typename?: 'ConditionParentCategory',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly parentCategory: Maybe<IPickerOrSection>,
}

export interface IConfigOffer  extends IDocument {
  readonly __typename?: 'ConfigOffer',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<IImage>,
  readonly configOnly: Maybe<Scalars['Boolean']>,
  readonly daypart: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly incentives: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferActivationOrOfferDiscountOrPickerOrSwapMapping>>>,
  readonly localizedImage: Maybe<ILocaleImages>,
  readonly lockedOffersPanel: Maybe<ILockedOffersPanel>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly marketPrice: Maybe<IComboOrItem>,
  readonly mobileOrderOnly: Maybe<Scalars['Boolean']>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly name: Maybe<ILocaleBlockContent>,
  readonly notificationDetails: Maybe<INotificationDetails>,
  readonly offerPrice: Maybe<Scalars['Float']>,
  readonly permutationPricingValidation: Maybe<IDataValidationObject>,
  readonly position: Maybe<Scalars['Boolean']>,
  readonly priceDistributionValidation: Maybe<IDataValidationObject>,
  readonly promoCodePanel: Maybe<IPromoCodePanel>,
  readonly redemptionType: Maybe<Scalars['String']>,
  readonly restaurantAvailabilityValidation: Maybe<IDataValidationObject>,
  readonly rules: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrCartLimitOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIsStackableOrLimitOrLoyaltyBetweenTimesOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated>>>,
  readonly shortCode: Maybe<Scalars['String']>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
}

export interface IConfigOfferFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly configOnly?: Maybe<Scalars['Boolean']>,
  readonly configOnly_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly marketPrice?: Maybe<Scalars['ID']>,
  readonly mobileOrderOnly?: Maybe<Scalars['Boolean']>,
  readonly mobileOrderOnly_not?: Maybe<Scalars['Boolean']>,
  readonly offerPrice?: Maybe<Scalars['Float']>,
  readonly offerPrice_gt?: Maybe<Scalars['Float']>,
  readonly offerPrice_gte?: Maybe<Scalars['Float']>,
  readonly offerPrice_lt?: Maybe<Scalars['Float']>,
  readonly offerPrice_lte?: Maybe<Scalars['Float']>,
  readonly offerPrice_not?: Maybe<Scalars['Float']>,
  readonly position?: Maybe<Scalars['Boolean']>,
  readonly position_not?: Maybe<Scalars['Boolean']>,
  readonly redemptionType?: Maybe<Scalars['String']>,
  readonly redemptionType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly redemptionType_matches?: Maybe<Scalars['String']>,
  readonly redemptionType_not?: Maybe<Scalars['String']>,
  readonly redemptionType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly shortCode?: Maybe<Scalars['String']>,
  readonly shortCode_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly shortCode_matches?: Maybe<Scalars['String']>,
  readonly shortCode_not?: Maybe<Scalars['String']>,
  readonly shortCode_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export type IConfigOfferOrConfigRewardOrRewardOrSystemwideOffer = IConfigOffer | IConfigReward | IReward | ISystemwideOffer;

export interface IConfigQuest  extends IDocument {
  readonly __typename?: 'ConfigQuest',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly completedState: Maybe<ICompletedState>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImage>,
  readonly incentive: Maybe<IQuestIncentive>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly mustActivateBy: Maybe<Scalars['Date']>,
  readonly name: Maybe<ILocaleString>,
  readonly questRules: Maybe<IQuestRules>,
  readonly rules: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrLimitOrUserCreated>>>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
}

export interface IConfigQuestFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mustActivateBy?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_gt?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_gte?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_lt?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_lte?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_not?: Maybe<Scalars['Date']>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
}

export interface IConfigReward  extends IDocument {
  readonly __typename?: 'ConfigReward',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly completedState: Maybe<ICompletedState>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImage>,
  readonly incentive: Maybe<IQuestIncentive>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly mustActivateBy: Maybe<Scalars['Date']>,
  readonly name: Maybe<ILocaleString>,
  readonly questRules: Maybe<IQuestRules>,
  readonly rules: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrLimitOrUserCreated>>>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
}

export interface IConfigRewardFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mustActivateBy?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_gt?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_gte?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_lt?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_lte?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_not?: Maybe<Scalars['Date']>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
}

export interface ICookieComplianceConfig {
  readonly __typename?: 'CookieComplianceConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly consentCategoryBranch: Maybe<Scalars['String']>,
  readonly consentCategoryBraze: Maybe<Scalars['String']>,
  readonly consentCategoryMParticle: Maybe<Scalars['String']>,
  readonly globalConsentState: Maybe<Scalars['String']>,
  readonly scriptId: Maybe<Scalars['String']>,
  readonly scriptUrl: Maybe<Scalars['String']>,
}

export interface ICoolDown {
  readonly __typename?: 'CoolDown',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly minimumElapsedTimeSeconds: Maybe<Scalars['Float']>,
}

export interface ICopyrightAndLanguageSelector {
  readonly __typename?: 'CopyrightAndLanguageSelector',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly copyrightText: Maybe<ILocaleString>,
}

export type ICopyrightAndLanguageSelectorOrHighlightedVerticalLinkListWidgetOrHorizontalLinkListWidgetOrImageWidgetOrSocialIconsWithHeaderWidgetOrTextWidgetOrVerticalLinkListWidgetOrVerticalLinkListWithHeaderWidgetOrWordmarkAndSocialIcons = ICopyrightAndLanguageSelector | IHighlightedVerticalLinkListWidget | IHorizontalLinkListWidget | IImageWidget | ISocialIconsWithHeaderWidget | ITextWidget | IVerticalLinkListWidget | IVerticalLinkListWithHeaderWidget | IWordmarkAndSocialIcons;

export interface ICss {
  readonly __typename?: 'Css',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly code: Maybe<Scalars['String']>,
  readonly filename: Maybe<Scalars['String']>,
  readonly highlightedLines: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>,
  readonly language: Maybe<Scalars['String']>,
}

export interface IDataDogConfig {
  readonly __typename?: 'DataDogConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly logs: Maybe<ILogsConfig>,
  readonly rum: Maybe<IRumConfig>,
}

export interface IDataValidationObject {
  readonly __typename?: 'DataValidationObject',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly lastValidated: Maybe<Scalars['String']>,
  readonly validationOutput: Maybe<Scalars['String']>,
  readonly validationStatus: Maybe<Scalars['String']>,
}



export interface IDayOfWeekBand {
  readonly __typename?: 'DayOfWeekBand',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly friday: Maybe<Scalars['Boolean']>,
  readonly monday: Maybe<Scalars['Boolean']>,
  readonly saturday: Maybe<Scalars['Boolean']>,
  readonly sunday: Maybe<Scalars['Boolean']>,
  readonly thursday: Maybe<Scalars['Boolean']>,
  readonly tuesday: Maybe<Scalars['Boolean']>,
  readonly wednesday: Maybe<Scalars['Boolean']>,
}

export interface IDayPart {
  readonly __typename?: 'DayPart',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly displayName: Maybe<ILocaleString>,
  readonly endTime: Maybe<Scalars['String']>,
  readonly icon: Maybe<IImage>,
  readonly key: Maybe<Scalars['String']>,
  readonly startTime: Maybe<Scalars['String']>,
  readonly weekDays: Maybe<IWeekDays>,
}

export interface IDaypartRule {
  readonly __typename?: 'DaypartRule',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly daypart: Maybe<Scalars['String']>,
}

export interface IDeliveryVendor {
  readonly __typename?: 'DeliveryVendor',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly storeIdMapping: Maybe<Scalars['String']>,
  readonly vendorName: Maybe<Scalars['String']>,
}

export interface IDisplayGroup  extends IDocument {
  readonly __typename?: 'DisplayGroup',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly displayRank: Maybe<Scalars['Float']>,
  readonly name: Maybe<ILocaleString>,
}

export interface IDisplayGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly displayRank?: Maybe<Scalars['Float']>,
  readonly displayRank_gt?: Maybe<Scalars['Float']>,
  readonly displayRank_gte?: Maybe<Scalars['Float']>,
  readonly displayRank_lt?: Maybe<Scalars['Float']>,
  readonly displayRank_lte?: Maybe<Scalars['Float']>,
  readonly displayRank_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IDocument {
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
}

export interface IDoubleImageWidget {
  readonly __typename?: 'DoubleImageWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly image1: Maybe<IImageWidget>,
  readonly image2: Maybe<IImageWidget>,
}

export interface IEarningCalculation  extends IDocument {
  readonly __typename?: 'EarningCalculation',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly cooldownPeriod: Maybe<Scalars['Float']>,
  readonly coreMetric: Maybe<Scalars['String']>,
  readonly initialUserPointBalance: Maybe<Scalars['Float']>,
  readonly minSpend: Maybe<Scalars['Float']>,
  readonly offerRedemptionCooldownPeriod: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays: Maybe<Scalars['Float']>,
  readonly pointsPerDollar: Maybe<Scalars['Float']>,
  readonly pointsPerVisit: Maybe<Scalars['Float']>,
}

export interface IEarningCalculationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly cooldownPeriod?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_gt?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_gte?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_lt?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_lte?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_not?: Maybe<Scalars['Float']>,
  readonly coreMetric?: Maybe<Scalars['String']>,
  readonly coreMetric_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly coreMetric_matches?: Maybe<Scalars['String']>,
  readonly coreMetric_not?: Maybe<Scalars['String']>,
  readonly coreMetric_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly initialUserPointBalance?: Maybe<Scalars['Float']>,
  readonly initialUserPointBalance_gt?: Maybe<Scalars['Float']>,
  readonly initialUserPointBalance_gte?: Maybe<Scalars['Float']>,
  readonly initialUserPointBalance_lt?: Maybe<Scalars['Float']>,
  readonly initialUserPointBalance_lte?: Maybe<Scalars['Float']>,
  readonly initialUserPointBalance_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly minSpend?: Maybe<Scalars['Float']>,
  readonly minSpend_gt?: Maybe<Scalars['Float']>,
  readonly minSpend_gte?: Maybe<Scalars['Float']>,
  readonly minSpend_lt?: Maybe<Scalars['Float']>,
  readonly minSpend_lte?: Maybe<Scalars['Float']>,
  readonly minSpend_not?: Maybe<Scalars['Float']>,
  readonly offerRedemptionCooldownPeriod?: Maybe<Scalars['Float']>,
  readonly offerRedemptionCooldownPeriod_gt?: Maybe<Scalars['Float']>,
  readonly offerRedemptionCooldownPeriod_gte?: Maybe<Scalars['Float']>,
  readonly offerRedemptionCooldownPeriod_lt?: Maybe<Scalars['Float']>,
  readonly offerRedemptionCooldownPeriod_lte?: Maybe<Scalars['Float']>,
  readonly offerRedemptionCooldownPeriod_not?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_gt?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_gte?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_lt?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_lte?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_not?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_gt?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_gte?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_lt?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_lte?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_not?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_gt?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_gte?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_lt?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_lte?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_not?: Maybe<Scalars['Float']>,
}

export interface IEmptyState  extends IDocument {
  readonly __typename?: 'EmptyState',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<IImageBackground>,
  readonly buttonAction: Maybe<ILinkAction>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly headerText: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImages>,
  readonly logo: Maybe<ILocaleImages>,
  readonly marketingTileList: Maybe<IMarketingTileList>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly subtitle: Maybe<ILocaleString>,
  readonly terms: Maybe<ILocaleBlockContent>,
  readonly title: Maybe<ILocaleString>,
}

export interface IEmptyStateFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IEndOfOffersLoggedIn {
  readonly __typename?: 'EndOfOffersLoggedIn',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly endOfOffersImage: Maybe<ILocaleImage>,
  readonly endOfOffersMessage: Maybe<ILocaleString>,
}

export interface IEndOfOffersLoggedOut {
  readonly __typename?: 'EndOfOffersLoggedOut',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly ctaButtonText: Maybe<ILocaleString>,
  readonly link: Maybe<ILocaleUrl>,
  readonly title: Maybe<ILocaleString>,
}

export interface IExternalLink {
  readonly __typename?: 'ExternalLink',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly link: Maybe<ILocaleUrl>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly name: Maybe<ILocaleString>,
  readonly url: Maybe<Scalars['String']>,
}

export interface IFanFavorites  extends IDocument {
  readonly __typename?: 'FanFavorites',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly fanFavoriteItems: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>,
  readonly favoriteSection: Maybe<IFavoriteSection>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IFanFavoritesFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IFavoriteSection {
  readonly __typename?: 'FavoriteSection',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly headerText: Maybe<ILocaleString>,
  readonly orderNowText: Maybe<ILocaleString>,
  readonly subheaderText: Maybe<ILocaleString>,
}

export interface IFeatureAccount  extends IDocument {
  readonly __typename?: 'FeatureAccount',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly emailAndPushOptInSettings: Maybe<ReadonlyArray<Maybe<IOptInPrivacyPreferencesOrOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum>>>,
}

export interface IFeatureAccountDeletePage  extends IDocument {
  readonly __typename?: 'FeatureAccountDeletePage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly cancelButtonText: Maybe<ILocaleString>,
  readonly confirmButtonText: Maybe<ILocaleString>,
  readonly content: Maybe<ILocaleBlockContent>,
  readonly errorText: Maybe<ILocaleString>,
  readonly headerText: Maybe<ILocaleString>,
}

export interface IFeatureAccountDeletePageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureAccountFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureAccountForm  extends IDocument {
  readonly __typename?: 'FeatureAccountForm',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly desktopImage: Maybe<ILocaleImages>,
  readonly postalOrZipDisclaimer: Maybe<ILocaleString>,
}

export interface IFeatureAccountFormFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureAccountRequestInfoPage  extends IDocument {
  readonly __typename?: 'FeatureAccountRequestInfoPage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly confirmButtonText: Maybe<ILocaleString>,
  readonly content: Maybe<ILocaleBlockContent>,
  readonly errorText: Maybe<ILocaleString>,
  readonly headerText: Maybe<ILocaleString>,
}

export interface IFeatureAccountRequestInfoPageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureBeeperModal  extends IDocument {
  readonly __typename?: 'FeatureBeeperModal',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly beeperButtonText: Maybe<ILocaleString>,
  readonly beeperModalBody: Maybe<ILocaleString>,
  readonly beeperModalImage: Maybe<ILocaleImage>,
  readonly beeperModalTitle: Maybe<ILocaleString>,
}

export interface IFeatureBeeperModalFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureCateringPage  extends IDocument {
  readonly __typename?: 'FeatureCateringPage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appAuthenticated: Maybe<ICateringPageConfiguration>,
  readonly appUnauthenticated: Maybe<ICateringPageConfiguration>,
  readonly webAuthenticated: Maybe<ICateringPageConfiguration>,
  readonly webUnauthenticated: Maybe<ICateringPageConfiguration>,
}

export interface IFeatureCateringPageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureDisclaimers  extends IDocument {
  readonly __typename?: 'FeatureDisclaimers',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly calorie: Maybe<ILocaleBlockContent>,
  readonly communicationPreferencesBlock: Maybe<ILocaleBlockContent>,
  readonly copyrightAndTrademark: Maybe<ILocaleString>,
  readonly country: Maybe<ILocaleString>,
  readonly deliveryDisclaimer: Maybe<ILocaleString>,
  readonly deliveryLogo: Maybe<ILocaleImage>,
  readonly images: Maybe<ILocaleString>,
  readonly itemAvailability: Maybe<ILocaleString>,
  readonly offers: Maybe<ILocaleString>,
  readonly phoneNumber: Maybe<ILocaleString>,
  readonly price: Maybe<ILocaleString>,
  readonly reservedRights: Maybe<ILocaleString>,
  readonly signUpDisclaimers: Maybe<ILocaleString>,
  readonly signUpMarketDisclaimers: Maybe<ILocaleString>,
  readonly superUpsell: Maybe<ILocaleBlockContent>,
}

export interface IFeatureDisclaimersFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeaturedReward {
  readonly __typename?: 'FeaturedReward',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly category: Maybe<IRewardCategory>,
  readonly reward: Maybe<IReward>,
}

export interface IFeatureFooter  extends IDocument {
  readonly __typename?: 'FeatureFooter',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly rows: Maybe<ReadonlyArray<Maybe<IRow>>>,
}

export interface IFeatureFooterFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureFooterV2  extends IDocument {
  readonly __typename?: 'FeatureFooterV2',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly copyrightText: Maybe<ILocaleString>,
  readonly mainLinks: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
  readonly miscellaneousLinks: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
  readonly socialMediaData: Maybe<ISocialIconsWidget>,
}

export interface IFeatureFooterV2Filter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureGeolocationMapMarkers  extends IDocument {
  readonly __typename?: 'FeatureGeolocationMapMarkers',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly driverIcon: Maybe<ILocaleImage>,
}

export interface IFeatureGeolocationMapMarkersFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureGeolocationModal  extends IDocument {
  readonly __typename?: 'FeatureGeolocationModal',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<ILocaleImage>,
  readonly body: Maybe<ILocaleString>,
  readonly deliveryImage: Maybe<ILocaleImage>,
  readonly header: Maybe<ILocaleString>,
  readonly logo: Maybe<ILocaleImage>,
}

export interface IFeatureGeolocationModalFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureGift  extends IDocument {
  readonly __typename?: 'FeatureGift',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<ILocaleImages>,
  readonly header: Maybe<ILocaleString>,
  readonly legalDisclaimer: Maybe<ILocaleBlockContent>,
  readonly receptionModalImage: Maybe<ILocaleImages>,
  readonly subHeader: Maybe<ILocaleBlockContent>,
}

export interface IFeatureGiftFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureHomePage  extends IDocument {
  readonly __typename?: 'FeatureHomePage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appAuthenticated: Maybe<IHomePageConfiguration>,
  readonly appUnauthenticated: Maybe<IHomePageConfiguration>,
  readonly name: Maybe<ILocaleString>,
  readonly webAuthenticated: Maybe<IHomePageConfiguration>,
  readonly webUnauthenticated: Maybe<IHomePageConfiguration>,
}

export interface IFeatureHomePageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureKiosk  extends IDocument {
  readonly __typename?: 'FeatureKiosk',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appData: Maybe<IKioskAppData>,
  readonly attractLoopImage: Maybe<ILocaleImage>,
  readonly rewardsMainImage: Maybe<ILocaleImage>,
}

export interface IFeatureKioskFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly appData?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureKioskHomePage  extends IDocument {
  readonly __typename?: 'FeatureKioskHomePage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly kioskAuthenticated: Maybe<IHomePageConfiguration>,
  readonly kioskUnauthenticated: Maybe<IHomePageConfiguration>,
  readonly name: Maybe<ILocaleString>,
}

export interface IFeatureKioskHomePageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureKioskMenu  extends IDocument {
  readonly __typename?: 'FeatureKioskMenu',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly cartAddOnSections: Maybe<ReadonlyArray<Maybe<IAddOnSection>>>,
  readonly dayParts: Maybe<ReadonlyArray<Maybe<IDayPart>>>,
  readonly defaultMenu: Maybe<IMenu>,
  readonly menuHeroImage: Maybe<ILocaleImage>,
  readonly menuHeroText: Maybe<ILocaleString>,
  readonly upsellItemsAtCheckoutRestaurant: Maybe<ReadonlyArray<Maybe<IItem>>>,
}

export interface IFeatureKioskMenuFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly defaultMenu?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureKioskScreensaver  extends IDocument {
  readonly __typename?: 'FeatureKioskScreensaver',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly delay: Maybe<Scalars['Float']>,
  readonly images: Maybe<ReadonlyArray<Maybe<ILocaleImage>>>,
}

export interface IFeatureKioskScreensaverFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly delay?: Maybe<Scalars['Float']>,
  readonly delay_gt?: Maybe<Scalars['Float']>,
  readonly delay_gte?: Maybe<Scalars['Float']>,
  readonly delay_lt?: Maybe<Scalars['Float']>,
  readonly delay_lte?: Maybe<Scalars['Float']>,
  readonly delay_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureLayout  extends IDocument {
  readonly __typename?: 'FeatureLayout',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appleWalletImage: Maybe<ILocaleImage>,
  readonly defaultHeroImage: Maybe<ILocaleImage>,
  readonly geolocationModalImage: Maybe<ILocaleImage>,
  readonly giftCardImage: Maybe<ILocaleImage>,
  readonly giftCardTextImage: Maybe<ILocaleImage>,
  readonly googlePayImage: Maybe<ILocaleImage>,
  readonly loadingGraphics: Maybe<ILoadingGraphics>,
  readonly recentOrderHeroText: Maybe<ILocaleString>,
}

export interface IFeatureLayoutFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureLocationPromo  extends IDocument {
  readonly __typename?: 'FeatureLocationPromo',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly bottomText: Maybe<ILocaleString>,
  readonly failLocationHeader: Maybe<ILocaleString>,
  readonly failLocationSubtext: Maybe<ILocaleString>,
  readonly legalText: Maybe<ILocaleString>,
  readonly linkToStaticPage: Maybe<ILinkAction>,
  readonly menuHeroText: Maybe<ILocaleString>,
  readonly promoBackgroundImage: Maybe<IImage>,
}

export interface IFeatureLocationPromoFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureLockers  extends IDocument {
  readonly __typename?: 'FeatureLockers',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly lockersDescription: Maybe<ILocaleBlockContent>,
  readonly lockersHowToUseLockersButtonText: Maybe<ILocaleString>,
  readonly lockersModalImage: Maybe<ILocaleImage>,
  readonly lockersPinInstructions: Maybe<ILocaleBlockContent>,
  readonly lockersTitle: Maybe<ILocaleString>,
  readonly lockersViewOrderButtonText: Maybe<ILocaleString>,
}

export interface IFeatureLockersFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureMenu  extends IDocument {
  readonly __typename?: 'FeatureMenu',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly cartAddOnSections: Maybe<ReadonlyArray<Maybe<IAddOnSection>>>,
  readonly cartAddOnSectionsCatering: Maybe<ReadonlyArray<Maybe<IAddOnSection>>>,
  readonly cateringMenu: Maybe<IMenu>,
  readonly dayParts: Maybe<ReadonlyArray<Maybe<IDayPart>>>,
  readonly defaultMenu: Maybe<IMenu>,
  readonly donationItemsAtCheckout: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly donationTermAndConditionUrl: Maybe<ILocaleUrl>,
  readonly gfoMenu: Maybe<IMenu>,
  readonly menuHeroImage: Maybe<ILocaleImage>,
  readonly menuHeroText: Maybe<ILocaleString>,
  readonly upsellItemsAtCheckoutCatering: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutDelivery: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutRestaurant: Maybe<ReadonlyArray<Maybe<IItem>>>,
}

export interface IFeatureMenuFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly cateringMenu?: Maybe<Scalars['ID']>,
  readonly defaultMenu?: Maybe<Scalars['ID']>,
  readonly gfoMenu?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureMobileAppConfiguration  extends IDocument {
  readonly __typename?: 'FeatureMobileAppConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appVersion: Maybe<IAppVersion>,
}

export interface IFeatureMobileAppConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly appVersion?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureNavigation  extends IDocument {
  readonly __typename?: 'FeatureNavigation',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly aboutMenuEntries: Maybe<INavigationSection>,
  readonly navigationDesktop: Maybe<INavigationDesktop>,
  readonly navigationMobile: Maybe<INavigationMobile>,
  readonly navigationMobileHeaderButton: Maybe<INavigationMobileHeaderButton>,
}

export interface IFeatureNavigationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureNutrition  extends IDocument {
  readonly __typename?: 'FeatureNutrition',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly nutritionTables: Maybe<ReadonlyArray<Maybe<INutritionTable>>>,
  readonly roundingRules: Maybe<IRoundingRules>,
}

export interface IFeatureNutritionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureOffers  extends IDocument {
  readonly __typename?: 'FeatureOffers',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly defaultBackgroundImage: Maybe<IImage>,
  readonly enableMovableInk: Maybe<Scalars['Boolean']>,
  readonly offersBrowsingPanel: Maybe<IOffersBrowsingPanel>,
  readonly offersDetailsPanel: Maybe<IOffersDetailsPanel>,
  readonly offersPageMarketingTiles: Maybe<ReadonlyArray<Maybe<IOffersPageMarketingTile>>>,
  readonly sortedOffers: Maybe<ReadonlyArray<Maybe<IOffer>>>,
}

export interface IFeatureOffersFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly enableMovableInk?: Maybe<Scalars['Boolean']>,
  readonly enableMovableInk_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureOnboarding  extends IDocument {
  readonly __typename?: 'FeatureOnboarding',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly channel: Maybe<Scalars['String']>,
  readonly screens: Maybe<ReadonlyArray<Maybe<IImageWithHeaderAndText>>>,
  readonly triggerRule: Maybe<Scalars['String']>,
}

export interface IFeatureOnboardingFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly channel?: Maybe<Scalars['String']>,
  readonly channel_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly channel_matches?: Maybe<Scalars['String']>,
  readonly channel_not?: Maybe<Scalars['String']>,
  readonly channel_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly triggerRule?: Maybe<Scalars['String']>,
  readonly triggerRule_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly triggerRule_matches?: Maybe<Scalars['String']>,
  readonly triggerRule_not?: Maybe<Scalars['String']>,
  readonly triggerRule_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IFeaturePayback  extends IDocument {
  readonly __typename?: 'FeaturePayback',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly paybackDescription: Maybe<ILocaleBlockContent>,
  readonly paybackLinkCardButtonText: Maybe<ILocaleString>,
  readonly paybackLoginUrl: Maybe<Scalars['String']>,
  readonly paybackLogoImage: Maybe<ILocaleImage>,
  readonly paybackLogoSmallImage: Maybe<ILocaleImage>,
  readonly paybackMainImage: Maybe<ILocaleImage>,
  readonly paybackNeedHelpButtonText: Maybe<ILocaleString>,
  readonly paybackPartnerID: Maybe<Scalars['String']>,
  readonly paybackRedirectUrl: Maybe<Scalars['String']>,
  readonly paybackRefreshPointsButtonText: Maybe<ILocaleString>,
  readonly paybackTitle: Maybe<ILocaleString>,
}

export interface IFeaturePaybackFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly paybackLoginUrl?: Maybe<Scalars['String']>,
  readonly paybackLoginUrl_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly paybackLoginUrl_matches?: Maybe<Scalars['String']>,
  readonly paybackLoginUrl_not?: Maybe<Scalars['String']>,
  readonly paybackLoginUrl_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly paybackPartnerID?: Maybe<Scalars['String']>,
  readonly paybackPartnerID_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly paybackPartnerID_matches?: Maybe<Scalars['String']>,
  readonly paybackPartnerID_not?: Maybe<Scalars['String']>,
  readonly paybackPartnerID_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly paybackRedirectUrl?: Maybe<Scalars['String']>,
  readonly paybackRedirectUrl_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly paybackRedirectUrl_matches?: Maybe<Scalars['String']>,
  readonly paybackRedirectUrl_not?: Maybe<Scalars['String']>,
  readonly paybackRedirectUrl_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IFeatureQuiz  extends IDocument {
  readonly __typename?: 'FeatureQuiz',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleString>,
  readonly endDate: Maybe<Scalars['Date']>,
  readonly introPageBackground: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
  readonly question: Maybe<ReadonlyArray<Maybe<IQuestionDetails>>>,
  readonly questionPageBackground: Maybe<IImage>,
  readonly questions: Maybe<ReadonlyArray<Maybe<IQuestionDetails>>>,
  readonly resultPageBackground: Maybe<IImage>,
  readonly results: Maybe<ReadonlyArray<Maybe<IResultDetails>>>,
  readonly startDate: Maybe<Scalars['Date']>,
}

export interface IFeatureQuizFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly endDate?: Maybe<Scalars['Date']>,
  readonly endDate_gt?: Maybe<Scalars['Date']>,
  readonly endDate_gte?: Maybe<Scalars['Date']>,
  readonly endDate_lt?: Maybe<Scalars['Date']>,
  readonly endDate_lte?: Maybe<Scalars['Date']>,
  readonly endDate_not?: Maybe<Scalars['Date']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly startDate?: Maybe<Scalars['Date']>,
  readonly startDate_gt?: Maybe<Scalars['Date']>,
  readonly startDate_gte?: Maybe<Scalars['Date']>,
  readonly startDate_lt?: Maybe<Scalars['Date']>,
  readonly startDate_lte?: Maybe<Scalars['Date']>,
  readonly startDate_not?: Maybe<Scalars['Date']>,
}

export interface IFeatureScanAndPay  extends IDocument {
  readonly __typename?: 'FeatureScanAndPay',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly addNewPaymentMethodStateText: Maybe<ILocaleBlockContent>,
  readonly header: Maybe<ILocaleString>,
  readonly inactiveStateText: Maybe<ILocaleBlockContent>,
  readonly paymentMethodDeletionModalText: Maybe<IPaymentMethodDeletionModalText>,
}

export interface IFeatureScanAndPayFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureStaticMenu  extends IDocument {
  readonly __typename?: 'FeatureStaticMenu',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly itemUnavailableModal: Maybe<IItemUnavailableModal>,
}

export interface IFeatureStaticMenuFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFile {
  readonly __typename?: 'File',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly asset: Maybe<ISanityFileAsset>,
}

export interface IFilter {
  readonly __typename?: 'Filter',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly conditions: Maybe<ReadonlyArray<Maybe<IConditionAllergenOrConditionItemOneOfOrConditionNutritionOrConditionParentCategory>>>,
  readonly description: Maybe<ILocaleString>,
}

export interface IFilterGroup {
  readonly __typename?: 'FilterGroup',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly filters: Maybe<ReadonlyArray<Maybe<IFilter>>>,
}

export interface IFirstOrderOnly {
  readonly __typename?: 'FirstOrderOnly',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly firstUserOrder: Maybe<Scalars['Boolean']>,
}

export interface IFooter  extends IDocument {
  readonly __typename?: 'Footer',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly accessibilitystatement: Maybe<ILink>,
  readonly careers: Maybe<ILink>,
  readonly company: Maybe<ILink>,
  readonly contactus: Maybe<ILink>,
  readonly foundation: Maybe<ILink>,
  readonly franchiseopportunities: Maybe<ILink>,
  readonly investorrelations: Maybe<ILink>,
  readonly legal: Maybe<ILink>,
  readonly ourstory: Maybe<ILink>,
  readonly privacypolicy: Maybe<ILink>,
  readonly sitemap: Maybe<ILink>,
  readonly support: Maybe<ILink>,
  readonly termsofuse: Maybe<ILink>,
}

export interface IFooterFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IForterConfig {
  readonly __typename?: 'ForterConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly siteId: Maybe<Scalars['String']>,
}

export interface IFrontEndConfiguration  extends IDocument {
  readonly __typename?: 'FrontEndConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly adyen: Maybe<IAdyenConfig>,
  readonly apiKeys: Maybe<IApiKeysConfig>,
  readonly apple: Maybe<IAppleConfig>,
  readonly aws: Maybe<IAwsConfig>,
  readonly bringg: Maybe<IBringgConfig>,
  readonly dataDog: Maybe<IDataDogConfig>,
  readonly dateFormat: Maybe<Scalars['String']>,
  readonly forter: Maybe<IForterConfig>,
  readonly google: Maybe<IGoogleConfig>,
  readonly googleAdManager: Maybe<IGoogleAdManagerConfig>,
  readonly googleTagManager: Maybe<IGoogleTagManagerConfig>,
  readonly kountMerchantId: Maybe<Scalars['String']>,
  readonly oneTrust: Maybe<IOneTrustConfig>,
  readonly pypestream: Maybe<IPypestreamConfig>,
  readonly restaurants: Maybe<IRestaurantConfig>,
  readonly timeFormat: Maybe<Scalars['String']>,
  readonly tokenEx: Maybe<ITokenExConfig>,
  readonly urls: Maybe<IUrlsConfig>,
  readonly vrPayment: Maybe<IVrPaymentConfig>,
}

export interface IFrontEndConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly dateFormat?: Maybe<Scalars['String']>,
  readonly dateFormat_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly dateFormat_matches?: Maybe<Scalars['String']>,
  readonly dateFormat_not?: Maybe<Scalars['String']>,
  readonly dateFormat_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly kountMerchantId?: Maybe<Scalars['String']>,
  readonly kountMerchantId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly kountMerchantId_matches?: Maybe<Scalars['String']>,
  readonly kountMerchantId_not?: Maybe<Scalars['String']>,
  readonly kountMerchantId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly timeFormat?: Maybe<Scalars['String']>,
  readonly timeFormat_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly timeFormat_matches?: Maybe<Scalars['String']>,
  readonly timeFormat_not?: Maybe<Scalars['String']>,
  readonly timeFormat_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IGeopoint {
  readonly __typename?: 'Geopoint',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly alt: Maybe<Scalars['Float']>,
  readonly lat: Maybe<Scalars['Float']>,
  readonly lng: Maybe<Scalars['Float']>,
}

export interface IGlobalOfferCooldownContent {
  readonly __typename?: 'GlobalOfferCooldownContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly actionButton: Maybe<IActionButton>,
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly terms: Maybe<ILocaleBlockContent>,
  readonly title: Maybe<ILocaleString>,
}

export interface IGoogleAdManagerConfig {
  readonly __typename?: 'GoogleAdManagerConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly campaignId: Maybe<Scalars['String']>,
}

export interface IGoogleAdSlot  extends IDocument {
  readonly __typename?: 'GoogleAdSlot',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly adSlotSize: Maybe<Scalars['String']>,
  readonly adUnitId: Maybe<Scalars['String']>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IGoogleAdSlotFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly adSlotSize?: Maybe<Scalars['String']>,
  readonly adSlotSize_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly adSlotSize_matches?: Maybe<Scalars['String']>,
  readonly adSlotSize_not?: Maybe<Scalars['String']>,
  readonly adSlotSize_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly adUnitId?: Maybe<Scalars['String']>,
  readonly adUnitId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly adUnitId_matches?: Maybe<Scalars['String']>,
  readonly adUnitId_not?: Maybe<Scalars['String']>,
  readonly adUnitId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IGoogleConfig {
  readonly __typename?: 'GoogleConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly paymentsEnvironment: Maybe<Scalars['String']>,
  readonly paymentsGateway: Maybe<Scalars['String']>,
  readonly paymentsGatewayMerchantId: Maybe<IPaymentsGatewayMerchantIdConfig>,
  readonly paymentsNetworks: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly prepaidPaymentsGateway: Maybe<Scalars['String']>,
  readonly prepaidPaymentsGatewayMerchantId: Maybe<IPrepaidPaymentsGatewayMerchantIdConfig>,
}

export interface IGoogleTagManagerConfig {
  readonly __typename?: 'GoogleTagManagerConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly containerId: Maybe<Scalars['String']>,
}

export interface IHeaderWidget {
  readonly __typename?: 'HeaderWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly headerImage: Maybe<ILocaleImage>,
  readonly headingContent: Maybe<ILocaleString>,
  readonly taglineContent: Maybe<ILocaleString>,
}

export interface IHero  extends IDocument {
  readonly __typename?: 'Hero',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly altImageText: Maybe<ILocaleString>,
  readonly complementaryCta: Maybe<ILinkAction>,
  readonly hasTerms: Maybe<Scalars['Boolean']>,
  readonly header: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly primaryCta: Maybe<ILinkAction>,
  readonly reversed: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly subheader: Maybe<ILocaleString>,
  readonly termsButton: Maybe<ILinkAction>,
  readonly termsText: Maybe<ILocaleBlockContent>,
}

export interface IHeroFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly hasTerms?: Maybe<Scalars['Boolean']>,
  readonly hasTerms_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly reversed?: Maybe<Scalars['Boolean']>,
  readonly reversed_not?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IHighlightedLinkWidget {
  readonly __typename?: 'HighlightedLinkWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly link: Maybe<ILocaleUrl>,
  readonly text: Maybe<ILocaleString>,
}

export interface IHighlightedVerticalLinkListWidget {
  readonly __typename?: 'HighlightedVerticalLinkListWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly header: Maybe<ILocaleString>,
  readonly highlightedLinks: Maybe<ReadonlyArray<Maybe<IHighlightedLinkWidget>>>,
  readonly subheader: Maybe<ILocaleString>,
}

export interface IHolidayHours {
  readonly __typename?: 'HolidayHours',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly close: Maybe<Scalars['String']>,
  readonly date: Maybe<Scalars['String']>,
  readonly holiday: Maybe<Scalars['String']>,
  readonly open: Maybe<Scalars['String']>,
}

export interface IHomeGraphic {
  readonly __typename?: 'HomeGraphic',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly asset: Maybe<ISanityFileAsset>,
  readonly description: Maybe<Scalars['String']>,
}

export interface IHomePageConfiguration  extends IDocument {
  readonly __typename?: 'HomePageConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly components: Maybe<ReadonlyArray<Maybe<IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrGoogleAdSlotOrHeroOrLockedOffersOrMainHeroOrMarketingCardGroupOrMarketingTileCarouselOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrRewardsSectionOrRollUpTheRimSectionOrScanForRewardsOrTrending>>>,
}

export interface IHomePageConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IHorizontalLinkListWidget {
  readonly __typename?: 'HorizontalLinkListWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly linkWidgets: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
}

export interface IHoursOfOperation {
  readonly __typename?: 'HoursOfOperation',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly friClose: Maybe<Scalars['String']>,
  readonly friOpen: Maybe<Scalars['String']>,
  readonly monClose: Maybe<Scalars['String']>,
  readonly monOpen: Maybe<Scalars['String']>,
  readonly satClose: Maybe<Scalars['String']>,
  readonly satOpen: Maybe<Scalars['String']>,
  readonly sunClose: Maybe<Scalars['String']>,
  readonly sunOpen: Maybe<Scalars['String']>,
  readonly thrClose: Maybe<Scalars['String']>,
  readonly thrOpen: Maybe<Scalars['String']>,
  readonly tueClose: Maybe<Scalars['String']>,
  readonly tueOpen: Maybe<Scalars['String']>,
  readonly wedClose: Maybe<Scalars['String']>,
  readonly wedOpen: Maybe<Scalars['String']>,
}

export interface IHslaColor {
  readonly __typename?: 'HslaColor',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly a: Maybe<Scalars['Float']>,
  readonly h: Maybe<Scalars['Float']>,
  readonly l: Maybe<Scalars['Float']>,
  readonly s: Maybe<Scalars['Float']>,
}

export interface IHsvaColor {
  readonly __typename?: 'HsvaColor',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly a: Maybe<Scalars['Float']>,
  readonly h: Maybe<Scalars['Float']>,
  readonly s: Maybe<Scalars['Float']>,
  readonly v: Maybe<Scalars['Float']>,
}

export interface IHtml {
  readonly __typename?: 'Html',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly code: Maybe<Scalars['String']>,
  readonly filename: Maybe<Scalars['String']>,
  readonly highlightedLines: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>,
  readonly language: Maybe<Scalars['String']>,
}

export interface IImage {
  readonly __typename?: 'Image',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly asset: Maybe<ISanityImageAsset>,
  readonly crop: Maybe<ISanityImageCrop>,
  readonly hotspot: Maybe<ISanityImageHotspot>,
}

export interface IImageBackground {
  readonly __typename?: 'ImageBackground',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly image: Maybe<IImage>,
}

export interface IImages {
  readonly __typename?: 'Images',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly app: Maybe<IImage>,
  readonly imageDescription: Maybe<Scalars['String']>,
  readonly kiosk: Maybe<IImage>,
}

export interface IImageWidget {
  readonly __typename?: 'ImageWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly attributionLink: Maybe<Scalars['String']>,
  readonly caption: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
}

export interface IImageWithHeaderAndText  extends IDocument {
  readonly __typename?: 'ImageWithHeaderAndText',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly buttonAction: Maybe<ILinkAction>,
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly textContent: Maybe<ILocaleTypographyBlock>,
  readonly title: Maybe<Scalars['String']>,
}

export interface IImageWithHeaderAndTextFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly title_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly title_matches?: Maybe<Scalars['String']>,
  readonly title_not?: Maybe<Scalars['String']>,
  readonly title_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IIncentiveNotAvailableModalContent {
  readonly __typename?: 'IncentiveNotAvailableModalContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImages>,
  readonly primaryButton: Maybe<IActionButton>,
  readonly secondaryButton: Maybe<IActionButton>,
  readonly title: Maybe<ILocaleString>,
}

export interface IIncentiveRequirement {
  readonly __typename?: 'IncentiveRequirement',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly incentiveRequirement: Maybe<ReadonlyArray<Maybe<IIncentiveRequirementEntry>>>,
}

export interface IIncentiveRequirementEntry {
  readonly __typename?: 'IncentiveRequirementEntry',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly incentive: Maybe<IConfigOfferOrConfigRewardOrRewardOrSystemwideOffer>,
  readonly quantity: Maybe<Scalars['Float']>,
}

export interface IIonicConfig {
  readonly __typename?: 'IonicConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly ionicAppId: Maybe<Scalars['String']>,
  readonly ionicChannelName: Maybe<Scalars['String']>,
}

export interface IIsStackable {
  readonly __typename?: 'IsStackable',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly stackable: Maybe<Scalars['Boolean']>,
}

export interface IItem  extends IDocument {
  readonly __typename?: 'Item',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly activationDate: Maybe<Scalars['Date']>,
  readonly additionalItemInformation: Maybe<IAdditionalItemInformation>,
  readonly allergens: Maybe<IOpAllergen>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly deactivationDate: Maybe<Scalars['Date']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly hideCalories: Maybe<Scalars['Boolean']>,
  readonly hideNutritionLegalDisclaimer: Maybe<Scalars['Boolean']>,
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly internalName: Maybe<Scalars['String']>,
  readonly labelAsPerPerson: Maybe<Scalars['Boolean']>,
  readonly menuObjectSettings: Maybe<IMenuObjectSettings>,
  readonly name: Maybe<ILocaleString>,
  readonly nutrition: Maybe<INutrition>,
  readonly nutritionWithModifiers: Maybe<INutrition>,
  readonly operationalItem: Maybe<IOpItem>,
  readonly options: Maybe<ReadonlyArray<Maybe<IItemOption>>>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
  readonly productHierarchy: Maybe<IProductHierarchy>,
  readonly promotion: Maybe<ISystemwidePromotion>,
  readonly region: Maybe<Scalars['String']>,
  readonly rewardEligible: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
  readonly tier: Maybe<ITier>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IItemFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly activationDate?: Maybe<Scalars['Date']>,
  readonly activationDate_gt?: Maybe<Scalars['Date']>,
  readonly activationDate_gte?: Maybe<Scalars['Date']>,
  readonly activationDate_lt?: Maybe<Scalars['Date']>,
  readonly activationDate_lte?: Maybe<Scalars['Date']>,
  readonly activationDate_not?: Maybe<Scalars['Date']>,
  readonly deactivationDate?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_not?: Maybe<Scalars['Date']>,
  readonly hideCalories?: Maybe<Scalars['Boolean']>,
  readonly hideCalories_not?: Maybe<Scalars['Boolean']>,
  readonly hideNutritionLegalDisclaimer?: Maybe<Scalars['Boolean']>,
  readonly hideNutritionLegalDisclaimer_not?: Maybe<Scalars['Boolean']>,
  readonly internalName?: Maybe<Scalars['String']>,
  readonly internalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly internalName_matches?: Maybe<Scalars['String']>,
  readonly internalName_not?: Maybe<Scalars['String']>,
  readonly internalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly labelAsPerPerson?: Maybe<Scalars['Boolean']>,
  readonly labelAsPerPerson_not?: Maybe<Scalars['Boolean']>,
  readonly promotion?: Maybe<Scalars['ID']>,
  readonly region?: Maybe<Scalars['String']>,
  readonly region_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly region_matches?: Maybe<Scalars['String']>,
  readonly region_not?: Maybe<Scalars['String']>,
  readonly region_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly rewardEligible?: Maybe<Scalars['Boolean']>,
  readonly rewardEligible_not?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu_not?: Maybe<Scalars['Boolean']>,
  readonly tier?: Maybe<Scalars['ID']>,
}

export interface IItemOption {
  readonly __typename?: 'ItemOption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly activationDate: Maybe<Scalars['DateTime']>,
  readonly allowMultipleSelections: Maybe<Scalars['Boolean']>,
  readonly componentStyle: Maybe<Scalars['String']>,
  readonly deactivationDate: Maybe<Scalars['DateTime']>,
  readonly displayGroup: Maybe<IDisplayGroup>,
  readonly displayModifierMultiplierName: Maybe<Scalars['Boolean']>,
  readonly documentDescription: Maybe<Scalars['String']>,
  readonly injectDefaultSelection: Maybe<Scalars['Boolean']>,
  readonly maxAmount: Maybe<Scalars['Float']>,
  readonly minAmount: Maybe<Scalars['Float']>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IItemOptionModifier>>>,
  readonly singleChoiceOnly: Maybe<Scalars['Boolean']>,
  readonly upsellModifier: Maybe<Scalars['Boolean']>,
}

export interface IItemOptionModifier {
  readonly __typename?: 'ItemOptionModifier',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly activationDate: Maybe<Scalars['DateTime']>,
  readonly allergen: Maybe<IOpAllergen>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly deactivationDate: Maybe<Scalars['DateTime']>,
  readonly default: Maybe<Scalars['Boolean']>,
  readonly documentDescription: Maybe<Scalars['String']>,
  readonly modifierMultiplier: Maybe<IModifierMultiplier>,
  readonly name: Maybe<ILocaleString>,
  readonly nutrition: Maybe<INutrition>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export type IItemOrNutritionalSection = IItem | INutritionalSection;

export type IItemOrPickerOrSection = IItem | IPicker | ISection;

export interface IItemUnavailableModal {
  readonly __typename?: 'ItemUnavailableModal',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly continue: Maybe<ILocaleString>,
  readonly header: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly itemNotAvailableForDelivery: Maybe<ILocaleString>,
  readonly selectNew: Maybe<ILocaleString>,
}


export interface IKiosk {
  readonly __typename?: 'Kiosk',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly serialNumber: Maybe<Scalars['String']>,
}

export interface IKioskAppData  extends IDocument {
  readonly __typename?: 'KioskAppData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly blacklistCharacterReplaceRules: Maybe<ReadonlyArray<Maybe<IBlacklistCharacterReplaceRule>>>,
  readonly userNameBlacklist: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface IKioskAppDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ILanguageSelectorWidget {
  readonly __typename?: 'LanguageSelectorWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface ILaunchDarklyNavigationLink {
  readonly __typename?: 'LaunchDarklyNavigationLink',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly enabled: Maybe<Scalars['Boolean']>,
  readonly launchDarklyFlagDependency: Maybe<ILaunchDarklySelect>,
  readonly navLink: Maybe<ILinkWidget>,
}

export interface ILaunchDarklyNavigationTab {
  readonly __typename?: 'LaunchDarklyNavigationTab',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly enabled: Maybe<Scalars['Boolean']>,
  readonly launchDarklyFlagDependency: Maybe<ILaunchDarklySelect>,
  readonly tabIcon: Maybe<ILocaleImage>,
  readonly tabIconActive: Maybe<ILocaleImage>,
  readonly tabLink: Maybe<ILinkWidget>,
}

export interface ILaunchDarklySelect {
  readonly __typename?: 'LaunchDarklySelect',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly launchDarklyFlag: Maybe<Scalars['String']>,
}

export interface ILimit {
  readonly __typename?: 'Limit',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly interval: Maybe<Scalars['String']>,
  readonly limitInterval: Maybe<Scalars['String']>,
  readonly maximumRedemptions: Maybe<Scalars['Float']>,
  readonly multiplier: Maybe<Scalars['Float']>,
  readonly resetAt: Maybe<Scalars['String']>,
}

export interface ILink {
  readonly __typename?: 'Link',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly link: Maybe<Scalars['String']>,
  readonly title: Maybe<Scalars['String']>,
}

export interface ILinkAction {
  readonly __typename?: 'LinkAction',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly actionText: Maybe<ILocaleString>,
  readonly actionUrl: Maybe<ILocaleUrl>,
  readonly route: Maybe<Scalars['String']>,
}

export interface ILinkCardFaqSection {
  readonly __typename?: 'LinkCardFaqSection',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly marketingTileList: Maybe<IMarketingTileList>,
  readonly subtitle: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILinkCardSection {
  readonly __typename?: 'LinkCardSection',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly ctaButtonLabel: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly subtitle: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILinkPhysicalCardUi  extends IDocument {
  readonly __typename?: 'LinkPhysicalCardUi',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly linkCardFaqSection: Maybe<ILinkCardFaqSection>,
  readonly linkCardSectionLinkedState: Maybe<ILinkCardSection>,
  readonly linkCardSectionUnlinkedState: Maybe<ILinkCardSection>,
}

export interface ILinkPhysicalCardUiFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ILinkWidget {
  readonly __typename?: 'LinkWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly link: Maybe<ILocaleUrl>,
  readonly text: Maybe<ILocaleString>,
}

export interface IListItem {
  readonly __typename?: 'ListItem',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly title: Maybe<Scalars['String']>,
  readonly value: Maybe<Scalars['String']>,
}

export interface ILoader {
  readonly __typename?: 'Loader',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly desktopGraphic: Maybe<IImage>,
  readonly mobileGraphic: Maybe<IImage>,
  readonly text: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoadingGraphics {
  readonly __typename?: 'LoadingGraphics',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly cartInitialLoader: Maybe<ILoader>,
  readonly cartPricingLoader: Maybe<ILoader>,
}

export interface ILocaleBlockContent {
  readonly __typename?: 'LocaleBlockContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly deRaw: Maybe<Scalars['JSON']>,
  readonly enRaw: Maybe<Scalars['JSON']>,
  readonly frRaw: Maybe<Scalars['JSON']>,
  readonly itRaw: Maybe<Scalars['JSON']>,
}

export interface ILocaleBlockTextWidget {
  readonly __typename?: 'LocaleBlockTextWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly blockTextInversion: Maybe<Scalars['Boolean']>,
  readonly localeBlockTextContent: Maybe<ILocaleBlockContent>,
}

export interface ILocaleFile {
  readonly __typename?: 'LocaleFile',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<IFile>,
  readonly en: Maybe<IFile>,
  readonly fr: Maybe<IFile>,
  readonly it: Maybe<IFile>,
}

export interface ILocaleImage {
  readonly __typename?: 'LocaleImage',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<IImage>,
  readonly en: Maybe<IImage>,
  readonly fr: Maybe<IImage>,
  readonly it: Maybe<IImage>,
}

export interface ILocaleImages {
  readonly __typename?: 'LocaleImages',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<IImages>,
  readonly en: Maybe<IImages>,
  readonly fr: Maybe<IImages>,
  readonly it: Maybe<IImages>,
}

export interface ILocaleSlug {
  readonly __typename?: 'LocaleSlug',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<ISlug>,
  readonly en: Maybe<ISlug>,
  readonly fr: Maybe<ISlug>,
  readonly it: Maybe<ISlug>,
}

export interface ILocaleSmartBlockContent {
  readonly __typename?: 'LocaleSmartBlockContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly deRaw: Maybe<Scalars['JSON']>,
  readonly enRaw: Maybe<Scalars['JSON']>,
  readonly frRaw: Maybe<Scalars['JSON']>,
  readonly itRaw: Maybe<Scalars['JSON']>,
}

export interface ILocaleSmartTextField {
  readonly __typename?: 'LocaleSmartTextField',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<Scalars['String']>,
  readonly en: Maybe<Scalars['String']>,
  readonly fr: Maybe<Scalars['String']>,
  readonly it: Maybe<Scalars['String']>,
}

export interface ILocaleString {
  readonly __typename?: 'LocaleString',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<Scalars['String']>,
  readonly en: Maybe<Scalars['String']>,
  readonly fr: Maybe<Scalars['String']>,
  readonly it: Maybe<Scalars['String']>,
}

export interface ILocaleTypographyBlock {
  readonly __typename?: 'LocaleTypographyBlock',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly deRaw: Maybe<Scalars['JSON']>,
  readonly enRaw: Maybe<Scalars['JSON']>,
  readonly frRaw: Maybe<Scalars['JSON']>,
  readonly itRaw: Maybe<Scalars['JSON']>,
}

export interface ILocaleUrl {
  readonly __typename?: 'LocaleUrl',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<Scalars['String']>,
  readonly en: Maybe<Scalars['String']>,
  readonly fr: Maybe<Scalars['String']>,
  readonly it: Maybe<Scalars['String']>,
}

export interface ILockedOffers  extends IDocument {
  readonly __typename?: 'LockedOffers',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface ILockedOffersFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ILockedOffersPanel {
  readonly __typename?: 'LockedOffersPanel',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly completedChallengeDescription: Maybe<ILocaleBlockContent>,
  readonly completedChallengeHeader: Maybe<ILocaleBlockContent>,
}

export interface ILogsConfig {
  readonly __typename?: 'LogsConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly clientToken: Maybe<Scalars['String']>,
  readonly dataCenter: Maybe<Scalars['String']>,
}

export interface ILoyaltyBasicCardWidget {
  readonly __typename?: 'LoyaltyBasicCardWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly linkedCard: Maybe<IMarketingTileBasic>,
  readonly unlinkedCard: Maybe<IMarketingTileBasic>,
}

export type ILoyaltyBasicCardWidgetOrLoyaltyButtonWidgetOrLoyaltyCartWidgetOrLoyaltyImageWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyPaymentMethodWidgetOrLoyaltyQrCodeWidgetOrLoyaltyQrScanButtonWidgetOrLoyaltyQrScanHeaderWidgetOrLoyaltyShortCodeWidgetOrLoyaltyTextWidgetOrLoyaltyTitleWidget = ILoyaltyBasicCardWidget | ILoyaltyButtonWidget | ILoyaltyCartWidget | ILoyaltyImageWidget | ILoyaltyMarketingTileGroupWidget | ILoyaltyPaymentMethodWidget | ILoyaltyQrCodeWidget | ILoyaltyQrScanButtonWidget | ILoyaltyQrScanHeaderWidget | ILoyaltyShortCodeWidget | ILoyaltyTextWidget | ILoyaltyTitleWidget;

export interface ILoyaltyBetweenTimes {
  readonly __typename?: 'LoyaltyBetweenTimes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly endTime: Maybe<Scalars['DateTime']>,
  readonly startTime: Maybe<Scalars['DateTime']>,
}

export interface ILoyaltyButtonWidget {
  readonly __typename?: 'LoyaltyButtonWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly link: Maybe<ILinkWidget>,
}

export interface ILoyaltyCartWidget {
  readonly __typename?: 'LoyaltyCartWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
}

export interface ILoyaltyConfiguration  extends IDocument {
  readonly __typename?: 'LoyaltyConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly bankMyRewardTier: Maybe<ITier>,
  readonly categories: Maybe<ReadonlyArray<Maybe<ICategory>>>,
  readonly defaultTier: Maybe<ITier>,
  readonly name: Maybe<ILocaleString>,
  readonly onboardingQuickSelectTiers: Maybe<ReadonlyArray<Maybe<ITier>>>,
}

export interface ILoyaltyConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly bankMyRewardTier?: Maybe<Scalars['ID']>,
  readonly defaultTier?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyContent  extends IDocument {
  readonly __typename?: 'LoyaltyContent',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly addCardHeaderText: Maybe<ILocaleString>,
  readonly addCardImage: Maybe<ILocaleImages>,
  readonly addCardSkipText: Maybe<ILocaleString>,
  readonly addCardTextBlock: Maybe<ILocaleBlockContent>,
  readonly birthdayLegalText: Maybe<ILocaleString>,
  readonly detailsIconFour: Maybe<ILocaleImage>,
  readonly detailsIconOne: Maybe<ILocaleImage>,
  readonly detailsIconThree: Maybe<ILocaleImage>,
  readonly detailsIconTwo: Maybe<ILocaleImage>,
  readonly detailsInstructionsFour: Maybe<ILocaleString>,
  readonly detailsInstructionsOne: Maybe<ILocaleString>,
  readonly detailsInstructionsThree: Maybe<ILocaleString>,
  readonly detailsInstructionsTwo: Maybe<ILocaleString>,
  readonly detailsPageHeroImage: Maybe<ILocaleImage>,
  readonly detailsPageHeroImageMobile: Maybe<ILocaleImage>,
  readonly detailsPageHeroImageWeb: Maybe<ILocaleImage>,
  readonly detailsSetupPageSubtext: Maybe<ILocaleString>,
  readonly detailsSetupPageText: Maybe<ILocaleString>,
  readonly detailsTabName: Maybe<ILocaleString>,
  readonly historyPageSubtext: Maybe<ILocaleString>,
  readonly historyPageText: Maybe<ILocaleString>,
  readonly historyTabName: Maybe<ILocaleString>,
  readonly lostCardSectionBlockText: Maybe<ILocaleBlockContent>,
  readonly lostCardSectionTitle: Maybe<ILocaleString>,
  readonly loyaltyCardSectionText: Maybe<ILocaleString>,
  readonly loyaltyCardSectionTitle: Maybe<ILocaleString>,
  readonly loyaltyProgramInstructionsBlockText: Maybe<ILocaleBlockContent>,
  readonly mainHeroLoyaltyImage: Maybe<ILocaleImage>,
  readonly mainHeroLoyaltySubtext: Maybe<ILocaleString>,
  readonly mainHeroLoyaltyText: Maybe<ILocaleString>,
  readonly name: Maybe<Scalars['String']>,
  readonly newPointsDisclaimerTextBlock: Maybe<ILocaleBlockContent>,
  readonly newPointsImage: Maybe<ILocaleImages>,
  readonly newPointsTextBlockBottom: Maybe<ILocaleBlockContent>,
  readonly newPointsTextBlockTop: Maybe<ILocaleBlockContent>,
  readonly onboardingBackgroundImage: Maybe<ILocaleImages>,
  readonly onboardingButtonLink: Maybe<Scalars['String']>,
  readonly onboardingButtonText: Maybe<ILocaleString>,
  readonly onboardingContentCardBackgroundImage: Maybe<ILocaleImages>,
  readonly onboardingImage: Maybe<ILocaleImages>,
  readonly onboardingTextBlock: Maybe<ILocaleBlockContent>,
  readonly onboardingTimsRewardHeaderImage: Maybe<ILocaleImages>,
  readonly pointsUpdateText: Maybe<ILocaleString>,
  readonly registerCardImage: Maybe<ILocaleImage>,
  readonly registerCardSectionBlockText: Maybe<ILocaleBlockContent>,
  readonly registerCardSectionTitle: Maybe<ILocaleString>,
  readonly rewardSetupPageBlockText: Maybe<ILocaleBlockContent>,
  readonly rewardSetupPageSubtext: Maybe<ILocaleString>,
  readonly rewardSetupPageText: Maybe<ILocaleString>,
  readonly rewardSetupTabName: Maybe<ILocaleString>,
  readonly rewardsUnavailableBlockText: Maybe<ILocaleBlockContent>,
  readonly seeMoreOptionsText: Maybe<ILocaleString>,
  readonly tierCardTextBlock: Maybe<ILocaleBlockContent>,
  readonly tierHeaderText: Maybe<ILocaleString>,
  readonly timsRewardsImage: Maybe<ILocaleImage>,
  readonly timsRewardsLevelImage: Maybe<ILocaleImages>,
}

export interface ILoyaltyContentFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly onboardingButtonLink?: Maybe<Scalars['String']>,
  readonly onboardingButtonLink_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly onboardingButtonLink_matches?: Maybe<Scalars['String']>,
  readonly onboardingButtonLink_not?: Maybe<Scalars['String']>,
  readonly onboardingButtonLink_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ILoyaltyDashboard {
  readonly __typename?: 'LoyaltyDashboard',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly widgets: Maybe<ReadonlyArray<Maybe<ILoyaltyDoubleButtonWidgetOrLoyaltyGreetingWidgetOrLoyaltyHistoryWidgetOrLoyaltyLinkWidgetOrLoyaltyLogoWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyNotificationsWidgetOrLoyaltyPointsAndRewardsWidgetOrLoyaltyPointsMeterWidgetOrLoyaltyQuestsWidgetOrLoyaltyTiersWidgetOrRewardsListWidget>>>,
}

export interface ILoyaltyDoubleButtonWidget {
  readonly __typename?: 'LoyaltyDoubleButtonWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly leftButtonPath: Maybe<ILocaleString>,
  readonly leftButtonText: Maybe<ILocaleString>,
  readonly rightButtonPath: Maybe<ILocaleString>,
  readonly rightButtonText: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export type ILoyaltyDoubleButtonWidgetOrLoyaltyGreetingWidgetOrLoyaltyHistoryWidgetOrLoyaltyLinkWidgetOrLoyaltyLogoWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyNotificationsWidgetOrLoyaltyPointsAndRewardsWidgetOrLoyaltyPointsMeterWidgetOrLoyaltyQuestsWidgetOrLoyaltyTiersWidgetOrRewardsListWidget = ILoyaltyDoubleButtonWidget | ILoyaltyGreetingWidget | ILoyaltyHistoryWidget | ILoyaltyLinkWidget | ILoyaltyLogoWidget | ILoyaltyMarketingTileGroupWidget | ILoyaltyNotificationsWidget | ILoyaltyPointsAndRewardsWidget | ILoyaltyPointsMeterWidget | ILoyaltyQuestsWidget | ILoyaltyTiersWidget | IRewardsListWidget;

export interface ILoyaltyGreetingWidget {
  readonly __typename?: 'LoyaltyGreetingWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyHistoryWidget {
  readonly __typename?: 'LoyaltyHistoryWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyImageWidget {
  readonly __typename?: 'LoyaltyImageWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly image: Maybe<ILocaleImage>,
}

export interface ILoyaltyInRestaurantRedemption {
  readonly __typename?: 'LoyaltyInRestaurantRedemption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bottomWidgets: Maybe<ReadonlyArray<Maybe<ILoyaltyBasicCardWidgetOrLoyaltyButtonWidgetOrLoyaltyCartWidgetOrLoyaltyImageWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyPaymentMethodWidgetOrLoyaltyQrCodeWidgetOrLoyaltyQrScanButtonWidgetOrLoyaltyQrScanHeaderWidgetOrLoyaltyShortCodeWidgetOrLoyaltyTextWidgetOrLoyaltyTitleWidget>>>,
  readonly topWidgets: Maybe<ReadonlyArray<Maybe<ILoyaltyBasicCardWidgetOrLoyaltyButtonWidgetOrLoyaltyCartWidgetOrLoyaltyImageWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyPaymentMethodWidgetOrLoyaltyQrCodeWidgetOrLoyaltyQrScanButtonWidgetOrLoyaltyQrScanHeaderWidgetOrLoyaltyShortCodeWidgetOrLoyaltyTextWidgetOrLoyaltyTitleWidget>>>,
}

export interface ILoyaltyLinkWidget {
  readonly __typename?: 'LoyaltyLinkWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly links: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyLogoWidget {
  readonly __typename?: 'LoyaltyLogoWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
}

export interface ILoyaltyMarketingTileGroupWidget {
  readonly __typename?: 'LoyaltyMarketingTileGroupWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly marketingTileGroup: Maybe<IMarketingTileGroup>,
  readonly marketingTileWidgetDisclaimer: Maybe<ILocaleBlockContent>,
  readonly marketingTileWidgetTitle: Maybe<ILocaleString>,
}

export interface ILoyaltyNotAvailableAtThisRestaurant {
  readonly __typename?: 'LoyaltyNotAvailableAtThisRestaurant',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly firstButtonText: Maybe<ILocaleString>,
  readonly firstRedirectPath: Maybe<ILocaleUrl>,
  readonly image: Maybe<ILocaleImages>,
  readonly secondButtonText: Maybe<ILocaleString>,
  readonly secondRedirectPath: Maybe<ILocaleUrl>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyNotificationsWidget {
  readonly __typename?: 'LoyaltyNotificationsWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly notifications: Maybe<ReadonlyArray<Maybe<IRewardOrSystemwideOfferOrSystemwidePromotion>>>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyOffersUi  extends IDocument {
  readonly __typename?: 'LoyaltyOffersUI',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly endOfOffersLoggedIn: Maybe<IEndOfOffersLoggedIn>,
  readonly endOfOffersLoggedOut: Maybe<IEndOfOffersLoggedOut>,
  readonly globalOfferCooldownContent: Maybe<IGlobalOfferCooldownContent>,
  readonly offerNotAvailableModalContent: Maybe<IIncentiveNotAvailableModalContent>,
  readonly rewardNotAvailableModalContent: Maybe<IIncentiveNotAvailableModalContent>,
  readonly sortedSystemwideOffers: Maybe<ReadonlyArray<Maybe<ISystemwideOffer>>>,
}

export interface ILoyaltyOffersUiFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyPaymentMethodWidget {
  readonly __typename?: 'LoyaltyPaymentMethodWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyPoints {
  readonly __typename?: 'LoyaltyPoints',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly points: Maybe<Scalars['Float']>,
}

export interface ILoyaltyPointsAndRewardsWidget {
  readonly __typename?: 'LoyaltyPointsAndRewardsWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyPointsMeterWidget {
  readonly __typename?: 'LoyaltyPointsMeterWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly ctaButton: Maybe<IActionButton>,
  readonly imageBackground: Maybe<IImageBackground>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyQrCodeWidget {
  readonly __typename?: 'LoyaltyQRCodeWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly expirationMessage: Maybe<ILocaleString>,
  readonly subtitle: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyQrScanButtonWidget {
  readonly __typename?: 'LoyaltyQRScanButtonWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly expirationMessage: Maybe<ILocaleString>,
  readonly link: Maybe<ILinkWidget>,
  readonly subtitle: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyQrScanHeaderWidget {
  readonly __typename?: 'LoyaltyQRScanHeaderWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly expirationMessage: Maybe<ILocaleString>,
  readonly link: Maybe<ILinkWidget>,
  readonly subtitle: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyQuestsWidget {
  readonly __typename?: 'LoyaltyQuestsWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyReceipts  extends IDocument {
  readonly __typename?: 'LoyaltyReceipts',
  readonly CARROLS: Maybe<ILoyaltyReceiptVariants>,
  readonly NCR: Maybe<ILoyaltyReceiptVariants>,
  readonly QDI: Maybe<ILoyaltyReceiptVariants>,
  readonly RPOS: Maybe<ILoyaltyReceiptVariants>,
  readonly SICOM: Maybe<ILoyaltyReceiptVariants>,
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly claimed: Maybe<ILoyaltyTransactionReceipt>,
  readonly mobile: Maybe<ILoyaltyTransactionReceipt>,
  readonly unclaimed: Maybe<ILoyaltyTransactionReceipt>,
}

export interface ILoyaltyReceiptsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyReceiptVariants {
  readonly __typename?: 'LoyaltyReceiptVariants',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly claimed: Maybe<ILoyaltyTransactionReceipt>,
  readonly mobile: Maybe<ILoyaltyTransactionReceipt>,
  readonly unclaimed: Maybe<ILoyaltyTransactionReceipt>,
}

export interface ILoyaltyShortCodeWidget {
  readonly __typename?: 'LoyaltyShortCodeWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly alternativeTitle: Maybe<ILocaleString>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly defaultCode: Maybe<ILocaleString>,
  readonly subtitle: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyTextWidget {
  readonly __typename?: 'LoyaltyTextWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly text: Maybe<ILocaleString>,
}

export interface ILoyaltyTiersWidget {
  readonly __typename?: 'LoyaltyTiersWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly sortByPointValue: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyTitleWidget {
  readonly __typename?: 'LoyaltyTitleWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoyaltyTransactionReceipt {
  readonly __typename?: 'LoyaltyTransactionReceipt',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly footer: Maybe<ILocaleString>,
  readonly guestDisplay: Maybe<ILocaleString>,
  readonly header: Maybe<ILocaleString>,
  readonly identifierPrefix: Maybe<ILocaleString>,
  readonly marketing: Maybe<ILocaleString>,
  readonly operatorDisplay: Maybe<ILocaleString>,
  readonly pointsEarnedPrefix: Maybe<ILocaleString>,
  readonly pointsRedeemedPrefix: Maybe<ILocaleString>,
  readonly qrCode: Maybe<ILocaleString>,
  readonly totalPointsPrefix: Maybe<ILocaleString>,
}

export interface ILoyaltyUi  extends IDocument {
  readonly __typename?: 'LoyaltyUI',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly featuredRewards: Maybe<IRewardsSection>,
  readonly imageBackground: Maybe<IImageBackground>,
  readonly loyaltyDashboard: Maybe<ILoyaltyDashboard>,
  readonly loyaltyInRestaurantRedemption: Maybe<ILoyaltyInRestaurantRedemption>,
  readonly loyaltyNotAvailableAtThisRestaurant: Maybe<ILoyaltyNotAvailableAtThisRestaurant>,
  readonly noRewardPoints: Maybe<IEmptyState>,
  readonly notEnrolledState: Maybe<IEmptyState>,
  readonly notEnrolledStateMobile: Maybe<IEmptyState>,
  readonly optInModal: Maybe<IOptInModalContent>,
  readonly optInModalError: Maybe<IOptInModalContent>,
  readonly optInModalLoading: Maybe<IOptInModalLoading>,
  readonly overrideShortCodeModalContent: Maybe<IOverrideShortCodeModalContent>,
  readonly rewardsLearnMoreIcon: Maybe<ILocaleImage>,
  readonly rewardsLogo: Maybe<ILocaleImage>,
  readonly shortCodeConfirmationModalContent: Maybe<IShortCodeConfirmationModalContent>,
  readonly surpriseAndDelightModalContent: Maybe<ISurpriseAndDelightModalContent>,
  readonly swapModalContent: Maybe<ISwapModalContent>,
}

export interface ILoyaltyUiFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly featuredRewards?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly noRewardPoints?: Maybe<Scalars['ID']>,
  readonly notEnrolledState?: Maybe<Scalars['ID']>,
  readonly notEnrolledStateMobile?: Maybe<Scalars['ID']>,
}

export interface IMainHero  extends IDocument {
  readonly __typename?: 'MainHero',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly action: Maybe<ILinkAction>,
  readonly actionLeft: Maybe<ILinkAction>,
  readonly actionLeftIcon: Maybe<ILocaleImage>,
  readonly actionRight: Maybe<ILinkAction>,
  readonly actionRightIcon: Maybe<ILocaleImage>,
  readonly image: Maybe<ILocaleImage>,
  readonly kioskImage: Maybe<ILocaleImage>,
  readonly loyaltyAction: Maybe<ILinkAction>,
  readonly mainText: Maybe<ILocaleString>,
  readonly maskCards: Maybe<ReadonlyArray<Maybe<ISimpleCard>>>,
  readonly mobileImage: Maybe<ILocaleImage>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly subText: Maybe<ILocaleString>,
  readonly superText: Maybe<ILocaleString>,
  readonly textColor: Maybe<Scalars['String']>,
}

export interface IMainHeroFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textColor?: Maybe<Scalars['String']>,
  readonly textColor_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textColor_matches?: Maybe<Scalars['String']>,
  readonly textColor_not?: Maybe<Scalars['String']>,
  readonly textColor_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IMarketingCard  extends IDocument {
  readonly __typename?: 'MarketingCard',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundColor: Maybe<IColor>,
  readonly buttonBackgroundColor: Maybe<IColor>,
  readonly buttonTextColor: Maybe<IColor>,
  readonly callToAction: Maybe<ILinkAction>,
  readonly description: Maybe<ILocaleString>,
  readonly hasCustomColors: Maybe<Scalars['Boolean']>,
  readonly hasTerms: Maybe<Scalars['Boolean']>,
  readonly header: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImages>,
  readonly termsButton: Maybe<ILinkAction>,
  readonly termsText: Maybe<ILocaleBlockContent>,
  readonly textColor: Maybe<IColor>,
}

export interface IMarketingCardFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly hasCustomColors?: Maybe<Scalars['Boolean']>,
  readonly hasCustomColors_not?: Maybe<Scalars['Boolean']>,
  readonly hasTerms?: Maybe<Scalars['Boolean']>,
  readonly hasTerms_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IMarketingCardGroup  extends IDocument {
  readonly __typename?: 'MarketingCardGroup',
  readonly Cards: Maybe<ReadonlyArray<Maybe<IMarketingCard>>>,
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IMarketingCardGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IMarketingTile  extends IDocument {
  readonly __typename?: 'MarketingTile',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<ILocaleImages>,
  readonly buttonAction: Maybe<ILinkAction>,
  readonly buttonAlignment: Maybe<Scalars['String']>,
  readonly lockedAspectRatio: Maybe<Scalars['Boolean']>,
  readonly ruleSet: Maybe<IMarketingTileRuleSet>,
  readonly termsButton: Maybe<ILinkAction>,
  readonly termsText: Maybe<ILocaleBlockContent>,
  readonly textAlignment: Maybe<Scalars['String']>,
  readonly textBlock: Maybe<ILocaleTypographyBlock>,
  readonly textColor: Maybe<Scalars['String']>,
}

export interface IMarketingTileBasic  extends IDocument {
  readonly __typename?: 'MarketingTileBasic',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly link: Maybe<ILocaleUrl>,
  readonly marketingBasicTileDescription: Maybe<ILocaleTypographyBlock>,
  readonly marketingBasicTileImage: Maybe<ILocaleImages>,
  readonly marketingBasicTileTitle: Maybe<ILocaleString>,
}

export interface IMarketingTileBasicFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IMarketingTileCarousel  extends IDocument {
  readonly __typename?: 'MarketingTileCarousel',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly header: Maybe<ILocaleString>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly tiles: Maybe<ReadonlyArray<Maybe<IMarketingTileBasic>>>,
}

export interface IMarketingTileCarouselFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IMarketingTileFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly buttonAlignment?: Maybe<Scalars['String']>,
  readonly buttonAlignment_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly buttonAlignment_matches?: Maybe<Scalars['String']>,
  readonly buttonAlignment_not?: Maybe<Scalars['String']>,
  readonly buttonAlignment_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly lockedAspectRatio?: Maybe<Scalars['Boolean']>,
  readonly lockedAspectRatio_not?: Maybe<Scalars['Boolean']>,
  readonly textAlignment?: Maybe<Scalars['String']>,
  readonly textAlignment_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textAlignment_matches?: Maybe<Scalars['String']>,
  readonly textAlignment_not?: Maybe<Scalars['String']>,
  readonly textAlignment_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textColor?: Maybe<Scalars['String']>,
  readonly textColor_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textColor_matches?: Maybe<Scalars['String']>,
  readonly textColor_not?: Maybe<Scalars['String']>,
  readonly textColor_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IMarketingTileGroup  extends IDocument {
  readonly __typename?: 'MarketingTileGroup',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly tiles: Maybe<ReadonlyArray<Maybe<IMarketingTileOrMarketingTileBasicOrMarketingTileListOrMarketingTilePairOrMarketingTileQuad>>>,
}

export interface IMarketingTileGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IMarketingTileList {
  readonly __typename?: 'MarketingTileList',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly tiles: Maybe<ReadonlyArray<Maybe<IMarketingTileBasic>>>,
}

export type IMarketingTileOrMarketingTileBasic = IMarketingTile | IMarketingTileBasic;

export type IMarketingTileOrMarketingTileBasicOrMarketingTileListOrMarketingTilePairOrMarketingTileQuad = IMarketingTile | IMarketingTileBasic | IMarketingTileList | IMarketingTilePair | IMarketingTileQuad;

export interface IMarketingTilePair {
  readonly __typename?: 'MarketingTilePair',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly left: Maybe<IMarketingTile>,
  readonly right: Maybe<IMarketingTile>,
}

export interface IMarketingTileQuad {
  readonly __typename?: 'MarketingTileQuad',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bottomLeftTile: Maybe<IMarketingTileBasic>,
  readonly bottomRightTile: Maybe<IMarketingTileBasic>,
  readonly topLeftTile: Maybe<IMarketingTileBasic>,
  readonly topRightTile: Maybe<IMarketingTileBasic>,
}

export interface IMarketingTileRuleSet {
  readonly __typename?: 'MarketingTileRuleSet',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly betweenTimes: Maybe<IBetweenTimes>,
  readonly dayOfWeek: Maybe<IDayOfWeekBand>,
}

export interface IMediaTag  extends IDocument {
  readonly __typename?: 'MediaTag',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<ISlug>,
}

export interface IMediaTagFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IMenu  extends IDocument {
  readonly __typename?: 'Menu',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly headerSuperText: Maybe<ILocaleString>,
  readonly headerText: Maybe<ILocaleString>,
  readonly image: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IComboOrItemOrPickerOrSection>>>,
  readonly pickerBackgroundImage: Maybe<IImage>,
}

export interface IMenuFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IMenuObjectSettings {
  readonly __typename?: 'MenuObjectSettings',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly limitPerOrder: Maybe<Scalars['Float']>,
}

export interface IModifier  extends IDocument {
  readonly __typename?: 'Modifier',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly name: Maybe<ILocaleString>,
  readonly region: Maybe<Scalars['String']>,
  readonly specificationName: Maybe<Scalars['String']>,
  readonly specificationNumber: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IModifierFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly region?: Maybe<Scalars['String']>,
  readonly region_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly region_matches?: Maybe<Scalars['String']>,
  readonly region_not?: Maybe<Scalars['String']>,
  readonly region_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly specificationName?: Maybe<Scalars['String']>,
  readonly specificationName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly specificationName_matches?: Maybe<Scalars['String']>,
  readonly specificationName_not?: Maybe<Scalars['String']>,
  readonly specificationName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly specificationNumber?: Maybe<Scalars['String']>,
  readonly specificationNumber_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly specificationNumber_matches?: Maybe<Scalars['String']>,
  readonly specificationNumber_not?: Maybe<Scalars['String']>,
  readonly specificationNumber_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IModifierMultiplier  extends IDocument {
  readonly __typename?: 'ModifierMultiplier',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly modifier: Maybe<IModifier>,
  readonly multiplier: Maybe<Scalars['Float']>,
  readonly prefix: Maybe<ILocaleString>,
  readonly region: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IModifierMultiplierFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly modifier?: Maybe<Scalars['ID']>,
  readonly multiplier?: Maybe<Scalars['Float']>,
  readonly multiplier_gt?: Maybe<Scalars['Float']>,
  readonly multiplier_gte?: Maybe<Scalars['Float']>,
  readonly multiplier_lt?: Maybe<Scalars['Float']>,
  readonly multiplier_lte?: Maybe<Scalars['Float']>,
  readonly multiplier_not?: Maybe<Scalars['Float']>,
  readonly region?: Maybe<Scalars['String']>,
  readonly region_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly region_matches?: Maybe<Scalars['String']>,
  readonly region_not?: Maybe<Scalars['String']>,
  readonly region_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IMultiWidget {
  readonly __typename?: 'MultiWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly widget: Maybe<Scalars['String']>,
}

export interface INavigationDesktop {
  readonly __typename?: 'NavigationDesktop',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly aboutMenuEntries: Maybe<INavigationSection>,
  readonly navigationLinks: Maybe<ReadonlyArray<Maybe<INavigationDesktopLink>>>,
}

export interface INavigationDesktopLink {
  readonly __typename?: 'NavigationDesktopLink',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly hideLinkBasedOnLdFlag: Maybe<ILaunchDarklySelect>,
  readonly launchDarklyAlternateNavigationLink: Maybe<ILaunchDarklyNavigationLink>,
  readonly navLink: Maybe<ILinkWidget>,
}

export interface INavigationMobile {
  readonly __typename?: 'NavigationMobile',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly aboutMenuEntries: Maybe<INavigationSection>,
  readonly navigationTabs: Maybe<ReadonlyArray<Maybe<INavigationMobileTab>>>,
}

export interface INavigationMobileHeaderButton {
  readonly __typename?: 'NavigationMobileHeaderButton',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly icon: Maybe<ILocaleImage>,
  readonly iconActive: Maybe<ILocaleImage>,
  readonly link: Maybe<ILocaleUrl>,
}

export interface INavigationMobileTab {
  readonly __typename?: 'NavigationMobileTab',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly hideLinkBasedOnLdFlag: Maybe<ILaunchDarklySelect>,
  readonly launchDarklyAlternateMobileTab: Maybe<ILaunchDarklyNavigationTab>,
  readonly tabIcon: Maybe<ILocaleImage>,
  readonly tabIconActive: Maybe<ILocaleImage>,
  readonly tabLink: Maybe<ILinkWidget>,
}

export interface INavigationSection  extends IDocument {
  readonly __typename?: 'NavigationSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<ILocaleString>,
  readonly pages: Maybe<ReadonlyArray<Maybe<INavigationSectionOrStaticPage>>>,
}

export interface INavigationSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export type INavigationSectionOrStaticPage = INavigationSection | IStaticPage;

export interface INotificationDetails {
  readonly __typename?: 'NotificationDetails',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly enabled: Maybe<Scalars['Boolean']>,
  readonly image: Maybe<ILocaleImage>,
  readonly path: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface INutrition {
  readonly __typename?: 'Nutrition',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly calories: Maybe<Scalars['Float']>,
  readonly caloriesPer100: Maybe<Scalars['Float']>,
  readonly carbohydrates: Maybe<Scalars['Float']>,
  readonly carbohydratesPer100: Maybe<Scalars['Float']>,
  readonly cholesterol: Maybe<Scalars['Float']>,
  readonly energyKJ: Maybe<Scalars['Float']>,
  readonly energyKJPer100: Maybe<Scalars['Float']>,
  readonly fat: Maybe<Scalars['Float']>,
  readonly fatPer100: Maybe<Scalars['Float']>,
  readonly fiber: Maybe<Scalars['Float']>,
  readonly proteins: Maybe<Scalars['Float']>,
  readonly proteinsPer100: Maybe<Scalars['Float']>,
  readonly salt: Maybe<Scalars['Float']>,
  readonly saltPer100: Maybe<Scalars['Float']>,
  readonly saturatedFat: Maybe<Scalars['Float']>,
  readonly saturatedFatPer100: Maybe<Scalars['Float']>,
  readonly sodium: Maybe<Scalars['Float']>,
  readonly sugar: Maybe<Scalars['Float']>,
  readonly sugarPer100: Maybe<Scalars['Float']>,
  readonly transFat: Maybe<Scalars['Float']>,
  readonly weight: Maybe<Scalars['Float']>,
}

export interface INutritionalSection  extends IDocument {
  readonly __typename?: 'NutritionalSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<ILocaleString>,
  readonly products: Maybe<ReadonlyArray<Maybe<IItemOrNutritionalSection>>>,
}

export interface INutritionalSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface INutritionExplorerWidget {
  readonly __typename?: 'NutritionExplorerWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly categoryWhitelist: Maybe<ReadonlyArray<Maybe<IPickerOrSection>>>,
  readonly madLibFilterGroup: Maybe<IFilterGroup>,
  readonly menu: Maybe<IMenu>,
  readonly modalFilterGroups: Maybe<ReadonlyArray<Maybe<IFilterGroup>>>,
  readonly moreOptionsButtonText: Maybe<ILocaleString>,
  readonly tastySwaps: Maybe<ITastySwaps>,
  readonly viewMenuButtonText: Maybe<ILocaleString>,
}

export interface INutritionInfoWidget {
  readonly __typename?: 'NutritionInfoWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly nutritionalSection: Maybe<INutritionalSection>,
}

export interface INutritionItem {
  readonly __typename?: 'NutritionItem',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly additionalItems: Maybe<ReadonlyArray<Maybe<INutritionItem>>>,
  readonly name: Maybe<ILocaleString>,
  readonly nutritionKey: Maybe<Scalars['String']>,
  readonly unit: Maybe<ILocaleString>,
}

export interface INutritionItemGroup {
  readonly __typename?: 'NutritionItemGroup',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly lineItems: Maybe<ReadonlyArray<Maybe<INutritionItem>>>,
  readonly mainItem: Maybe<INutritionItem>,
}

export type INutritionItemOrNutritionItemGroup = INutritionItem | INutritionItemGroup;

export interface INutritionTable {
  readonly __typename?: 'NutritionTable',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly items: Maybe<ReadonlyArray<Maybe<INutritionItemOrNutritionItemGroup>>>,
  readonly title: Maybe<ILocaleString>,
}

export interface IOffer  extends IDocument {
  readonly __typename?: 'Offer',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly activationDate: Maybe<Scalars['Date']>,
  readonly backgroundImage: Maybe<IImage>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly daypart: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly deactivationDate: Maybe<Scalars['Date']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly documentDescription: Maybe<Scalars['String']>,
  readonly forSupport: Maybe<Scalars['Boolean']>,
  readonly headerSuperText: Maybe<ILocaleString>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly incentives: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferActivationOrOfferDiscountOrOfferItemDiscountOrOfferLoyaltyActionOrPicker>>>,
  readonly internalName: Maybe<Scalars['String']>,
  readonly localizedImage: Maybe<ILocaleImages>,
  readonly lockedOffersPanel: Maybe<ILockedOffersPanel>,
  readonly marketPrice: Maybe<IComboOrItem>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly mustBeAssigned: Maybe<Scalars['Boolean']>,
  readonly name: Maybe<ILocaleBlockContent>,
  readonly offerCTA: Maybe<ILinkAction>,
  readonly offerPrice: Maybe<Scalars['Float']>,
  readonly offerTags: Maybe<ReadonlyArray<Maybe<ITag>>>,
  readonly option: Maybe<IComboOrItemOrOfferActivationOrOfferDiscountOrOfferLoyaltyActionOrPicker>,
  readonly percentageDiscount: Maybe<Scalars['Boolean']>,
  readonly permutationPricingValidation: Maybe<IDataValidationObject>,
  readonly priceDistributionValidation: Maybe<IDataValidationObject>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
  readonly promoCodePanel: Maybe<IPromoCodePanel>,
  readonly redemptionMethod: Maybe<Scalars['String']>,
  readonly requirements: Maybe<IRequirements>,
  readonly restaurantAvailabilityValidation: Maybe<IDataValidationObject>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrAndOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrOrOrOrderHistoryOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>,
  readonly shortCode: Maybe<Scalars['String']>,
  readonly uiPattern: Maybe<Scalars['String']>,
  readonly upsellOptions: Maybe<ReadonlyArray<Maybe<IOffer>>>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IOfferActivation  extends IDocument {
  readonly __typename?: 'OfferActivation',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly fakeField: Maybe<Scalars['Boolean']>,
}

export interface IOfferActivationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly fakeField?: Maybe<Scalars['Boolean']>,
  readonly fakeField_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IOfferDiscount  extends IDocument {
  readonly __typename?: 'OfferDiscount',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly discountType: Maybe<Scalars['String']>,
  readonly discountValue: Maybe<Scalars['Float']>,
}

export interface IOfferDiscountFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly discountType?: Maybe<Scalars['String']>,
  readonly discountType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly discountType_matches?: Maybe<Scalars['String']>,
  readonly discountType_not?: Maybe<Scalars['String']>,
  readonly discountType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly discountValue?: Maybe<Scalars['Float']>,
  readonly discountValue_gt?: Maybe<Scalars['Float']>,
  readonly discountValue_gte?: Maybe<Scalars['Float']>,
  readonly discountValue_lt?: Maybe<Scalars['Float']>,
  readonly discountValue_lte?: Maybe<Scalars['Float']>,
  readonly discountValue_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IOfferFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly activationDate?: Maybe<Scalars['Date']>,
  readonly activationDate_gt?: Maybe<Scalars['Date']>,
  readonly activationDate_gte?: Maybe<Scalars['Date']>,
  readonly activationDate_lt?: Maybe<Scalars['Date']>,
  readonly activationDate_lte?: Maybe<Scalars['Date']>,
  readonly activationDate_not?: Maybe<Scalars['Date']>,
  readonly deactivationDate?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_not?: Maybe<Scalars['Date']>,
  readonly documentDescription?: Maybe<Scalars['String']>,
  readonly documentDescription_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly documentDescription_matches?: Maybe<Scalars['String']>,
  readonly documentDescription_not?: Maybe<Scalars['String']>,
  readonly documentDescription_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly forSupport?: Maybe<Scalars['Boolean']>,
  readonly forSupport_not?: Maybe<Scalars['Boolean']>,
  readonly internalName?: Maybe<Scalars['String']>,
  readonly internalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly internalName_matches?: Maybe<Scalars['String']>,
  readonly internalName_not?: Maybe<Scalars['String']>,
  readonly internalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly marketPrice?: Maybe<Scalars['ID']>,
  readonly mustBeAssigned?: Maybe<Scalars['Boolean']>,
  readonly mustBeAssigned_not?: Maybe<Scalars['Boolean']>,
  readonly offerPrice?: Maybe<Scalars['Float']>,
  readonly offerPrice_gt?: Maybe<Scalars['Float']>,
  readonly offerPrice_gte?: Maybe<Scalars['Float']>,
  readonly offerPrice_lt?: Maybe<Scalars['Float']>,
  readonly offerPrice_lte?: Maybe<Scalars['Float']>,
  readonly offerPrice_not?: Maybe<Scalars['Float']>,
  readonly option?: Maybe<Scalars['ID']>,
  readonly percentageDiscount?: Maybe<Scalars['Boolean']>,
  readonly percentageDiscount_not?: Maybe<Scalars['Boolean']>,
  readonly redemptionMethod?: Maybe<Scalars['String']>,
  readonly redemptionMethod_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly redemptionMethod_matches?: Maybe<Scalars['String']>,
  readonly redemptionMethod_not?: Maybe<Scalars['String']>,
  readonly redemptionMethod_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly shortCode?: Maybe<Scalars['String']>,
  readonly shortCode_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly shortCode_matches?: Maybe<Scalars['String']>,
  readonly shortCode_not?: Maybe<Scalars['String']>,
  readonly shortCode_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IOfferItemDiscount  extends IDocument {
  readonly __typename?: 'OfferItemDiscount',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly discountType: Maybe<Scalars['String']>,
  readonly discountValue: Maybe<Scalars['Float']>,
  readonly option: Maybe<IComboOrItemOrPicker>,
}

export interface IOfferItemDiscountFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly discountType?: Maybe<Scalars['String']>,
  readonly discountType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly discountType_matches?: Maybe<Scalars['String']>,
  readonly discountType_not?: Maybe<Scalars['String']>,
  readonly discountType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly discountValue?: Maybe<Scalars['Float']>,
  readonly discountValue_gt?: Maybe<Scalars['Float']>,
  readonly discountValue_gte?: Maybe<Scalars['Float']>,
  readonly discountValue_lt?: Maybe<Scalars['Float']>,
  readonly discountValue_lte?: Maybe<Scalars['Float']>,
  readonly discountValue_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly option?: Maybe<Scalars['ID']>,
}

export interface IOfferLoyaltyAction  extends IDocument {
  readonly __typename?: 'OfferLoyaltyAction',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly loyaltyType: Maybe<Scalars['String']>,
  readonly loyaltyValue: Maybe<Scalars['Float']>,
}

export interface IOfferLoyaltyActionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyType?: Maybe<Scalars['String']>,
  readonly loyaltyType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyType_matches?: Maybe<Scalars['String']>,
  readonly loyaltyType_not?: Maybe<Scalars['String']>,
  readonly loyaltyType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyValue?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_gt?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_gte?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_lt?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_lte?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_not?: Maybe<Scalars['Float']>,
}

export interface IOfferRequirementCode {
  readonly __typename?: 'OfferRequirementCode',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly shortCode: Maybe<Scalars['String']>,
}

export interface IOfferRequirementPlatform {
  readonly __typename?: 'OfferRequirementPlatform',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly platform: Maybe<Scalars['String']>,
}

export interface IOfferRequirementPurchase {
  readonly __typename?: 'OfferRequirementPurchase',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly option: Maybe<IComboOrItem>,
}

export interface IOfferRequirementUser {
  readonly __typename?: 'OfferRequirementUser',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly status: Maybe<Scalars['String']>,
}

export interface IOffersBrowsingPanel {
  readonly __typename?: 'OffersBrowsingPanel',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly emptyStateBody: Maybe<ILocaleString>,
  readonly emptyStateImage: Maybe<ILocaleImage>,
  readonly emptyStateTitle: Maybe<ILocaleString>,
  readonly endOfOffersImage: Maybe<ILocaleImage>,
  readonly endOfOffersMessage: Maybe<ILocaleString>,
  readonly offersSelectRestaurantCta: Maybe<IOffersSelectRestaurantCta>,
}

export interface IOffersDetailsPanel {
  readonly __typename?: 'OffersDetailsPanel',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly emptyStateAction: Maybe<ILinkAction>,
  readonly emptyStateBody: Maybe<ILocaleString>,
  readonly emptyStateImage: Maybe<ILocaleImage>,
  readonly emptyStateTitle: Maybe<ILocaleString>,
  readonly missingOfferAction: Maybe<ILinkAction>,
  readonly missingOfferBody: Maybe<ILocaleString>,
  readonly missingOfferImage: Maybe<ILocaleImage>,
  readonly missingOfferTitle: Maybe<ILocaleString>,
}

export interface IOffersPageMarketingTile {
  readonly __typename?: 'OffersPageMarketingTile',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly customPosition: Maybe<Scalars['Float']>,
  readonly displayPosition: Maybe<Scalars['String']>,
  readonly marketingTileReference: Maybe<IMarketingTile>,
}

export interface IOffersSection  extends IDocument {
  readonly __typename?: 'OffersSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IOffersSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IOffersSelectRestaurantCta {
  readonly __typename?: 'OffersSelectRestaurantCta',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly ctaButtonText: Maybe<ILocaleString>,
  readonly link: Maybe<ILocaleUrl>,
  readonly minimumNumberOfOffers: Maybe<Scalars['Float']>,
  readonly title: Maybe<ILocaleString>,
}

export interface IOfferTemplate  extends IDocument {
  readonly __typename?: 'OfferTemplate',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<IImage>,
  readonly configIncentive: Maybe<IConfigOffer>,
  readonly description: Maybe<ILocaleSmartBlockContent>,
  readonly localizedImage: Maybe<ILocaleImages>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleSmartBlockContent>,
  readonly requiredRules: Maybe<IRequiredRules>,
  readonly templateType: Maybe<Scalars['String']>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
}

export interface IOfferTemplateFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly configIncentive?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly templateType?: Maybe<Scalars['String']>,
  readonly templateType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly templateType_matches?: Maybe<Scalars['String']>,
  readonly templateType_not?: Maybe<Scalars['String']>,
  readonly templateType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
}

export interface IOneTrustConfig {
  readonly __typename?: 'OneTrustConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly cookieCompliance: Maybe<ICookieComplianceConfig>,
}

export interface IOpAllergen {
  readonly __typename?: 'OpAllergen',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly celery: Maybe<Scalars['Float']>,
  readonly eggs: Maybe<Scalars['Float']>,
  readonly fish: Maybe<Scalars['Float']>,
  readonly gluten: Maybe<Scalars['Float']>,
  readonly lupin: Maybe<Scalars['Float']>,
  readonly milk: Maybe<Scalars['Float']>,
  readonly mustard: Maybe<Scalars['Float']>,
  readonly peanuts: Maybe<Scalars['Float']>,
  readonly sesame: Maybe<Scalars['Float']>,
  readonly shellfish: Maybe<Scalars['Float']>,
  readonly soy: Maybe<Scalars['Float']>,
  readonly sulphurDioxide: Maybe<Scalars['Float']>,
  readonly treeNuts: Maybe<Scalars['Float']>,
  readonly wheat: Maybe<Scalars['Float']>,
}

export interface IOpItem {
  readonly __typename?: 'OpItem',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly daypart: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly launchDate: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly product: Maybe<Scalars['String']>,
  readonly productNumber: Maybe<Scalars['Float']>,
}

export interface IOpPricingRegion  extends IDocument {
  readonly __typename?: 'OpPricingRegion',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<Scalars['String']>,
  readonly restaurants: Maybe<ReadonlyArray<Maybe<IRestaurant>>>,
}

export interface IOpPricingRegionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IOptInModalContent {
  readonly __typename?: 'OptInModalContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly blockText: Maybe<ILocaleBlockContent>,
  readonly buttonText: Maybe<ILocaleString>,
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImages>,
  readonly title: Maybe<ILocaleString>,
}

export interface IOptInModalLoading {
  readonly __typename?: 'OptInModalLoading',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface IOptInPrivacyPreferences {
  readonly __typename?: 'OptInPrivacyPreferences',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly key: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly view: Maybe<ILocaleString>,
}

export type IOptInPrivacyPreferencesOrOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum = IOptInPrivacyPreferences | IOptInSettingBoolean | IOptInSettingEmailAndPush | IOptInSettingEnum;

export interface IOptInSettingBoolean {
  readonly __typename?: 'OptInSettingBoolean',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly key: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
}

export type IOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum = IOptInSettingBoolean | IOptInSettingEmailAndPush | IOptInSettingEnum;

export interface IOptInSettingEmailAndPush {
  readonly __typename?: 'OptInSettingEmailAndPush',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly emailKey: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly pushKey: Maybe<Scalars['String']>,
}

export interface IOptInSettingEnum {
  readonly __typename?: 'OptInSettingEnum',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly enumStrings: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly key: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
}

export interface IOptionVisibilitySettings {
  readonly __typename?: 'OptionVisibilitySettings',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly toggleButtonTextClosed: Maybe<ILocaleString>,
  readonly toggleButtonTextOpen: Maybe<ILocaleString>,
  readonly visibleOptions: Maybe<Scalars['Float']>,
}

export interface IOr {
  readonly __typename?: 'Or',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>,
}

export interface IOrderHistory {
  readonly __typename?: 'OrderHistory',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly from: Maybe<Scalars['Date']>,
  readonly isSequential: Maybe<Scalars['Boolean']>,
  readonly lastNSeconds: Maybe<Scalars['Float']>,
  readonly rangeType: Maybe<Scalars['String']>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IAndOrBetweenTimesOrCartContainsPluOrCartPropertyOrDayOfWeekBandOrOrOrPaymentCardTypeOrPurchase>>>,
  readonly to: Maybe<Scalars['Date']>,
}

export interface IOurServices  extends IDocument {
  readonly __typename?: 'OurServices',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly ourServicesHeroImageLocale: Maybe<ILocaleImage>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly servicesHeaderTextLocale: Maybe<ILocaleString>,
  readonly servicesHeroTextLocale: Maybe<ILocaleString>,
}

export interface IOurServicesFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IOverrideShortCodeModalContent {
  readonly __typename?: 'OverrideShortCodeModalContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly confirmButton: Maybe<ILocaleString>,
  readonly discardButton: Maybe<ILocaleString>,
  readonly header: Maybe<ILocaleString>,
}

export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly childPlu: Maybe<Scalars['String']>,
  readonly plu: Maybe<Scalars['String']>,
}

export interface IPaymentCardType {
  readonly __typename?: 'PaymentCardType',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly cardType: Maybe<Scalars['String']>,
}

export interface IPaymentMethod {
  readonly __typename?: 'PaymentMethod',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly paymentMethod: Maybe<Scalars['String']>,
}

export interface IPaymentMethodDeletionModalText {
  readonly __typename?: 'PaymentMethodDeletionModalText',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly paymentMethodDeletionModalTextBody: Maybe<ILocaleBlockContent>,
  readonly paymentMethodDeletionModalTextHeader: Maybe<ILocaleString>,
}

export interface IPaymentsGatewayMerchantIdConfig {
  readonly __typename?: 'PaymentsGatewayMerchantIdConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly ca: Maybe<Scalars['String']>,
  readonly us: Maybe<Scalars['String']>,
}

export interface IPicker  extends IDocument {
  readonly __typename?: 'Picker',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly hideCalories: Maybe<Scalars['Boolean']>,
  readonly hideNutritionLegalDisclaimer: Maybe<Scalars['Boolean']>,
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly internalName: Maybe<Scalars['String']>,
  readonly isRealMeal: Maybe<Scalars['Boolean']>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IPickerOption>>>,
  readonly pickerAspectItemOptionMappings: Maybe<ReadonlyArray<Maybe<IPickerAspectItemOptions>>>,
  readonly pickerAspects: Maybe<ReadonlyArray<Maybe<IPickerAspect>>>,
  readonly pickerDefaults: Maybe<ReadonlyArray<Maybe<IPickerItemMapping>>>,
  readonly quickConfigs: Maybe<ReadonlyArray<Maybe<IQuickConfig>>>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
}

export interface IPickerAspect  extends IDocument {
  readonly __typename?: 'PickerAspect',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly internalName: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly pickerAspectOptions: Maybe<ReadonlyArray<Maybe<IPickerAspectValue>>>,
  readonly uiPattern: Maybe<Scalars['String']>,
}

export interface IPickerAspectFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly internalName?: Maybe<Scalars['String']>,
  readonly internalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly internalName_matches?: Maybe<Scalars['String']>,
  readonly internalName_not?: Maybe<Scalars['String']>,
  readonly internalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IPickerAspectItemOptions {
  readonly __typename?: 'PickerAspectItemOptions',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly options: Maybe<ReadonlyArray<Maybe<IListItem>>>,
  readonly pickerAspect: Maybe<IPickerAspect>,
}

export interface IPickerAspectValue {
  readonly __typename?: 'PickerAspectValue',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly hideNameInItemPreview: Maybe<Scalars['Boolean']>,
  readonly identifier: Maybe<Scalars['String']>,
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly name: Maybe<ILocaleString>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
}

export interface IPickerFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly hideCalories?: Maybe<Scalars['Boolean']>,
  readonly hideCalories_not?: Maybe<Scalars['Boolean']>,
  readonly hideNutritionLegalDisclaimer?: Maybe<Scalars['Boolean']>,
  readonly hideNutritionLegalDisclaimer_not?: Maybe<Scalars['Boolean']>,
  readonly internalName?: Maybe<Scalars['String']>,
  readonly internalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly internalName_matches?: Maybe<Scalars['String']>,
  readonly internalName_not?: Maybe<Scalars['String']>,
  readonly internalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly isRealMeal?: Maybe<Scalars['Boolean']>,
  readonly isRealMeal_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IPickerItemMapping {
  readonly __typename?: 'PickerItemMapping',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly pickerAspect: Maybe<IPickerAspect>,
  readonly pickerAspectValueIdentifier: Maybe<Scalars['String']>,
}

export interface IPickerOption {
  readonly __typename?: 'PickerOption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly default: Maybe<Scalars['Boolean']>,
  readonly option: Maybe<IComboOrItem>,
  readonly pickerItemMappings: Maybe<ReadonlyArray<Maybe<IPickerItemMapping>>>,
}

export type IPickerOrSection = IPicker | ISection;

export interface IPlaceholderField  extends IDocument {
  readonly __typename?: 'PlaceholderField',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly alwaysAvailable: Maybe<Scalars['Boolean']>,
  readonly applicableTo: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly fieldId: Maybe<Scalars['String']>,
  readonly formatter: Maybe<Scalars['String']>,
  readonly path: Maybe<Scalars['String']>,
  readonly requiredField: Maybe<Scalars['String']>,
}

export interface IPlaceholderFieldFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly alwaysAvailable?: Maybe<Scalars['Boolean']>,
  readonly alwaysAvailable_not?: Maybe<Scalars['Boolean']>,
  readonly fieldId?: Maybe<Scalars['String']>,
  readonly fieldId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fieldId_matches?: Maybe<Scalars['String']>,
  readonly fieldId_not?: Maybe<Scalars['String']>,
  readonly fieldId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly formatter?: Maybe<Scalars['String']>,
  readonly formatter_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly formatter_matches?: Maybe<Scalars['String']>,
  readonly formatter_not?: Maybe<Scalars['String']>,
  readonly formatter_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly path?: Maybe<Scalars['String']>,
  readonly path_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path_matches?: Maybe<Scalars['String']>,
  readonly path_not?: Maybe<Scalars['String']>,
  readonly path_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly requiredField?: Maybe<Scalars['String']>,
  readonly requiredField_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly requiredField_matches?: Maybe<Scalars['String']>,
  readonly requiredField_not?: Maybe<Scalars['String']>,
  readonly requiredField_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IPlu {
  readonly __typename?: 'Plu',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly plu: Maybe<Scalars['String']>,
  readonly qualifier: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Float']>,
}

export interface IPluData {
  readonly __typename?: 'PluData',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly available: Maybe<Scalars['Boolean']>,
  readonly pluNumber: Maybe<Scalars['Float']>,
  readonly price: Maybe<Scalars['Float']>,
}

export interface IPos {
  readonly __typename?: 'Pos',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly vendor: Maybe<Scalars['String']>,
  readonly version: Maybe<Scalars['String']>,
}

export interface IPosConfiguration  extends IDocument {
  readonly __typename?: 'PosConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly posVendors: Maybe<ReadonlyArray<Maybe<IPosVendorConfigOption>>>,
}

export interface IPosConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IPosValidationThreshold {
  readonly __typename?: 'PosValidationThreshold',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly carrols: Maybe<Scalars['Float']>,
  readonly carrolsDelivery: Maybe<Scalars['Float']>,
  readonly hdx: Maybe<Scalars['Float']>,
  readonly ncr: Maybe<Scalars['Float']>,
  readonly ncrDelivery: Maybe<Scalars['Float']>,
  readonly oheics: Maybe<Scalars['Float']>,
  readonly oheicsDelivery: Maybe<Scalars['Float']>,
  readonly productNumber: Maybe<Scalars['Float']>,
  readonly productNumberDelivery: Maybe<Scalars['Float']>,
  readonly qdi: Maybe<Scalars['Float']>,
  readonly qdiDelivery: Maybe<Scalars['Float']>,
  readonly qst: Maybe<Scalars['Float']>,
  readonly qstDelivery: Maybe<Scalars['Float']>,
  readonly rpos: Maybe<Scalars['Float']>,
  readonly rposDelivery: Maybe<Scalars['Float']>,
  readonly sicom: Maybe<Scalars['Float']>,
  readonly sicomDelivery: Maybe<Scalars['Float']>,
  readonly simplyDelivery: Maybe<Scalars['Float']>,
  readonly simplyDeliveryDelivery: Maybe<Scalars['Float']>,
  readonly tablet: Maybe<Scalars['Float']>,
  readonly tabletDelivery: Maybe<Scalars['Float']>,
}

export interface IPosVendorConfigOption {
  readonly __typename?: 'PosVendorConfigOption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly posVendor: Maybe<Scalars['String']>,
}

export interface IPrepaidPaymentsGatewayMerchantIdConfig {
  readonly __typename?: 'PrepaidPaymentsGatewayMerchantIdConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly ca: Maybe<Scalars['String']>,
  readonly us: Maybe<Scalars['String']>,
}

export interface IPreviewEntry {
  readonly __typename?: 'PreviewEntry',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bodyText: Maybe<ILocaleString>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly linkText: Maybe<ILocaleString>,
  readonly linkURL: Maybe<Scalars['String']>,
  readonly localizedLinkURL: Maybe<ILocaleString>,
  readonly previewImage: Maybe<ILocaleImage>,
  readonly titleText: Maybe<ILocaleString>,
}

export interface IPreviewWidget {
  readonly __typename?: 'PreviewWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly previewContent: Maybe<ReadonlyArray<Maybe<IPreviewEntry>>>,
}

export interface IPricingRegionPrice {
  readonly __typename?: 'PricingRegionPrice',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly opPricingRegion: Maybe<IOpPricingRegion>,
  readonly price: Maybe<Scalars['Float']>,
}

export interface IPrizes {
  readonly __typename?: 'Prizes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly buttonText: Maybe<ILocaleBlockContent>,
  readonly excludeInAlberta: Maybe<Scalars['Boolean']>,
  readonly header: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImages>,
  readonly numberAwarded: Maybe<ILocaleBlockContent>,
  readonly text: Maybe<ILocaleBlockContent>,
}

export interface IProductCategory  extends IDocument {
  readonly __typename?: 'ProductCategory',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly hierarchyLevel: Maybe<Scalars['String']>,
  readonly image: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
}

export interface IProductCategoryFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly hierarchyLevel?: Maybe<Scalars['String']>,
  readonly hierarchyLevel_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly hierarchyLevel_matches?: Maybe<Scalars['String']>,
  readonly hierarchyLevel_not?: Maybe<Scalars['String']>,
  readonly hierarchyLevel_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IProductHierarchy {
  readonly __typename?: 'ProductHierarchy',
  readonly L1: Maybe<Scalars['String']>,
  readonly L2: Maybe<Scalars['String']>,
  readonly L3: Maybe<Scalars['String']>,
  readonly L4: Maybe<Scalars['String']>,
  readonly L5: Maybe<Scalars['String']>,
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
}

export interface IPromoCodePanel {
  readonly __typename?: 'PromoCodePanel',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly promoCodeDescription: Maybe<ILocaleBlockContent>,
  readonly promoCodeLabel: Maybe<ILocaleBlockContent>,
  readonly promoCodeLink: Maybe<Scalars['String']>,
}

export interface IPurchase {
  readonly __typename?: 'Purchase',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly isPicker: Maybe<Scalars['Boolean']>,
  readonly option: Maybe<IComboOrItemOrPickerOrProductCategory>,
  readonly quantity: Maybe<Scalars['Float']>,
  readonly sanityId: Maybe<Scalars['String']>,
}

export interface IPypestreamConfig {
  readonly __typename?: 'PypestreamConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly appId: Maybe<Scalars['String']>,
  readonly scriptUrl: Maybe<Scalars['String']>,
}

export interface IQuestIncentive {
  readonly __typename?: 'QuestIncentive',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bonusPoints: Maybe<Scalars['Float']>,
  readonly offer: Maybe<IConfigOffer>,
  readonly reward: Maybe<IConfigReward>,
  readonly type: Maybe<Scalars['String']>,
}

export interface IQuestionDetails  extends IDocument {
  readonly __typename?: 'QuestionDetails',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly countdownTimer: Maybe<Scalars['Float']>,
  readonly responses: Maybe<ReadonlyArray<Maybe<IResponseDetails>>>,
  readonly text: Maybe<ILocaleString>,
}

export interface IQuestionDetailsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly countdownTimer?: Maybe<Scalars['Float']>,
  readonly countdownTimer_gt?: Maybe<Scalars['Float']>,
  readonly countdownTimer_gte?: Maybe<Scalars['Float']>,
  readonly countdownTimer_lt?: Maybe<Scalars['Float']>,
  readonly countdownTimer_lte?: Maybe<Scalars['Float']>,
  readonly countdownTimer_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IQuestRules {
  readonly __typename?: 'QuestRules',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly isSequential: Maybe<Scalars['Boolean']>,
  readonly onDistinctPurchases: Maybe<Scalars['Boolean']>,
  readonly steps: Maybe<ReadonlyArray<Maybe<IQuestStep>>>,
}

export interface IQuestStep {
  readonly __typename?: 'QuestStep',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly rules: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrCartRequirementOrDayOfWeekBandOrIncentiveRequirementOrLoyaltyBetweenTimesOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpend>>>,
}

export interface IQuestTemplate  extends IDocument {
  readonly __typename?: 'QuestTemplate',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<IImage>,
  readonly configIncentive: Maybe<IConfigQuest>,
  readonly description: Maybe<ILocaleSmartBlockContent>,
  readonly localizedImage: Maybe<ILocaleImages>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleSmartBlockContent>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
}

export interface IQuestTemplateFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly configIncentive?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
}

export interface IQuickConfig {
  readonly __typename?: 'QuickConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly rules: Maybe<ReadonlyArray<Maybe<IQuickConfigRule>>>,
}

export interface IQuickConfigRule {
  readonly __typename?: 'QuickConfigRule',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly itemOptions: Maybe<ReadonlyArray<Maybe<IListItem>>>,
  readonly modifier: Maybe<IListItem>,
}

export interface IQuoteWidget {
  readonly __typename?: 'QuoteWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly attributionImage: Maybe<IImage>,
  readonly attributionName: Maybe<Scalars['String']>,
  readonly attributionTitle: Maybe<ILocaleString>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly quoteText: Maybe<ILocaleString>,
}

export interface IRecentItems  extends IDocument {
  readonly __typename?: 'RecentItems',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IRecentItemsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRemediationReason {
  readonly __typename?: 'RemediationReason',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly reasonLabel: Maybe<Scalars['String']>,
  readonly reasonSlug: Maybe<ISlug>,
  readonly reasonValue: Maybe<Scalars['String']>,
}

export interface IRemediationReasons  extends IDocument {
  readonly __typename?: 'RemediationReasons',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly reasons: Maybe<ReadonlyArray<Maybe<IRemediationReason>>>,
}

export interface IRemediationReasonsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IRequiredRules {
  readonly __typename?: 'RequiredRules',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly cartLimit: Maybe<Scalars['Boolean']>,
  readonly cartRequirement: Maybe<Scalars['Boolean']>,
  readonly cooldown: Maybe<Scalars['Boolean']>,
  readonly dateBand: Maybe<Scalars['Boolean']>,
  readonly dayOfTheWeek: Maybe<Scalars['Boolean']>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly maxRedemption: Maybe<Scalars['Boolean']>,
  readonly minimumSpend: Maybe<Scalars['Boolean']>,
  readonly paymentMethod: Maybe<Scalars['Boolean']>,
  readonly restaurantGroups: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<Scalars['Boolean']>,
  readonly stackable: Maybe<Scalars['Boolean']>,
  readonly timeBand: Maybe<Scalars['Boolean']>,
  readonly transactionCount: Maybe<Scalars['Boolean']>,
  readonly userEnrollment: Maybe<Scalars['Boolean']>,
}

export interface IRequirements {
  readonly __typename?: 'Requirements',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly platform: Maybe<Scalars['String']>,
  readonly purchase: Maybe<IComboOrItemOrPickerOrSection>,
  readonly shortCode: Maybe<Scalars['String']>,
  readonly status: Maybe<Scalars['String']>,
}

export interface IRequiresAssignment {
  readonly __typename?: 'RequiresAssignment',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly requiresAssignment: Maybe<Scalars['String']>,
}

export interface IResponseDetails  extends IDocument {
  readonly __typename?: 'ResponseDetails',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly content: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly resultsValuesDetails: Maybe<ReadonlyArray<Maybe<IResultValueDetails>>>,
  readonly text: Maybe<ILocaleString>,
}

export interface IResponseDetailsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IRestaurant  extends IDocument {
  readonly __typename?: 'Restaurant',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly adi: Maybe<Scalars['String']>,
  readonly amenities: Maybe<ReadonlyArray<Maybe<IRestaurantAmenity>>>,
  readonly chaseMerchantId: Maybe<Scalars['String']>,
  readonly curbsideHolidayHours: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>,
  readonly curbsideHours: Maybe<IHoursOfOperation>,
  readonly deliveryConfiguration: Maybe<ReadonlyArray<Maybe<IDeliveryVendor>>>,
  readonly deliveryHolidayHours: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>,
  readonly deliveryHours: Maybe<IHoursOfOperation>,
  readonly deliveryProviders: Maybe<ReadonlyArray<Maybe<IRestaurantDeliveryProvider>>>,
  readonly diningRoomHolidayHours: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>,
  readonly diningRoomHours: Maybe<IHoursOfOperation>,
  readonly documentDescription: Maybe<Scalars['String']>,
  readonly drinkStationType: Maybe<Scalars['String']>,
  readonly driveThruHolidayHours: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>,
  readonly driveThruHours: Maybe<IHoursOfOperation>,
  readonly driveThruLaneType: Maybe<Scalars['String']>,
  readonly email: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly environment: Maybe<Scalars['String']>,
  readonly franchiseGroupId: Maybe<Scalars['Float']>,
  readonly franchiseGroupName: Maybe<Scalars['String']>,
  readonly frontCounterClosed: Maybe<Scalars['Boolean']>,
  readonly fzAddress: Maybe<Scalars['String']>,
  readonly fzAuthorizedRepresentative: Maybe<Scalars['String']>,
  readonly fzCity: Maybe<Scalars['String']>,
  readonly fzEmail: Maybe<Scalars['String']>,
  readonly fzHrb: Maybe<Scalars['String']>,
  readonly fzRegistryCourt: Maybe<Scalars['String']>,
  readonly fzTelephone: Maybe<Scalars['String']>,
  readonly fzUstNr: Maybe<Scalars['String']>,
  readonly fzZipCode: Maybe<Scalars['String']>,
  readonly fzeeGroup: Maybe<Scalars['String']>,
  readonly googleOrderingStatus: Maybe<Scalars['String']>,
  readonly hasBreakfast: Maybe<Scalars['Boolean']>,
  readonly hasBurgersForBreakfast: Maybe<Scalars['Boolean']>,
  readonly hasCatering: Maybe<Scalars['Boolean']>,
  readonly hasCurbside: Maybe<Scalars['Boolean']>,
  readonly hasDMBSuggestiveSelling: Maybe<Scalars['Boolean']>,
  readonly hasDelivery: Maybe<Scalars['Boolean']>,
  readonly hasDineIn: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru: Maybe<Scalars['Boolean']>,
  readonly hasInternalDeliveryFleet: Maybe<Scalars['Boolean']>,
  readonly hasLateNightMenu: Maybe<Scalars['Boolean']>,
  readonly hasLoyalty: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering: Maybe<Scalars['Boolean']>,
  readonly hasModifiedTakeout: Maybe<Scalars['Boolean']>,
  readonly hasParking: Maybe<Scalars['Boolean']>,
  readonly hasPlayground: Maybe<Scalars['Boolean']>,
  readonly hasTakeOut: Maybe<Scalars['Boolean']>,
  readonly hasWifi: Maybe<Scalars['Boolean']>,
  readonly hideInEnvironments: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly isDarkKitchen: Maybe<Scalars['Boolean']>,
  readonly isHalal: Maybe<Scalars['Boolean']>,
  readonly landmark: Maybe<ILocaleString>,
  readonly lastModifiedTime: Maybe<Scalars['DateTime']>,
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly mobileOrderingStatus: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly nbrDriveThruWindows: Maybe<Scalars['Float']>,
  readonly number: Maybe<Scalars['String']>,
  readonly ownership: Maybe<Scalars['String']>,
  readonly parkingType: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly physicalAddress: Maybe<IAddress>,
  readonly playgroundType: Maybe<Scalars['String']>,
  readonly pos: Maybe<IPos>,
  readonly posRestaurantId: Maybe<Scalars['String']>,
  readonly restaurantImage: Maybe<IImage>,
  readonly restaurantKioskData: Maybe<IRestaurantKioskData>,
  readonly restaurantPosData: Maybe<IRestaurantPosData>,
  readonly servicesHasDriveThru: Maybe<Scalars['Boolean']>,
  readonly status: Maybe<Scalars['String']>,
  readonly timezone: Maybe<Scalars['String']>,
  readonly vatNumber: Maybe<Scalars['String']>,
  readonly vrPaymentMerchantId: Maybe<Scalars['String']>,
}

export interface IRestaurantAmenity  extends IDocument {
  readonly __typename?: 'RestaurantAmenity',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly icon: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
}

export interface IRestaurantAmenityFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IRestaurantConfig {
  readonly __typename?: 'RestaurantConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly displayEnv: Maybe<Scalars['String']>,
  readonly validMobileOrderingEnvs: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface IRestaurantDeliveryProvider  extends IDocument {
  readonly __typename?: 'RestaurantDeliveryProvider',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly icon: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
  readonly providerId: Maybe<Scalars['String']>,
}

export interface IRestaurantDeliveryProviderFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly providerId?: Maybe<Scalars['String']>,
  readonly providerId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly providerId_matches?: Maybe<Scalars['String']>,
  readonly providerId_not?: Maybe<Scalars['String']>,
  readonly providerId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRestaurantFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly adi?: Maybe<Scalars['String']>,
  readonly adi_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly adi_matches?: Maybe<Scalars['String']>,
  readonly adi_not?: Maybe<Scalars['String']>,
  readonly adi_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly chaseMerchantId?: Maybe<Scalars['String']>,
  readonly chaseMerchantId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly chaseMerchantId_matches?: Maybe<Scalars['String']>,
  readonly chaseMerchantId_not?: Maybe<Scalars['String']>,
  readonly chaseMerchantId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly documentDescription?: Maybe<Scalars['String']>,
  readonly documentDescription_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly documentDescription_matches?: Maybe<Scalars['String']>,
  readonly documentDescription_not?: Maybe<Scalars['String']>,
  readonly documentDescription_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly drinkStationType?: Maybe<Scalars['String']>,
  readonly drinkStationType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly drinkStationType_matches?: Maybe<Scalars['String']>,
  readonly drinkStationType_not?: Maybe<Scalars['String']>,
  readonly drinkStationType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly driveThruLaneType?: Maybe<Scalars['String']>,
  readonly driveThruLaneType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly driveThruLaneType_matches?: Maybe<Scalars['String']>,
  readonly driveThruLaneType_not?: Maybe<Scalars['String']>,
  readonly driveThruLaneType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly environment?: Maybe<Scalars['String']>,
  readonly environment_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly environment_matches?: Maybe<Scalars['String']>,
  readonly environment_not?: Maybe<Scalars['String']>,
  readonly environment_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly franchiseGroupId?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_gt?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_gte?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_lt?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_lte?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_not?: Maybe<Scalars['Float']>,
  readonly franchiseGroupName?: Maybe<Scalars['String']>,
  readonly franchiseGroupName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly franchiseGroupName_matches?: Maybe<Scalars['String']>,
  readonly franchiseGroupName_not?: Maybe<Scalars['String']>,
  readonly franchiseGroupName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly frontCounterClosed?: Maybe<Scalars['Boolean']>,
  readonly frontCounterClosed_not?: Maybe<Scalars['Boolean']>,
  readonly fzAddress?: Maybe<Scalars['String']>,
  readonly fzAddress_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzAddress_matches?: Maybe<Scalars['String']>,
  readonly fzAddress_not?: Maybe<Scalars['String']>,
  readonly fzAddress_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzAuthorizedRepresentative?: Maybe<Scalars['String']>,
  readonly fzAuthorizedRepresentative_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzAuthorizedRepresentative_matches?: Maybe<Scalars['String']>,
  readonly fzAuthorizedRepresentative_not?: Maybe<Scalars['String']>,
  readonly fzAuthorizedRepresentative_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzCity?: Maybe<Scalars['String']>,
  readonly fzCity_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzCity_matches?: Maybe<Scalars['String']>,
  readonly fzCity_not?: Maybe<Scalars['String']>,
  readonly fzCity_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzEmail?: Maybe<Scalars['String']>,
  readonly fzEmail_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzEmail_matches?: Maybe<Scalars['String']>,
  readonly fzEmail_not?: Maybe<Scalars['String']>,
  readonly fzEmail_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzHrb?: Maybe<Scalars['String']>,
  readonly fzHrb_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzHrb_matches?: Maybe<Scalars['String']>,
  readonly fzHrb_not?: Maybe<Scalars['String']>,
  readonly fzHrb_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzRegistryCourt?: Maybe<Scalars['String']>,
  readonly fzRegistryCourt_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzRegistryCourt_matches?: Maybe<Scalars['String']>,
  readonly fzRegistryCourt_not?: Maybe<Scalars['String']>,
  readonly fzRegistryCourt_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzTelephone?: Maybe<Scalars['String']>,
  readonly fzTelephone_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzTelephone_matches?: Maybe<Scalars['String']>,
  readonly fzTelephone_not?: Maybe<Scalars['String']>,
  readonly fzTelephone_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzUstNr?: Maybe<Scalars['String']>,
  readonly fzUstNr_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzUstNr_matches?: Maybe<Scalars['String']>,
  readonly fzUstNr_not?: Maybe<Scalars['String']>,
  readonly fzUstNr_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzZipCode?: Maybe<Scalars['String']>,
  readonly fzZipCode_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzZipCode_matches?: Maybe<Scalars['String']>,
  readonly fzZipCode_not?: Maybe<Scalars['String']>,
  readonly fzZipCode_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzeeGroup?: Maybe<Scalars['String']>,
  readonly fzeeGroup_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly fzeeGroup_matches?: Maybe<Scalars['String']>,
  readonly fzeeGroup_not?: Maybe<Scalars['String']>,
  readonly fzeeGroup_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly googleOrderingStatus?: Maybe<Scalars['String']>,
  readonly googleOrderingStatus_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly googleOrderingStatus_matches?: Maybe<Scalars['String']>,
  readonly googleOrderingStatus_not?: Maybe<Scalars['String']>,
  readonly googleOrderingStatus_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly hasBreakfast?: Maybe<Scalars['Boolean']>,
  readonly hasBreakfast_not?: Maybe<Scalars['Boolean']>,
  readonly hasBurgersForBreakfast?: Maybe<Scalars['Boolean']>,
  readonly hasBurgersForBreakfast_not?: Maybe<Scalars['Boolean']>,
  readonly hasCatering?: Maybe<Scalars['Boolean']>,
  readonly hasCatering_not?: Maybe<Scalars['Boolean']>,
  readonly hasCurbside?: Maybe<Scalars['Boolean']>,
  readonly hasCurbside_not?: Maybe<Scalars['Boolean']>,
  readonly hasDMBSuggestiveSelling?: Maybe<Scalars['Boolean']>,
  readonly hasDMBSuggestiveSelling_not?: Maybe<Scalars['Boolean']>,
  readonly hasDelivery?: Maybe<Scalars['Boolean']>,
  readonly hasDelivery_not?: Maybe<Scalars['Boolean']>,
  readonly hasDineIn?: Maybe<Scalars['Boolean']>,
  readonly hasDineIn_not?: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru_not?: Maybe<Scalars['Boolean']>,
  readonly hasInternalDeliveryFleet?: Maybe<Scalars['Boolean']>,
  readonly hasInternalDeliveryFleet_not?: Maybe<Scalars['Boolean']>,
  readonly hasLateNightMenu?: Maybe<Scalars['Boolean']>,
  readonly hasLateNightMenu_not?: Maybe<Scalars['Boolean']>,
  readonly hasLoyalty?: Maybe<Scalars['Boolean']>,
  readonly hasLoyalty_not?: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering_not?: Maybe<Scalars['Boolean']>,
  readonly hasModifiedTakeout?: Maybe<Scalars['Boolean']>,
  readonly hasModifiedTakeout_not?: Maybe<Scalars['Boolean']>,
  readonly hasParking?: Maybe<Scalars['Boolean']>,
  readonly hasParking_not?: Maybe<Scalars['Boolean']>,
  readonly hasPlayground?: Maybe<Scalars['Boolean']>,
  readonly hasPlayground_not?: Maybe<Scalars['Boolean']>,
  readonly hasTakeOut?: Maybe<Scalars['Boolean']>,
  readonly hasTakeOut_not?: Maybe<Scalars['Boolean']>,
  readonly hasWifi?: Maybe<Scalars['Boolean']>,
  readonly hasWifi_not?: Maybe<Scalars['Boolean']>,
  readonly isDarkKitchen?: Maybe<Scalars['Boolean']>,
  readonly isDarkKitchen_not?: Maybe<Scalars['Boolean']>,
  readonly isHalal?: Maybe<Scalars['Boolean']>,
  readonly isHalal_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly lastModifiedTime?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_gt?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_gte?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_lt?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_lte?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_not?: Maybe<Scalars['DateTime']>,
  readonly latitude?: Maybe<Scalars['Float']>,
  readonly latitude_gt?: Maybe<Scalars['Float']>,
  readonly latitude_gte?: Maybe<Scalars['Float']>,
  readonly latitude_lt?: Maybe<Scalars['Float']>,
  readonly latitude_lte?: Maybe<Scalars['Float']>,
  readonly latitude_not?: Maybe<Scalars['Float']>,
  readonly longitude?: Maybe<Scalars['Float']>,
  readonly longitude_gt?: Maybe<Scalars['Float']>,
  readonly longitude_gte?: Maybe<Scalars['Float']>,
  readonly longitude_lt?: Maybe<Scalars['Float']>,
  readonly longitude_lte?: Maybe<Scalars['Float']>,
  readonly longitude_not?: Maybe<Scalars['Float']>,
  readonly mobileOrderingStatus?: Maybe<Scalars['String']>,
  readonly mobileOrderingStatus_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mobileOrderingStatus_matches?: Maybe<Scalars['String']>,
  readonly mobileOrderingStatus_not?: Maybe<Scalars['String']>,
  readonly mobileOrderingStatus_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly nbrDriveThruWindows?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_gt?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_gte?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_lt?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_lte?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_not?: Maybe<Scalars['Float']>,
  readonly number?: Maybe<Scalars['String']>,
  readonly number_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly number_matches?: Maybe<Scalars['String']>,
  readonly number_not?: Maybe<Scalars['String']>,
  readonly number_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly ownership?: Maybe<Scalars['String']>,
  readonly ownership_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly ownership_matches?: Maybe<Scalars['String']>,
  readonly ownership_not?: Maybe<Scalars['String']>,
  readonly ownership_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly parkingType?: Maybe<Scalars['String']>,
  readonly parkingType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly parkingType_matches?: Maybe<Scalars['String']>,
  readonly parkingType_not?: Maybe<Scalars['String']>,
  readonly parkingType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly phoneNumber?: Maybe<Scalars['String']>,
  readonly phoneNumber_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly phoneNumber_matches?: Maybe<Scalars['String']>,
  readonly phoneNumber_not?: Maybe<Scalars['String']>,
  readonly phoneNumber_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly playgroundType?: Maybe<Scalars['String']>,
  readonly playgroundType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly playgroundType_matches?: Maybe<Scalars['String']>,
  readonly playgroundType_not?: Maybe<Scalars['String']>,
  readonly playgroundType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly posRestaurantId?: Maybe<Scalars['String']>,
  readonly posRestaurantId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly posRestaurantId_matches?: Maybe<Scalars['String']>,
  readonly posRestaurantId_not?: Maybe<Scalars['String']>,
  readonly posRestaurantId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly restaurantKioskData?: Maybe<Scalars['ID']>,
  readonly restaurantPosData?: Maybe<Scalars['ID']>,
  readonly servicesHasDriveThru?: Maybe<Scalars['Boolean']>,
  readonly servicesHasDriveThru_not?: Maybe<Scalars['Boolean']>,
  readonly status?: Maybe<Scalars['String']>,
  readonly status_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly status_matches?: Maybe<Scalars['String']>,
  readonly status_not?: Maybe<Scalars['String']>,
  readonly status_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly timezone?: Maybe<Scalars['String']>,
  readonly timezone_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly timezone_matches?: Maybe<Scalars['String']>,
  readonly timezone_not?: Maybe<Scalars['String']>,
  readonly timezone_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly vatNumber?: Maybe<Scalars['String']>,
  readonly vatNumber_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly vatNumber_matches?: Maybe<Scalars['String']>,
  readonly vatNumber_not?: Maybe<Scalars['String']>,
  readonly vatNumber_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly vrPaymentMerchantId?: Maybe<Scalars['String']>,
  readonly vrPaymentMerchantId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly vrPaymentMerchantId_matches?: Maybe<Scalars['String']>,
  readonly vrPaymentMerchantId_not?: Maybe<Scalars['String']>,
  readonly vrPaymentMerchantId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRestaurantGroup  extends IDocument {
  readonly __typename?: 'RestaurantGroup',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<Scalars['String']>,
  readonly restaurants: Maybe<ReadonlyArray<Maybe<IRestaurant>>>,
}

export interface IRestaurantGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRestaurantGroupRestrictions {
  readonly __typename?: 'RestaurantGroupRestrictions',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly restaurantGroupRestrictionList: Maybe<ReadonlyArray<Maybe<IRestaurantGroup>>>,
}

export interface IRestaurantKioskData  extends IDocument {
  readonly __typename?: 'RestaurantKioskData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly kiosks: Maybe<ReadonlyArray<Maybe<IKiosk>>>,
  readonly restaurantNumber: Maybe<Scalars['Float']>,
}

export interface IRestaurantKioskDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly restaurantNumber?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_gt?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_gte?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_lt?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_lte?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_not?: Maybe<Scalars['Float']>,
}

export interface IRestaurantPosData  extends IDocument {
  readonly __typename?: 'RestaurantPosData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly deliveryPLUs: Maybe<Scalars['String']>,
  readonly disableChickenSandwich: Maybe<Scalars['Boolean']>,
  readonly heartbeatOverride: Maybe<Scalars['String']>,
  readonly heartbeatStatus: Maybe<Scalars['Boolean']>,
  readonly lastHeartbeatTimestamp: Maybe<Scalars['DateTime']>,
  readonly plus: Maybe<Scalars['String']>,
  readonly restaurant: Maybe<IRestaurant>,
  readonly restaurantNumber: Maybe<Scalars['Float']>,
}

export interface IRestaurantPosDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly deliveryPLUs?: Maybe<Scalars['String']>,
  readonly deliveryPLUs_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly deliveryPLUs_matches?: Maybe<Scalars['String']>,
  readonly deliveryPLUs_not?: Maybe<Scalars['String']>,
  readonly deliveryPLUs_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly disableChickenSandwich?: Maybe<Scalars['Boolean']>,
  readonly disableChickenSandwich_not?: Maybe<Scalars['Boolean']>,
  readonly heartbeatOverride?: Maybe<Scalars['String']>,
  readonly heartbeatOverride_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heartbeatOverride_matches?: Maybe<Scalars['String']>,
  readonly heartbeatOverride_not?: Maybe<Scalars['String']>,
  readonly heartbeatOverride_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heartbeatStatus?: Maybe<Scalars['Boolean']>,
  readonly heartbeatStatus_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly lastHeartbeatTimestamp?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_gt?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_gte?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_lt?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_lte?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_not?: Maybe<Scalars['DateTime']>,
  readonly plus?: Maybe<Scalars['String']>,
  readonly plus_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly plus_matches?: Maybe<Scalars['String']>,
  readonly plus_not?: Maybe<Scalars['String']>,
  readonly plus_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly restaurant?: Maybe<Scalars['ID']>,
  readonly restaurantNumber?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_gt?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_gte?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_lt?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_lte?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_not?: Maybe<Scalars['Float']>,
}

export interface IResultDetails  extends IDocument {
  readonly __typename?: 'ResultDetails',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly offer: Maybe<IOffer>,
  readonly prefix: Maybe<ILocaleString>,
  readonly text: Maybe<ILocaleString>,
}

export interface IResultDetailsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly offer?: Maybe<Scalars['ID']>,
}

export interface IResultValueDetails {
  readonly __typename?: 'ResultValueDetails',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly result: Maybe<IResultDetails>,
  readonly value: Maybe<Scalars['Float']>,
}

export interface IReward  extends IDocument {
  readonly __typename?: 'Reward',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<IImage>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly incentiveNotInMenu: Maybe<Scalars['Boolean']>,
  readonly incentives: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferDiscountOrPicker>>>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly name: Maybe<ILocaleString>,
  readonly notificationDetails: Maybe<INotificationDetails>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrCartLimitOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrLoyaltyBetweenTimesOrLoyaltyPointsOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated>>>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
}

export interface IRewardCategory  extends IDocument {
  readonly __typename?: 'RewardCategory',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly label: Maybe<ILocaleString>,
  readonly rewards: Maybe<ReadonlyArray<Maybe<IReward>>>,
  readonly validations: Maybe<ReadonlyArray<Maybe<IValidationLoyaltyPoints>>>,
}

export interface IRewardCategoryFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IRewardFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly incentiveNotInMenu?: Maybe<Scalars['Boolean']>,
  readonly incentiveNotInMenu_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
}

export interface IRewardList  extends IDocument {
  readonly __typename?: 'RewardList',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly rewardCategories: Maybe<ReadonlyArray<Maybe<IRewardCategory>>>,
}

export interface IRewardListFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export type IRewardOrSystemwideOfferOrSystemwidePromotion = IReward | ISystemwideOffer | ISystemwidePromotion;

export interface IRewards {
  readonly __typename?: 'Rewards',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly allSetBlurbBlock: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImages>,
  readonly key: Maybe<Scalars['String']>,
  readonly requireSkillsQuestion: Maybe<Scalars['Boolean']>,
  readonly rewardCodeDescription: Maybe<ILocaleBlockContent>,
  readonly rewardLink: Maybe<ILocaleString>,
  readonly rewardName: Maybe<ILocaleString>,
  readonly rewardYouWonMessageBlock: Maybe<ILocaleBlockContent>,
}

export interface IRewardsListWidget {
  readonly __typename?: 'RewardsListWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly componentKey: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface IRewardsSection  extends IDocument {
  readonly __typename?: 'RewardsSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly rewards: Maybe<ReadonlyArray<Maybe<IFeaturedReward>>>,
  readonly rewardsList: Maybe<ReadonlyArray<Maybe<IFeaturedReward>>>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IRewardsSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRgbaColor {
  readonly __typename?: 'RgbaColor',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly a: Maybe<Scalars['Float']>,
  readonly b: Maybe<Scalars['Float']>,
  readonly g: Maybe<Scalars['Float']>,
  readonly r: Maybe<Scalars['Float']>,
}

export interface IRollUpTheRim  extends IDocument {
  readonly __typename?: 'RollUpTheRim',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly allSetClaimFailedHeaderText: Maybe<ILocaleString>,
  readonly allSetEmailSentText: Maybe<ILocaleString>,
  readonly allSetHeaderBlock: Maybe<ILocaleBlockContent>,
  readonly allSetHeaderText: Maybe<ILocaleString>,
  readonly allSetLegalBlock: Maybe<ILocaleBlockContent>,
  readonly allSetTextBlock: Maybe<ILocaleBlockContent>,
  readonly countdownText: Maybe<ILocaleBlockContent>,
  readonly cupImage: Maybe<ILocaleImages>,
  readonly desktopGamePlayImage: Maybe<ILocaleImages>,
  readonly desktopPrizesImage: Maybe<ILocaleImages>,
  readonly desktopReusablesImage: Maybe<ILocaleImages>,
  readonly desktopShareImage: Maybe<ILocaleImages>,
  readonly desktopSponsorsImage: Maybe<ILocaleImages>,
  readonly emptyTimelineButtonBlock: Maybe<ILocaleBlockContent>,
  readonly emptyTimelineImage: Maybe<ILocaleImages>,
  readonly emptyTimelineTextBlock: Maybe<ILocaleBlockContent>,
  readonly endText: Maybe<ILocaleBlockContent>,
  readonly enterButtonText: Maybe<ILocaleBlockContent>,
  readonly entriesText: Maybe<ILocaleBlockContent>,
  readonly errorTimelineButtonText: Maybe<ILocaleString>,
  readonly errorTimelineImage: Maybe<ILocaleImages>,
  readonly errorTimelineText: Maybe<ILocaleString>,
  readonly firstDrawing: Maybe<Scalars['DateTime']>,
  readonly footerLinks: Maybe<ReadonlyArray<Maybe<IRutrFooter>>>,
  readonly fourthDrawing: Maybe<Scalars['DateTime']>,
  readonly gameBackgroundImage: Maybe<ILocaleImages>,
  readonly gameButtonText: Maybe<ILocaleBlockContent>,
  readonly gameErrorBlock: Maybe<ILocaleBlockContent>,
  readonly gameErrorHeaderText: Maybe<ILocaleString>,
  readonly gameHeader: Maybe<ILocaleBlockContent>,
  readonly gameHeaderText: Maybe<ILocaleString>,
  readonly gameNeedHelp: Maybe<ILocaleString>,
  readonly gamePlayButtonText: Maybe<ILocaleBlockContent>,
  readonly gamePlayHeader: Maybe<ILocaleBlockContent>,
  readonly gamePlayImage: Maybe<ILocaleImages>,
  readonly gamePlayTextBlock: Maybe<ILocaleBlockContent>,
  readonly gamePlayUnauthButtonText: Maybe<ILocaleString>,
  readonly gamePlayUnauthButtonVariant: Maybe<Scalars['String']>,
  readonly gameRollButtonText: Maybe<ILocaleString>,
  readonly gameTextBlock: Maybe<ILocaleBlockContent>,
  readonly gameplayRollAudio: Maybe<IFile>,
  readonly gameplayWinAudio: Maybe<IFile>,
  readonly homepageBackgroundImage: Maybe<ILocaleImages>,
  readonly homepageCupImage: Maybe<ILocaleImages>,
  readonly homepageHeader: Maybe<ILocaleBlockContent>,
  readonly howManyTextBlock: Maybe<ILocaleBlockContent>,
  readonly localeSwitchModalDisclaimerText: Maybe<ILocaleString>,
  readonly localeSwitchModalHeaderText: Maybe<ILocaleString>,
  readonly localeSwitchModalPrimaryText: Maybe<ILocaleString>,
  readonly localeSwitchModalSecondaryText: Maybe<ILocaleString>,
  readonly lockoutScreenButtonText: Maybe<ILocaleString>,
  readonly lockoutScreenImage: Maybe<ILocaleImages>,
  readonly lockoutScreenTextBlock: Maybe<ILocaleBlockContent>,
  readonly modalTimelineHeader: Maybe<ILocaleBlockContent>,
  readonly modalWinnersHeader: Maybe<ILocaleBlockContent>,
  readonly modalWinnersTextBlock: Maybe<ILocaleBlockContent>,
  readonly moneyStackImage: Maybe<ILocaleImages>,
  readonly nextDrawText: Maybe<ILocaleBlockContent>,
  readonly planeImage: Maybe<ILocaleImages>,
  readonly prizes: Maybe<ReadonlyArray<Maybe<IPrizes>>>,
  readonly prizesButtonText: Maybe<ILocaleBlockContent>,
  readonly prizesHeader: Maybe<ILocaleBlockContent>,
  readonly prizesImage: Maybe<ILocaleImages>,
  readonly prizesSeparator: Maybe<ILocaleBlockContent>,
  readonly prizesTextBlock: Maybe<ILocaleBlockContent>,
  readonly reusablesButtonText: Maybe<ILocaleBlockContent>,
  readonly reusablesHeader: Maybe<ILocaleBlockContent>,
  readonly reusablesImage: Maybe<ILocaleImages>,
  readonly reusablesTextBlock: Maybe<ILocaleBlockContent>,
  readonly rewards: Maybe<ReadonlyArray<Maybe<IRewards>>>,
  readonly rewardsBackgroundImage: Maybe<ILocaleImages>,
  readonly rewardsButtonText: Maybe<ILocaleBlockContent>,
  readonly rewardsCupImage: Maybe<ILocaleImages>,
  readonly rewardsHeader: Maybe<ILocaleBlockContent>,
  readonly rewardsHeaderSubtitleText: Maybe<ILocaleString>,
  readonly rewardsHeaderText: Maybe<ILocaleString>,
  readonly rewardsTextBlock: Maybe<ILocaleBlockContent>,
  readonly rollsRemainingText: Maybe<ILocaleBlockContent>,
  readonly rollupAnimationFrames: Maybe<ReadonlyArray<Maybe<ILocaleImages>>>,
  readonly rrrollButtonText: Maybe<ILocaleBlockContent>,
  readonly rulesLinkPath: Maybe<ILocaleString>,
  readonly rulesLinkText: Maybe<ILocaleString>,
  readonly rulesText: Maybe<ILocaleBlockContent>,
  readonly rutwLogo: Maybe<ILocaleImages>,
  readonly secondDrawing: Maybe<Scalars['DateTime']>,
  readonly shareButtonText: Maybe<ILocaleBlockContent>,
  readonly shareHeader: Maybe<ILocaleBlockContent>,
  readonly shareImage: Maybe<ILocaleImages>,
  readonly shareRollHeader: Maybe<ILocaleBlockContent>,
  readonly shareRollIncrementText: Maybe<ILocaleString>,
  readonly shareRollLinkTitle: Maybe<ILocaleString>,
  readonly shareRollReclaimButtonText: Maybe<ILocaleString>,
  readonly shareRollReclaimDescriptionText: Maybe<ILocaleString>,
  readonly shareRollReclaimQuestionText: Maybe<ILocaleString>,
  readonly shareRollShare: Maybe<ILocaleString>,
  readonly shareRollTextBlock: Maybe<ILocaleBlockContent>,
  readonly shareRollTo: Maybe<ILocaleString>,
  readonly shareRollURL: Maybe<ILocaleString>,
  readonly shareRollYouHave: Maybe<ILocaleString>,
  readonly shareRollsBackgroundImage: Maybe<ILocaleImages>,
  readonly shareRollsDisclaimer: Maybe<ILocaleBlockContent>,
  readonly shareRollsImage: Maybe<ILocaleImages>,
  readonly shareRolluttonText: Maybe<ILocaleBlockContent>,
  readonly shareTextBlock: Maybe<ILocaleBlockContent>,
  readonly shareYourRollsLinkText: Maybe<ILocaleString>,
  readonly sharedLandingAddedBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingBackgroundImage: Maybe<ILocaleImages>,
  readonly sharedLandingBadLinkButtonBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingBadLinkHeaderBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingBadLinkImage: Maybe<ILocaleImages>,
  readonly sharedLandingBadLinkTextBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingButtonBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingHeaderBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingImage: Maybe<ILocaleImages>,
  readonly sharedLandingMoreThanOneRollAddedBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingMoreThanOneRollHeaderBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingMoreThanOneRollTextBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingTextBlock: Maybe<ILocaleBlockContent>,
  readonly skillsQuestionAcknowledgeText: Maybe<ILocaleString>,
  readonly skillsQuestionDescriptionText: Maybe<ILocaleString>,
  readonly skillsQuestionHeaderText: Maybe<ILocaleString>,
  readonly skillsQuestionHintText: Maybe<ILocaleString>,
  readonly skillsQuestionMathBlock: Maybe<ILocaleBlockContent>,
  readonly skillsQuestionReleaseBlock: Maybe<ILocaleBlockContent>,
  readonly skillsQuestionsGroup: Maybe<ReadonlyArray<Maybe<ISkillsTest>>>,
  readonly sponsorTitle: Maybe<ILocaleString>,
  readonly sponsorsImage: Maybe<ILocaleImages>,
  readonly thirdDrawing: Maybe<Scalars['DateTime']>,
  readonly timelineButtonText: Maybe<ILocaleBlockContent>,
  readonly timelineComponents: Maybe<ReadonlyArray<Maybe<ITimelineComponents>>>,
  readonly timelineConfetti: Maybe<ILocaleImages>,
  readonly timelineHeader: Maybe<ILocaleBlockContent>,
  readonly timelinePrizeClaimedText: Maybe<ILocaleString>,
  readonly timelineRollSharedText: Maybe<ILocaleString>,
  readonly timelineTextBlock: Maybe<ILocaleBlockContent>,
  readonly timelineTextLoadMore: Maybe<ILocaleString>,
  readonly unauthenticatedEmptyTimelineButtonBlock: Maybe<ILocaleBlockContent>,
  readonly unauthenticatedEmptyTimelineImage: Maybe<ILocaleImages>,
  readonly unauthenticatedEmptyTimelineTextBlock: Maybe<ILocaleBlockContent>,
  readonly unauthenticatedGamePlayHeader: Maybe<ILocaleBlockContent>,
  readonly unauthenticatedgGamePlayTextBlock: Maybe<ILocaleBlockContent>,
  readonly winnersButtonText: Maybe<ILocaleBlockContent>,
  readonly winnersHeader: Maybe<ILocaleBlockContent>,
  readonly winnersTextBlock: Maybe<ILocaleBlockContent>,
}

export interface IRollUpTheRimFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_gt?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_gte?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_lt?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_lte?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_not?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_gt?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_gte?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_lt?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_lte?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_not?: Maybe<Scalars['DateTime']>,
  readonly gamePlayUnauthButtonVariant?: Maybe<Scalars['String']>,
  readonly gamePlayUnauthButtonVariant_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly gamePlayUnauthButtonVariant_matches?: Maybe<Scalars['String']>,
  readonly gamePlayUnauthButtonVariant_not?: Maybe<Scalars['String']>,
  readonly gamePlayUnauthButtonVariant_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly secondDrawing?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_gt?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_gte?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_lt?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_lte?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_not?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_gt?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_gte?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_lt?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_lte?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_not?: Maybe<Scalars['DateTime']>,
}

export interface IRollUpTheRimSection  extends IDocument {
  readonly __typename?: 'RollUpTheRimSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IRollUpTheRimSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRootQuery {
  readonly __typename?: 'RootQuery',
  readonly AddOnSection: Maybe<IAddOnSection>,
  readonly AdminToolReleaseNotes: Maybe<IAdminToolReleaseNotes>,
  readonly Alert: Maybe<IAlert>,
  readonly AppData: Maybe<IAppData>,
  readonly AppDownload: Maybe<IAppDownload>,
  readonly AppVersion: Maybe<IAppVersion>,
  readonly Barcodes: Maybe<IBarcodes>,
  readonly BrazeContentCards: Maybe<IBrazeContentCards>,
  readonly BuildConfiguration: Maybe<IBuildConfiguration>,
  readonly Category: Maybe<ICategory>,
  readonly CateringPageConfiguration: Maybe<ICateringPageConfiguration>,
  readonly ClaimPointsUI: Maybe<IClaimPointsUi>,
  readonly Combo: Maybe<ICombo>,
  readonly ComboSlot: Maybe<IComboSlot>,
  readonly ConfigOffer: Maybe<IConfigOffer>,
  readonly ConfigQuest: Maybe<IConfigQuest>,
  readonly ConfigReward: Maybe<IConfigReward>,
  readonly DisplayGroup: Maybe<IDisplayGroup>,
  readonly EarningCalculation: Maybe<IEarningCalculation>,
  readonly EmptyState: Maybe<IEmptyState>,
  readonly FanFavorites: Maybe<IFanFavorites>,
  readonly FeatureAccount: Maybe<IFeatureAccount>,
  readonly FeatureAccountDeletePage: Maybe<IFeatureAccountDeletePage>,
  readonly FeatureAccountForm: Maybe<IFeatureAccountForm>,
  readonly FeatureAccountRequestInfoPage: Maybe<IFeatureAccountRequestInfoPage>,
  readonly FeatureBeeperModal: Maybe<IFeatureBeeperModal>,
  readonly FeatureCateringPage: Maybe<IFeatureCateringPage>,
  readonly FeatureDisclaimers: Maybe<IFeatureDisclaimers>,
  readonly FeatureFooter: Maybe<IFeatureFooter>,
  readonly FeatureFooterV2: Maybe<IFeatureFooterV2>,
  readonly FeatureGeolocationMapMarkers: Maybe<IFeatureGeolocationMapMarkers>,
  readonly FeatureGeolocationModal: Maybe<IFeatureGeolocationModal>,
  readonly FeatureGift: Maybe<IFeatureGift>,
  readonly FeatureHomePage: Maybe<IFeatureHomePage>,
  readonly FeatureKiosk: Maybe<IFeatureKiosk>,
  readonly FeatureKioskHomePage: Maybe<IFeatureKioskHomePage>,
  readonly FeatureKioskMenu: Maybe<IFeatureKioskMenu>,
  readonly FeatureKioskScreensaver: Maybe<IFeatureKioskScreensaver>,
  readonly FeatureLayout: Maybe<IFeatureLayout>,
  readonly FeatureLocationPromo: Maybe<IFeatureLocationPromo>,
  readonly FeatureLockers: Maybe<IFeatureLockers>,
  readonly FeatureMenu: Maybe<IFeatureMenu>,
  readonly FeatureMobileAppConfiguration: Maybe<IFeatureMobileAppConfiguration>,
  readonly FeatureNavigation: Maybe<IFeatureNavigation>,
  readonly FeatureNutrition: Maybe<IFeatureNutrition>,
  readonly FeatureOffers: Maybe<IFeatureOffers>,
  readonly FeatureOnboarding: Maybe<IFeatureOnboarding>,
  readonly FeaturePayback: Maybe<IFeaturePayback>,
  readonly FeatureQuiz: Maybe<IFeatureQuiz>,
  readonly FeatureScanAndPay: Maybe<IFeatureScanAndPay>,
  readonly FeatureStaticMenu: Maybe<IFeatureStaticMenu>,
  readonly Footer: Maybe<IFooter>,
  readonly FrontEndConfiguration: Maybe<IFrontEndConfiguration>,
  readonly GoogleAdSlot: Maybe<IGoogleAdSlot>,
  readonly Hero: Maybe<IHero>,
  readonly HomePageConfiguration: Maybe<IHomePageConfiguration>,
  readonly ImageWithHeaderAndText: Maybe<IImageWithHeaderAndText>,
  readonly Item: Maybe<IItem>,
  readonly KioskAppData: Maybe<IKioskAppData>,
  readonly LinkPhysicalCardUi: Maybe<ILinkPhysicalCardUi>,
  readonly LockedOffers: Maybe<ILockedOffers>,
  readonly LoyaltyConfiguration: Maybe<ILoyaltyConfiguration>,
  readonly LoyaltyContent: Maybe<ILoyaltyContent>,
  readonly LoyaltyOffersUI: Maybe<ILoyaltyOffersUi>,
  readonly LoyaltyReceipts: Maybe<ILoyaltyReceipts>,
  readonly LoyaltyUI: Maybe<ILoyaltyUi>,
  readonly MainHero: Maybe<IMainHero>,
  readonly MarketingCard: Maybe<IMarketingCard>,
  readonly MarketingCardGroup: Maybe<IMarketingCardGroup>,
  readonly MarketingTile: Maybe<IMarketingTile>,
  readonly MarketingTileBasic: Maybe<IMarketingTileBasic>,
  readonly MarketingTileCarousel: Maybe<IMarketingTileCarousel>,
  readonly MarketingTileGroup: Maybe<IMarketingTileGroup>,
  readonly MediaTag: Maybe<IMediaTag>,
  readonly Menu: Maybe<IMenu>,
  readonly Modifier: Maybe<IModifier>,
  readonly ModifierMultiplier: Maybe<IModifierMultiplier>,
  readonly NavigationSection: Maybe<INavigationSection>,
  readonly NutritionalSection: Maybe<INutritionalSection>,
  readonly Offer: Maybe<IOffer>,
  readonly OfferActivation: Maybe<IOfferActivation>,
  readonly OfferDiscount: Maybe<IOfferDiscount>,
  readonly OfferItemDiscount: Maybe<IOfferItemDiscount>,
  readonly OfferLoyaltyAction: Maybe<IOfferLoyaltyAction>,
  readonly OfferTemplate: Maybe<IOfferTemplate>,
  readonly OffersSection: Maybe<IOffersSection>,
  readonly OpPricingRegion: Maybe<IOpPricingRegion>,
  readonly OurServices: Maybe<IOurServices>,
  readonly Picker: Maybe<IPicker>,
  readonly PickerAspect: Maybe<IPickerAspect>,
  readonly PlaceholderField: Maybe<IPlaceholderField>,
  readonly PosConfiguration: Maybe<IPosConfiguration>,
  readonly ProductCategory: Maybe<IProductCategory>,
  readonly QuestTemplate: Maybe<IQuestTemplate>,
  readonly QuestionDetails: Maybe<IQuestionDetails>,
  readonly RecentItems: Maybe<IRecentItems>,
  readonly RemediationReasons: Maybe<IRemediationReasons>,
  readonly ResponseDetails: Maybe<IResponseDetails>,
  readonly Restaurant: Maybe<IRestaurant>,
  readonly RestaurantAmenity: Maybe<IRestaurantAmenity>,
  readonly RestaurantDeliveryProvider: Maybe<IRestaurantDeliveryProvider>,
  readonly RestaurantGroup: Maybe<IRestaurantGroup>,
  readonly RestaurantKioskData: Maybe<IRestaurantKioskData>,
  readonly RestaurantPosData: Maybe<IRestaurantPosData>,
  readonly ResultDetails: Maybe<IResultDetails>,
  readonly Reward: Maybe<IReward>,
  readonly RewardCategory: Maybe<IRewardCategory>,
  readonly RewardList: Maybe<IRewardList>,
  readonly RewardsSection: Maybe<IRewardsSection>,
  readonly RollUpTheRim: Maybe<IRollUpTheRim>,
  readonly RollUpTheRimSection: Maybe<IRollUpTheRimSection>,
  readonly SanityFileAsset: Maybe<ISanityFileAsset>,
  readonly SanityImageAsset: Maybe<ISanityImageAsset>,
  readonly SanityReleaseNotes: Maybe<ISanityReleaseNotes>,
  readonly SanityValidationConfiguration: Maybe<ISanityValidationConfiguration>,
  readonly ScanForRewards: Maybe<IScanForRewards>,
  readonly Section: Maybe<ISection>,
  readonly StaticPage: Maybe<IStaticPage>,
  readonly SupportCategoryGroup: Maybe<ISupportCategoryGroup>,
  readonly SupportData: Maybe<ISupportData>,
  readonly SupportFaq: Maybe<ISupportFaq>,
  readonly SupportSubcategory: Maybe<ISupportSubcategory>,
  readonly SwapMapping: Maybe<ISwapMapping>,
  readonly SystemwideOffer: Maybe<ISystemwideOffer>,
  readonly SystemwidePromotion: Maybe<ISystemwidePromotion>,
  readonly SystemwideQuest: Maybe<ISystemwideQuest>,
  readonly Tag: Maybe<ITag>,
  readonly Tier: Maybe<ITier>,
  readonly Trending: Maybe<ITrending>,
  readonly allAddOnSections: ReadonlyArray<IAddOnSection>,
  readonly allAdminToolReleaseNotes: ReadonlyArray<IAdminToolReleaseNotes>,
  readonly allAlerts: ReadonlyArray<IAlert>,
  readonly allAppData: ReadonlyArray<IAppData>,
  readonly allAppDownloads: ReadonlyArray<IAppDownload>,
  readonly allAppVersions: ReadonlyArray<IAppVersion>,
  readonly allBarcodes: ReadonlyArray<IBarcodes>,
  readonly allBrazeContentCards: ReadonlyArray<IBrazeContentCards>,
  readonly allBuildConfigurations: ReadonlyArray<IBuildConfiguration>,
  readonly allCategories: ReadonlyArray<ICategory>,
  readonly allCateringPageConfigurations: ReadonlyArray<ICateringPageConfiguration>,
  readonly allClaimPointsUis: ReadonlyArray<IClaimPointsUi>,
  readonly allComboSlots: ReadonlyArray<IComboSlot>,
  readonly allCombos: ReadonlyArray<ICombo>,
  readonly allConfigOffers: ReadonlyArray<IConfigOffer>,
  readonly allConfigQuests: ReadonlyArray<IConfigQuest>,
  readonly allConfigRewards: ReadonlyArray<IConfigReward>,
  readonly allDisplayGroups: ReadonlyArray<IDisplayGroup>,
  readonly allEarningCalculations: ReadonlyArray<IEarningCalculation>,
  readonly allEmptyStates: ReadonlyArray<IEmptyState>,
  readonly allFanFavorites: ReadonlyArray<IFanFavorites>,
  readonly allFeatureAccountDeletePages: ReadonlyArray<IFeatureAccountDeletePage>,
  readonly allFeatureAccountForms: ReadonlyArray<IFeatureAccountForm>,
  readonly allFeatureAccountRequestInfoPages: ReadonlyArray<IFeatureAccountRequestInfoPage>,
  readonly allFeatureAccounts: ReadonlyArray<IFeatureAccount>,
  readonly allFeatureBeeperModals: ReadonlyArray<IFeatureBeeperModal>,
  readonly allFeatureCateringPages: ReadonlyArray<IFeatureCateringPage>,
  readonly allFeatureDisclaimers: ReadonlyArray<IFeatureDisclaimers>,
  readonly allFeatureFooterV2S: ReadonlyArray<IFeatureFooterV2>,
  readonly allFeatureFooters: ReadonlyArray<IFeatureFooter>,
  readonly allFeatureGeolocationMapMarkers: ReadonlyArray<IFeatureGeolocationMapMarkers>,
  readonly allFeatureGeolocationModals: ReadonlyArray<IFeatureGeolocationModal>,
  readonly allFeatureGifts: ReadonlyArray<IFeatureGift>,
  readonly allFeatureHomePages: ReadonlyArray<IFeatureHomePage>,
  readonly allFeatureKioskHomePages: ReadonlyArray<IFeatureKioskHomePage>,
  readonly allFeatureKioskMenus: ReadonlyArray<IFeatureKioskMenu>,
  readonly allFeatureKioskScreensavers: ReadonlyArray<IFeatureKioskScreensaver>,
  readonly allFeatureKiosks: ReadonlyArray<IFeatureKiosk>,
  readonly allFeatureLayouts: ReadonlyArray<IFeatureLayout>,
  readonly allFeatureLocationPromos: ReadonlyArray<IFeatureLocationPromo>,
  readonly allFeatureLockers: ReadonlyArray<IFeatureLockers>,
  readonly allFeatureMenus: ReadonlyArray<IFeatureMenu>,
  readonly allFeatureMobileAppConfigurations: ReadonlyArray<IFeatureMobileAppConfiguration>,
  readonly allFeatureNavigations: ReadonlyArray<IFeatureNavigation>,
  readonly allFeatureNutritions: ReadonlyArray<IFeatureNutrition>,
  readonly allFeatureOffers: ReadonlyArray<IFeatureOffers>,
  readonly allFeatureOnboardings: ReadonlyArray<IFeatureOnboarding>,
  readonly allFeaturePaybacks: ReadonlyArray<IFeaturePayback>,
  readonly allFeatureQuizzes: ReadonlyArray<IFeatureQuiz>,
  readonly allFeatureScanAndPays: ReadonlyArray<IFeatureScanAndPay>,
  readonly allFeatureStaticMenus: ReadonlyArray<IFeatureStaticMenu>,
  readonly allFooters: ReadonlyArray<IFooter>,
  readonly allFrontEndConfigurations: ReadonlyArray<IFrontEndConfiguration>,
  readonly allGoogleAdSlots: ReadonlyArray<IGoogleAdSlot>,
  readonly allHeroes: ReadonlyArray<IHero>,
  readonly allHomePageConfigurations: ReadonlyArray<IHomePageConfiguration>,
  readonly allImageWithHeaderAndTexts: ReadonlyArray<IImageWithHeaderAndText>,
  readonly allItems: ReadonlyArray<IItem>,
  readonly allKioskAppData: ReadonlyArray<IKioskAppData>,
  readonly allLinkPhysicalCardUis: ReadonlyArray<ILinkPhysicalCardUi>,
  readonly allLockedOffers: ReadonlyArray<ILockedOffers>,
  readonly allLoyaltyConfigurations: ReadonlyArray<ILoyaltyConfiguration>,
  readonly allLoyaltyContents: ReadonlyArray<ILoyaltyContent>,
  readonly allLoyaltyOffersUis: ReadonlyArray<ILoyaltyOffersUi>,
  readonly allLoyaltyReceipts: ReadonlyArray<ILoyaltyReceipts>,
  readonly allLoyaltyUis: ReadonlyArray<ILoyaltyUi>,
  readonly allMainHeroes: ReadonlyArray<IMainHero>,
  readonly allMarketingCardGroups: ReadonlyArray<IMarketingCardGroup>,
  readonly allMarketingCards: ReadonlyArray<IMarketingCard>,
  readonly allMarketingTileBasics: ReadonlyArray<IMarketingTileBasic>,
  readonly allMarketingTileCarousels: ReadonlyArray<IMarketingTileCarousel>,
  readonly allMarketingTileGroups: ReadonlyArray<IMarketingTileGroup>,
  readonly allMarketingTiles: ReadonlyArray<IMarketingTile>,
  readonly allMediaTags: ReadonlyArray<IMediaTag>,
  readonly allMenus: ReadonlyArray<IMenu>,
  readonly allModifierMultipliers: ReadonlyArray<IModifierMultiplier>,
  readonly allModifiers: ReadonlyArray<IModifier>,
  readonly allNavigationSections: ReadonlyArray<INavigationSection>,
  readonly allNutritionalSections: ReadonlyArray<INutritionalSection>,
  readonly allOfferActivations: ReadonlyArray<IOfferActivation>,
  readonly allOfferDiscounts: ReadonlyArray<IOfferDiscount>,
  readonly allOfferItemDiscounts: ReadonlyArray<IOfferItemDiscount>,
  readonly allOfferLoyaltyActions: ReadonlyArray<IOfferLoyaltyAction>,
  readonly allOfferTemplates: ReadonlyArray<IOfferTemplate>,
  readonly allOffers: ReadonlyArray<IOffer>,
  readonly allOffersSections: ReadonlyArray<IOffersSection>,
  readonly allOpPricingRegions: ReadonlyArray<IOpPricingRegion>,
  readonly allOurServices: ReadonlyArray<IOurServices>,
  readonly allPickerAspects: ReadonlyArray<IPickerAspect>,
  readonly allPickers: ReadonlyArray<IPicker>,
  readonly allPlaceholderFields: ReadonlyArray<IPlaceholderField>,
  readonly allPosConfigurations: ReadonlyArray<IPosConfiguration>,
  readonly allProductCategories: ReadonlyArray<IProductCategory>,
  readonly allQuestTemplates: ReadonlyArray<IQuestTemplate>,
  readonly allQuestionDetails: ReadonlyArray<IQuestionDetails>,
  readonly allRecentItems: ReadonlyArray<IRecentItems>,
  readonly allRemediationReasons: ReadonlyArray<IRemediationReasons>,
  readonly allResponseDetails: ReadonlyArray<IResponseDetails>,
  readonly allRestaurantAmenities: ReadonlyArray<IRestaurantAmenity>,
  readonly allRestaurantDeliveryProviders: ReadonlyArray<IRestaurantDeliveryProvider>,
  readonly allRestaurantGroups: ReadonlyArray<IRestaurantGroup>,
  readonly allRestaurantKioskData: ReadonlyArray<IRestaurantKioskData>,
  readonly allRestaurantPosData: ReadonlyArray<IRestaurantPosData>,
  readonly allRestaurants: ReadonlyArray<IRestaurant>,
  readonly allResultDetails: ReadonlyArray<IResultDetails>,
  readonly allRewardCategories: ReadonlyArray<IRewardCategory>,
  readonly allRewardLists: ReadonlyArray<IRewardList>,
  readonly allRewards: ReadonlyArray<IReward>,
  readonly allRewardsSections: ReadonlyArray<IRewardsSection>,
  readonly allRollUpTheRimSections: ReadonlyArray<IRollUpTheRimSection>,
  readonly allRollUpTheRims: ReadonlyArray<IRollUpTheRim>,
  readonly allSanityFileAssets: ReadonlyArray<ISanityFileAsset>,
  readonly allSanityImageAssets: ReadonlyArray<ISanityImageAsset>,
  readonly allSanityReleaseNotes: ReadonlyArray<ISanityReleaseNotes>,
  readonly allSanityValidationConfigurations: ReadonlyArray<ISanityValidationConfiguration>,
  readonly allScanForRewards: ReadonlyArray<IScanForRewards>,
  readonly allSections: ReadonlyArray<ISection>,
  readonly allStaticPages: ReadonlyArray<IStaticPage>,
  readonly allSupportCategoryGroups: ReadonlyArray<ISupportCategoryGroup>,
  readonly allSupportData: ReadonlyArray<ISupportData>,
  readonly allSupportFaqs: ReadonlyArray<ISupportFaq>,
  readonly allSupportSubcategories: ReadonlyArray<ISupportSubcategory>,
  readonly allSwapMappings: ReadonlyArray<ISwapMapping>,
  readonly allSystemwideOffers: ReadonlyArray<ISystemwideOffer>,
  readonly allSystemwidePromotions: ReadonlyArray<ISystemwidePromotion>,
  readonly allSystemwideQuests: ReadonlyArray<ISystemwideQuest>,
  readonly allTags: ReadonlyArray<ITag>,
  readonly allTiers: ReadonlyArray<ITier>,
  readonly allTrendings: ReadonlyArray<ITrending>,
}


export interface IRootQueryAddOnSectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryAdminToolReleaseNotesArgs {
  id: Scalars['ID']
}


export interface IRootQueryAlertArgs {
  id: Scalars['ID']
}


export interface IRootQueryAppDataArgs {
  id: Scalars['ID']
}


export interface IRootQueryAppDownloadArgs {
  id: Scalars['ID']
}


export interface IRootQueryAppVersionArgs {
  id: Scalars['ID']
}


export interface IRootQueryBarcodesArgs {
  id: Scalars['ID']
}


export interface IRootQueryBrazeContentCardsArgs {
  id: Scalars['ID']
}


export interface IRootQueryBuildConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryCategoryArgs {
  id: Scalars['ID']
}


export interface IRootQueryCateringPageConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryClaimPointsUiArgs {
  id: Scalars['ID']
}


export interface IRootQueryComboArgs {
  id: Scalars['ID']
}


export interface IRootQueryComboSlotArgs {
  id: Scalars['ID']
}


export interface IRootQueryConfigOfferArgs {
  id: Scalars['ID']
}


export interface IRootQueryConfigQuestArgs {
  id: Scalars['ID']
}


export interface IRootQueryConfigRewardArgs {
  id: Scalars['ID']
}


export interface IRootQueryDisplayGroupArgs {
  id: Scalars['ID']
}


export interface IRootQueryEarningCalculationArgs {
  id: Scalars['ID']
}


export interface IRootQueryEmptyStateArgs {
  id: Scalars['ID']
}


export interface IRootQueryFanFavoritesArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureAccountArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureAccountDeletePageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureAccountFormArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureAccountRequestInfoPageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureBeeperModalArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureCateringPageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureDisclaimersArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureFooterArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureFooterV2Args {
  id: Scalars['ID']
}


export interface IRootQueryFeatureGeolocationMapMarkersArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureGeolocationModalArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureGiftArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureHomePageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureKioskArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureKioskHomePageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureKioskMenuArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureKioskScreensaverArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureLayoutArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureLocationPromoArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureLockersArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureMenuArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureMobileAppConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureNavigationArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureNutritionArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureOffersArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureOnboardingArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeaturePaybackArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureQuizArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureScanAndPayArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureStaticMenuArgs {
  id: Scalars['ID']
}


export interface IRootQueryFooterArgs {
  id: Scalars['ID']
}


export interface IRootQueryFrontEndConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryGoogleAdSlotArgs {
  id: Scalars['ID']
}


export interface IRootQueryHeroArgs {
  id: Scalars['ID']
}


export interface IRootQueryHomePageConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryImageWithHeaderAndTextArgs {
  id: Scalars['ID']
}


export interface IRootQueryItemArgs {
  id: Scalars['ID']
}


export interface IRootQueryKioskAppDataArgs {
  id: Scalars['ID']
}


export interface IRootQueryLinkPhysicalCardUiArgs {
  id: Scalars['ID']
}


export interface IRootQueryLockedOffersArgs {
  id: Scalars['ID']
}


export interface IRootQueryLoyaltyConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryLoyaltyContentArgs {
  id: Scalars['ID']
}


export interface IRootQueryLoyaltyOffersUiArgs {
  id: Scalars['ID']
}


export interface IRootQueryLoyaltyReceiptsArgs {
  id: Scalars['ID']
}


export interface IRootQueryLoyaltyUiArgs {
  id: Scalars['ID']
}


export interface IRootQueryMainHeroArgs {
  id: Scalars['ID']
}


export interface IRootQueryMarketingCardArgs {
  id: Scalars['ID']
}


export interface IRootQueryMarketingCardGroupArgs {
  id: Scalars['ID']
}


export interface IRootQueryMarketingTileArgs {
  id: Scalars['ID']
}


export interface IRootQueryMarketingTileBasicArgs {
  id: Scalars['ID']
}


export interface IRootQueryMarketingTileCarouselArgs {
  id: Scalars['ID']
}


export interface IRootQueryMarketingTileGroupArgs {
  id: Scalars['ID']
}


export interface IRootQueryMediaTagArgs {
  id: Scalars['ID']
}


export interface IRootQueryMenuArgs {
  id: Scalars['ID']
}


export interface IRootQueryModifierArgs {
  id: Scalars['ID']
}


export interface IRootQueryModifierMultiplierArgs {
  id: Scalars['ID']
}


export interface IRootQueryNavigationSectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryNutritionalSectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferActivationArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferDiscountArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferItemDiscountArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferLoyaltyActionArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferTemplateArgs {
  id: Scalars['ID']
}


export interface IRootQueryOffersSectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryOpPricingRegionArgs {
  id: Scalars['ID']
}


export interface IRootQueryOurServicesArgs {
  id: Scalars['ID']
}


export interface IRootQueryPickerArgs {
  id: Scalars['ID']
}


export interface IRootQueryPickerAspectArgs {
  id: Scalars['ID']
}


export interface IRootQueryPlaceholderFieldArgs {
  id: Scalars['ID']
}


export interface IRootQueryPosConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryProductCategoryArgs {
  id: Scalars['ID']
}


export interface IRootQueryQuestTemplateArgs {
  id: Scalars['ID']
}


export interface IRootQueryQuestionDetailsArgs {
  id: Scalars['ID']
}


export interface IRootQueryRecentItemsArgs {
  id: Scalars['ID']
}


export interface IRootQueryRemediationReasonsArgs {
  id: Scalars['ID']
}


export interface IRootQueryResponseDetailsArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantAmenityArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantDeliveryProviderArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantGroupArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantKioskDataArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantPosDataArgs {
  id: Scalars['ID']
}


export interface IRootQueryResultDetailsArgs {
  id: Scalars['ID']
}


export interface IRootQueryRewardArgs {
  id: Scalars['ID']
}


export interface IRootQueryRewardCategoryArgs {
  id: Scalars['ID']
}


export interface IRootQueryRewardListArgs {
  id: Scalars['ID']
}


export interface IRootQueryRewardsSectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryRollUpTheRimArgs {
  id: Scalars['ID']
}


export interface IRootQueryRollUpTheRimSectionArgs {
  id: Scalars['ID']
}


export interface IRootQuerySanityFileAssetArgs {
  id: Scalars['ID']
}


export interface IRootQuerySanityImageAssetArgs {
  id: Scalars['ID']
}


export interface IRootQuerySanityReleaseNotesArgs {
  id: Scalars['ID']
}


export interface IRootQuerySanityValidationConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryScanForRewardsArgs {
  id: Scalars['ID']
}


export interface IRootQuerySectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryStaticPageArgs {
  id: Scalars['ID']
}


export interface IRootQuerySupportCategoryGroupArgs {
  id: Scalars['ID']
}


export interface IRootQuerySupportDataArgs {
  id: Scalars['ID']
}


export interface IRootQuerySupportFaqArgs {
  id: Scalars['ID']
}


export interface IRootQuerySupportSubcategoryArgs {
  id: Scalars['ID']
}


export interface IRootQuerySwapMappingArgs {
  id: Scalars['ID']
}


export interface IRootQuerySystemwideOfferArgs {
  id: Scalars['ID']
}


export interface IRootQuerySystemwidePromotionArgs {
  id: Scalars['ID']
}


export interface IRootQuerySystemwideQuestArgs {
  id: Scalars['ID']
}


export interface IRootQueryTagArgs {
  id: Scalars['ID']
}


export interface IRootQueryTierArgs {
  id: Scalars['ID']
}


export interface IRootQueryTrendingArgs {
  id: Scalars['ID']
}


export interface IRootQueryAllAddOnSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAddOnSectionFilter>
}


export interface IRootQueryAllAdminToolReleaseNotesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAdminToolReleaseNotesFilter>
}


export interface IRootQueryAllAlertsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAlertFilter>
}


export interface IRootQueryAllAppDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAppDataFilter>
}


export interface IRootQueryAllAppDownloadsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAppDownloadFilter>
}


export interface IRootQueryAllAppVersionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAppVersionFilter>
}


export interface IRootQueryAllBarcodesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IBarcodesFilter>
}


export interface IRootQueryAllBrazeContentCardsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IBrazeContentCardsFilter>
}


export interface IRootQueryAllBuildConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IBuildConfigurationFilter>
}


export interface IRootQueryAllCategoriesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ICategoryFilter>
}


export interface IRootQueryAllCateringPageConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ICateringPageConfigurationFilter>
}


export interface IRootQueryAllClaimPointsUisArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IClaimPointsUiFilter>
}


export interface IRootQueryAllComboSlotsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IComboSlotFilter>
}


export interface IRootQueryAllCombosArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IComboFilter>
}


export interface IRootQueryAllConfigOffersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IConfigOfferFilter>
}


export interface IRootQueryAllConfigQuestsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IConfigQuestFilter>
}


export interface IRootQueryAllConfigRewardsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IConfigRewardFilter>
}


export interface IRootQueryAllDisplayGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IDisplayGroupFilter>
}


export interface IRootQueryAllEarningCalculationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IEarningCalculationFilter>
}


export interface IRootQueryAllEmptyStatesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IEmptyStateFilter>
}


export interface IRootQueryAllFanFavoritesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFanFavoritesFilter>
}


export interface IRootQueryAllFeatureAccountDeletePagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureAccountDeletePageFilter>
}


export interface IRootQueryAllFeatureAccountFormsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureAccountFormFilter>
}


export interface IRootQueryAllFeatureAccountRequestInfoPagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureAccountRequestInfoPageFilter>
}


export interface IRootQueryAllFeatureAccountsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureAccountFilter>
}


export interface IRootQueryAllFeatureBeeperModalsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureBeeperModalFilter>
}


export interface IRootQueryAllFeatureCateringPagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureCateringPageFilter>
}


export interface IRootQueryAllFeatureDisclaimersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureDisclaimersFilter>
}


export interface IRootQueryAllFeatureFooterV2SArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureFooterV2Filter>
}


export interface IRootQueryAllFeatureFootersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureFooterFilter>
}


export interface IRootQueryAllFeatureGeolocationMapMarkersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureGeolocationMapMarkersFilter>
}


export interface IRootQueryAllFeatureGeolocationModalsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureGeolocationModalFilter>
}


export interface IRootQueryAllFeatureGiftsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureGiftFilter>
}


export interface IRootQueryAllFeatureHomePagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureHomePageFilter>
}


export interface IRootQueryAllFeatureKioskHomePagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureKioskHomePageFilter>
}


export interface IRootQueryAllFeatureKioskMenusArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureKioskMenuFilter>
}


export interface IRootQueryAllFeatureKioskScreensaversArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureKioskScreensaverFilter>
}


export interface IRootQueryAllFeatureKiosksArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureKioskFilter>
}


export interface IRootQueryAllFeatureLayoutsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureLayoutFilter>
}


export interface IRootQueryAllFeatureLocationPromosArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureLocationPromoFilter>
}


export interface IRootQueryAllFeatureLockersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureLockersFilter>
}


export interface IRootQueryAllFeatureMenusArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureMenuFilter>
}


export interface IRootQueryAllFeatureMobileAppConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureMobileAppConfigurationFilter>
}


export interface IRootQueryAllFeatureNavigationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureNavigationFilter>
}


export interface IRootQueryAllFeatureNutritionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureNutritionFilter>
}


export interface IRootQueryAllFeatureOffersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureOffersFilter>
}


export interface IRootQueryAllFeatureOnboardingsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureOnboardingFilter>
}


export interface IRootQueryAllFeaturePaybacksArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeaturePaybackFilter>
}


export interface IRootQueryAllFeatureQuizzesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureQuizFilter>
}


export interface IRootQueryAllFeatureScanAndPaysArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureScanAndPayFilter>
}


export interface IRootQueryAllFeatureStaticMenusArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureStaticMenuFilter>
}


export interface IRootQueryAllFootersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFooterFilter>
}


export interface IRootQueryAllFrontEndConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFrontEndConfigurationFilter>
}


export interface IRootQueryAllGoogleAdSlotsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IGoogleAdSlotFilter>
}


export interface IRootQueryAllHeroesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IHeroFilter>
}


export interface IRootQueryAllHomePageConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IHomePageConfigurationFilter>
}


export interface IRootQueryAllImageWithHeaderAndTextsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IImageWithHeaderAndTextFilter>
}


export interface IRootQueryAllItemsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IItemFilter>
}


export interface IRootQueryAllKioskAppDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IKioskAppDataFilter>
}


export interface IRootQueryAllLinkPhysicalCardUisArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILinkPhysicalCardUiFilter>
}


export interface IRootQueryAllLockedOffersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILockedOffersFilter>
}


export interface IRootQueryAllLoyaltyConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILoyaltyConfigurationFilter>
}


export interface IRootQueryAllLoyaltyContentsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILoyaltyContentFilter>
}


export interface IRootQueryAllLoyaltyOffersUisArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILoyaltyOffersUiFilter>
}


export interface IRootQueryAllLoyaltyReceiptsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILoyaltyReceiptsFilter>
}


export interface IRootQueryAllLoyaltyUisArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILoyaltyUiFilter>
}


export interface IRootQueryAllMainHeroesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMainHeroFilter>
}


export interface IRootQueryAllMarketingCardGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMarketingCardGroupFilter>
}


export interface IRootQueryAllMarketingCardsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMarketingCardFilter>
}


export interface IRootQueryAllMarketingTileBasicsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMarketingTileBasicFilter>
}


export interface IRootQueryAllMarketingTileCarouselsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMarketingTileCarouselFilter>
}


export interface IRootQueryAllMarketingTileGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMarketingTileGroupFilter>
}


export interface IRootQueryAllMarketingTilesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMarketingTileFilter>
}


export interface IRootQueryAllMediaTagsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMediaTagFilter>
}


export interface IRootQueryAllMenusArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMenuFilter>
}


export interface IRootQueryAllModifierMultipliersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IModifierMultiplierFilter>
}


export interface IRootQueryAllModifiersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IModifierFilter>
}


export interface IRootQueryAllNavigationSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<INavigationSectionFilter>
}


export interface IRootQueryAllNutritionalSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<INutritionalSectionFilter>
}


export interface IRootQueryAllOfferActivationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferActivationFilter>
}


export interface IRootQueryAllOfferDiscountsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferDiscountFilter>
}


export interface IRootQueryAllOfferItemDiscountsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferItemDiscountFilter>
}


export interface IRootQueryAllOfferLoyaltyActionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferLoyaltyActionFilter>
}


export interface IRootQueryAllOfferTemplatesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferTemplateFilter>
}


export interface IRootQueryAllOffersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferFilter>
}


export interface IRootQueryAllOffersSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOffersSectionFilter>
}


export interface IRootQueryAllOpPricingRegionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOpPricingRegionFilter>
}


export interface IRootQueryAllOurServicesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOurServicesFilter>
}


export interface IRootQueryAllPickerAspectsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IPickerAspectFilter>
}


export interface IRootQueryAllPickersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IPickerFilter>
}


export interface IRootQueryAllPlaceholderFieldsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IPlaceholderFieldFilter>
}


export interface IRootQueryAllPosConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IPosConfigurationFilter>
}


export interface IRootQueryAllProductCategoriesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IProductCategoryFilter>
}


export interface IRootQueryAllQuestTemplatesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IQuestTemplateFilter>
}


export interface IRootQueryAllQuestionDetailsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IQuestionDetailsFilter>
}


export interface IRootQueryAllRecentItemsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRecentItemsFilter>
}


export interface IRootQueryAllRemediationReasonsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRemediationReasonsFilter>
}


export interface IRootQueryAllResponseDetailsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IResponseDetailsFilter>
}


export interface IRootQueryAllRestaurantAmenitiesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantAmenityFilter>
}


export interface IRootQueryAllRestaurantDeliveryProvidersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantDeliveryProviderFilter>
}


export interface IRootQueryAllRestaurantGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantGroupFilter>
}


export interface IRootQueryAllRestaurantKioskDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantKioskDataFilter>
}


export interface IRootQueryAllRestaurantPosDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantPosDataFilter>
}


export interface IRootQueryAllRestaurantsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantFilter>
}


export interface IRootQueryAllResultDetailsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IResultDetailsFilter>
}


export interface IRootQueryAllRewardCategoriesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRewardCategoryFilter>
}


export interface IRootQueryAllRewardListsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRewardListFilter>
}


export interface IRootQueryAllRewardsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRewardFilter>
}


export interface IRootQueryAllRewardsSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRewardsSectionFilter>
}


export interface IRootQueryAllRollUpTheRimSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRollUpTheRimSectionFilter>
}


export interface IRootQueryAllRollUpTheRimsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRollUpTheRimFilter>
}


export interface IRootQueryAllSanityFileAssetsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISanityFileAssetFilter>
}


export interface IRootQueryAllSanityImageAssetsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISanityImageAssetFilter>
}


export interface IRootQueryAllSanityReleaseNotesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISanityReleaseNotesFilter>
}


export interface IRootQueryAllSanityValidationConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISanityValidationConfigurationFilter>
}


export interface IRootQueryAllScanForRewardsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IScanForRewardsFilter>
}


export interface IRootQueryAllSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISectionFilter>
}


export interface IRootQueryAllStaticPagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IStaticPageFilter>
}


export interface IRootQueryAllSupportCategoryGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISupportCategoryGroupFilter>
}


export interface IRootQueryAllSupportDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISupportDataFilter>
}


export interface IRootQueryAllSupportFaqsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISupportFaqFilter>
}


export interface IRootQueryAllSupportSubcategoriesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISupportSubcategoryFilter>
}


export interface IRootQueryAllSwapMappingsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISwapMappingFilter>
}


export interface IRootQueryAllSystemwideOffersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISystemwideOfferFilter>
}


export interface IRootQueryAllSystemwidePromotionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISystemwidePromotionFilter>
}


export interface IRootQueryAllSystemwideQuestsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISystemwideQuestFilter>
}


export interface IRootQueryAllTagsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ITagFilter>
}


export interface IRootQueryAllTiersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ITierFilter>
}


export interface IRootQueryAllTrendingsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ITrendingFilter>
}

export interface IRoundingRules {
  readonly __typename?: 'RoundingRules',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly decimalPlaces: Maybe<Scalars['Float']>,
  readonly enabled: Maybe<Scalars['Boolean']>,
  readonly roundingType: Maybe<Scalars['String']>,
}

export interface IRow {
  readonly __typename?: 'Row',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly columns: Maybe<ReadonlyArray<Maybe<IColumn>>>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IRumConfig {
  readonly __typename?: 'RumConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly applicationId: Maybe<Scalars['String']>,
  readonly clientToken: Maybe<Scalars['String']>,
  readonly dataCenter: Maybe<Scalars['String']>,
}

export interface IRutrFooter {
  readonly __typename?: 'RutrFooter',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly footerLinkLocalizedPath: Maybe<ILocaleString>,
  readonly footerLinkText: Maybe<ILocaleString>,
  readonly footerText: Maybe<ILocaleString>,
  readonly footerTitle: Maybe<ILocaleString>,
}

export interface ISanityAssetSourceData {
  readonly __typename?: 'SanityAssetSourceData',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly id: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly url: Maybe<Scalars['String']>,
}

export interface ISanityFileAsset  extends IDocument {
  readonly __typename?: 'SanityFileAsset',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly altText: Maybe<Scalars['String']>,
  readonly assetId: Maybe<Scalars['String']>,
  readonly description: Maybe<Scalars['String']>,
  readonly extension: Maybe<Scalars['String']>,
  readonly label: Maybe<Scalars['String']>,
  readonly mimeType: Maybe<Scalars['String']>,
  readonly originalFilename: Maybe<Scalars['String']>,
  readonly path: Maybe<Scalars['String']>,
  readonly sha1hash: Maybe<Scalars['String']>,
  readonly size: Maybe<Scalars['Float']>,
  readonly source: Maybe<ISanityAssetSourceData>,
  readonly title: Maybe<Scalars['String']>,
  readonly url: Maybe<Scalars['String']>,
}

export interface ISanityFileAssetFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly altText?: Maybe<Scalars['String']>,
  readonly altText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly altText_matches?: Maybe<Scalars['String']>,
  readonly altText_not?: Maybe<Scalars['String']>,
  readonly altText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly assetId?: Maybe<Scalars['String']>,
  readonly assetId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly assetId_matches?: Maybe<Scalars['String']>,
  readonly assetId_not?: Maybe<Scalars['String']>,
  readonly assetId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly description?: Maybe<Scalars['String']>,
  readonly description_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly description_matches?: Maybe<Scalars['String']>,
  readonly description_not?: Maybe<Scalars['String']>,
  readonly description_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly extension?: Maybe<Scalars['String']>,
  readonly extension_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly extension_matches?: Maybe<Scalars['String']>,
  readonly extension_not?: Maybe<Scalars['String']>,
  readonly extension_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly label?: Maybe<Scalars['String']>,
  readonly label_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly label_matches?: Maybe<Scalars['String']>,
  readonly label_not?: Maybe<Scalars['String']>,
  readonly label_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mimeType?: Maybe<Scalars['String']>,
  readonly mimeType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mimeType_matches?: Maybe<Scalars['String']>,
  readonly mimeType_not?: Maybe<Scalars['String']>,
  readonly mimeType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly originalFilename?: Maybe<Scalars['String']>,
  readonly originalFilename_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly originalFilename_matches?: Maybe<Scalars['String']>,
  readonly originalFilename_not?: Maybe<Scalars['String']>,
  readonly originalFilename_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path?: Maybe<Scalars['String']>,
  readonly path_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path_matches?: Maybe<Scalars['String']>,
  readonly path_not?: Maybe<Scalars['String']>,
  readonly path_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sha1hash?: Maybe<Scalars['String']>,
  readonly sha1hash_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sha1hash_matches?: Maybe<Scalars['String']>,
  readonly sha1hash_not?: Maybe<Scalars['String']>,
  readonly sha1hash_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly size?: Maybe<Scalars['Float']>,
  readonly size_gt?: Maybe<Scalars['Float']>,
  readonly size_gte?: Maybe<Scalars['Float']>,
  readonly size_lt?: Maybe<Scalars['Float']>,
  readonly size_lte?: Maybe<Scalars['Float']>,
  readonly size_not?: Maybe<Scalars['Float']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly title_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly title_matches?: Maybe<Scalars['String']>,
  readonly title_not?: Maybe<Scalars['String']>,
  readonly title_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly url?: Maybe<Scalars['String']>,
  readonly url_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly url_matches?: Maybe<Scalars['String']>,
  readonly url_not?: Maybe<Scalars['String']>,
  readonly url_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISanityImageAsset  extends IDocument {
  readonly __typename?: 'SanityImageAsset',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly altText: Maybe<Scalars['String']>,
  readonly assetId: Maybe<Scalars['String']>,
  readonly description: Maybe<Scalars['String']>,
  readonly extension: Maybe<Scalars['String']>,
  readonly label: Maybe<Scalars['String']>,
  readonly metadata: Maybe<ISanityImageMetadata>,
  readonly mimeType: Maybe<Scalars['String']>,
  readonly originalFilename: Maybe<Scalars['String']>,
  readonly path: Maybe<Scalars['String']>,
  readonly sha1hash: Maybe<Scalars['String']>,
  readonly size: Maybe<Scalars['Float']>,
  readonly source: Maybe<ISanityAssetSourceData>,
  readonly title: Maybe<Scalars['String']>,
  readonly uploadId: Maybe<Scalars['String']>,
  readonly url: Maybe<Scalars['String']>,
}

export interface ISanityImageAssetFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly altText?: Maybe<Scalars['String']>,
  readonly altText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly altText_matches?: Maybe<Scalars['String']>,
  readonly altText_not?: Maybe<Scalars['String']>,
  readonly altText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly assetId?: Maybe<Scalars['String']>,
  readonly assetId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly assetId_matches?: Maybe<Scalars['String']>,
  readonly assetId_not?: Maybe<Scalars['String']>,
  readonly assetId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly description?: Maybe<Scalars['String']>,
  readonly description_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly description_matches?: Maybe<Scalars['String']>,
  readonly description_not?: Maybe<Scalars['String']>,
  readonly description_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly extension?: Maybe<Scalars['String']>,
  readonly extension_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly extension_matches?: Maybe<Scalars['String']>,
  readonly extension_not?: Maybe<Scalars['String']>,
  readonly extension_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly label?: Maybe<Scalars['String']>,
  readonly label_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly label_matches?: Maybe<Scalars['String']>,
  readonly label_not?: Maybe<Scalars['String']>,
  readonly label_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mimeType?: Maybe<Scalars['String']>,
  readonly mimeType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mimeType_matches?: Maybe<Scalars['String']>,
  readonly mimeType_not?: Maybe<Scalars['String']>,
  readonly mimeType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly originalFilename?: Maybe<Scalars['String']>,
  readonly originalFilename_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly originalFilename_matches?: Maybe<Scalars['String']>,
  readonly originalFilename_not?: Maybe<Scalars['String']>,
  readonly originalFilename_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path?: Maybe<Scalars['String']>,
  readonly path_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path_matches?: Maybe<Scalars['String']>,
  readonly path_not?: Maybe<Scalars['String']>,
  readonly path_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sha1hash?: Maybe<Scalars['String']>,
  readonly sha1hash_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sha1hash_matches?: Maybe<Scalars['String']>,
  readonly sha1hash_not?: Maybe<Scalars['String']>,
  readonly sha1hash_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly size?: Maybe<Scalars['Float']>,
  readonly size_gt?: Maybe<Scalars['Float']>,
  readonly size_gte?: Maybe<Scalars['Float']>,
  readonly size_lt?: Maybe<Scalars['Float']>,
  readonly size_lte?: Maybe<Scalars['Float']>,
  readonly size_not?: Maybe<Scalars['Float']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly title_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly title_matches?: Maybe<Scalars['String']>,
  readonly title_not?: Maybe<Scalars['String']>,
  readonly title_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uploadId?: Maybe<Scalars['String']>,
  readonly uploadId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uploadId_matches?: Maybe<Scalars['String']>,
  readonly uploadId_not?: Maybe<Scalars['String']>,
  readonly uploadId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly url?: Maybe<Scalars['String']>,
  readonly url_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly url_matches?: Maybe<Scalars['String']>,
  readonly url_not?: Maybe<Scalars['String']>,
  readonly url_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISanityImageCrop {
  readonly __typename?: 'SanityImageCrop',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bottom: Maybe<Scalars['Float']>,
  readonly left: Maybe<Scalars['Float']>,
  readonly right: Maybe<Scalars['Float']>,
  readonly top: Maybe<Scalars['Float']>,
}

export interface ISanityImageDimensions {
  readonly __typename?: 'SanityImageDimensions',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly aspectRatio: Maybe<Scalars['Float']>,
  readonly height: Maybe<Scalars['Float']>,
  readonly width: Maybe<Scalars['Float']>,
}

export interface ISanityImageHotspot {
  readonly __typename?: 'SanityImageHotspot',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly height: Maybe<Scalars['Float']>,
  readonly width: Maybe<Scalars['Float']>,
  readonly x: Maybe<Scalars['Float']>,
  readonly y: Maybe<Scalars['Float']>,
}

export interface ISanityImageMetadata {
  readonly __typename?: 'SanityImageMetadata',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly blurHash: Maybe<Scalars['String']>,
  readonly dimensions: Maybe<ISanityImageDimensions>,
  readonly hasAlpha: Maybe<Scalars['Boolean']>,
  readonly isOpaque: Maybe<Scalars['Boolean']>,
  readonly location: Maybe<IGeopoint>,
  readonly lqip: Maybe<Scalars['String']>,
  readonly palette: Maybe<ISanityImagePalette>,
}

export interface ISanityImagePalette {
  readonly __typename?: 'SanityImagePalette',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly darkMuted: Maybe<ISanityImagePaletteSwatch>,
  readonly darkVibrant: Maybe<ISanityImagePaletteSwatch>,
  readonly dominant: Maybe<ISanityImagePaletteSwatch>,
  readonly lightMuted: Maybe<ISanityImagePaletteSwatch>,
  readonly lightVibrant: Maybe<ISanityImagePaletteSwatch>,
  readonly muted: Maybe<ISanityImagePaletteSwatch>,
  readonly vibrant: Maybe<ISanityImagePaletteSwatch>,
}

export interface ISanityImagePaletteSwatch {
  readonly __typename?: 'SanityImagePaletteSwatch',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly background: Maybe<Scalars['String']>,
  readonly foreground: Maybe<Scalars['String']>,
  readonly population: Maybe<Scalars['Float']>,
  readonly title: Maybe<Scalars['String']>,
}

export interface ISanityReleaseNotes  extends IDocument {
  readonly __typename?: 'SanityReleaseNotes',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly releaseDate: Maybe<Scalars['Date']>,
  readonly releaseNotesRaw: Maybe<Scalars['JSON']>,
  readonly syncReleaseNotes: Maybe<Scalars['String']>,
}

export interface ISanityReleaseNotesFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly releaseDate?: Maybe<Scalars['Date']>,
  readonly releaseDate_gt?: Maybe<Scalars['Date']>,
  readonly releaseDate_gte?: Maybe<Scalars['Date']>,
  readonly releaseDate_lt?: Maybe<Scalars['Date']>,
  readonly releaseDate_lte?: Maybe<Scalars['Date']>,
  readonly releaseDate_not?: Maybe<Scalars['Date']>,
  readonly syncReleaseNotes?: Maybe<Scalars['String']>,
  readonly syncReleaseNotes_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly syncReleaseNotes_matches?: Maybe<Scalars['String']>,
  readonly syncReleaseNotes_not?: Maybe<Scalars['String']>,
  readonly syncReleaseNotes_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISanityValidationConfiguration  extends IDocument {
  readonly __typename?: 'SanityValidationConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly restaurantAvailabilityValidation: Maybe<IPosValidationThreshold>,
}

export interface ISanityValidationConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IScanForRewards  extends IDocument {
  readonly __typename?: 'ScanForRewards',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IScanForRewardsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISection  extends IDocument {
  readonly __typename?: 'Section',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly carouselImage: Maybe<IImage>,
  readonly carouselImageDescription: Maybe<ILocaleString>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly daypart: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly headerSuperText: Maybe<ILocaleString>,
  readonly headerText: Maybe<ILocaleString>,
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly isBurgersForBreakfastSection: Maybe<Scalars['Boolean']>,
  readonly isRealMeal: Maybe<Scalars['Boolean']>,
  readonly kioskImage: Maybe<IImage>,
  readonly kioskImageDescription: Maybe<ILocaleString>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>,
  readonly redirectLink: Maybe<ILocaleUrl>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
}

export interface ISectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly isBurgersForBreakfastSection?: Maybe<Scalars['Boolean']>,
  readonly isBurgersForBreakfastSection_not?: Maybe<Scalars['Boolean']>,
  readonly isRealMeal?: Maybe<Scalars['Boolean']>,
  readonly isRealMeal_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IServiceModeRestrictions {
  readonly __typename?: 'ServiceModeRestrictions',
  readonly CATERING_DELIVERY: Maybe<Scalars['Boolean']>,
  readonly CATERING_PICKUP: Maybe<Scalars['Boolean']>,
  readonly CURBSIDE: Maybe<Scalars['Boolean']>,
  readonly DELIVERY: Maybe<Scalars['Boolean']>,
  readonly DRIVE_THRU: Maybe<Scalars['Boolean']>,
  readonly EAT_IN: Maybe<Scalars['Boolean']>,
  readonly TAKEOUT: Maybe<Scalars['Boolean']>,
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
}

export interface IShortCodeConfirmationModalContent {
  readonly __typename?: 'ShortCodeConfirmationModalContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly actionButton: Maybe<IActionButton>,
  readonly body: Maybe<ILocaleString>,
  readonly dismissButtonText: Maybe<ILocaleString>,
  readonly header: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImages>,
}

export interface ISimpleCard {
  readonly __typename?: 'SimpleCard',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<IImage>,
  readonly title: Maybe<ILocaleString>,
}

export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly comboPlu: Maybe<Scalars['String']>,
  readonly comboSize: Maybe<Scalars['String']>,
}

export interface ISkillsTest {
  readonly __typename?: 'SkillsTest',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly answersList: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>,
  readonly correctAnswer: Maybe<Scalars['Float']>,
  readonly mathBlock: Maybe<ILocaleBlockContent>,
}

export interface ISlug {
  readonly __typename?: 'Slug',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly current: Maybe<Scalars['String']>,
}

export interface ISocialIconsWidget {
  readonly __typename?: 'SocialIconsWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly facebookUrl: Maybe<ILocaleUrl>,
  readonly instagramUrl: Maybe<ILocaleUrl>,
  readonly tiktokUrl: Maybe<ILocaleUrl>,
  readonly twitterUrl: Maybe<ILocaleUrl>,
  readonly youtubeUrl: Maybe<ILocaleUrl>,
}

export interface ISocialIconsWithHeaderWidget {
  readonly __typename?: 'SocialIconsWithHeaderWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly header: Maybe<ILocaleString>,
  readonly socialIconsWidget: Maybe<ISocialIconsWidget>,
}

export interface ISpan {
  readonly __typename?: 'Span',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly marks: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly text: Maybe<Scalars['String']>,
}

export interface IStaticPage  extends IDocument {
  readonly __typename?: 'StaticPage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly displayIndex: Maybe<Scalars['Float']>,
  readonly image: Maybe<IImage>,
  readonly includedInSitemap: Maybe<Scalars['Boolean']>,
  readonly localePath: Maybe<ILocaleSlug>,
  readonly localeTitle: Maybe<ILocaleString>,
  readonly pageCSS: Maybe<ICss>,
  readonly pageHtml: Maybe<IHtml>,
  readonly pageVariablesRaw: Maybe<Scalars['JSON']>,
  readonly parent: Maybe<IStaticPage>,
  readonly path: Maybe<ISlug>,
  readonly redirectUrl: Maybe<ILocaleString>,
  readonly title: Maybe<Scalars['String']>,
  readonly vendorId: Maybe<Scalars['String']>,
  readonly vendorRedirectPath: Maybe<ILocaleString>,
  readonly widgets: Maybe<ReadonlyArray<Maybe<IAccordionWidgetOrAnchorLinksWidgetOrAnchorWidgetOrCallToActionWidgetOrDoubleImageWidgetOrHeaderWidgetOrImageWidgetOrLocaleBlockTextWidgetOrMultiWidgetOrNutritionExplorerWidgetOrNutritionInfoWidgetOrPreviewWidgetOrQuoteWidgetOrVideoWidgetOrYoutubeWidget>>>,
}

export interface IStaticPageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly displayIndex?: Maybe<Scalars['Float']>,
  readonly displayIndex_gt?: Maybe<Scalars['Float']>,
  readonly displayIndex_gte?: Maybe<Scalars['Float']>,
  readonly displayIndex_lt?: Maybe<Scalars['Float']>,
  readonly displayIndex_lte?: Maybe<Scalars['Float']>,
  readonly displayIndex_not?: Maybe<Scalars['Float']>,
  readonly includedInSitemap?: Maybe<Scalars['Boolean']>,
  readonly includedInSitemap_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly parent?: Maybe<Scalars['ID']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly title_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly title_matches?: Maybe<Scalars['String']>,
  readonly title_not?: Maybe<Scalars['String']>,
  readonly title_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly vendorId?: Maybe<Scalars['String']>,
  readonly vendorId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly vendorId_matches?: Maybe<Scalars['String']>,
  readonly vendorId_not?: Maybe<Scalars['String']>,
  readonly vendorId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IStoreLocatorContent {
  readonly __typename?: 'StoreLocatorContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly findStoresCard: Maybe<ITextCard>,
  readonly noStoresCard: Maybe<ITextCard>,
  readonly searchThisAreaButtonLabel: Maybe<ILocaleString>,
  readonly tabsContent: Maybe<ITabsContent>,
  readonly tabsStoreLocatorContent: Maybe<ITabsStoreLocatorContent>,
}

export interface ISubtotalSpend {
  readonly __typename?: 'SubtotalSpend',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly minimumSpend: Maybe<Scalars['Float']>,
}

export interface ISupportCategory {
  readonly __typename?: 'SupportCategory',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly directTicketProcessingPercentage: Maybe<Scalars['Float']>,
  readonly knowledgeForceIssueId: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
}

export interface ISupportCategoryGroup  extends IDocument {
  readonly __typename?: 'SupportCategoryGroup',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<ILocaleString>,
  readonly showRestaurantSelector: Maybe<Scalars['Boolean']>,
  readonly supportSubcategories: Maybe<ReadonlyArray<Maybe<ISupportSubcategory>>>,
  readonly suppotCategoryFaqs: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>,
}

export interface ISupportCategoryGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly showRestaurantSelector?: Maybe<Scalars['Boolean']>,
  readonly showRestaurantSelector_not?: Maybe<Scalars['Boolean']>,
}

export interface ISupportCategorySubTypes {
  readonly __typename?: 'SupportCategorySubTypes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly directTicketProcessingPercentage: Maybe<Scalars['Float']>,
  readonly knowledgeForceIssueId: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
}

export interface ISupportCategoryTypes {
  readonly __typename?: 'SupportCategoryTypes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly supportCategorySubTypes: Maybe<ReadonlyArray<Maybe<ISupportCategorySubTypes>>>,
}

export interface ISupportData  extends IDocument {
  readonly __typename?: 'SupportData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly categories: Maybe<ReadonlyArray<Maybe<ISupportCategory>>>,
  readonly deliveryMissingItemsSubcategory: Maybe<ISupportSubcategory>,
  readonly deliveryNeverArriveSubcategory: Maybe<ISupportSubcategory>,
  readonly orderingIssuesCategoryGroup: Maybe<ISupportCategoryGroup>,
  readonly supportCategories: Maybe<ReadonlyArray<Maybe<ISupportCategoryTypes>>>,
  readonly supportCategoryGroups: Maybe<ReadonlyArray<Maybe<ISupportCategoryGroup>>>,
  readonly supportDataFaqs: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>,
  readonly supportFaqs: Maybe<ReadonlyArray<Maybe<ISupportFaqs>>>,
  readonly updateDateOfBirthSubcategory: Maybe<ISupportSubcategory>,
}

export interface ISupportDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly deliveryMissingItemsSubcategory?: Maybe<Scalars['ID']>,
  readonly deliveryNeverArriveSubcategory?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly orderingIssuesCategoryGroup?: Maybe<Scalars['ID']>,
  readonly updateDateOfBirthSubcategory?: Maybe<Scalars['ID']>,
}

export interface ISupportFaq  extends IDocument {
  readonly __typename?: 'SupportFaq',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly supportFaqContent: Maybe<ILocaleBlockContent>,
  readonly supportFaqMParticleEvent: Maybe<Scalars['String']>,
  readonly supportFaqTitle: Maybe<ILocaleString>,
}

export interface ISupportFaqFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly supportFaqMParticleEvent?: Maybe<Scalars['String']>,
  readonly supportFaqMParticleEvent_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly supportFaqMParticleEvent_matches?: Maybe<Scalars['String']>,
  readonly supportFaqMParticleEvent_not?: Maybe<Scalars['String']>,
  readonly supportFaqMParticleEvent_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISupportFaqs {
  readonly __typename?: 'SupportFaqs',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly accordionWidget: Maybe<IAccordionWidget>,
  readonly key: Maybe<Scalars['String']>,
}

export interface ISupportSubcategory  extends IDocument {
  readonly __typename?: 'SupportSubcategory',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly directTicketProcessingPercentage: Maybe<Scalars['Float']>,
  readonly knowledgeForceIssueId: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly supportSubcategoryFaq: Maybe<ISupportFaq>,
  readonly supportSubcategoryFaqs: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>,
  readonly supportSubcategoryForwardToOrders: Maybe<Scalars['Boolean']>,
  readonly supportSubcategoryServiceModeSelector: Maybe<Scalars['Boolean']>,
  readonly supportSubcategorySubmitToSutherland: Maybe<Scalars['Boolean']>,
}

export interface ISupportSubcategoryFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly directTicketProcessingPercentage?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_gt?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_gte?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_lt?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_lte?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly knowledgeForceIssueId?: Maybe<Scalars['String']>,
  readonly knowledgeForceIssueId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly knowledgeForceIssueId_matches?: Maybe<Scalars['String']>,
  readonly knowledgeForceIssueId_not?: Maybe<Scalars['String']>,
  readonly knowledgeForceIssueId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly supportSubcategoryFaq?: Maybe<Scalars['ID']>,
  readonly supportSubcategoryForwardToOrders?: Maybe<Scalars['Boolean']>,
  readonly supportSubcategoryForwardToOrders_not?: Maybe<Scalars['Boolean']>,
  readonly supportSubcategoryServiceModeSelector?: Maybe<Scalars['Boolean']>,
  readonly supportSubcategoryServiceModeSelector_not?: Maybe<Scalars['Boolean']>,
  readonly supportSubcategorySubmitToSutherland?: Maybe<Scalars['Boolean']>,
  readonly supportSubcategorySubmitToSutherland_not?: Maybe<Scalars['Boolean']>,
}

export interface ISurpriseAndDelightModalContent {
  readonly __typename?: 'SurpriseAndDelightModalContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly backgroundImage: Maybe<ILocaleImage>,
  readonly buttonText: Maybe<ILocaleString>,
  readonly description: Maybe<ILocaleString>,
  readonly noThanksText: Maybe<ILocaleString>,
  readonly prompt: Maybe<ILocaleString>,
  readonly termsText: Maybe<ILocaleBlockContent>,
  readonly title: Maybe<ILocaleString>,
}

export interface ISwap {
  readonly __typename?: 'Swap',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly initialItem: Maybe<IComboOrItem>,
  readonly swapType: Maybe<Scalars['String']>,
  readonly swappedItem: Maybe<IComboOrItem>,
}

export interface ISwapMapping  extends IDocument {
  readonly __typename?: 'SwapMapping',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly eligibleSwaps: Maybe<ReadonlyArray<Maybe<ISwap>>>,
  readonly internalName: Maybe<Scalars['String']>,
}

export interface ISwapMappingFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly internalName?: Maybe<Scalars['String']>,
  readonly internalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly internalName_matches?: Maybe<Scalars['String']>,
  readonly internalName_not?: Maybe<Scalars['String']>,
  readonly internalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ISwapModalContent {
  readonly __typename?: 'SwapModalContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly itemSelectionHeader: Maybe<ILocaleString>,
  readonly noThanksButtonText: Maybe<ILocaleString>,
  readonly swapButtonText: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ISystemwideOffer  extends IDocument {
  readonly __typename?: 'SystemwideOffer',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<IImage>,
  readonly configOnly: Maybe<Scalars['Boolean']>,
  readonly daypart: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly incentives: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferActivationOrOfferDiscountOrPickerOrSwapMapping>>>,
  readonly localizedImage: Maybe<ILocaleImages>,
  readonly lockedOffersPanel: Maybe<ILockedOffersPanel>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly marketPrice: Maybe<IComboOrItem>,
  readonly mobileOrderOnly: Maybe<Scalars['Boolean']>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly name: Maybe<ILocaleBlockContent>,
  readonly notificationDetails: Maybe<INotificationDetails>,
  readonly offerPrice: Maybe<Scalars['Float']>,
  readonly permutationPricingValidation: Maybe<IDataValidationObject>,
  readonly position: Maybe<Scalars['Boolean']>,
  readonly priceDistributionValidation: Maybe<IDataValidationObject>,
  readonly promoCodePanel: Maybe<IPromoCodePanel>,
  readonly redemptionType: Maybe<Scalars['String']>,
  readonly restaurantAvailabilityValidation: Maybe<IDataValidationObject>,
  readonly rules: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrCartLimitOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIsStackableOrLimitOrLoyaltyBetweenTimesOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated>>>,
  readonly shortCode: Maybe<Scalars['String']>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
}

export interface ISystemwideOfferFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly configOnly?: Maybe<Scalars['Boolean']>,
  readonly configOnly_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly marketPrice?: Maybe<Scalars['ID']>,
  readonly mobileOrderOnly?: Maybe<Scalars['Boolean']>,
  readonly mobileOrderOnly_not?: Maybe<Scalars['Boolean']>,
  readonly offerPrice?: Maybe<Scalars['Float']>,
  readonly offerPrice_gt?: Maybe<Scalars['Float']>,
  readonly offerPrice_gte?: Maybe<Scalars['Float']>,
  readonly offerPrice_lt?: Maybe<Scalars['Float']>,
  readonly offerPrice_lte?: Maybe<Scalars['Float']>,
  readonly offerPrice_not?: Maybe<Scalars['Float']>,
  readonly position?: Maybe<Scalars['Boolean']>,
  readonly position_not?: Maybe<Scalars['Boolean']>,
  readonly redemptionType?: Maybe<Scalars['String']>,
  readonly redemptionType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly redemptionType_matches?: Maybe<Scalars['String']>,
  readonly redemptionType_not?: Maybe<Scalars['String']>,
  readonly redemptionType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly shortCode?: Maybe<Scalars['String']>,
  readonly shortCode_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly shortCode_matches?: Maybe<Scalars['String']>,
  readonly shortCode_not?: Maybe<Scalars['String']>,
  readonly shortCode_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISystemwidePromotion  extends IDocument {
  readonly __typename?: 'SystemwidePromotion',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly bonusPoints: Maybe<Scalars['Float']>,
  readonly endDate: Maybe<Scalars['DateTime']>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly notificationDetails: Maybe<INotificationDetails>,
  readonly pointsMultiplier: Maybe<Scalars['Float']>,
  readonly promoMessage: Maybe<ILocaleString>,
  readonly startDate: Maybe<Scalars['DateTime']>,
  readonly systemwidePromotion: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrBirthdayMultiplierOrCartLimitOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIncentiveRequirementOrLimitOrLoyaltyBetweenTimesOrPaymentMethodOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated>>>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
}

export interface ISystemwidePromotionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly bonusPoints?: Maybe<Scalars['Float']>,
  readonly bonusPoints_gt?: Maybe<Scalars['Float']>,
  readonly bonusPoints_gte?: Maybe<Scalars['Float']>,
  readonly bonusPoints_lt?: Maybe<Scalars['Float']>,
  readonly bonusPoints_lte?: Maybe<Scalars['Float']>,
  readonly bonusPoints_not?: Maybe<Scalars['Float']>,
  readonly endDate?: Maybe<Scalars['DateTime']>,
  readonly endDate_gt?: Maybe<Scalars['DateTime']>,
  readonly endDate_gte?: Maybe<Scalars['DateTime']>,
  readonly endDate_lt?: Maybe<Scalars['DateTime']>,
  readonly endDate_lte?: Maybe<Scalars['DateTime']>,
  readonly endDate_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly pointsMultiplier?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_gt?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_gte?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_lt?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_lte?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_not?: Maybe<Scalars['Float']>,
  readonly startDate?: Maybe<Scalars['DateTime']>,
  readonly startDate_gt?: Maybe<Scalars['DateTime']>,
  readonly startDate_gte?: Maybe<Scalars['DateTime']>,
  readonly startDate_lt?: Maybe<Scalars['DateTime']>,
  readonly startDate_lte?: Maybe<Scalars['DateTime']>,
  readonly startDate_not?: Maybe<Scalars['DateTime']>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
}

export interface ISystemwideQuest  extends IDocument {
  readonly __typename?: 'SystemwideQuest',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly completedState: Maybe<ICompletedState>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImage>,
  readonly incentive: Maybe<IQuestIncentive>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly mustActivateBy: Maybe<Scalars['Date']>,
  readonly name: Maybe<ILocaleString>,
  readonly questRules: Maybe<IQuestRules>,
  readonly rules: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrLimitOrUserCreated>>>,
  readonly testOnly: Maybe<Scalars['Boolean']>,
}

export interface ISystemwideQuestFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mustActivateBy?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_gt?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_gte?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_lt?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_lte?: Maybe<Scalars['Date']>,
  readonly mustActivateBy_not?: Maybe<Scalars['Date']>,
  readonly testOnly?: Maybe<Scalars['Boolean']>,
  readonly testOnly_not?: Maybe<Scalars['Boolean']>,
}

export interface ITabDetailContent {
  readonly __typename?: 'TabDetailContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly title: Maybe<ILocaleString>,
}

export interface ITabsContent {
  readonly __typename?: 'TabsContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly favoritesTab: Maybe<ITitleAndBody>,
  readonly nearbyTab: Maybe<ITitleAndBody>,
  readonly recentTab: Maybe<ITitleAndBody>,
}

export interface ITabsStoreLocatorContent {
  readonly __typename?: 'TabsStoreLocatorContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly favoritesTab: Maybe<ITabDetailContent>,
  readonly nearbyTab: Maybe<ITabDetailContent>,
  readonly recentTab: Maybe<ITabDetailContent>,
}

export interface ITag  extends IDocument {
  readonly __typename?: 'Tag',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly value: Maybe<Scalars['String']>,
}

export interface ITagFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly value?: Maybe<Scalars['String']>,
  readonly value_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly value_matches?: Maybe<Scalars['String']>,
  readonly value_not?: Maybe<Scalars['String']>,
  readonly value_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ITastySwap {
  readonly __typename?: 'TastySwap',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly selectedProduct: Maybe<IComboOrItem>,
  readonly suggestedProduct: Maybe<IComboOrItem>,
  readonly swapTitle: Maybe<ILocaleString>,
}

export interface ITastySwaps {
  readonly __typename?: 'TastySwaps',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly mainSubtitle: Maybe<ILocaleString>,
  readonly mainTitle: Maybe<ILocaleString>,
  readonly modalSubtitle: Maybe<ILocaleString>,
  readonly modalTitle: Maybe<ILocaleString>,
  readonly swaps: Maybe<ReadonlyArray<Maybe<ITastySwap>>>,
}

export interface ITextCard {
  readonly __typename?: 'TextCard',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly heading: Maybe<ILocaleString>,
  readonly superHeading: Maybe<ILocaleString>,
}

export interface ITextWidget {
  readonly __typename?: 'TextWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly text: Maybe<ILocaleString>,
}

export interface ITier  extends IDocument {
  readonly __typename?: 'Tier',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
  readonly points: Maybe<Scalars['Float']>,
}

export interface ITierFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly points?: Maybe<Scalars['Float']>,
  readonly points_gt?: Maybe<Scalars['Float']>,
  readonly points_gte?: Maybe<Scalars['Float']>,
  readonly points_lt?: Maybe<Scalars['Float']>,
  readonly points_lte?: Maybe<Scalars['Float']>,
  readonly points_not?: Maybe<Scalars['Float']>,
}

export interface ITimelineComponents {
  readonly __typename?: 'TimelineComponents',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly buttonText: Maybe<ILocaleString>,
  readonly description: Maybe<ILocaleString>,
  readonly headerColor: Maybe<Scalars['String']>,
  readonly image: Maybe<ILocaleImages>,
  readonly key: Maybe<Scalars['String']>,
  readonly state: Maybe<Scalars['String']>,
  readonly timelineEventType: Maybe<Scalars['String']>,
  readonly timelineHeader: Maybe<ILocaleString>,
}

export interface ITitleAndBody {
  readonly __typename?: 'TitleAndBody',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ITokenExConfig {
  readonly __typename?: 'TokenExConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly publicKey: Maybe<Scalars['String']>,
}

export interface ITransactionCount {
  readonly __typename?: 'TransactionCount',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly everyNumberOfTransaction: Maybe<Scalars['Float']>,
  readonly from: Maybe<Scalars['Float']>,
  readonly schedule: Maybe<Scalars['String']>,
  readonly to: Maybe<Scalars['Float']>,
  readonly transactionNumber: Maybe<Scalars['Float']>,
}

export interface ITrending  extends IDocument {
  readonly __typename?: 'Trending',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly promotions: Maybe<ReadonlyArray<Maybe<IComboOrExternalLinkOrItemOrOfferOrPickerOrSection>>>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface ITrendingFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IUrlsConfig {
  readonly __typename?: 'UrlsConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly braze: Maybe<Scalars['String']>,
  readonly firstData: Maybe<Scalars['String']>,
  readonly firstDataTh: Maybe<Scalars['String']>,
  readonly kount: Maybe<Scalars['String']>,
  readonly thDigital: Maybe<Scalars['String']>,
  readonly tokenEx: Maybe<Scalars['String']>,
  readonly webBaseUrl: Maybe<Scalars['String']>,
}

export interface IUserCreated {
  readonly __typename?: 'UserCreated',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly endDate: Maybe<Scalars['Date']>,
  readonly startDate: Maybe<Scalars['Date']>,
}

export interface IValidationLoyaltyPoints {
  readonly __typename?: 'ValidationLoyaltyPoints',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly maxPoints: Maybe<Scalars['Float']>,
  readonly minPoints: Maybe<Scalars['Float']>,
}

export interface IVendorConfig {
  readonly __typename?: 'VendorConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly constantPlu: Maybe<Scalars['String']>,
  readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<IPlu>>>,
  readonly parentChildPlu: Maybe<IParentChildPlu>,
  readonly parentSanityId: Maybe<Scalars['String']>,
  readonly pluType: Maybe<Scalars['String']>,
  readonly pullUpLevels: Maybe<Scalars['Float']>,
  readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<IPlu>>>,
  readonly sizeBasedPlu: Maybe<ISizeBasedPlu>,
}

export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly carrols: Maybe<IVendorConfig>,
  readonly carrolsDelivery: Maybe<IVendorConfig>,
  readonly hdx: Maybe<IVendorConfig>,
  readonly ncr: Maybe<IVendorConfig>,
  readonly ncrDelivery: Maybe<IVendorConfig>,
  readonly oheics: Maybe<IVendorConfig>,
  readonly oheicsDelivery: Maybe<IVendorConfig>,
  readonly productNumber: Maybe<IVendorConfig>,
  readonly productNumberDelivery: Maybe<IVendorConfig>,
  readonly qdi: Maybe<IVendorConfig>,
  readonly qdiDelivery: Maybe<IVendorConfig>,
  readonly qst: Maybe<IVendorConfig>,
  readonly qstDelivery: Maybe<IVendorConfig>,
  readonly rpos: Maybe<IVendorConfig>,
  readonly rposDelivery: Maybe<IVendorConfig>,
  readonly sicom: Maybe<IVendorConfig>,
  readonly sicomDelivery: Maybe<IVendorConfig>,
  readonly simplyDelivery: Maybe<IVendorConfig>,
  readonly simplyDeliveryDelivery: Maybe<IVendorConfig>,
  readonly tablet: Maybe<IVendorConfig>,
  readonly tabletDelivery: Maybe<IVendorConfig>,
}

export interface IVendorPlus {
  readonly __typename?: 'VendorPlus',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly carrols: Maybe<Scalars['String']>,
  readonly carrolsDelivery: Maybe<Scalars['String']>,
  readonly ncr: Maybe<Scalars['String']>,
  readonly ncrDelivery: Maybe<Scalars['String']>,
  readonly oheics: Maybe<Scalars['String']>,
  readonly oheicsDelivery: Maybe<Scalars['String']>,
  readonly productNumber: Maybe<Scalars['String']>,
  readonly productNumberDelivery: Maybe<Scalars['String']>,
  readonly qst: Maybe<Scalars['String']>,
  readonly sicom: Maybe<Scalars['String']>,
  readonly sicomDelivery: Maybe<Scalars['String']>,
}

export interface IVerticalLinkListWidget {
  readonly __typename?: 'VerticalLinkListWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly linkWidgets: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
}

export interface IVerticalLinkListWithHeaderWidget {
  readonly __typename?: 'VerticalLinkListWithHeaderWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly header: Maybe<ILocaleString>,
  readonly linkWidgets: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
}

export interface IVideoWidget {
  readonly __typename?: 'VideoWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly attributionLink: Maybe<Scalars['String']>,
  readonly caption: Maybe<ILocaleString>,
  readonly video: Maybe<ILocaleFile>,
}

export interface IVrPaymentConfig {
  readonly __typename?: 'VrPaymentConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly braintreeTokenizationKey: Maybe<Scalars['String']>,
}

export interface IWeekDays {
  readonly __typename?: 'WeekDays',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly friday: Maybe<Scalars['Boolean']>,
  readonly monday: Maybe<Scalars['Boolean']>,
  readonly saturday: Maybe<Scalars['Boolean']>,
  readonly sunday: Maybe<Scalars['Boolean']>,
  readonly thursday: Maybe<Scalars['Boolean']>,
  readonly tuesday: Maybe<Scalars['Boolean']>,
  readonly wednesday: Maybe<Scalars['Boolean']>,
}

export interface IWordmarkAndSocialIcons {
  readonly __typename?: 'WordmarkAndSocialIcons',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly socialIconsWidget: Maybe<ISocialIconsWidget>,
}

export interface IYoutubeWidget {
  readonly __typename?: 'YoutubeWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly videoAutoplay: Maybe<Scalars['Boolean']>,
  readonly videoId: Maybe<Scalars['String']>,
}

export type IAllFeatureIdsQueryVariables = {};


export type IAllFeatureIdsQuery = { readonly __typename?: 'RootQuery', readonly allFeatureAccountForms: ReadonlyArray<{ readonly __typename?: 'FeatureAccountForm', readonly _id: string }>, readonly allFeatureGeolocationMapMarkers: ReadonlyArray<{ readonly __typename?: 'FeatureGeolocationMapMarkers', readonly _id: string }>, readonly allFeatureGeolocationModals: ReadonlyArray<{ readonly __typename?: 'FeatureGeolocationModal', readonly _id: string }>, readonly allFeatureHomePages: ReadonlyArray<{ readonly __typename?: 'FeatureHomePage', readonly _id: string }>, readonly allFeatureOffers: ReadonlyArray<{ readonly __typename?: 'FeatureOffers', readonly _id: string }>, readonly allFeatureFooters: ReadonlyArray<{ readonly __typename?: 'FeatureFooter', readonly _id: string }>, readonly allFeatureFooterV2S: ReadonlyArray<{ readonly __typename?: 'FeatureFooterV2', readonly _id: string }>, readonly allFeatureNavigations: ReadonlyArray<{ readonly __typename?: 'FeatureNavigation', readonly _id: string }>, readonly allFeatureAccountDeletePages: ReadonlyArray<{ readonly __typename?: 'FeatureAccountDeletePage', readonly _id: string }>, readonly allFeatureAccountRequestInfoPages: ReadonlyArray<{ readonly __typename?: 'FeatureAccountRequestInfoPage', readonly _id: string }>, readonly allSupportData: ReadonlyArray<{ readonly __typename?: 'SupportData', readonly _id: string }>, readonly allFeatureStaticMenus: ReadonlyArray<{ readonly __typename?: 'FeatureStaticMenu', readonly _id: string }>, readonly allFeatureMenus: ReadonlyArray<{ readonly __typename?: 'FeatureMenu', readonly _id: string }>, readonly allFeatureLayouts: ReadonlyArray<{ readonly __typename?: 'FeatureLayout', readonly _id: string }>, readonly allFeatureDisclaimers: ReadonlyArray<{ readonly __typename?: 'FeatureDisclaimers', readonly _id: string }>, readonly allFeatureAccounts: ReadonlyArray<{ readonly __typename?: 'FeatureAccount', readonly _id: string }>, readonly allFeatureCateringPages: ReadonlyArray<{ readonly __typename?: 'FeatureCateringPage', readonly _id: string }>, readonly allLoyaltyUis: ReadonlyArray<{ readonly __typename?: 'LoyaltyUI', readonly _id: string }>, readonly allFeatureNutritions: ReadonlyArray<{ readonly __typename?: 'FeatureNutrition', readonly _id: string }>, readonly allFeatureGifts: ReadonlyArray<{ readonly __typename?: 'FeatureGift', readonly _id: string }>, readonly allRewardLists: ReadonlyArray<{ readonly __typename?: 'RewardList', readonly _id: string }>, readonly allClaimPointsUis: ReadonlyArray<{ readonly __typename?: 'ClaimPointsUI', readonly _id: string }>, readonly allFeatureOnboardings: ReadonlyArray<{ readonly __typename?: 'FeatureOnboarding', readonly _id: string }>, readonly allFeatureLockers: ReadonlyArray<{ readonly __typename?: 'FeatureLockers', readonly _id: string }>, readonly allFeatureBeeperModals: ReadonlyArray<{ readonly __typename?: 'FeatureBeeperModal', readonly _id: string }>, readonly allFeaturePaybacks: ReadonlyArray<{ readonly __typename?: 'FeaturePayback', readonly _id: string }>, readonly allLinkPhysicalCardUis: ReadonlyArray<{ readonly __typename?: 'LinkPhysicalCardUi', readonly _id: string }> };

export type IAllItemsQueryVariables = {
  where?: Maybe<IItemFilter>
};


export type IAllItemsQuery = { readonly __typename?: 'RootQuery', readonly allItems: ReadonlyArray<(
    { readonly __typename?: 'Item', readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }
    & IItemFragment
    & IItemAvailabilityFragment
  )> };

export type IGetComboQueryVariables = {
  id: Scalars['ID']
};


export type IGetComboQuery = { readonly __typename?: 'RootQuery', readonly Combo: Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboFragment
  )> };

export type IGetComboWithVendorConfigQueryVariables = {
  id: Scalars['ID']
};


export type IGetComboWithVendorConfigQuery = { readonly __typename?: 'RootQuery', readonly Combo: Maybe<(
    { readonly __typename?: 'Combo', readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> }
    & IComboFragment
  )> };

export type IGetComboAvailabilityQueryVariables = {
  id: Scalars['ID']
};


export type IGetComboAvailabilityQuery = { readonly __typename?: 'RootQuery', readonly Combo: Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboAvailabilityFragment
  )> };

export type IFeatureAccountDeletePageQueryVariables = {
  featureAccountDeletePageId: Scalars['ID']
};


export type IFeatureAccountDeletePageQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccountDeletePage: Maybe<{ readonly __typename?: 'FeatureAccountDeletePage', readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly content: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly confirmButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly cancelButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureAccountFormQueryVariables = {
  featureAccountFormId: Scalars['ID']
};


export type IFeatureAccountFormQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccountForm: Maybe<{ readonly __typename?: 'FeatureAccountForm', readonly postalOrZipDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly desktopImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }> }> };

export type IFeatureAccountRequestInfoPageQueryVariables = {
  featureAccountRequestInfoPageId: Scalars['ID']
};


export type IFeatureAccountRequestInfoPageQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccountRequestInfoPage: Maybe<{ readonly __typename?: 'FeatureAccountRequestInfoPage', readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly content: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly confirmButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureAccountQueryVariables = {
  featureAccountId: Scalars['ID']
};


export type IFeatureAccountQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccount: Maybe<{ readonly __typename?: 'FeatureAccount', readonly _id: string, readonly emailAndPushOptInSettings: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'OptInPrivacyPreferences' }
      & IOptInPrivacyPreferencesFragment
    ) | (
      { readonly __typename?: 'OptInSettingBoolean' }
      & IOptInSettingBooleanFragment
    ) | (
      { readonly __typename?: 'OptInSettingEmailAndPush' }
      & IOptInSettingEmailAndPushFragment
    ) | (
      { readonly __typename?: 'OptInSettingEnum' }
      & IOptInSettingEnumFragment
    )>>> }> };

export type IFeatureBeeperQueryVariables = {
  featureBeeperId: Scalars['ID']
};


export type IFeatureBeeperQuery = { readonly __typename?: 'RootQuery', readonly FeatureBeeperModal: Maybe<{ readonly __typename?: 'FeatureBeeperModal', readonly beeperModalTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly beeperModalImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly beeperModalBody: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly beeperButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureCateringPageQueryVariables = {
  featureCateringPageId: Scalars['ID']
};


export type IFeatureCateringPageQuery = { readonly __typename?: 'RootQuery', readonly FeatureCateringPage: Maybe<{ readonly __typename?: 'FeatureCateringPage', readonly appUnauthenticated: Maybe<(
      { readonly __typename?: 'CateringPageConfiguration' }
      & ICateringPageConfigurationFragment
    )>, readonly appAuthenticated: Maybe<(
      { readonly __typename?: 'CateringPageConfiguration' }
      & ICateringPageConfigurationFragment
    )>, readonly webUnauthenticated: Maybe<(
      { readonly __typename?: 'CateringPageConfiguration' }
      & ICateringPageConfigurationFragment
    )>, readonly webAuthenticated: Maybe<(
      { readonly __typename?: 'CateringPageConfiguration' }
      & ICateringPageConfigurationFragment
    )> }> };

export type IFeatureLoyaltyClaimPointsContentQueryVariables = {
  featureClaimPointsUIId: Scalars['ID']
};


export type IFeatureLoyaltyClaimPointsContentQuery = { readonly __typename?: 'RootQuery', readonly ClaimPointsUI: Maybe<{ readonly __typename?: 'ClaimPointsUI', readonly _id: string, readonly claimPointsHomeScreenContent: Maybe<(
      { readonly __typename?: 'ClaimPointsScreenContent' }
      & IClaimPointsScreenContentFragment
    )>, readonly claimQrCode: Maybe<(
      { readonly __typename?: 'ClaimQrCode' }
      & IClaimPointsQrCodeContentFragment
    )>, readonly claimPointsSurveyContent: Maybe<(
      { readonly __typename?: 'ClaimPointsSurveyScreenContent' }
      & IClaimPointsSurveyContentFragment
    )>, readonly claimPointsSuccessfulSubmissionScreenContent: Maybe<(
      { readonly __typename?: 'ClaimPointsScreenContent' }
      & IClaimPointsScreenContentFragment
    )>, readonly claimOnHistory: Maybe<{ readonly __typename?: 'ClaimOnHistory', readonly linkText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }> }>, readonly claimPointsPendingContent: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )>, readonly claimPointsExpiredContent: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )>, readonly claimPointsInvalidCodeContent: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )>, readonly claimPointsAlreadyClaimedContent: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )>, readonly claimPointsTransactionNotFoundContent: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )>, readonly claimPointsInvalidRestaurantContent: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )>, readonly claimPointsDailyAmountExceededContent: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )>, readonly claimPointsDuplicateTransactionId: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )>, readonly claimPointsTooManyRequests: Maybe<(
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    )> }> };

export type IFeatureDisclaimersQueryVariables = {
  featureDisclaimersId: Scalars['ID']
};


export type IFeatureDisclaimersQuery = { readonly __typename?: 'RootQuery', readonly FeatureDisclaimers: Maybe<{ readonly __typename?: 'FeatureDisclaimers', readonly _id: string, readonly superUpsell: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly calorie: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly price: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly itemAvailability: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly images: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly phoneNumber: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly country: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly offers: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly copyrightAndTrademark: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly reservedRights: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly communicationPreferencesBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly signUpDisclaimers: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly signUpMarketDisclaimers: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly deliveryDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly deliveryLogo: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IFeatureFooterV2QueryVariables = {
  featureFooterV2Id: Scalars['ID']
};


export type IFeatureFooterV2Query = { readonly __typename?: 'RootQuery', readonly FeatureFooterV2: Maybe<(
    { readonly __typename?: 'FeatureFooterV2' }
    & IFeatureFooterV2Fragment
  )> };

export type IFeatureFooterQueryVariables = {
  featureFooterId: Scalars['ID']
};


export type IFeatureFooterQuery = { readonly __typename?: 'RootQuery', readonly FeatureFooter: Maybe<{ readonly __typename?: 'FeatureFooter', readonly rows: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Row', readonly _key: Maybe<string>, readonly columns: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Column', readonly _key: Maybe<string>, readonly options: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CopyrightAndLanguageSelector' }
          & ICopyrightAndLanguageSelectorFragment
        ) | (
          { readonly __typename?: 'HighlightedVerticalLinkListWidget' }
          & IHighlightedVerticalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'HorizontalLinkListWidget' }
          & IHorizontalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'ImageWidget' }
          & IImageWidgetFragment
        ) | (
          { readonly __typename?: 'SocialIconsWithHeaderWidget' }
          & ISocialIconsWithHeaderWidgetFragment
        ) | (
          { readonly __typename?: 'TextWidget' }
          & ITextWidgetFragment
        ) | (
          { readonly __typename?: 'VerticalLinkListWidget' }
          & IVerticalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'VerticalLinkListWithHeaderWidget' }
          & IVerticalLinkListWithHeaderWidgetFragment
        ) | (
          { readonly __typename?: 'WordmarkAndSocialIcons' }
          & IWordmarkAndSocialIconsFragment
        )>>> }>>> }>>> }> };

export type IFeatureGeolocationMapMarkersQueryVariables = {
  featureGeolocationMapMarkersId: Scalars['ID']
};


export type IFeatureGeolocationMapMarkersQuery = { readonly __typename?: 'RootQuery', readonly FeatureGeolocationMapMarkers: Maybe<{ readonly __typename?: 'FeatureGeolocationMapMarkers', readonly _id: string, readonly driverIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IFeatureGeolocationModalQueryVariables = {
  featureGeolocationModalId: Scalars['ID']
};


export type IFeatureGeolocationModalQuery = { readonly __typename?: 'RootQuery', readonly FeatureGeolocationModal: Maybe<{ readonly __typename?: 'FeatureGeolocationModal', readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureGiftQueryVariables = {
  featureGiftId: Scalars['ID']
};


export type IFeatureGiftQuery = { readonly __typename?: 'RootQuery', readonly FeatureGift: Maybe<{ readonly __typename?: 'FeatureGift', readonly backgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly legalDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly receptionModalImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }> }> };

export type IFeatureWebHomePageQueryVariables = {
  featureHomePageId: Scalars['ID']
};


export type IFeatureWebHomePageQuery = { readonly __typename?: 'RootQuery', readonly FeatureHomePage: Maybe<{ readonly __typename?: 'FeatureHomePage', readonly unauthenticated: Maybe<(
      { readonly __typename?: 'HomePageConfiguration' }
      & IHomePageConfigurationFragment
    )>, readonly authenticated: Maybe<(
      { readonly __typename?: 'HomePageConfiguration' }
      & IHomePageConfigurationFragment
    )> }> };

export type IFeatureAppHomePageQueryVariables = {
  featureHomePageId: Scalars['ID']
};


export type IFeatureAppHomePageQuery = { readonly __typename?: 'RootQuery', readonly FeatureHomePage: Maybe<{ readonly __typename?: 'FeatureHomePage', readonly unauthenticated: Maybe<(
      { readonly __typename?: 'HomePageConfiguration' }
      & IHomePageConfigurationFragment
    )>, readonly authenticated: Maybe<(
      { readonly __typename?: 'HomePageConfiguration' }
      & IHomePageConfigurationFragment
    )> }> };

export type IMainHeroQueryVariables = {
  mainHeroId: Scalars['ID']
};


export type IMainHeroQuery = { readonly __typename?: 'RootQuery', readonly MainHero: Maybe<(
    { readonly __typename?: 'MainHero' }
    & IMainHeroFragment
  )> };

export type IHeroQueryVariables = {
  heroId: Scalars['ID']
};


export type IHeroQuery = { readonly __typename?: 'RootQuery', readonly Hero: Maybe<(
    { readonly __typename?: 'Hero' }
    & IHeroFragment
  )> };

export type IBrazeContentCardsQueryVariables = {
  brazeContentCardsId: Scalars['ID']
};


export type IBrazeContentCardsQuery = { readonly __typename?: 'RootQuery', readonly BrazeContentCards: Maybe<(
    { readonly __typename?: 'BrazeContentCards' }
    & IBrazeContentCardsFragment
  )> };

export type IAlertQueryVariables = {
  alertId: Scalars['ID']
};


export type IAlertQuery = { readonly __typename?: 'RootQuery', readonly Alert: Maybe<(
    { readonly __typename?: 'Alert' }
    & IAlertFrangmentFragment
  )> };

export type IMarketingCardGroupsQueryVariables = {
  where?: Maybe<IMarketingCardGroupFilter>
};


export type IMarketingCardGroupsQuery = { readonly __typename?: 'RootQuery', readonly allMarketingCardGroups: ReadonlyArray<(
    { readonly __typename?: 'MarketingCardGroup' }
    & IMarketingCardGroupFragment
  )> };

export type IMarketingTileCarouselQueryVariables = {
  marketingTileCarouselId: Scalars['ID']
};


export type IMarketingTileCarouselQuery = { readonly __typename?: 'RootQuery', readonly MarketingTileCarousel: Maybe<(
    { readonly __typename?: 'MarketingTileCarousel' }
    & IMarketingTileCarouselFragment
  )> };

export type IMarketingTileGroupsQueryVariables = {
  where?: Maybe<IMarketingTileGroupFilter>
};


export type IMarketingTileGroupsQuery = { readonly __typename?: 'RootQuery', readonly allMarketingTileGroups: ReadonlyArray<(
    { readonly __typename?: 'MarketingTileGroup' }
    & IMarketingTileGroupFragment
  )> };

export type ITrendingQueryVariables = {
  trendingId: Scalars['ID']
};


export type ITrendingQuery = { readonly __typename?: 'RootQuery', readonly Trending: Maybe<(
    { readonly __typename?: 'Trending' }
    & ITrendingFragment
  )> };

export type IFanFavoritesQueryVariables = {
  fanFavoritesId: Scalars['ID']
};


export type IFanFavoritesQuery = { readonly __typename?: 'RootQuery', readonly FanFavorites: Maybe<(
    { readonly __typename?: 'FanFavorites' }
    & IFanFavoritesFragment
  )> };

export type IOurServicesQueryVariables = {
  ourServicesId: Scalars['ID']
};


export type IOurServicesQuery = { readonly __typename?: 'RootQuery', readonly OurServices: Maybe<(
    { readonly __typename?: 'OurServices' }
    & IOurServicesFragment
  )> };

export type IAppDownloadQueryVariables = {
  appDownloadId: Scalars['ID']
};


export type IAppDownloadQuery = { readonly __typename?: 'RootQuery', readonly AppDownload: Maybe<(
    { readonly __typename?: 'AppDownload' }
    & IAppDownloadFragment
  )> };

export type IRewardsSectionQueryVariables = {
  rewardsSectionId: Scalars['ID']
};


export type IRewardsSectionQuery = { readonly __typename?: 'RootQuery', readonly RewardsSection: Maybe<(
    { readonly __typename?: 'RewardsSection' }
    & IRewardsSectionFragment
  )> };

export type IGoogleAdSlotsQueryVariables = {
  where?: Maybe<IGoogleAdSlotFilter>
};


export type IGoogleAdSlotsQuery = { readonly __typename?: 'RootQuery', readonly allGoogleAdSlots: ReadonlyArray<(
    { readonly __typename?: 'GoogleAdSlot' }
    & IGoogleAdSlotFragment
  )> };

export type IFeatureLayoutQueryVariables = {
  featureLayoutId: Scalars['ID']
};


export type IFeatureLayoutQuery = { readonly __typename?: 'RootQuery', readonly FeatureLayout: Maybe<{ readonly __typename?: 'FeatureLayout', readonly _id: string, readonly defaultHeroImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly recentOrderHeroText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly loadingGraphics: Maybe<(
      { readonly __typename?: 'LoadingGraphics' }
      & ILoadingGraphicsFragment
    )>, readonly geolocationModalImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly appleWalletImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly googlePayImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly giftCardImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly giftCardTextImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IFeatureLoyaltyLinkPhysicalCardContentQueryVariables = {
  featureLinkPhysicalCardUIId: Scalars['ID']
};


export type IFeatureLoyaltyLinkPhysicalCardContentQuery = { readonly __typename?: 'RootQuery', readonly LinkPhysicalCardUi: Maybe<{ readonly __typename?: 'LinkPhysicalCardUi', readonly _id: string, readonly linkCardSectionLinkedState: Maybe<(
      { readonly __typename?: 'LinkCardSection' }
      & ILinkPhysicalCardSectionFragment
    )>, readonly linkCardSectionUnlinkedState: Maybe<(
      { readonly __typename?: 'LinkCardSection' }
      & ILinkPhysicalCardSectionFragment
    )>, readonly linkCardFaqSection: Maybe<(
      { readonly __typename?: 'LinkCardFaqSection' }
      & ILinkPhysicalCardFaqFragment
    )> }> };

export type IFeatureLockersQueryVariables = {
  featureLockersId: Scalars['ID']
};


export type IFeatureLockersQuery = { readonly __typename?: 'RootQuery', readonly FeatureLockers: Maybe<{ readonly __typename?: 'FeatureLockers', readonly lockersPinInstructions: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly lockersTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly lockersModalImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly lockersDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly lockersViewOrderButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly lockersHowToUseLockersButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureLoyaltyBackgroundQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyBackgroundQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly imageBackground: Maybe<{ readonly __typename?: 'ImageBackground', readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IRefFragment
      )> }> }> };

export type IFeatureLoyaltyDashboardQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyDashboardQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly loyaltyDashboard: Maybe<{ readonly __typename?: 'LoyaltyDashboard', readonly widgets: Maybe<ReadonlyArray<Maybe<{ readonly __typename: 'LoyaltyDoubleButtonWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly leftButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly leftButtonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rightButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rightButtonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename: 'LoyaltyGreetingWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string> } | { readonly __typename: 'LoyaltyHistoryWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string> } | { readonly __typename: 'LoyaltyLinkWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly links: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LinkWidget', readonly _key: Maybe<string>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>>> } | { readonly __typename: 'LoyaltyLogoWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string> } | { readonly __typename: 'LoyaltyMarketingTileGroupWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly disclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly marketingTileGroup: Maybe<(
          { readonly __typename?: 'MarketingTileGroup' }
          & IMarketingTileGroupFragment
        )>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename: 'LoyaltyNotificationsWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly notifications: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Reward', readonly loyaltyEngineId: Maybe<string>, readonly notificationDetails: Maybe<(
            { readonly __typename?: 'NotificationDetails' }
            & INotificationDetailsFragment
          )> } | { readonly __typename?: 'SystemwideOffer', readonly loyaltyEngineId: Maybe<string>, readonly redemptionType: Maybe<string>, readonly notificationDetails: Maybe<(
            { readonly __typename?: 'NotificationDetails' }
            & INotificationDetailsFragment
          )> } | { readonly __typename?: 'SystemwidePromotion', readonly loyaltyEngineId: Maybe<string>, readonly notificationDetails: Maybe<(
            { readonly __typename?: 'NotificationDetails' }
            & INotificationDetailsFragment
          )> }>>> } | { readonly __typename: 'LoyaltyPointsAndRewardsWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string> } | { readonly __typename: 'LoyaltyPointsMeterWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly imageBackground: Maybe<{ readonly __typename?: 'ImageBackground', readonly image: Maybe<(
            { readonly __typename?: 'Image' }
            & IImageFragment
          )> }>, readonly ctaButton: Maybe<{ readonly __typename?: 'ActionButton', readonly buttonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> } | { readonly __typename: 'LoyaltyQuestsWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename: 'LoyaltyTiersWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly sortByPointValue: Maybe<string>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename: 'RewardsListWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string> }>>> }> }> };

export type IFeatureEarningCalculationQueryVariables = {
  id: Scalars['ID']
};


export type IFeatureEarningCalculationQuery = { readonly __typename?: 'RootQuery', readonly EarningCalculation: Maybe<{ readonly __typename?: 'EarningCalculation', readonly _id: string, readonly offerRedemptionCooldownPeriod: Maybe<number> }> };

export type IFeatureLoyaltyFeaturedRewardsQueryVariables = {
  id: Scalars['ID']
};


export type IFeatureLoyaltyFeaturedRewardsQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly featuredRewards: Maybe<(
      { readonly __typename?: 'RewardsSection' }
      & IRewardsSectionFragment
    )> }> };

export type IFeatureLoyaltyInRestaurantRedemptionQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyInRestaurantRedemptionQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly loyaltyInRestaurantRedemption: Maybe<{ readonly __typename?: 'LoyaltyInRestaurantRedemption', readonly topWidgets: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'LoyaltyBasicCardWidget' }
        & ILoyaltyBasicCardWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyButtonWidget' }
        & ILoyaltyButtonWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyCartWidget' }
        & ILoyaltyCartWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyImageWidget' }
        & ILoyaltyImageWidgetFragment
      ) | { readonly __typename?: 'LoyaltyMarketingTileGroupWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly marketingTileGroup: Maybe<(
          { readonly __typename?: 'MarketingTileGroup' }
          & IMarketingTileGroupFragment
        )> } | (
        { readonly __typename?: 'LoyaltyPaymentMethodWidget' }
        & ILoyaltyPaymentMethodWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyQRCodeWidget' }
        & ILoyaltyQrCodeWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyQRScanButtonWidget' }
        & ILoyaltyQrScanButtonWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyQRScanHeaderWidget' }
        & ILoyaltyQrScanHeaderWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyShortCodeWidget' }
        & ILoyaltyShortCodeWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyTextWidget' }
        & ILoyaltyTextWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyTitleWidget' }
        & ILoyaltyTitleWidgetFragment
      )>>>, readonly bottomWidgets: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'LoyaltyBasicCardWidget' }
        & ILoyaltyBasicCardWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyButtonWidget' }
        & ILoyaltyButtonWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyCartWidget' }
        & ILoyaltyCartWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyImageWidget' }
        & ILoyaltyImageWidgetFragment
      ) | { readonly __typename?: 'LoyaltyMarketingTileGroupWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly marketingTileGroup: Maybe<(
          { readonly __typename?: 'MarketingTileGroup' }
          & IMarketingTileGroupFragment
        )> } | (
        { readonly __typename?: 'LoyaltyPaymentMethodWidget' }
        & ILoyaltyPaymentMethodWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyQRCodeWidget' }
        & ILoyaltyQrCodeWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyQRScanButtonWidget' }
        & ILoyaltyQrScanButtonWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyQRScanHeaderWidget' }
        & ILoyaltyQrScanHeaderWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyShortCodeWidget' }
        & ILoyaltyShortCodeWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyTextWidget' }
        & ILoyaltyTextWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyTitleWidget' }
        & ILoyaltyTitleWidgetFragment
      )>>> }> }> };

export type IFeatureLoyaltyUiNoRewardQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyUiNoRewardQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly noRewardPoints: Maybe<(
      { readonly __typename?: 'EmptyState' }
      & IEmptyStateFragment
    )> }> };

export type IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables = {
  id: Scalars['ID']
};


export type IFeatureLoyaltyNotAvailableAtThisRestaurantQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly loyaltyNotAvailableAtThisRestaurant: Maybe<{ readonly __typename?: 'LoyaltyNotAvailableAtThisRestaurant', readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly firstButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly firstRedirectPath: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly secondButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly secondRedirectPath: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> }> };

export type IFeatureLoyaltyUiNotEnrolledQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyUiNotEnrolledQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly notEnrolledState: Maybe<(
      { readonly __typename?: 'EmptyState' }
      & IEmptyStateFragment
    )>, readonly notEnrolledStateMobile: Maybe<(
      { readonly __typename?: 'EmptyState' }
      & IEmptyStateFragment
    )> }> };

export type ILoyaltyOffersUiIncentiveNotAvailableQueryVariables = {
  id: Scalars['ID']
};


export type ILoyaltyOffersUiIncentiveNotAvailableQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI: Maybe<{ readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly offerNotAvailableModalContent: Maybe<{ readonly __typename?: 'IncentiveNotAvailableModalContent', readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly primaryButton: Maybe<{ readonly __typename?: 'ActionButton', readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly secondaryButton: Maybe<{ readonly __typename?: 'ActionButton', readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }>, readonly rewardNotAvailableModalContent: Maybe<{ readonly __typename?: 'IncentiveNotAvailableModalContent', readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly primaryButton: Maybe<{ readonly __typename?: 'ActionButton', readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly secondaryButton: Maybe<{ readonly __typename?: 'ActionButton', readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }> }> };

export type IFeatureSortedLoyaltyOffersQueryVariables = {
  id: Scalars['ID']
};


export type IFeatureSortedLoyaltyOffersQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI: Maybe<{ readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly sortedSystemwideOffers: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'SystemwideOffer' }
      & ISystemwideOffersFragment
    )>>> }> };

export type ILoyaltyOffersUiLoggedInQueryVariables = {
  id: Scalars['ID']
};


export type ILoyaltyOffersUiLoggedInQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI: Maybe<{ readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly endOfOffersLoggedIn: Maybe<{ readonly __typename?: 'EndOfOffersLoggedIn', readonly endOfOffersMessage: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly endOfOffersImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }> }> }> };

export type ILoyaltyOffersUiLoggedOutQueryVariables = {
  id: Scalars['ID']
};


export type ILoyaltyOffersUiLoggedOutQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI: Maybe<{ readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly endOfOffersLoggedOut: Maybe<{ readonly __typename?: 'EndOfOffersLoggedOut', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly ctaButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> }> };

export type ILoyaltyOffersUiCooldownContentQueryVariables = {
  id: Scalars['ID']
};


export type ILoyaltyOffersUiCooldownContentQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI: Maybe<{ readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly globalOfferCooldownContent: Maybe<{ readonly __typename?: 'GlobalOfferCooldownContent', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly localeRaw: Maybe<string> }>, readonly actionButton: Maybe<{ readonly __typename?: 'ActionButton', readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly terms: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }> }> };

export type IFeatureLoyaltyOffersQueryVariables = {};


export type IFeatureLoyaltyOffersQuery = { readonly __typename?: 'RootQuery', readonly allSystemwideOffers: ReadonlyArray<(
    { readonly __typename?: 'SystemwideOffer' }
    & ISystemwideOffersFragment
  )> };

export type ILoyaltySystemwideOffersByEngineIdQueryVariables = {
  ids: ReadonlyArray<Scalars['String']>
};


export type ILoyaltySystemwideOffersByEngineIdQuery = { readonly __typename?: 'RootQuery', readonly allSystemwideOffers: ReadonlyArray<(
    { readonly __typename?: 'SystemwideOffer' }
    & ISystemwideOffersFragment
  )> };

export type ILoyaltySystemwideOffersByIdsQueryVariables = {
  ids: ReadonlyArray<Scalars['String']>
};


export type ILoyaltySystemwideOffersByIdsQuery = { readonly __typename?: 'RootQuery', readonly allSystemwideOffers: ReadonlyArray<(
    { readonly __typename?: 'SystemwideOffer' }
    & ISystemwideOffersFragment
  )> };

export type ILoyaltyOfferConfigsQueryVariables = {
  ids: ReadonlyArray<Scalars['String']>
};


export type ILoyaltyOfferConfigsQuery = { readonly __typename?: 'RootQuery', readonly allConfigOffers: ReadonlyArray<(
    { readonly __typename?: 'ConfigOffer' }
    & IConfigOfferFragment
  )> };

export type ILoyaltyOfferTemplatesQueryVariables = {
  ids: ReadonlyArray<Scalars['String']>
};


export type ILoyaltyOfferTemplatesQuery = { readonly __typename?: 'RootQuery', readonly allOfferTemplates: ReadonlyArray<(
    { readonly __typename?: 'OfferTemplate' }
    & ILoyaltyOfferTemplateFragment
  )> };

export type IFeatureLoyaltyUiOptInModalQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyUiOptInModalQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly optInModal: Maybe<(
      { readonly __typename?: 'OptInModalContent' }
      & IOptInModalFragment
    )>, readonly optInModalError: Maybe<(
      { readonly __typename?: 'OptInModalContent' }
      & IOptInModalFragment
    )>, readonly optInModalLoading: Maybe<{ readonly __typename?: 'OptInModalLoading', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }> };

export type IFeatureLoyaltyRewardListCategoriesOnlyQueryVariables = {
  featureLoyaltyRewardListCategoriesId: Scalars['ID']
};


export type IFeatureLoyaltyRewardListCategoriesOnlyQuery = { readonly __typename?: 'RootQuery', readonly RewardList: Maybe<{ readonly __typename?: 'RewardList', readonly _id: string, readonly rewardCategories: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RewardCategory', readonly _id: string, readonly label: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }> }>>> }> };

export type IFeatureLoyaltyRewardListCategoriesQueryVariables = {
  featureLoyaltyRewardListCategoriesId: Scalars['ID']
};


export type IFeatureLoyaltyRewardListCategoriesQuery = { readonly __typename?: 'RootQuery', readonly RewardList: Maybe<{ readonly __typename?: 'RewardList', readonly _id: string, readonly rewardCategories: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RewardCategory', readonly label: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rewards: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Reward', readonly _id: string, readonly loyaltyEngineId: Maybe<string> }>>> }>>> }> };

export type IFeatureLoyaltyShortCodeConfirmationModalQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyShortCodeConfirmationModalQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly shortCodeConfirmationModalContent: Maybe<(
      { readonly __typename?: 'ShortCodeConfirmationModalContent' }
      & IShortCodeConfirmationModalFragment
    )> }> };

export type IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyOverrideShortCodeModalContentQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly overrideShortCodeModalContent: Maybe<{ readonly __typename?: 'OverrideShortCodeModalContent', readonly header: Maybe<(
        { readonly __typename?: 'LocaleString' }
        & ILocaleStringFragment
      )>, readonly body: Maybe<(
        { readonly __typename?: 'LocaleString' }
        & ILocaleStringFragment
      )>, readonly confirmButton: Maybe<(
        { readonly __typename?: 'LocaleString' }
        & ILocaleStringFragment
      )>, readonly discardButton: Maybe<(
        { readonly __typename?: 'LocaleString' }
        & ILocaleStringFragment
      )> }> }> };

export type IFeatureLoyaltySurpriseModalQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltySurpriseModalQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly surpriseAndDelightModalContent: Maybe<{ readonly __typename?: 'SurpriseAndDelightModalContent', readonly backgroundImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly noThanksText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly prompt: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly termsText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }> };

export type IFeatureLoyaltyUiQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyUiQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly rewardsLogo: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly rewardsLearnMoreIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IFeatureMenuQueryVariables = {
  featureMenuId: Scalars['ID']
};


export type IFeatureMenuQuery = { readonly __typename?: 'RootQuery', readonly FeatureMenu: Maybe<{ readonly __typename?: 'FeatureMenu', readonly _id: string, readonly menuHeroImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly menuHeroText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly dayParts: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'DayPart', readonly key: Maybe<string>, readonly endTime: Maybe<string>, readonly startTime: Maybe<string>, readonly weekDays: Maybe<{ readonly __typename?: 'WeekDays', readonly monday: Maybe<boolean>, readonly tuesday: Maybe<boolean>, readonly wednesday: Maybe<boolean>, readonly thursday: Maybe<boolean>, readonly friday: Maybe<boolean>, readonly saturday: Maybe<boolean>, readonly sunday: Maybe<boolean> }>, readonly displayName: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly icon: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>>>, readonly defaultMenu: Maybe<{ readonly __typename?: 'Menu', readonly _id: string }>, readonly cateringMenu: Maybe<{ readonly __typename?: 'Menu', readonly _id: string }>, readonly donationTermAndConditionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly donationItemsAtCheckout: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Item', readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )> }
      & IItemFragment
    )>>>, readonly upsellItemsAtCheckoutRestaurant: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Item', readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )> }
      & IItemFragment
    )>>>, readonly upsellItemsAtCheckoutDelivery: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Item', readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )> }
      & IItemFragment
    )>>>, readonly upsellItemsAtCheckoutCatering: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Item', readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )> }
      & IItemFragment
    )>>>, readonly cartAddOnSections: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AddOnSection' }
      & IAddOnSectionFragment
    )>>>, readonly cartAddOnSectionsCatering: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AddOnSection' }
      & IAddOnSectionFragment
    )>>> }> };

export type IFeatureNavigationQueryVariables = {
  featureNavigationId: Scalars['ID']
};


export type IFeatureNavigationQuery = { readonly __typename?: 'RootQuery', readonly FeatureNavigation: Maybe<(
    { readonly __typename?: 'FeatureNavigation', readonly aboutMenuEntries: Maybe<(
      { readonly __typename?: 'NavigationSection' }
      & INavigationSectionFragment
    )> }
    & INavigationDesktopFragment
    & INavigationMobileFragment
    & INavigationButtonFragment
  )> };

export type IFeatureNutritionQueryVariables = {
  featureNutritionId: Scalars['ID']
};


export type IFeatureNutritionQuery = { readonly __typename?: 'RootQuery', readonly FeatureNutrition: Maybe<{ readonly __typename?: 'FeatureNutrition', readonly _id: string, readonly nutritionTables: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'NutritionTable' }
      & INutritionTableFragment
    )>>>, readonly roundingRules: Maybe<(
      { readonly __typename?: 'RoundingRules' }
      & IRoundingRulesFragment
    )> }> };

export type IFeatureOffersQueryVariables = {
  featureOffersId: Scalars['ID']
};


export type IFeatureOffersQuery = { readonly __typename?: 'RootQuery', readonly FeatureOffers: Maybe<{ readonly __typename?: 'FeatureOffers', readonly offersBrowsingPanel: Maybe<(
      { readonly __typename?: 'OffersBrowsingPanel', readonly endOfOffersMessage: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly endOfOffersImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly emptyStateTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly emptyStateBody: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly emptyStateImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }> }
      & IOffersSelectRestaurantCtaFragment
    )>, readonly offersDetailsPanel: Maybe<{ readonly __typename?: 'OffersDetailsPanel', readonly emptyStateTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly emptyStateBody: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly emptyStateImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly emptyStateAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly missingOfferTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly missingOfferBody: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly missingOfferImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly missingOfferAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }>, readonly defaultBackgroundImage: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly offersPageMarketingTiles: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'OffersPageMarketingTile' }
      & IOffersPageMarketingTileFragment
    )>>> }> };

export type IFeatureOnboardingQueryVariables = {};


export type IFeatureOnboardingQuery = { readonly __typename?: 'RootQuery', readonly allFeatureOnboardings: ReadonlyArray<{ readonly __typename?: 'FeatureOnboarding', readonly _id: string, readonly channel: Maybe<string>, readonly triggerRule: Maybe<string>, readonly screens: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'ImageWithHeaderAndText' }
      & IOnboardingScreenFragment
    )>>> }> };

export type IFeaturePaybackQueryVariables = {
  featurePaybackId: Scalars['ID']
};


export type IFeaturePaybackQuery = { readonly __typename?: 'RootQuery', readonly FeaturePayback: Maybe<{ readonly __typename?: 'FeaturePayback', readonly paybackLoginUrl: Maybe<string>, readonly paybackPartnerID: Maybe<string>, readonly paybackRedirectUrl: Maybe<string>, readonly paybackMainImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly paybackLogoImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly paybackLogoSmallImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly paybackTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly paybackDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly paybackLinkCardButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly paybackNeedHelpButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly paybackRefreshPointsButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureQuizQueryVariables = {
  quizId: Scalars['ID']
};


export type IFeatureQuizQuery = { readonly __typename?: 'RootQuery', readonly FeatureQuiz: Maybe<{ readonly __typename?: 'FeatureQuiz', readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly introPageBackground: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly questionPageBackground: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly resultPageBackground: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly questions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuestionDetails', readonly _id: string, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly responses: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ResponseDetails', readonly _id: string, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly en: Maybe<(
            { readonly __typename?: 'Image' }
            & IImageFragment
          )> }>, readonly resultsValuesDetails: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ResultValueDetails', readonly value: Maybe<number>, readonly result: Maybe<{ readonly __typename?: 'ResultDetails', readonly _id: string, readonly prefix: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }> }> }>>> }>>> }>>>, readonly results: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ResultDetails', readonly _id: string, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly en: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }> }>>> }> };

export type IGetFeatureScanAndPayQueryVariables = {
  featureScanAndPayId: Scalars['ID']
};


export type IGetFeatureScanAndPayQuery = { readonly __typename?: 'RootQuery', readonly FeatureScanAndPay: Maybe<(
    { readonly __typename?: 'FeatureScanAndPay', readonly _id: string, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly inactiveStateText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly addNewPaymentMethodStateText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }> }
    & IPaymentMethodDeletionModalTextFragment
  )> };

export type IFeatureStaticMenuQueryVariables = {
  featureStaticMenuId: Scalars['ID']
};


export type IFeatureStaticMenuQuery = { readonly __typename?: 'RootQuery', readonly FeatureStaticMenu: Maybe<(
    { readonly __typename?: 'FeatureStaticMenu' }
    & IItemUnavailableModalFragment
  )> };

export type IAboutContentFragment = { readonly __typename?: 'AppData', readonly _id: string, readonly aboutMenuEntries: Maybe<{ readonly __typename?: 'NavigationSection', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pages: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NavigationSection', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pages: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NavigationSection' } | { readonly __typename?: 'StaticPage', readonly title: Maybe<string>, readonly localeTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly path: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }>, readonly localePath: Maybe<{ readonly __typename?: 'LocaleSlug', readonly locale: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }> }>, readonly redirectUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> } | { readonly __typename?: 'StaticPage', readonly title: Maybe<string>, readonly localeTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly path: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }>, readonly localePath: Maybe<{ readonly __typename?: 'LocaleSlug', readonly locale: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }> }>, readonly redirectUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> }>, readonly calorieDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly priceDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly imagesDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly copyrightAndTrademarkDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly reservedRightsDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type INavigationSectionFragment = { readonly __typename?: 'NavigationSection', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pages: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NavigationSection', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pages: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NavigationSection' } | { readonly __typename?: 'StaticPage', readonly title: Maybe<string>, readonly localeTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly path: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }>, readonly localePath: Maybe<{ readonly __typename?: 'LocaleSlug', readonly locale: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }> }>, readonly redirectUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> } | { readonly __typename?: 'StaticPage', readonly title: Maybe<string>, readonly localeTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly path: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }>, readonly localePath: Maybe<{ readonly __typename?: 'LocaleSlug', readonly locale: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }> }>, readonly redirectUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> };

export type IAddOnSectionOptionFragment = { readonly __typename?: 'AddOnSectionOption', readonly _key: Maybe<string>, readonly maxAmount: Maybe<number>, readonly option: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemFragment
    & IItemAvailabilityFragment
  )> };

export type IAddOnSectionFragment = { readonly __typename?: 'AddOnSection', readonly _id: string, readonly _key: Maybe<string>, readonly maxAmount: Maybe<number>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly options: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'AddOnSectionOption' }
    & IAddOnSectionOptionFragment
  )>>> };

export type IAdditionalItemInformationFragment = { readonly __typename?: 'AdditionalItemInformation', readonly ingredients: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly additives: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly producerDetails: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IAlertFrangmentFragment = { readonly __typename?: 'Alert', readonly _id: string, readonly heading: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly learnMoreText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly learnMoreUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IAllergensFragment = { readonly __typename?: 'OpAllergen', readonly milk: Maybe<number>, readonly eggs: Maybe<number>, readonly fish: Maybe<number>, readonly peanuts: Maybe<number>, readonly shellfish: Maybe<number>, readonly treeNuts: Maybe<number>, readonly soy: Maybe<number>, readonly wheat: Maybe<number>, readonly mustard: Maybe<number>, readonly sesame: Maybe<number>, readonly celery: Maybe<number>, readonly lupin: Maybe<number>, readonly gluten: Maybe<number>, readonly sulphurDioxide: Maybe<number> };

export type IAppDownloadFragment = { readonly __typename?: 'AppDownload', readonly _id: string, readonly details: Maybe<{ readonly __typename?: 'AppDownloadSection', readonly iOSDownloadLink: Maybe<string>, readonly androidDownloadLink: Maybe<string>, readonly backgroundImage: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly primaryImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly copy: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly textDecorationLeft: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly textDecorationRight: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly submitButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly iOSDownloadImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly androidDownloadImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IBrazeContentCardsFragment = { readonly __typename?: 'BrazeContentCards', readonly _id: string, readonly contentCardsHeader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly contentCardsSubheader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IColorFragment = { readonly __typename?: 'Color', readonly alpha: Maybe<number>, readonly hex: Maybe<string>, readonly hsl: Maybe<{ readonly __typename?: 'HslaColor', readonly _type: Maybe<string>, readonly a: Maybe<number>, readonly h: Maybe<number>, readonly l: Maybe<number>, readonly s: Maybe<number> }>, readonly hsv: Maybe<{ readonly __typename?: 'HsvaColor', readonly _type: Maybe<string>, readonly a: Maybe<number>, readonly h: Maybe<number>, readonly s: Maybe<number>, readonly v: Maybe<number> }>, readonly rgb: Maybe<{ readonly __typename?: 'RgbaColor', readonly _type: Maybe<string>, readonly a: Maybe<number>, readonly b: Maybe<number>, readonly g: Maybe<number>, readonly r: Maybe<number> }> };

export type IComboAvailabilityFragment = { readonly __typename?: 'Combo', readonly showInStaticMenu: Maybe<boolean>, readonly mainItem: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemAvailabilityFragment
  )>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ComboSlot', readonly minAmount: Maybe<number>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ComboSlotOption', readonly maxAmount: Maybe<number>, readonly option: Maybe<(
        { readonly __typename?: 'Item' }
        & IItemAvailabilityFragment
      ) | { readonly __typename?: 'Picker' } | { readonly __typename?: 'Section' }> }>>> }>>> };

export type IComboFragment = { readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly hideMainItemDescription: Maybe<boolean>, readonly forceModifiersToBottom: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly mainItem: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemFragment
  )>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ComboSlot', readonly _type: string, readonly _id: string, readonly uiPattern: Maybe<string>, readonly minAmount: Maybe<number>, readonly maxAmount: Maybe<number>, readonly respectMaximum: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly optionVisibilitySettings: Maybe<{ readonly __typename?: 'OptionVisibilitySettings', readonly visibleOptions: Maybe<number>, readonly toggleButtonTextClosed: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly toggleButtonTextOpen: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ComboSlotOption', readonly _key: Maybe<string>, readonly minAmount: Maybe<number>, readonly defaultAmount: Maybe<number>, readonly isPremium: Maybe<boolean>, readonly option: Maybe<(
        { readonly __typename?: 'Item' }
        & IItemFragment
      ) | { readonly __typename?: 'Picker', readonly _type: string, readonly uiPattern: Maybe<string>, readonly pickerAspects: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspect', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerAspectOptions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspectValue', readonly identifier: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> }>>> } | { readonly __typename?: 'Section' }> }>>> }>>>, readonly menuObjectSettings: Maybe<{ readonly __typename?: 'MenuObjectSettings', readonly limitPerOrder: Maybe<number> }> };

export type IConfigOfferFragment = { readonly __typename?: 'ConfigOffer', readonly _id: string, readonly _type: string, readonly loyaltyEngineId: Maybe<string>, readonly shortCode: Maybe<string>, readonly mobileOrderOnly: Maybe<boolean>, readonly daypart: Maybe<ReadonlyArray<Maybe<string>>>, readonly redemptionType: Maybe<string>, readonly offerPrice: Maybe<number>, readonly uiPattern: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly moreInfo: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly howToRedeem: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly enRaw: Maybe<any> }>, readonly backgroundImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly marketPrice: Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> }>, readonly localizedImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    )> }>, readonly lockedOffersPanel: Maybe<{ readonly __typename?: 'LockedOffersPanel', readonly completedChallengeHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly completedChallengeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>, readonly promoCodePanel: Maybe<{ readonly __typename?: 'PromoCodePanel', readonly promoCodeLink: Maybe<string>, readonly promoCodeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly promoCodeLabel: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>, readonly incentives: Maybe<ReadonlyArray<Maybe<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<{ readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename: 'OfferActivation', readonly _id: string, readonly _type: string } | { readonly __typename: 'OfferDiscount', readonly _id: string, readonly _type: string, readonly discountValue: Maybe<number>, readonly discountType: Maybe<string> } | { readonly __typename: 'Picker', readonly _id: string, readonly _type: string, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly option: Maybe<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<{ readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> }>>> } | { readonly __typename: 'SwapMapping', readonly _type: string }>>>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IEmptyStateFragment = { readonly __typename?: 'EmptyState', readonly _id: string, readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly logo: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly backgroundImage: Maybe<{ readonly __typename?: 'ImageBackground', readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IRefFragment
    )> }>, readonly marketingTileList: Maybe<(
    { readonly __typename?: 'MarketingTileList' }
    & IMarketingTileListFragment
  )>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subtitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly buttonAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>, readonly terms: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }> };

export type IFanFavoritesFragment = { readonly __typename?: 'FanFavorites', readonly _id: string, readonly fanFavoriteItems: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> } | { readonly __typename?: 'Item', readonly _id: string, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'Picker', readonly _id: string, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Section', readonly _id: string, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>>, readonly favoriteSection: Maybe<{ readonly __typename?: 'FavoriteSection', readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type ICateringPageConfigurationFragment = { readonly __typename?: 'CateringPageConfiguration', readonly components: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'Alert' }
    & IAlertFrangmentFragment
  ) | (
    { readonly __typename?: 'AppDownload' }
    & IAppDownloadFragment
  ) | (
    { readonly __typename?: 'BrazeContentCards' }
    & IBrazeContentCardsFragment
  ) | (
    { readonly __typename?: 'FanFavorites' }
    & IFanFavoritesFragment
  ) | { readonly __typename?: 'LockedOffers', readonly _id: string } | (
    { readonly __typename?: 'MainHero' }
    & IMainHeroFragment
  ) | (
    { readonly __typename?: 'MarketingTileGroup' }
    & IMarketingTileGroupFragment
  ) | { readonly __typename?: 'OffersSection', readonly _id: string } | (
    { readonly __typename?: 'OurServices' }
    & IOurServicesFragment
  ) | { readonly __typename?: 'RecentItems', readonly _id: string } | (
    { readonly __typename?: 'Trending' }
    & ITrendingFragment
  )>>> };

export type IFeatureFooterV2Fragment = { readonly __typename: 'FeatureFooterV2', readonly _id: string, readonly copyrightText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly mainLinks: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LinkWidget', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>>, readonly miscellaneousLinks: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LinkWidget', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>>, readonly socialMediaData: Maybe<(
    { readonly __typename?: 'SocialIconsWidget' }
    & ISocialIconsWidgetFragment
  )> };

export type IHomePageConfigurationFragment = { readonly __typename?: 'HomePageConfiguration', readonly components: Maybe<ReadonlyArray<Maybe<{ readonly __typename: 'Alert', readonly _id: string } | { readonly __typename: 'AppDownload', readonly _id: string } | { readonly __typename: 'BrazeContentCards', readonly _id: string } | { readonly __typename: 'FanFavorites', readonly _id: string } | { readonly __typename: 'GoogleAdSlot', readonly _id: string } | { readonly __typename: 'Hero', readonly _id: string } | { readonly __typename: 'LockedOffers', readonly _id: string } | { readonly __typename: 'MainHero', readonly _id: string } | { readonly __typename: 'MarketingCardGroup', readonly _id: string } | { readonly __typename: 'MarketingTileCarousel', readonly _id: string } | { readonly __typename: 'MarketingTileGroup', readonly _id: string } | { readonly __typename: 'OffersSection', readonly _id: string } | { readonly __typename: 'OurServices', readonly _id: string } | { readonly __typename: 'RecentItems', readonly _id: string } | { readonly __typename: 'RewardsSection', readonly _id: string } | { readonly __typename: 'RollUpTheRimSection', readonly _id: string } | { readonly __typename: 'ScanForRewards', readonly _id: string } | { readonly __typename: 'Trending', readonly _id: string }>>> };

export type INavigationDesktopFragment = { readonly __typename?: 'FeatureNavigation', readonly navigationDesktop: Maybe<(
    { readonly __typename?: 'NavigationDesktop', readonly _key: Maybe<string>, readonly _type: Maybe<string> }
    & INavigationLinksFragment
    & IAboutMenuEntriesDesktopFragment
  )> };

export type INavigationLinksFragment = { readonly __typename?: 'NavigationDesktop', readonly navigationLinks: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'NavigationDesktopLink' }
    & INavigationLinkFragment
  )>>> };

export type IAboutMenuEntriesDesktopFragment = { readonly __typename?: 'NavigationDesktop', readonly aboutMenuEntries: Maybe<(
    { readonly __typename?: 'NavigationSection' }
    & INavigationSectionFragment
  )> };

export type INavigationLinkFragment = { readonly __typename?: 'NavigationDesktopLink', readonly _key: Maybe<string>, readonly hideLinkBasedOnLdFlag: Maybe<{ readonly __typename?: 'LaunchDarklySelect', readonly launchDarklyFlag: Maybe<string> }>, readonly navLink: Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )>, readonly launchDarklyAlternateNavigationLink: Maybe<{ readonly __typename?: 'LaunchDarklyNavigationLink', readonly enabled: Maybe<boolean>, readonly launchDarklyFlagDependency: Maybe<{ readonly __typename?: 'LaunchDarklySelect', readonly launchDarklyFlag: Maybe<string> }>, readonly navLink: Maybe<(
      { readonly __typename?: 'LinkWidget' }
      & ILinkWidgetFragment
    )> }> };

export type INavigationMobileFragment = { readonly __typename?: 'FeatureNavigation', readonly navigationMobile: Maybe<(
    { readonly __typename?: 'NavigationMobile', readonly _key: Maybe<string>, readonly _type: Maybe<string> }
    & INavigationTabsFragment
    & IAboutMenuEntriesMobileFragment
  )> };

export type INavigationTabsFragment = { readonly __typename?: 'NavigationMobile', readonly navigationTabs: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'NavigationMobileTab' }
    & INavigationTabFragment
  )>>> };

export type IAboutMenuEntriesMobileFragment = { readonly __typename?: 'NavigationMobile', readonly aboutMenuEntries: Maybe<(
    { readonly __typename?: 'NavigationSection' }
    & INavigationSectionFragment
  )> };

export type INavigationTabFragment = { readonly __typename?: 'NavigationMobileTab', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly hideLinkBasedOnLdFlag: Maybe<{ readonly __typename?: 'LaunchDarklySelect', readonly launchDarklyFlag: Maybe<string> }>, readonly tabIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly tabIconActive: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly tabLink: Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )>, readonly launchDarklyAlternateMobileTab: Maybe<{ readonly __typename?: 'LaunchDarklyNavigationTab', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly enabled: Maybe<boolean>, readonly launchDarklyFlagDependency: Maybe<{ readonly __typename?: 'LaunchDarklySelect', readonly launchDarklyFlag: Maybe<string> }>, readonly tabIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly tabIconActive: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly tabLink: Maybe<(
      { readonly __typename?: 'LinkWidget' }
      & ILinkWidgetFragment
    )> }> };

export type INavigationButtonFragment = { readonly __typename?: 'FeatureNavigation', readonly navigationMobileHeaderButton: Maybe<{ readonly __typename?: 'NavigationMobileHeaderButton', readonly _key: Maybe<string>, readonly icon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly iconActive: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> };

export type INutritionItemFragment = { readonly __typename?: 'NutritionItem', readonly _type: Maybe<string>, readonly nutritionKey: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly unit: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly additionalItems: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NutritionItem', readonly nutritionKey: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly unit: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> };

export type INutritionItemGroupFragment = { readonly __typename?: 'NutritionItemGroup', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly mainItem: Maybe<(
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  )>, readonly lineItems: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  )>>> };

export type INutritionTableFragment = { readonly __typename?: 'NutritionTable', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly items: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  ) | (
    { readonly __typename?: 'NutritionItemGroup' }
    & INutritionItemGroupFragment
  )>>> };

export type IRoundingRulesFragment = { readonly __typename?: 'RoundingRules', readonly enabled: Maybe<boolean>, readonly decimalPlaces: Maybe<number>, readonly roundingType: Maybe<string> };

export type IOffersPageMarketingTileFragment = { readonly __typename?: 'OffersPageMarketingTile', readonly displayPosition: Maybe<string>, readonly customPosition: Maybe<number>, readonly marketingTileReference: Maybe<(
    { readonly __typename?: 'MarketingTile' }
    & IMarketingTileFragment
  )> };

export type IOnboardingScreenFragment = { readonly __typename?: 'ImageWithHeaderAndText', readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly textContent: Maybe<{ readonly __typename?: 'LocaleTypographyBlock', readonly localeRaw: Maybe<any> }>, readonly buttonAction: Maybe<{ readonly __typename?: 'LinkAction', readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> };

export type IItemUnavailableModalFragment = { readonly __typename?: 'FeatureStaticMenu', readonly itemUnavailableModal: Maybe<{ readonly __typename?: 'ItemUnavailableModal', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly continue: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly selectNew: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly itemNotAvailableForDelivery: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type ICopyrightAndLanguageSelectorFragment = { readonly __typename?: 'CopyrightAndLanguageSelector', readonly _type: Maybe<string>, readonly copyrightText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IHighlightedLinkWidgetFragment = { readonly __typename?: 'HighlightedLinkWidget', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type IHighlightedVerticalLinkListWidgetFragment = { readonly __typename?: 'HighlightedVerticalLinkListWidget', readonly _type: Maybe<string>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subheader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly highlightedLinks: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'HighlightedLinkWidget' }
    & IHighlightedLinkWidgetFragment
  )>>> };

export type IHorizontalLinkListWidgetFragment = { readonly __typename?: 'HorizontalLinkListWidget', readonly _type: Maybe<string>, readonly linkWidgets: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )>>> };

export type IImageWidgetFragment = { readonly __typename?: 'ImageWidget', readonly _type: Maybe<string>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type ISocialIconsWithHeaderWidgetFragment = { readonly __typename?: 'SocialIconsWithHeaderWidget', readonly _type: Maybe<string>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly socialIconsWidget: Maybe<(
    { readonly __typename?: 'SocialIconsWidget' }
    & ISocialIconsWidgetFragment
  )> };

export type ISocialIconsWidgetFragment = { readonly __typename?: 'SocialIconsWidget', readonly _type: Maybe<string>, readonly instagramUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly facebookUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly youtubeUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly twitterUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly tiktokUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type ITextWidgetFragment = { readonly __typename?: 'TextWidget', readonly _type: Maybe<string>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IVerticalLinkListWithHeaderWidgetFragment = { readonly __typename?: 'VerticalLinkListWithHeaderWidget', readonly _type: Maybe<string>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly linkWidgets: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )>>> };

export type IVerticalLinkListWidgetFragment = { readonly __typename?: 'VerticalLinkListWidget', readonly _type: Maybe<string>, readonly linkWidgets: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )>>> };

export type IWordmarkAndSocialIconsFragment = { readonly __typename?: 'WordmarkAndSocialIcons', readonly _type: Maybe<string>, readonly socialIconsWidget: Maybe<(
    { readonly __typename?: 'SocialIconsWidget' }
    & ISocialIconsWidgetFragment
  )> };

export type IGoogleAdSlotFragment = { readonly __typename?: 'GoogleAdSlot', readonly _id: string, readonly adUnitId: Maybe<string>, readonly adSlotSize: Maybe<string> };

export type IHeroMaskCardFragment = { readonly __typename?: 'SimpleCard', readonly _key: Maybe<string>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )> };

export type IHeroContentFragment = { readonly __typename?: 'AppData', readonly _id: string, readonly heroTextColor: Maybe<string>, readonly mainHeroImageAuthenticatedLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly mainHeroImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly mainHeroMobileImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly heroTextAuthenticatedLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroActionAuthenticated: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly heroAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly heroActionLeft: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly heroActionRight: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly heroSuperTextAuthenticated: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroSubTextAuthenticated: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroSubText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroMaskCards: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'SimpleCard' }
    & IHeroMaskCardFragment
  )>>>, readonly loyaltyHeroAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly loyaltyHeroSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly loyaltyHeroSubText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroActionLeftIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly heroActionRightIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }> };

export type IHeroFragment = { readonly __typename?: 'Hero', readonly _id: string, readonly reversed: Maybe<boolean>, readonly hasTerms: Maybe<boolean>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly altImageText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subheader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly primaryCta: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>, readonly complementaryCta: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>, readonly termsText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly termsButton: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> };

export type IRefFragment = { readonly __typename?: 'Image', readonly asset: Maybe<{ readonly __typename?: 'SanityImageAsset', readonly _id: string }> };

export type IImageFragment = { readonly __typename?: 'Image', readonly hotspot: Maybe<{ readonly __typename?: 'SanityImageHotspot', readonly x: Maybe<number>, readonly y: Maybe<number>, readonly height: Maybe<number>, readonly width: Maybe<number> }>, readonly crop: Maybe<{ readonly __typename?: 'SanityImageCrop', readonly top: Maybe<number>, readonly bottom: Maybe<number>, readonly left: Maybe<number>, readonly right: Maybe<number> }>, readonly asset: Maybe<{ readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly metadata: Maybe<{ readonly __typename?: 'SanityImageMetadata', readonly lqip: Maybe<string>, readonly palette: Maybe<{ readonly __typename?: 'SanityImagePalette', readonly dominant: Maybe<{ readonly __typename?: 'SanityImagePaletteSwatch', readonly background: Maybe<string>, readonly foreground: Maybe<string> }> }> }> }> };

export type IImagesFragment = { readonly __typename?: 'Images', readonly imageDescription: Maybe<string>, readonly app: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )>, readonly kiosk: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )> };

export type IItemAvailabilityFragment = { readonly __typename?: 'Item', readonly showInStaticMenu: Maybe<boolean>, readonly hideCalories: Maybe<boolean>, readonly hideNutritionLegalDisclaimer: Maybe<boolean>, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )>, readonly options: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'ItemOption' }
    & IItemOptionAvailabilityFragment
  )>>> };

export type IItemOptionAvailabilityFragment = { readonly __typename?: 'ItemOption', readonly injectDefaultSelection: Maybe<boolean>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ItemOptionModifier', readonly default: Maybe<boolean>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )>, readonly modifierMultiplier: Maybe<{ readonly __typename?: 'ModifierMultiplier', readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )>, readonly modifier: Maybe<{ readonly __typename?: 'Modifier', readonly vendorConfigs: Maybe<(
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        )> }> }> }>>> };

export type IItemOptionFragment = { readonly __typename?: 'ItemOption', readonly componentStyle: Maybe<string>, readonly upsellModifier: Maybe<boolean>, readonly allowMultipleSelections: Maybe<boolean>, readonly displayModifierMultiplierName: Maybe<boolean>, readonly injectDefaultSelection: Maybe<boolean>, readonly singleChoiceOnly: Maybe<boolean>, readonly minAmount: Maybe<number>, readonly maxAmount: Maybe<number>, readonly _key: Maybe<string>, readonly type: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly displayGroup: Maybe<{ readonly __typename?: 'DisplayGroup', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ItemOptionModifier', readonly _key: Maybe<string>, readonly default: Maybe<boolean>, readonly type: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )>, readonly modifierMultiplier: Maybe<{ readonly __typename?: 'ModifierMultiplier', readonly multiplier: Maybe<number>, readonly prefix: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly modifier: Maybe<{ readonly __typename?: 'Modifier', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
          { readonly __typename?: 'Image' }
          & IMenuImageFragment
        )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }>, readonly nutrition: Maybe<(
      { readonly __typename?: 'Nutrition' }
      & INutritionFragment
    )> }>>> };

export type IItemFragment = { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly rewardEligible: Maybe<boolean>, readonly labelAsPerPerson: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly nutrition: Maybe<(
    { readonly __typename?: 'Nutrition' }
    & INutritionFragment
  )>, readonly additionalItemInformation: Maybe<(
    { readonly __typename?: 'AdditionalItemInformation' }
    & IAdditionalItemInformationFragment
  )>, readonly nutritionWithModifiers: Maybe<(
    { readonly __typename?: 'Nutrition' }
    & INutritionFragment
  )>, readonly allergens: Maybe<(
    { readonly __typename?: 'OpAllergen' }
    & IAllergensFragment
  )>, readonly options: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'ItemOption' }
    & IItemOptionFragment
  )>>>, readonly productHierarchy: Maybe<{ readonly __typename?: 'ProductHierarchy', readonly L1: Maybe<string>, readonly L2: Maybe<string>, readonly L3: Maybe<string>, readonly L4: Maybe<string>, readonly L5: Maybe<string> }>, readonly menuObjectSettings: Maybe<{ readonly __typename?: 'MenuObjectSettings', readonly limitPerOrder: Maybe<number> }> };

export type ILinkWidgetFragment = { readonly __typename?: 'LinkWidget', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type ILoadingGraphicsFragment = { readonly __typename?: 'LoadingGraphics', readonly cartInitialLoader: Maybe<{ readonly __typename?: 'Loader', readonly desktopGraphic: Maybe<(
      { readonly __typename?: 'Image' }
      & IRefFragment
    )>, readonly mobileGraphic: Maybe<(
      { readonly __typename?: 'Image' }
      & IRefFragment
    )>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type ILocaleImageFragment = { readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )> };

export type ILocaleStringFragment = { readonly __typename?: 'LocaleString', readonly locale: Maybe<string> };

export type ILocaleVideoFileFragment = { readonly __typename?: 'LocaleFile', readonly locale: Maybe<(
    { readonly __typename?: 'File' }
    & IVideoFileFragment
  )> };

export type IClaimPointsScreenContentFragment = { readonly __typename?: 'ClaimPointsScreenContent', readonly rewardsIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly secondImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly screenTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly instructionsTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly topButtonTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly topButtonUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly bottomButtonTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly bottomButtonUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type IClaimPointsSurveyContentFragment = { readonly __typename?: 'ClaimPointsSurveyScreenContent', readonly expirationTimeReceipts: Maybe<number>, readonly rewardsIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly secondImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly screenTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly instructionsTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly expirationDateInstructionsTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly inputBoxExpirationDatePlaceholder: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly topButtonTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly topButtonUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly bottomButtonTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly bottomButtonUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type IClaimPointsQrCodeContentFragment = { readonly __typename?: 'ClaimQrCode', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly link: Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )> };

export type IClaimPointsFailedSubmissionContentFragment = { readonly __typename?: 'ClaimPointsFailedSubmissionContent', readonly screenTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly failureTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly buttonTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type ILinkPhysicalCardSectionFragment = { readonly __typename?: 'LinkCardSection', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subtitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly ctaButtonLabel: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type ILinkPhysicalCardFaqFragment = { readonly __typename?: 'LinkCardFaqSection', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subtitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly marketingTileList: Maybe<(
    { readonly __typename?: 'MarketingTileList' }
    & IMarketingTileListFragment
  )> };

export type ILoyaltyOfferTemplateFragment = { readonly __typename?: 'OfferTemplate', readonly _id: string, readonly _type: string, readonly loyaltyEngineId: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleSmartBlockContent', readonly localeRaw: Maybe<any> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleSmartBlockContent', readonly localeRaw: Maybe<any> }>, readonly backgroundImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly localizedImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    )> }> };

export type IOptInModalFragment = { readonly __typename?: 'OptInModalContent', readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly blockText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> };

export type IShortCodeConfirmationModalFragment = { readonly __typename?: 'ShortCodeConfirmationModalContent', readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionButton: Maybe<{ readonly __typename?: 'ActionButton', readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly dismissButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type ILoyaltyButtonWidgetFragment = { readonly __typename?: 'LoyaltyButtonWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly link: Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )> };

export type ILoyaltyImageWidgetFragment = { readonly __typename?: 'LoyaltyImageWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly image: Maybe<(
    { readonly __typename?: 'LocaleImage' }
    & ILocaleImageFragment
  )> };

export type ILoyaltyTextWidgetFragment = { readonly __typename?: 'LoyaltyTextWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly text: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )> };

export type ILoyaltyTitleWidgetFragment = { readonly __typename?: 'LoyaltyTitleWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly title: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )> };

export type ILoyaltyPaymentMethodWidgetFragment = { readonly __typename?: 'LoyaltyPaymentMethodWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly title: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )> };

export type ILoyaltyQrScanButtonWidgetFragment = { readonly __typename?: 'LoyaltyQRScanButtonWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly title: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly subtitle: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly expirationMessage: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly link: Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )> };

export type ILoyaltyQrScanHeaderWidgetFragment = { readonly __typename?: 'LoyaltyQRScanHeaderWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly title: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly subtitle: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly expirationMessage: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly link: Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )> };

export type ILoyaltyCartWidgetFragment = { readonly __typename?: 'LoyaltyCartWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string> };

export type ILoyaltyShortCodeWidgetFragment = { readonly __typename?: 'LoyaltyShortCodeWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly defaultCode: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly title: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly alternativeTitle: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly subtitle: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )> };

export type ILoyaltyQrCodeWidgetFragment = { readonly __typename?: 'LoyaltyQRCodeWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly title: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly subtitle: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly expirationMessage: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )> };

export type ILoyaltyBasicCardWidgetFragment = { readonly __typename?: 'LoyaltyBasicCardWidget', readonly _key: Maybe<string>, readonly componentKey: Maybe<string>, readonly linkedCard: Maybe<(
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  )>, readonly unlinkedCard: Maybe<(
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  )> };

export type IMainHeroFragment = { readonly __typename?: 'MainHero', readonly _id: string, readonly textColor: Maybe<string>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly mobileImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly superText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly mainText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly action: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly actionRight: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly actionRightIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly actionLeft: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly actionLeftIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly maskCards: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'SimpleCard' }
    & IHeroMaskCardFragment
  )>>>, readonly loyaltyAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IMarketingCardGroupFragment = { readonly __typename?: 'MarketingCardGroup', readonly _id: string, readonly Cards: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'MarketingCard' }
    & IMarketingCardFragment
  )>>> };

export type IMarketingCardFragment = { readonly __typename?: 'MarketingCard', readonly _id: string, readonly hasCustomColors: Maybe<boolean>, readonly hasTerms: Maybe<boolean>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly callToAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>, readonly textColor: Maybe<(
    { readonly __typename?: 'Color' }
    & IColorFragment
  )>, readonly backgroundColor: Maybe<(
    { readonly __typename?: 'Color' }
    & IColorFragment
  )>, readonly buttonTextColor: Maybe<(
    { readonly __typename?: 'Color' }
    & IColorFragment
  )>, readonly buttonBackgroundColor: Maybe<(
    { readonly __typename?: 'Color' }
    & IColorFragment
  )>, readonly termsText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly termsButton: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> };

export type IMarketingTileCarouselFragment = { readonly __typename?: 'MarketingTileCarousel', readonly _id: string, readonly header: Maybe<(
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  )>, readonly tiles: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  )>>> };

export type IMarketingTileGroupFragment = { readonly __typename?: 'MarketingTileGroup', readonly _id: string, readonly tiles: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'MarketingTile' }
    & IMarketingTileFragment
  ) | (
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  ) | (
    { readonly __typename?: 'MarketingTileList' }
    & IMarketingTileListFragment
  ) | { readonly __typename?: 'MarketingTilePair', readonly left: Maybe<(
      { readonly __typename?: 'MarketingTile' }
      & IMarketingTileFragment
    )>, readonly right: Maybe<(
      { readonly __typename?: 'MarketingTile' }
      & IMarketingTileFragment
    )> } | { readonly __typename?: 'MarketingTileQuad', readonly topLeftTile: Maybe<(
      { readonly __typename?: 'MarketingTileBasic' }
      & IMarketingTileBasicFragment
    )>, readonly topRightTile: Maybe<(
      { readonly __typename?: 'MarketingTileBasic' }
      & IMarketingTileBasicFragment
    )>, readonly bottomLeftTile: Maybe<(
      { readonly __typename?: 'MarketingTileBasic' }
      & IMarketingTileBasicFragment
    )>, readonly bottomRightTile: Maybe<(
      { readonly __typename?: 'MarketingTileBasic' }
      & IMarketingTileBasicFragment
    )> }>>> };

export type IMarketingTileFragment = { readonly __typename?: 'MarketingTile', readonly _id: string, readonly textAlignment: Maybe<string>, readonly buttonAlignment: Maybe<string>, readonly textColor: Maybe<string>, readonly lockedAspectRatio: Maybe<boolean>, readonly backgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly buttonAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>, readonly textBlock: Maybe<{ readonly __typename?: 'LocaleTypographyBlock', readonly localeRaw: Maybe<any> }>, readonly termsText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly termsButton: Maybe<{ readonly __typename?: 'LinkAction', readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>, readonly ruleSet: Maybe<{ readonly __typename?: 'MarketingTileRuleSet', readonly dayOfWeek: Maybe<{ readonly __typename?: 'DayOfWeekBand', readonly monday: Maybe<boolean>, readonly tuesday: Maybe<boolean>, readonly wednesday: Maybe<boolean>, readonly thursday: Maybe<boolean>, readonly friday: Maybe<boolean>, readonly saturday: Maybe<boolean>, readonly sunday: Maybe<boolean> }>, readonly betweenTimes: Maybe<{ readonly __typename?: 'BetweenTimes', readonly startTime: Maybe<string>, readonly endTime: Maybe<string> }> }> };

export type IMarketingTileBasicFragment = { readonly __typename?: 'MarketingTileBasic', readonly _id: string, readonly marketingBasicTileDescription: Maybe<{ readonly __typename?: 'LocaleTypographyBlock', readonly localeRaw: Maybe<any> }>, readonly marketingBasicTileImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly marketingBasicTileTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type IMarketingTileListFragment = { readonly __typename: 'MarketingTileList', readonly _type: Maybe<string>, readonly tiles: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  )>>> };

export type IMenuImageFragment = { readonly __typename?: 'Image', readonly hotspot: Maybe<{ readonly __typename?: 'SanityImageHotspot', readonly x: Maybe<number>, readonly y: Maybe<number>, readonly height: Maybe<number>, readonly width: Maybe<number> }>, readonly crop: Maybe<{ readonly __typename?: 'SanityImageCrop', readonly top: Maybe<number>, readonly bottom: Maybe<number>, readonly left: Maybe<number>, readonly right: Maybe<number> }>, readonly asset: Maybe<{ readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly metadata: Maybe<{ readonly __typename?: 'SanityImageMetadata', readonly lqip: Maybe<string>, readonly palette: Maybe<{ readonly __typename?: 'SanityImagePalette', readonly dominant: Maybe<{ readonly __typename?: 'SanityImagePaletteSwatch', readonly background: Maybe<string>, readonly foreground: Maybe<string> }> }> }> }> };

export type IMenuImagesFragment = { readonly __typename?: 'Images', readonly imageDescription: Maybe<string>, readonly app: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly kiosk: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )> };

export type INotificationDetailsFragment = { readonly __typename?: 'NotificationDetails', readonly enabled: Maybe<boolean>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly path: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type INutritionFragment = { readonly __typename?: 'Nutrition', readonly calories: Maybe<number>, readonly fat: Maybe<number>, readonly saturatedFat: Maybe<number>, readonly transFat: Maybe<number>, readonly cholesterol: Maybe<number>, readonly sodium: Maybe<number>, readonly salt: Maybe<number>, readonly carbohydrates: Maybe<number>, readonly fiber: Maybe<number>, readonly sugar: Maybe<number>, readonly proteins: Maybe<number>, readonly weight: Maybe<number> };

export type IOffersSelectRestaurantCtaFragment = { readonly __typename?: 'OffersBrowsingPanel', readonly offersSelectRestaurantCta: Maybe<{ readonly __typename?: 'OffersSelectRestaurantCta', readonly minimumNumberOfOffers: Maybe<number>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly ctaButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> };

export type IAllowRedemptionWithoutLoginFragment = { readonly __typename?: 'AllowRedemptionWithoutLogin', readonly ruleSetType: Maybe<string> };

export type IBetweenDatesFragment = { readonly __typename?: 'BetweenDates', readonly endDate: Maybe<any>, readonly startDate: Maybe<any>, readonly ruleSetType: Maybe<string> };

export type IBetweenTimesFragment = { readonly __typename?: 'BetweenTimes', readonly endTime: Maybe<string>, readonly startTime: Maybe<string>, readonly ruleSetType: Maybe<string> };

export type ICartPropertyFragment = { readonly __typename?: 'CartProperty', readonly key: Maybe<string>, readonly negated: Maybe<boolean>, readonly operator: Maybe<string>, readonly value: Maybe<string>, readonly ruleSetType: Maybe<string> };

export type ICoolDownFragment = { readonly __typename?: 'CoolDown', readonly minimumElapsedTimeSeconds: Maybe<number>, readonly ruleSetType: Maybe<string> };

export type IDayOfWeekBandFragment = { readonly __typename?: 'DayOfWeekBand', readonly monday: Maybe<boolean>, readonly tuesday: Maybe<boolean>, readonly wednesday: Maybe<boolean>, readonly thursday: Maybe<boolean>, readonly friday: Maybe<boolean>, readonly saturday: Maybe<boolean>, readonly sunday: Maybe<boolean>, readonly ruleSetType: Maybe<string> };

export type IFirstOrderOnlyFragment = { readonly __typename?: 'FirstOrderOnly', readonly ruleSetType: Maybe<string> };

export type ILimitFragment = { readonly __typename?: 'Limit', readonly interval: Maybe<string>, readonly maximumRedemptions: Maybe<number>, readonly ruleSetType: Maybe<string> };

export type IPaymentCardTypeFragment = { readonly __typename?: 'PaymentCardType', readonly cardType: Maybe<string>, readonly ruleSetType: Maybe<string> };

export type IPurchaseFragment = { readonly __typename?: 'Purchase', readonly quantity: Maybe<number>, readonly sanityId: Maybe<string>, readonly ruleSetType: Maybe<string>, readonly option: Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboMetaFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  ) | (
    { readonly __typename?: 'Picker' }
    & IPickerMetaFragment
  ) | (
    { readonly __typename?: 'ProductCategory' }
    & IProductCategoryFragment
  )> };

export type IRequiresAssignmentFragment = { readonly __typename?: 'RequiresAssignment', readonly ruleSetType: Maybe<string> };

export type IRestaurantGroupRestrictionListFragment = { readonly __typename?: 'RestaurantGroupRestrictions', readonly ruleSetType: Maybe<string>, readonly restaurantGroupRestrictionList: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RestaurantGroup', readonly restaurants: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Restaurant', readonly number: Maybe<string> }>>> }>>> };

export type IItemMetaFragment = { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IComboMetaFragment = { readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  )>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IPickerMetaFragment = { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly option: Maybe<(
      { readonly __typename?: 'Combo' }
      & IComboMetaFragment
    ) | (
      { readonly __typename?: 'Item' }
      & IItemMetaFragment
    )> }>>> };

export type IActivateOfferMetaFragment = { readonly __typename?: 'OfferActivation', readonly _type: string };

export type IDiscountOfferMetaFragment = { readonly __typename?: 'OfferDiscount', readonly discountValue: Maybe<number>, readonly discountType: Maybe<string>, readonly _type: string };

export type IOffersFragment = { readonly __typename?: 'Offer', readonly _id: string, readonly _type: string, readonly daypart: Maybe<ReadonlyArray<Maybe<string>>>, readonly forSupport: Maybe<boolean>, readonly redemptionMethod: Maybe<string>, readonly offerPrice: Maybe<number>, readonly uiPattern: Maybe<string>, readonly shortCode: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly moreInfo: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly howToRedeem: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly backgroundImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly offerTags: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Tag', readonly value: Maybe<string>, readonly _id: string }>>>, readonly offerCTA: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly marketPrice: Maybe<{ readonly __typename?: 'Combo', readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename?: 'Item', readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> }>, readonly localizedImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    )> }>, readonly option: Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboMetaFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  ) | (
    { readonly __typename?: 'OfferActivation' }
    & IActivateOfferMetaFragment
  ) | (
    { readonly __typename?: 'OfferDiscount' }
    & IDiscountOfferMetaFragment
  ) | { readonly __typename?: 'OfferLoyaltyAction' } | (
    { readonly __typename?: 'Picker' }
    & IPickerMetaFragment
  )>, readonly lockedOffersPanel: Maybe<{ readonly __typename?: 'LockedOffersPanel', readonly completedChallengeHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly completedChallengeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>, readonly promoCodePanel: Maybe<{ readonly __typename?: 'PromoCodePanel', readonly promoCodeLink: Maybe<string>, readonly promoCodeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly promoCodeLabel: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'AllowRedemptionWithoutLogin' }
    & IAllowRedemptionWithoutLoginFragment
  ) | { readonly __typename?: 'And', readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | { readonly __typename?: 'CartRequirement' } | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | { readonly __typename?: 'IsStackable' } | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    )>>> } | (
    { readonly __typename?: 'BetweenDates' }
    & IBetweenDatesFragment
  ) | (
    { readonly __typename?: 'BetweenTimes' }
    & IBetweenTimesFragment
  ) | { readonly __typename?: 'CartContainsPlu' } | (
    { readonly __typename?: 'CartProperty' }
    & ICartPropertyFragment
  ) | (
    { readonly __typename?: 'CoolDown' }
    & ICoolDownFragment
  ) | (
    { readonly __typename?: 'DayOfWeekBand' }
    & IDayOfWeekBandFragment
  ) | (
    { readonly __typename?: 'FirstOrderOnly' }
    & IFirstOrderOnlyFragment
  ) | (
    { readonly __typename?: 'Limit' }
    & ILimitFragment
  ) | { readonly __typename?: 'Or', readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | { readonly __typename?: 'CartRequirement' } | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    )>>> } | (
    { readonly __typename?: 'OrderHistory' }
    & IOrderHistoryFragment
  ) | (
    { readonly __typename?: 'PaymentCardType' }
    & IPaymentCardTypeFragment
  ) | (
    { readonly __typename?: 'Purchase' }
    & IPurchaseFragment
  ) | (
    { readonly __typename?: 'RequiresAssignment' }
    & IRequiresAssignmentFragment
  ) | (
    { readonly __typename?: 'RestaurantGroupRestrictions' }
    & IRestaurantGroupRestrictionListFragment
  )>>>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IOptInSettingBooleanFragment = { readonly __typename?: 'OptInSettingBoolean', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly key: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IOptInSettingEmailAndPushFragment = { readonly __typename?: 'OptInSettingEmailAndPush', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly pushKey: Maybe<string>, readonly emailKey: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IOptInSettingEnumFragment = { readonly __typename?: 'OptInSettingEnum', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly key: Maybe<string>, readonly enumStrings: Maybe<ReadonlyArray<Maybe<string>>>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IOptInPrivacyPreferencesFragment = { readonly __typename?: 'OptInPrivacyPreferences', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly key: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly view: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IOrderHistoryFragment = { readonly __typename?: 'OrderHistory', readonly rangeType: Maybe<string>, readonly from: Maybe<any>, readonly to: Maybe<any>, readonly lastNSeconds: Maybe<number>, readonly isSequential: Maybe<boolean>, readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'And', readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | { readonly __typename?: 'CartRequirement' } | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | { readonly __typename?: 'IsStackable' } | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    )>>> } | (
    { readonly __typename?: 'BetweenTimes' }
    & IBetweenTimesFragment
  ) | { readonly __typename?: 'CartContainsPlu' } | (
    { readonly __typename?: 'CartProperty' }
    & ICartPropertyFragment
  ) | (
    { readonly __typename?: 'DayOfWeekBand' }
    & IDayOfWeekBandFragment
  ) | { readonly __typename?: 'Or', readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | { readonly __typename?: 'CartRequirement' } | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    )>>> } | (
    { readonly __typename?: 'PaymentCardType' }
    & IPaymentCardTypeFragment
  ) | (
    { readonly __typename?: 'Purchase' }
    & IPurchaseFragment
  )>>> };

export type IOurServicesFragment = { readonly __typename?: 'OurServices', readonly _id: string, readonly servicesHeaderTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly servicesHeroTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly ourServicesHeroImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }> };

export type IPaymentMethodDeletionModalTextFragment = { readonly __typename?: 'FeatureScanAndPay', readonly paymentMethodDeletionModalText: Maybe<{ readonly __typename?: 'PaymentMethodDeletionModalText', readonly paymentMethodDeletionModalTextHeader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly paymentMethodDeletionModalTextBody: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }> }> };

export type IPickerAvailabilityFragment = { readonly __typename?: 'Picker', readonly showInStaticMenu: Maybe<boolean>, readonly hideCalories: Maybe<boolean>, readonly hideNutritionLegalDisclaimer: Maybe<boolean>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly option: Maybe<(
      { readonly __typename?: 'Combo' }
      & IComboAvailabilityFragment
    ) | (
      { readonly __typename?: 'Item' }
      & IItemAvailabilityFragment
    )> }>>> };

export type IPickerWithVendorConfigFragment = { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly isRealMeal: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerDefaults: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerItemMapping', readonly _key: Maybe<string>, readonly pickerAspectValueIdentifier: Maybe<string>, readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }>>>, readonly pickerAspects: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerAspectOptions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspectValue', readonly identifier: Maybe<string>, readonly hideNameInItemPreview: Maybe<boolean>, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> }>>>, readonly pickerAspectItemOptionMappings: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspectItemOptions', readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ListItem', readonly value: Maybe<string> }>>> }>>>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly _key: Maybe<string>, readonly default: Maybe<boolean>, readonly type: Maybe<string>, readonly pickerItemMappings: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerItemMapping', readonly pickerAspectValueIdentifier: Maybe<string>, readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string }> }>>>, readonly option: Maybe<(
      { readonly __typename?: 'Combo', readonly _key: Maybe<string>, readonly _id: string, readonly promotion: Maybe<{ readonly __typename?: 'SystemwidePromotion', readonly bonusPoints: Maybe<number> }>, readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )> }
      & IComboFragment
    ) | (
      { readonly __typename?: 'Item', readonly _key: Maybe<string>, readonly promotion: Maybe<{ readonly __typename?: 'SystemwidePromotion', readonly bonusPoints: Maybe<number> }>, readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )> }
      & IItemFragment
    )> }>>>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly quickConfigs: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'QuickConfig' }
    & IQuickConfigFragment
  )>>>, readonly channelExclusions: Maybe<{ readonly __typename?: 'ChannelExclusions', readonly delivery: Maybe<boolean>, readonly pickup: Maybe<boolean>, readonly kiosk: Maybe<boolean>, readonly googleFoodOrdering: Maybe<boolean> }> };

export type IPickerFragment = { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly isRealMeal: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerDefaults: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerItemMapping', readonly _key: Maybe<string>, readonly pickerAspectValueIdentifier: Maybe<string>, readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }>>>, readonly pickerAspects: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerAspectOptions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspectValue', readonly identifier: Maybe<string>, readonly hideNameInItemPreview: Maybe<boolean>, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> }>>>, readonly pickerAspectItemOptionMappings: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspectItemOptions', readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ListItem', readonly value: Maybe<string> }>>> }>>>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly _key: Maybe<string>, readonly default: Maybe<boolean>, readonly type: Maybe<string>, readonly pickerItemMappings: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerItemMapping', readonly pickerAspectValueIdentifier: Maybe<string>, readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string }> }>>>, readonly option: Maybe<(
      { readonly __typename?: 'Combo', readonly _key: Maybe<string>, readonly _id: string, readonly promotion: Maybe<{ readonly __typename?: 'SystemwidePromotion', readonly bonusPoints: Maybe<number> }> }
      & IComboFragment
    ) | (
      { readonly __typename?: 'Item', readonly _key: Maybe<string>, readonly promotion: Maybe<{ readonly __typename?: 'SystemwidePromotion', readonly bonusPoints: Maybe<number> }> }
      & IItemFragment
    )> }>>>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly quickConfigs: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'QuickConfig' }
    & IQuickConfigFragment
  )>>>, readonly channelExclusions: Maybe<{ readonly __typename?: 'ChannelExclusions', readonly delivery: Maybe<boolean>, readonly pickup: Maybe<boolean>, readonly kiosk: Maybe<boolean>, readonly googleFoodOrdering: Maybe<boolean> }> };

export type IProductCategoryFragment = { readonly __typename?: 'ProductCategory', readonly _id: string, readonly hierarchyLevel: Maybe<string>, readonly ruleSetType: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )> };

export type IProductListSectionFragment = { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly daypart: Maybe<ReadonlyArray<Maybe<string>>>, readonly uiPattern: Maybe<string>, readonly showInStaticMenu: Maybe<boolean>, readonly isRealMeal: Maybe<boolean>, readonly isBurgersForBreakfastSection: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )>, readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly carouselImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> } | { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly showInStaticMenu: Maybe<boolean>, readonly daypart: Maybe<ReadonlyArray<Maybe<string>>>, readonly isRealMeal: Maybe<boolean>, readonly isBurgersForBreakfastSection: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly carouselImage: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> } | { readonly __typename?: 'Section' }>>> }>>> };

export type IQuickConfigFragment = { readonly __typename?: 'QuickConfig', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rules: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuickConfigRule', readonly itemOptions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ListItem', readonly value: Maybe<string> }>>>, readonly modifier: Maybe<{ readonly __typename?: 'ListItem', readonly value: Maybe<string> }> }>>> };

export type IRewardFragment = { readonly __typename?: 'Reward', readonly _id: string, readonly loyaltyEngineId: Maybe<string>, readonly incentiveNotInMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly moreInfo: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly enRaw: Maybe<any> }>, readonly howToRedeem: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly enRaw: Maybe<any> }>, readonly backgroundImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly incentives: Maybe<ReadonlyArray<Maybe<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<{ readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename: 'OfferDiscount', readonly _id: string, readonly _type: string, readonly discountValue: Maybe<number>, readonly discountType: Maybe<string> } | { readonly __typename: 'Picker', readonly _id: string, readonly _type: string, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly option: Maybe<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<{ readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> }>>> }>>>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IRewardsSectionFragment = { readonly __typename?: 'RewardsSection', readonly _id: string, readonly rewardsList: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'FeaturedReward', readonly reward: Maybe<(
      { readonly __typename?: 'Reward' }
      & IRewardFragment
    )>, readonly category: Maybe<{ readonly __typename?: 'RewardCategory', readonly label: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }> }> }>>> };

export type ISectionAvailabilityFragment = { readonly __typename?: 'Section', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>>, readonly showInStaticMenu: Maybe<boolean>, readonly isBurgersForBreakfastSection: Maybe<boolean>, readonly options: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboAvailabilityFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemAvailabilityFragment
  ) | { readonly __typename?: 'Offer' } | (
    { readonly __typename?: 'Picker' }
    & IPickerAvailabilityFragment
  ) | { readonly __typename?: 'Section', readonly showInStaticMenu: Maybe<boolean>, readonly options: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Combo' }
      & IComboAvailabilityFragment
    ) | (
      { readonly __typename?: 'Item' }
      & IItemAvailabilityFragment
    ) | { readonly __typename?: 'Offer' } | (
      { readonly __typename?: 'Picker' }
      & IPickerAvailabilityFragment
    ) | { readonly __typename?: 'Section', readonly options: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'Combo' }
        & IComboAvailabilityFragment
      ) | (
        { readonly __typename?: 'Item' }
        & IItemAvailabilityFragment
      ) | { readonly __typename?: 'Offer' } | (
        { readonly __typename?: 'Picker' }
        & IPickerAvailabilityFragment
      ) | { readonly __typename?: 'Section' }>>> }>>> }>>> };

export type ISectionFragment = { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly isRealMeal: Maybe<boolean>, readonly redirectLink: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly carouselImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )>, readonly carouselImageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly options: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemFragment
  ) | { readonly __typename?: 'Offer' } | (
    { readonly __typename?: 'Picker' }
    & IPickerFragment
  ) | { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly redirectLink: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly channelExclusions: Maybe<{ readonly __typename?: 'ChannelExclusions', readonly delivery: Maybe<boolean>, readonly pickup: Maybe<boolean>, readonly kiosk: Maybe<boolean>, readonly googleFoodOrdering: Maybe<boolean> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly options: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Combo' }
      & IComboFragment
    ) | (
      { readonly __typename?: 'Item' }
      & IItemFragment
    ) | { readonly __typename?: 'Offer' } | (
      { readonly __typename?: 'Picker' }
      & IPickerFragment
    ) | { readonly __typename?: 'Section', readonly _type: string, readonly _id: string, readonly uiPattern: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly options: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'Combo' }
        & IComboFragment
      ) | (
        { readonly __typename?: 'Item' }
        & IItemFragment
      ) | { readonly __typename?: 'Offer' } | (
        { readonly __typename?: 'Picker' }
        & IPickerFragment
      ) | { readonly __typename?: 'Section' }>>> }>>> }>>> };

export type ISkillsTestFragment = { readonly __typename?: 'SkillsTest', readonly correctAnswer: Maybe<number>, readonly answersList: Maybe<ReadonlyArray<Maybe<number>>>, readonly mathBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> };

export type ISystemwideOffersFragment = { readonly __typename?: 'SystemwideOffer', readonly _id: string, readonly _type: string, readonly loyaltyEngineId: Maybe<string>, readonly shortCode: Maybe<string>, readonly mobileOrderOnly: Maybe<boolean>, readonly daypart: Maybe<ReadonlyArray<Maybe<string>>>, readonly redemptionType: Maybe<string>, readonly offerPrice: Maybe<number>, readonly uiPattern: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly moreInfo: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly howToRedeem: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly enRaw: Maybe<any> }>, readonly backgroundImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly marketPrice: Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> }>, readonly localizedImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    )> }>, readonly lockedOffersPanel: Maybe<{ readonly __typename?: 'LockedOffersPanel', readonly completedChallengeHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly completedChallengeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>, readonly promoCodePanel: Maybe<{ readonly __typename?: 'PromoCodePanel', readonly promoCodeLink: Maybe<string>, readonly promoCodeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly promoCodeLabel: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>, readonly incentives: Maybe<ReadonlyArray<Maybe<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<{ readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename: 'OfferActivation', readonly _id: string, readonly _type: string } | { readonly __typename: 'OfferDiscount', readonly _id: string, readonly _type: string, readonly discountValue: Maybe<number>, readonly discountType: Maybe<string> } | { readonly __typename: 'Picker', readonly _id: string, readonly _type: string, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly option: Maybe<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<{ readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> }>>> } | { readonly __typename: 'SwapMapping', readonly _type: string }>>>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type ITabDetailContentFragment = { readonly __typename?: 'TabDetailContent', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }> };

export type ITitleAndBodyFragment = { readonly __typename?: 'TitleAndBody', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type ITrendingFragment = { readonly __typename?: 'Trending', readonly _id: string, readonly promotions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'ExternalLink', readonly _key: Maybe<string>, readonly url: Maybe<string>, readonly type: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Offer', readonly _id: string, readonly _type: string } | { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> };

export type IVendorConfigFragment = { readonly __typename?: 'VendorConfig', readonly pluType: Maybe<string>, readonly parentSanityId: Maybe<string>, readonly pullUpLevels: Maybe<number>, readonly constantPlu: Maybe<string>, readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Plu', readonly quantity: Maybe<number>, readonly plu: Maybe<string>, readonly qualifier: Maybe<string> }>>>, readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Plu', readonly quantity: Maybe<number>, readonly plu: Maybe<string>, readonly qualifier: Maybe<string> }>>>, readonly parentChildPlu: Maybe<{ readonly __typename?: 'ParentChildPlu', readonly plu: Maybe<string>, readonly childPlu: Maybe<string> }>, readonly sizeBasedPlu: Maybe<{ readonly __typename?: 'SizeBasedPlu', readonly comboPlu: Maybe<string>, readonly comboSize: Maybe<string> }> };

export type IVendorConfigsFragment = { readonly __typename?: 'VendorConfigs', readonly carrols: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly carrolsDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncr: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncrDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly oheics: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly oheicsDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumber: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumberDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicom: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicomDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdi: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdiDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qst: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qstDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rpos: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rposDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly simplyDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly simplyDeliveryDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tablet: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tabletDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )> };

export type IVideoFileFragment = { readonly __typename?: 'File', readonly asset: Maybe<{ readonly __typename?: 'SanityFileAsset', readonly assetId: Maybe<string>, readonly path: Maybe<string>, readonly url: Maybe<string> }> };

export type IGetItemQueryVariables = {
  id: Scalars['ID']
};


export type IGetItemQuery = { readonly __typename?: 'RootQuery', readonly Item: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemFragment
  )> };

export type IGetItemWithVendorConfigQueryVariables = {
  id: Scalars['ID']
};


export type IGetItemWithVendorConfigQuery = { readonly __typename?: 'RootQuery', readonly Item: Maybe<(
    { readonly __typename?: 'Item', readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> }
    & IItemFragment
  )> };

export type IGetItemAvailabilityQueryVariables = {
  id: Scalars['ID']
};


export type IGetItemAvailabilityQuery = { readonly __typename?: 'RootQuery', readonly Item: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemAvailabilityFragment
  )> };

export type ISingleLoyaltyContentQueryVariables = {};


export type ISingleLoyaltyContentQuery = { readonly __typename?: 'RootQuery', readonly allLoyaltyContents: ReadonlyArray<{ readonly __typename?: 'LoyaltyContent', readonly _id: string }> };

export type IBirthdayLegalTextQueryVariables = {
  loyaltyContentId: Scalars['ID']
};


export type IBirthdayLegalTextQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyContent: Maybe<{ readonly __typename?: 'LoyaltyContent', readonly birthdayLegalText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type ISystemwidePromotionMessageQueryVariables = {
  id: Scalars['ID']
};


export type ISystemwidePromotionMessageQuery = { readonly __typename?: 'RootQuery', readonly SystemwidePromotion: Maybe<{ readonly __typename?: 'SystemwidePromotion', readonly promoMessage: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IPosDataQueryVariables = {
  id: Scalars['ID']
};


export type IPosDataQuery = { readonly __typename?: 'RootQuery', readonly RestaurantPosData: Maybe<{ readonly __typename?: 'RestaurantPosData', readonly _id: string, readonly disableChickenSandwich: Maybe<boolean>, readonly plus: Maybe<string>, readonly deliveryPLUs: Maybe<string> }> };

export type IGetOfferByIdQueryVariables = {
  id: Scalars['ID']
};


export type IGetOfferByIdQuery = { readonly __typename?: 'RootQuery', readonly Offer: Maybe<(
    { readonly __typename?: 'Offer' }
    & IOffersFragment
  )> };

export type IGetPickerQueryVariables = {
  id: Scalars['ID']
};


export type IGetPickerQuery = { readonly __typename?: 'RootQuery', readonly Picker: Maybe<(
    { readonly __typename?: 'Picker' }
    & IPickerFragment
  )> };

export type IGetPickerWithVendorConfigQueryVariables = {
  id: Scalars['ID']
};


export type IGetPickerWithVendorConfigQuery = { readonly __typename?: 'RootQuery', readonly Picker: Maybe<(
    { readonly __typename?: 'Picker' }
    & IPickerWithVendorConfigFragment
  )> };

export type IGetPickerAvailabilityQueryVariables = {
  id: Scalars['ID']
};


export type IGetPickerAvailabilityQuery = { readonly __typename?: 'RootQuery', readonly Picker: Maybe<(
    { readonly __typename?: 'Picker' }
    & IPickerAvailabilityFragment
  )> };

export type IPlaceholderFieldsQueryVariables = {};


export type IPlaceholderFieldsQuery = { readonly __typename?: 'RootQuery', readonly allPlaceholderFields: ReadonlyArray<{ readonly __typename?: 'PlaceholderField', readonly _id: string, readonly formatter: Maybe<string>, readonly path: Maybe<string>, readonly fieldId: Maybe<string> }> };

export type IGetProductCategoryQueryVariables = {
  id: Scalars['ID']
};


export type IGetProductCategoryQuery = { readonly __typename?: 'RootQuery', readonly ProductCategory: Maybe<(
    { readonly __typename?: 'ProductCategory' }
    & IProductCategoryFragment
  )> };

export type IGetMenuSectionsQueryVariables = {
  id: Scalars['ID']
};


export type IGetMenuSectionsQuery = { readonly __typename?: 'RootQuery', readonly Menu: Maybe<{ readonly __typename?: 'Menu', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo' } | { readonly __typename?: 'Item' } | (
      { readonly __typename?: 'Picker' }
      & IPickerFragment
    ) | (
      { readonly __typename?: 'Section' }
      & IProductListSectionFragment
    )>>>, readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerBackgroundImage: Maybe<{ readonly __typename?: 'Image', readonly asset: Maybe<{ readonly __typename?: 'SanityImageAsset', readonly _id: string }> }> }> };

export type IGetMenuPickerByIdQueryVariables = {
  id: Scalars['ID']
};


export type IGetMenuPickerByIdQuery = { readonly __typename?: 'RootQuery', readonly Picker: Maybe<(
    { readonly __typename?: 'Picker' }
    & IPickerFragment
  )> };

export type IGetMenuComboByIdQueryVariables = {
  id: Scalars['ID']
};


export type IGetMenuComboByIdQuery = { readonly __typename?: 'RootQuery', readonly Combo: Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboFragment
  )> };

export type IGetMenuItemByIdQueryVariables = {
  id: Scalars['ID']
};


export type IGetMenuItemByIdQuery = { readonly __typename?: 'RootQuery', readonly Item: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemFragment
  )> };

export type IGetRestaurantsQueryVariables = {
  filter?: Maybe<IRestaurantFilter>,
  limit?: Maybe<Scalars['Int']>
};


export type IGetRestaurantsQuery = { readonly __typename?: 'RootQuery', readonly allRestaurants: ReadonlyArray<(
    { readonly __typename?: 'Restaurant' }
    & IRestaurantFragment
  )> };

export type IRestaurantFragment = { readonly __typename?: 'Restaurant', readonly _id: string, readonly environment: Maybe<string>, readonly chaseMerchantId: Maybe<string>, readonly drinkStationType: Maybe<string>, readonly driveThruLaneType: Maybe<string>, readonly email: Maybe<ReadonlyArray<Maybe<string>>>, readonly franchiseGroupId: Maybe<number>, readonly franchiseGroupName: Maybe<string>, readonly frontCounterClosed: Maybe<boolean>, readonly hasBreakfast: Maybe<boolean>, readonly hasBurgersForBreakfast: Maybe<boolean>, readonly hasCurbside: Maybe<boolean>, readonly hasDineIn: Maybe<boolean>, readonly hasCatering: Maybe<boolean>, readonly hasDelivery: Maybe<boolean>, readonly hasDriveThru: Maybe<boolean>, readonly hasLateNightMenu: Maybe<boolean>, readonly hasMobileOrdering: Maybe<boolean>, readonly hasParking: Maybe<boolean>, readonly hasPlayground: Maybe<boolean>, readonly hasTakeOut: Maybe<boolean>, readonly hasWifi: Maybe<boolean>, readonly hasLoyalty: Maybe<boolean>, readonly isDarkKitchen: Maybe<boolean>, readonly isHalal: Maybe<boolean>, readonly latitude: Maybe<number>, readonly longitude: Maybe<number>, readonly mobileOrderingStatus: Maybe<string>, readonly name: Maybe<string>, readonly number: Maybe<string>, readonly parkingType: Maybe<string>, readonly phoneNumber: Maybe<string>, readonly playgroundType: Maybe<string>, readonly posRestaurantId: Maybe<string>, readonly status: Maybe<string>, readonly timezone: Maybe<string>, readonly vatNumber: Maybe<string>, readonly deliveryHours: Maybe<(
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  )>, readonly diningRoomHours: Maybe<(
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  )>, readonly curbsideHours: Maybe<(
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  )>, readonly driveThruHours: Maybe<(
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  )>, readonly pos: Maybe<{ readonly __typename?: 'Pos', readonly _type: Maybe<string>, readonly vendor: Maybe<string> }>, readonly physicalAddress: Maybe<{ readonly __typename?: 'Address', readonly _type: Maybe<string>, readonly address1: Maybe<string>, readonly address2: Maybe<string>, readonly city: Maybe<string>, readonly country: Maybe<string>, readonly postalCode: Maybe<string>, readonly stateProvince: Maybe<string> }>, readonly restaurantPosData: Maybe<{ readonly __typename?: 'RestaurantPosData', readonly _id: string }>, readonly restaurantImage: Maybe<{ readonly __typename?: 'Image', readonly hotspot: Maybe<{ readonly __typename?: 'SanityImageHotspot', readonly width: Maybe<number>, readonly height: Maybe<number>, readonly x: Maybe<number>, readonly y: Maybe<number> }>, readonly crop: Maybe<{ readonly __typename?: 'SanityImageCrop', readonly top: Maybe<number>, readonly bottom: Maybe<number>, readonly left: Maybe<number>, readonly right: Maybe<number> }>, readonly asset: Maybe<(
      { readonly __typename?: 'SanityImageAsset' }
      & IImageAssetFragment
    )> }>, readonly amenities: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RestaurantAmenity', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly icon: Maybe<{ readonly __typename?: 'Image', readonly asset: Maybe<(
        { readonly __typename?: 'SanityImageAsset' }
        & IImageAssetFragment
      )> }> }>>> };

export type IHoursFragment = { readonly __typename?: 'HoursOfOperation', readonly _type: Maybe<string>, readonly friClose: Maybe<string>, readonly friOpen: Maybe<string>, readonly monClose: Maybe<string>, readonly monOpen: Maybe<string>, readonly satClose: Maybe<string>, readonly satOpen: Maybe<string>, readonly sunClose: Maybe<string>, readonly sunOpen: Maybe<string>, readonly thrClose: Maybe<string>, readonly thrOpen: Maybe<string>, readonly tueClose: Maybe<string>, readonly tueOpen: Maybe<string>, readonly wedClose: Maybe<string>, readonly wedOpen: Maybe<string> };

export type IImageAssetFragment = { readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly label: Maybe<string>, readonly title: Maybe<string>, readonly url: Maybe<string>, readonly source: Maybe<{ readonly __typename?: 'SanityAssetSourceData', readonly id: Maybe<string>, readonly url: Maybe<string> }>, readonly metadata: Maybe<{ readonly __typename?: 'SanityImageMetadata', readonly lqip: Maybe<string>, readonly palette: Maybe<{ readonly __typename?: 'SanityImagePalette', readonly dominant: Maybe<{ readonly __typename?: 'SanityImagePaletteSwatch', readonly background: Maybe<string>, readonly foreground: Maybe<string> }> }> }> };

export type IGetRestaurantLoyaltyEnabledQueryVariables = {
  storeId: Scalars['ID']
};


export type IGetRestaurantLoyaltyEnabledQuery = { readonly __typename?: 'RootQuery', readonly Restaurant: Maybe<{ readonly __typename?: 'Restaurant', readonly hasLoyalty: Maybe<boolean> }> };

export type IGetRestaurantFzDetailsQueryVariables = {
  storeId: Scalars['ID']
};


export type IGetRestaurantFzDetailsQuery = { readonly __typename?: 'RootQuery', readonly Restaurant: Maybe<{ readonly __typename?: 'Restaurant', readonly fzAddress: Maybe<string>, readonly fzZipCode: Maybe<string>, readonly fzCity: Maybe<string>, readonly fzeeGroup: Maybe<string>, readonly fzAuthorizedRepresentative: Maybe<string>, readonly fzEmail: Maybe<string>, readonly fzTelephone: Maybe<string>, readonly fzRegistryCourt: Maybe<string>, readonly fzHrb: Maybe<string>, readonly fzUstNr: Maybe<string>, readonly physicalAddress: Maybe<{ readonly __typename?: 'Address', readonly address1: Maybe<string>, readonly address2: Maybe<string>, readonly city: Maybe<string>, readonly country: Maybe<string>, readonly postalCode: Maybe<string>, readonly stateProvince: Maybe<string> }> }> };

export type IGetRestaurantVrPaymentMerchantIdQueryVariables = {
  storeId: Scalars['ID']
};


export type IGetRestaurantVrPaymentMerchantIdQuery = { readonly __typename?: 'RootQuery', readonly Restaurant: Maybe<{ readonly __typename?: 'Restaurant', readonly vrPaymentMerchantId: Maybe<string> }> };

export type ILoyaltyRewardsByEngineIdQueryVariables = {
  ids: ReadonlyArray<Scalars['String']>
};


export type ILoyaltyRewardsByEngineIdQuery = { readonly __typename?: 'RootQuery', readonly allRewards: ReadonlyArray<(
    { readonly __typename?: 'Reward' }
    & IRewardFragment
  )> };

export type ILoyaltyRewardsQueryVariables = {};


export type ILoyaltyRewardsQuery = { readonly __typename?: 'RootQuery', readonly allRewards: ReadonlyArray<(
    { readonly __typename?: 'Reward' }
    & IRewardFragment
  )> };

export type ILoyaltyFeaturedRewardsQueryVariables = {};


export type ILoyaltyFeaturedRewardsQuery = { readonly __typename?: 'RootQuery', readonly allRewardsSections: ReadonlyArray<(
    { readonly __typename?: 'RewardsSection' }
    & IRewardsSectionFragment
  )> };

export type IGetAllRollUpTheRimsQueryVariables = {};


export type IGetAllRollUpTheRimsQuery = { readonly __typename?: 'RootQuery', readonly allRollUpTheRims: ReadonlyArray<{ readonly __typename?: 'RollUpTheRim', readonly _id: string, readonly gamePlayUnauthButtonVariant: Maybe<string>, readonly firstDrawing: Maybe<any>, readonly secondDrawing: Maybe<any>, readonly thirdDrawing: Maybe<any>, readonly fourthDrawing: Maybe<any>, readonly rutwLogo: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly gamePlayHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly unauthenticatedGamePlayHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly gamePlayTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly unauthenticatedgGamePlayTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameErrorHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly gameErrorBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameRollButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly gamePlayImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopGamePlayImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly gamePlayButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gamePlayUnauthButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rollsRemainingText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameplayRollAudio: Maybe<{ readonly __typename?: 'File', readonly asset: Maybe<{ readonly __typename?: 'SanityFileAsset', readonly url: Maybe<string> }> }>, readonly gameplayWinAudio: Maybe<{ readonly __typename?: 'File', readonly asset: Maybe<{ readonly __typename?: 'SanityFileAsset', readonly url: Maybe<string> }> }>, readonly timelineHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly timelineTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly timelineComponents: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'TimelineComponents', readonly key: Maybe<string>, readonly state: Maybe<string>, readonly timelineEventType: Maybe<string>, readonly headerColor: Maybe<string>, readonly timelineHeader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }> }>>>, readonly timelinePrizeClaimedText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly timelineRollSharedText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly timelineConfetti: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly emptyTimelineTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly unauthenticatedEmptyTimelineTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly emptyTimelineButtonBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly unauthenticatedEmptyTimelineButtonBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly emptyTimelineImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly unauthenticatedEmptyTimelineImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly timelineButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly timelineTextLoadMore: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareYourRollsLinkText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopShareImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly prizesHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly prizesSeparator: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly prizesTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly prizesButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly prizesImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly planeImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly sponsorTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly sponsorsImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopPrizesImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopSponsorsImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly sharedLandingBadLinkButtonBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly sharedLandingBadLinkHeaderBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly sharedLandingBadLinkTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly sharedLandingBadLinkImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly shareRollTo: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollYouHave: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollShare: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollIncrementText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollReclaimButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollsDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly winnersHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly winnersTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly winnersButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly reusablesHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly reusablesTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly reusablesButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly reusablesImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopReusablesImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly modalTimelineHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly endText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly countdownText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly entriesText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly nextDrawText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly moneyStackImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly prizes: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Prizes', readonly excludeInAlberta: Maybe<boolean>, readonly numberAwarded: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly text: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }>, readonly buttonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>>, readonly rulesLinkText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rulesLinkPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly footerLinks: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RutrFooter', readonly _key: Maybe<string>, readonly footerLinkLocalizedPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly footerLinkText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly footerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly footerTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>>, readonly modalWinnersHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly modalWinnersTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameNeedHelp: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly cupImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly gameBackgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly gameButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rewardsHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rewardsHeaderSubtitleText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rewards: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Rewards', readonly key: Maybe<string>, readonly requireSkillsQuestion: Maybe<boolean>, readonly rewardName: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rewardLink: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rewardCodeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }>, readonly rewardYouWonMessageBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly allSetBlurbBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>>, readonly allSetHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly allSetEmailSentText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly allSetLegalBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly allSetClaimFailedHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorTimelineText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorTimelineButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorTimelineImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly homepageHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly homepageCupImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly homepageBackgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly enterButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rulesText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rrrollButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareRollHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareRollTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareRollURL: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollLinkTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollReclaimQuestionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollReclaimDescriptionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollsImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly shareRollsBackgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly howManyTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareRolluttonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rollupAnimationFrames: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>>>, readonly skillsQuestionHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly skillsQuestionsGroup: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'SkillsTest' }
      & ISkillsTestFragment
    )>>>, readonly localeSwitchModalHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly localeSwitchModalPrimaryText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly localeSwitchModalSecondaryText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly localeSwitchModalDisclaimerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly lockoutScreenTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly lockoutScreenImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly lockoutScreenButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IGetSectionQueryVariables = {
  id: Scalars['ID']
};


export type IGetSectionQuery = { readonly __typename?: 'RootQuery', readonly Section: Maybe<(
    { readonly __typename?: 'Section' }
    & ISectionFragment
  )> };

export type IGetSectionAvailabilityQueryVariables = {
  id: Scalars['ID']
};


export type IGetSectionAvailabilityQuery = { readonly __typename?: 'RootQuery', readonly Section: Maybe<(
    { readonly __typename?: 'Section' }
    & ISectionAvailabilityFragment
  )> };

export type ISingleAppDataQueryVariables = {};


export type ISingleAppDataQuery = { readonly __typename?: 'RootQuery', readonly allAppData: ReadonlyArray<{ readonly __typename?: 'AppData', readonly _id: string }> };

export type IGetSupportDataQueryVariables = {
  supportDataId: Scalars['ID']
};


export type IGetSupportDataQuery = { readonly __typename?: 'RootQuery', readonly SupportData: Maybe<{ readonly __typename?: 'SupportData', readonly _id: string, readonly supportCategoryGroups: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportCategoryGroup', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategories: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId: Maybe<string>, readonly supportSubcategoryForwardToOrders: Maybe<boolean>, readonly supportSubcategoryServiceModeSelector: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategoryFaqs: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>> }>>> }>>>, readonly deliveryNeverArriveSubcategory: Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly deliveryMissingItemsSubcategory: Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly orderingIssuesCategoryGroup: Maybe<{ readonly __typename?: 'SupportCategoryGroup', readonly _id: string }>, readonly supportDataFaqs: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>> }> };

export type IGetSupportSubcategoryQueryVariables = {
  id: Scalars['ID']
};


export type IGetSupportSubcategoryQuery = { readonly __typename?: 'RootQuery', readonly SupportSubcategory: Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly _type: string, readonly _createdAt: any, readonly _key: Maybe<string>, readonly _rev: string, readonly _updatedAt: any, readonly knowledgeForceIssueId: Maybe<string>, readonly directTicketProcessingPercentage: Maybe<number>, readonly supportSubcategoryForwardToOrders: Maybe<boolean>, readonly supportSubcategoryServiceModeSelector: Maybe<boolean>, readonly supportSubcategorySubmitToSutherland: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategoryFaqs: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>>, readonly supportSubcategoryFaq: Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }> }> };

export type IGetSupportCategoryGroupQueryVariables = {
  id: Scalars['ID']
};


export type IGetSupportCategoryGroupQuery = { readonly __typename?: 'RootQuery', readonly SupportCategoryGroup: Maybe<{ readonly __typename?: 'SupportCategoryGroup', readonly _id: string, readonly showRestaurantSelector: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategories: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId: Maybe<string>, readonly supportSubcategoryForwardToOrders: Maybe<boolean>, readonly supportSubcategoryServiceModeSelector: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategoryFaqs: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>> }>>> }> };

export const AboutContentFragmentDoc = gql`
    fragment AboutContent on AppData {
  _id
  aboutMenuEntries {
    name {
      locale: en
    }
    pages {
      ... on StaticPage {
        title
        localeTitle {
          locale: en
        }
        path {
          current
        }
        localePath {
          locale: en {
            current
          }
        }
        redirectUrl {
          locale: en
        }
      }
      ... on NavigationSection {
        name {
          locale: en
        }
        pages {
          ... on StaticPage {
            title
            localeTitle {
              locale: en
            }
            path {
              current
            }
            localePath {
              locale: en {
                current
              }
            }
            redirectUrl {
              locale: en
            }
          }
        }
      }
    }
  }
  calorieDisclaimer {
    localeRaw: enRaw
  }
  priceDisclaimer {
    locale: en
  }
  imagesDisclaimer {
    locale: en
  }
  copyrightAndTrademarkDisclaimer {
    locale: en
  }
  reservedRightsDisclaimer {
    locale: en
  }
}
    `;
export const MenuImageFragmentFragmentDoc = gql`
    fragment MenuImageFragment on Image {
  hotspot {
    x
    y
    height
    width
  }
  crop {
    top
    bottom
    left
    right
  }
  asset {
    metadata {
      lqip
      palette {
        dominant {
          background
          foreground
        }
      }
    }
    _id
  }
}
    `;
export const NutritionFragmentFragmentDoc = gql`
    fragment NutritionFragment on Nutrition {
  calories
  fat
  saturatedFat
  transFat
  cholesterol
  sodium
  salt
  carbohydrates
  fiber
  sugar
  proteins
  weight
}
    `;
export const AdditionalItemInformationFragmentFragmentDoc = gql`
    fragment AdditionalItemInformationFragment on AdditionalItemInformation {
  ingredients {
    locale: en
  }
  additives {
    locale: en
  }
  producerDetails {
    locale: en
  }
}
    `;
export const AllergensFragmentFragmentDoc = gql`
    fragment AllergensFragment on OpAllergen {
  milk
  eggs
  fish
  peanuts
  shellfish
  treeNuts
  soy
  wheat
  mustard
  sesame
  celery
  lupin
  gluten
  sulphurDioxide
}
    `;
export const VendorConfigFragmentFragmentDoc = gql`
    fragment VendorConfigFragment on VendorConfig {
  pluType
  parentSanityId
  pullUpLevels
  constantPlu
  quantityBasedPlu {
    quantity
    plu
    qualifier
  }
  multiConstantPlus {
    quantity
    plu
    qualifier
  }
  parentChildPlu {
    plu
    childPlu
  }
  sizeBasedPlu {
    comboPlu
    comboSize
  }
}
    `;
export const VendorConfigsFragmentFragmentDoc = gql`
    fragment VendorConfigsFragment on VendorConfigs {
  carrols {
    ...VendorConfigFragment
  }
  carrolsDelivery {
    ...VendorConfigFragment
  }
  ncr {
    ...VendorConfigFragment
  }
  ncrDelivery {
    ...VendorConfigFragment
  }
  oheics {
    ...VendorConfigFragment
  }
  oheicsDelivery {
    ...VendorConfigFragment
  }
  productNumber {
    ...VendorConfigFragment
  }
  productNumberDelivery {
    ...VendorConfigFragment
  }
  sicom {
    ...VendorConfigFragment
  }
  sicomDelivery {
    ...VendorConfigFragment
  }
  qdi {
    ...VendorConfigFragment
  }
  qdiDelivery {
    ...VendorConfigFragment
  }
  qst {
    ...VendorConfigFragment
  }
  qstDelivery {
    ...VendorConfigFragment
  }
  rpos {
    ...VendorConfigFragment
  }
  rposDelivery {
    ...VendorConfigFragment
  }
  simplyDelivery {
    ...VendorConfigFragment
  }
  simplyDeliveryDelivery {
    ...VendorConfigFragment
  }
  tablet {
    ...VendorConfigFragment
  }
  tabletDelivery {
    ...VendorConfigFragment
  }
}
    ${VendorConfigFragmentFragmentDoc}`;
export const ItemOptionFragmentFragmentDoc = gql`
    fragment ItemOptionFragment on ItemOption {
  name {
    locale: en
  }
  displayGroup {
    name {
      locale: en
    }
  }
  componentStyle
  upsellModifier
  allowMultipleSelections
  displayModifierMultiplierName
  injectDefaultSelection
  singleChoiceOnly
  minAmount
  maxAmount
  _key
  type: _type
  options {
    _key
    type: _type
    name {
      locale: en
    }
    vendorConfigs {
      ...VendorConfigsFragment
    }
    default
    modifierMultiplier {
      multiplier
      prefix {
        locale: en
      }
      modifier {
        name {
          locale: en
        }
        image {
          ...MenuImageFragment
        }
        imageDescription {
          locale: en
        }
      }
    }
    nutrition {
      ...NutritionFragment
    }
  }
}
    ${VendorConfigsFragmentFragmentDoc}
${MenuImageFragmentFragmentDoc}
${NutritionFragmentFragmentDoc}`;
export const ItemFragmentFragmentDoc = gql`
    fragment ItemFragment on Item {
  _id
  _type
  name {
    locale: en
  }
  description {
    localeRaw: enRaw
  }
  image {
    ...MenuImageFragment
  }
  imageDescription {
    locale: en
  }
  rewardEligible
  labelAsPerPerson
  nutrition {
    ...NutritionFragment
  }
  additionalItemInformation {
    ...AdditionalItemInformationFragment
  }
  nutritionWithModifiers {
    ...NutritionFragment
  }
  allergens {
    ...AllergensFragment
  }
  options {
    ...ItemOptionFragment
  }
  productHierarchy {
    L1
    L2
    L3
    L4
    L5
  }
  menuObjectSettings {
    limitPerOrder
  }
}
    ${MenuImageFragmentFragmentDoc}
${NutritionFragmentFragmentDoc}
${AdditionalItemInformationFragmentFragmentDoc}
${AllergensFragmentFragmentDoc}
${ItemOptionFragmentFragmentDoc}`;
export const ItemOptionAvailabilityFragmentFragmentDoc = gql`
    fragment ItemOptionAvailabilityFragment on ItemOption {
  injectDefaultSelection
  options {
    default
    vendorConfigs {
      ...VendorConfigsFragment
    }
    modifierMultiplier {
      vendorConfigs {
        ...VendorConfigsFragment
      }
      modifier {
        vendorConfigs {
          ...VendorConfigsFragment
        }
      }
    }
  }
}
    ${VendorConfigsFragmentFragmentDoc}`;
export const ItemAvailabilityFragmentFragmentDoc = gql`
    fragment ItemAvailabilityFragment on Item {
  operationalItem {
    daypart
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
  showInStaticMenu
  hideCalories
  hideNutritionLegalDisclaimer
  options {
    ...ItemOptionAvailabilityFragment
  }
}
    ${VendorConfigsFragmentFragmentDoc}
${ItemOptionAvailabilityFragmentFragmentDoc}`;
export const AddOnSectionOptionFragmentFragmentDoc = gql`
    fragment AddOnSectionOptionFragment on AddOnSectionOption {
  _key
  maxAmount
  option {
    ...ItemFragment
    ...ItemAvailabilityFragment
  }
}
    ${ItemFragmentFragmentDoc}
${ItemAvailabilityFragmentFragmentDoc}`;
export const AddOnSectionFragmentFragmentDoc = gql`
    fragment AddOnSectionFragment on AddOnSection {
  _id
  _key
  name {
    locale: en
  }
  maxAmount
  options {
    ...AddOnSectionOptionFragment
  }
}
    ${AddOnSectionOptionFragmentFragmentDoc}`;
export const MenuImagesFragmentFragmentDoc = gql`
    fragment MenuImagesFragment on Images {
  app {
    ...MenuImageFragment
  }
  kiosk {
    ...MenuImageFragment
  }
  imageDescription
}
    ${MenuImageFragmentFragmentDoc}`;
export const ConfigOfferFragmentFragmentDoc = gql`
    fragment ConfigOfferFragment on ConfigOffer {
  _id
  _type
  loyaltyEngineId
  name {
    localeRaw: enRaw
  }
  description {
    localeRaw: enRaw
  }
  moreInfo {
    localeRaw: enRaw
  }
  howToRedeem {
    enRaw
  }
  backgroundImage {
    ...MenuImageFragment
  }
  shortCode
  mobileOrderOnly
  daypart
  redemptionType
  offerPrice
  marketPrice {
    ... on Item {
      _id
      _type
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Combo {
      _id
      _type
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
  }
  localizedImage {
    locale: en {
      ...MenuImagesFragment
    }
  }
  uiPattern
  lockedOffersPanel {
    completedChallengeHeader {
      localeRaw: enRaw
    }
    completedChallengeDescription {
      localeRaw: enRaw
    }
  }
  promoCodePanel {
    promoCodeDescription {
      localeRaw: enRaw
    }
    promoCodeLabel {
      localeRaw: enRaw
    }
    promoCodeLink
  }
  incentives {
    __typename
    ... on Combo {
      _id
      _type
      mainItem {
        _id
        _type
        operationalItem {
          daypart
        }
      }
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Item {
      _id
      _type
      operationalItem {
        daypart
      }
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Picker {
      _id
      _type
      options {
        option {
          __typename
          ... on Combo {
            _id
            _type
            mainItem {
              _id
              _type
              operationalItem {
                daypart
              }
            }
          }
          ... on Item {
            _id
            _type
            operationalItem {
              daypart
            }
          }
        }
      }
    }
    ... on OfferDiscount {
      _id
      _type
      discountValue
      discountType
    }
    ... on OfferActivation {
      _id
      _type
    }
    ... on SwapMapping {
      _type
    }
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${MenuImageFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}
${MenuImagesFragmentFragmentDoc}`;
export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on Image {
  hotspot {
    x
    y
    height
    width
  }
  crop {
    top
    bottom
    left
    right
  }
  asset {
    metadata {
      lqip
      palette {
        dominant {
          background
          foreground
        }
      }
    }
    _id
  }
}
    `;
export const ImagesFragmentFragmentDoc = gql`
    fragment ImagesFragment on Images {
  app {
    ...ImageFragment
  }
  kiosk {
    ...ImageFragment
  }
  imageDescription
}
    ${ImageFragmentFragmentDoc}`;
export const RefFragmentDoc = gql`
    fragment ref on Image {
  asset {
    _id
  }
}
    `;
export const MarketingTileBasicFragmentFragmentDoc = gql`
    fragment MarketingTileBasicFragment on MarketingTileBasic {
  _id
  marketingBasicTileDescription {
    localeRaw: enRaw
  }
  marketingBasicTileImage {
    locale: en {
      ...ImagesFragment
    }
  }
  marketingBasicTileTitle {
    locale: en
  }
  link {
    locale: en
  }
}
    ${ImagesFragmentFragmentDoc}`;
export const MarketingTileListFragmentFragmentDoc = gql`
    fragment MarketingTileListFragment on MarketingTileList {
  __typename
  _type
  tiles {
    ...MarketingTileBasicFragment
  }
}
    ${MarketingTileBasicFragmentFragmentDoc}`;
export const EmptyStateFragmentFragmentDoc = gql`
    fragment EmptyStateFragment on EmptyState {
  _id
  headerText {
    locale: en
  }
  logo {
    locale: en {
      ...ImagesFragment
    }
  }
  backgroundImage {
    image {
      ...ref
    }
  }
  marketingTileList {
    ...MarketingTileListFragment
  }
  image {
    locale: en {
      ...ImagesFragment
    }
  }
  title {
    locale: en
  }
  subtitle {
    locale: en
  }
  description {
    locale: enRaw
  }
  buttonAction {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
  terms {
    locale: enRaw
  }
}
    ${ImagesFragmentFragmentDoc}
${RefFragmentDoc}
${MarketingTileListFragmentFragmentDoc}`;
export const HeroMaskCardFragmentDoc = gql`
    fragment HeroMaskCard on SimpleCard {
  _key
  title {
    locale: en
  }
  description {
    locale: en
  }
  image {
    ...ImageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const MainHeroFragmentFragmentDoc = gql`
    fragment MainHeroFragment on MainHero {
  _id
  image {
    locale: en {
      ...ImageFragment
    }
  }
  mobileImage {
    locale: en {
      ...ImageFragment
    }
  }
  superText {
    locale: en
  }
  mainText {
    locale: en
  }
  subText {
    locale: en
  }
  textColor
  action {
    route
    actionUrl {
      locale: en
    }
    actionText {
      locale: en
    }
  }
  actionRight {
    route
    actionUrl {
      locale: en
    }
    actionText {
      locale: en
    }
  }
  actionRightIcon {
    locale: en {
      ...ImageFragment
    }
  }
  actionLeft {
    route
    actionUrl {
      locale: en
    }
    actionText {
      locale: en
    }
  }
  actionLeftIcon {
    locale: en {
      ...ImageFragment
    }
  }
  maskCards {
    ...HeroMaskCard
  }
  loyaltyAction {
    route
    actionText {
      locale: en
    }
  }
}
    ${ImageFragmentFragmentDoc}
${HeroMaskCardFragmentDoc}`;
export const BrazeContentCardsFragmentFragmentDoc = gql`
    fragment BrazeContentCardsFragment on BrazeContentCards {
  _id
  contentCardsHeader: sectionheader {
    locale: en
  }
  contentCardsSubheader: sectionSubheader {
    locale: en
  }
}
    `;
export const AlertFrangmentFragmentDoc = gql`
    fragment AlertFrangment on Alert {
  _id
  heading {
    locale: en
  }
  body {
    locale: en
  }
  learnMoreText {
    locale: en
  }
  learnMoreUrl {
    locale: en
  }
}
    `;
export const MarketingTileFragmentFragmentDoc = gql`
    fragment MarketingTileFragment on MarketingTile {
  _id
  textAlignment
  backgroundImage {
    locale: en {
      ...ImagesFragment
    }
  }
  buttonAction {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
  buttonAlignment
  textColor
  textBlock {
    localeRaw: enRaw
  }
  lockedAspectRatio
  termsText {
    localeRaw: enRaw
  }
  termsButton {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
  }
  ruleSet {
    dayOfWeek {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
    betweenTimes {
      startTime
      endTime
    }
  }
}
    ${ImagesFragmentFragmentDoc}`;
export const MarketingTileGroupFragmentFragmentDoc = gql`
    fragment MarketingTileGroupFragment on MarketingTileGroup {
  _id
  tiles {
    ... on MarketingTile {
      ...MarketingTileFragment
    }
    ... on MarketingTileBasic {
      ...MarketingTileBasicFragment
    }
    ... on MarketingTileList {
      ...MarketingTileListFragment
    }
    ... on MarketingTilePair {
      left {
        ...MarketingTileFragment
      }
      right {
        ...MarketingTileFragment
      }
    }
    ... on MarketingTileQuad {
      topLeftTile {
        ...MarketingTileBasicFragment
      }
      topRightTile {
        ...MarketingTileBasicFragment
      }
      bottomLeftTile {
        ...MarketingTileBasicFragment
      }
      bottomRightTile {
        ...MarketingTileBasicFragment
      }
    }
  }
}
    ${MarketingTileFragmentFragmentDoc}
${MarketingTileBasicFragmentFragmentDoc}
${MarketingTileListFragmentFragmentDoc}`;
export const TrendingFragmentFragmentDoc = gql`
    fragment TrendingFragment on Trending {
  _id
  promotions {
    ... on Picker {
      _id
      _type
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      image {
        ...MenuImageFragment
      }
      imageDescription {
        locale: en
      }
    }
    ... on Item {
      _id
      _type
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      image {
        ...MenuImageFragment
      }
      imageDescription {
        locale: en
      }
    }
    ... on Combo {
      _id
      _type
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      image {
        ...MenuImageFragment
      }
      imageDescription {
        locale: en
      }
    }
    ... on Section {
      _id
      _type
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      image {
        ...ImageFragment
      }
      imageDescription {
        locale: en
      }
    }
    ... on Offer {
      _id
      _type
    }
    ... on ExternalLink {
      _key
      type: _type
      name {
        locale: en
      }
      image {
        locale: en {
          ...ImageFragment
        }
      }
      imageDescription {
        locale: en
      }
      description {
        locale: en
      }
      link {
        locale: en
      }
      url
    }
  }
}
    ${MenuImageFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const FanFavoritesFragmentFragmentDoc = gql`
    fragment FanFavoritesFragment on FanFavorites {
  _id
  fanFavoriteItems {
    ... on Picker {
      _id
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      imageDescription {
        locale: en
      }
    }
    ... on Item {
      _id
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      imageDescription {
        locale: en
      }
    }
    ... on Combo {
      _id
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
    }
    ... on Section {
      _id
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      imageDescription {
        locale: en
      }
    }
  }
  favoriteSection {
    headerText {
      locale: en
    }
  }
}
    ${MenuImageFragmentFragmentDoc}`;
export const OurServicesFragmentFragmentDoc = gql`
    fragment OurServicesFragment on OurServices {
  _id
  servicesHeaderTextLocale {
    locale: en
  }
  servicesHeroTextLocale {
    locale: en
  }
  ourServicesHeroImageLocale {
    locale: en {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const AppDownloadFragmentFragmentDoc = gql`
    fragment AppDownloadFragment on AppDownload {
  _id
  details {
    backgroundImage {
      ...ImageFragment
    }
    primaryImage {
      locale: en {
        ...ImageFragment
      }
    }
    headerSuperText {
      locale: en
    }
    header {
      locale: en
    }
    copy {
      locale: en
    }
    textDecorationLeft {
      ...ImageFragment
    }
    textDecorationRight {
      ...ImageFragment
    }
    submitButtonText {
      locale: en
    }
    iOSDownloadLink
    iOSDownloadImage {
      locale: en {
        ...ImageFragment
      }
    }
    androidDownloadLink
    androidDownloadImage {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const CateringPageConfigurationFragmentFragmentDoc = gql`
    fragment CateringPageConfigurationFragment on CateringPageConfiguration {
  components {
    ... on MainHero {
      ...MainHeroFragment
    }
    ... on BrazeContentCards {
      ...BrazeContentCardsFragment
    }
    ... on Alert {
      ...AlertFrangment
    }
    ... on MarketingTileGroup {
      ...MarketingTileGroupFragment
    }
    ... on OffersSection {
      _id
    }
    ... on Trending {
      ...TrendingFragment
    }
    ... on FanFavorites {
      ...FanFavoritesFragment
    }
    ... on OurServices {
      ...OurServicesFragment
    }
    ... on AppDownload {
      ...AppDownloadFragment
    }
    ... on RecentItems {
      _id
    }
    ... on LockedOffers {
      _id
    }
  }
}
    ${MainHeroFragmentFragmentDoc}
${BrazeContentCardsFragmentFragmentDoc}
${AlertFrangmentFragmentDoc}
${MarketingTileGroupFragmentFragmentDoc}
${TrendingFragmentFragmentDoc}
${FanFavoritesFragmentFragmentDoc}
${OurServicesFragmentFragmentDoc}
${AppDownloadFragmentFragmentDoc}`;
export const SocialIconsWidgetFragmentFragmentDoc = gql`
    fragment SocialIconsWidgetFragment on SocialIconsWidget {
  _type
  instagramUrl {
    locale: en
  }
  facebookUrl {
    locale: en
  }
  youtubeUrl {
    locale: en
  }
  twitterUrl {
    locale: en
  }
  tiktokUrl {
    locale: en
  }
}
    `;
export const FeatureFooterV2FragmentFragmentDoc = gql`
    fragment FeatureFooterV2Fragment on FeatureFooterV2 {
  _id
  __typename
  copyrightText {
    locale: en
  }
  mainLinks {
    _key
    _type
    link {
      locale: en
    }
    text {
      locale: en
    }
  }
  miscellaneousLinks {
    _key
    _type
    link {
      locale: en
    }
    text {
      locale: en
    }
  }
  socialMediaData {
    ...SocialIconsWidgetFragment
  }
}
    ${SocialIconsWidgetFragmentFragmentDoc}`;
export const HomePageConfigurationFragmentFragmentDoc = gql`
    fragment HomePageConfigurationFragment on HomePageConfiguration {
  components {
    ... on MainHero {
      _id
      __typename
    }
    ... on Hero {
      _id
      __typename
    }
    ... on BrazeContentCards {
      _id
      __typename
    }
    ... on Alert {
      _id
      __typename
    }
    ... on MarketingTileGroup {
      _id
      __typename
    }
    ... on MarketingTileCarousel {
      _id
      __typename
    }
    ... on MarketingCardGroup {
      _id
      __typename
    }
    ... on OffersSection {
      _id
      __typename
    }
    ... on Trending {
      _id
      __typename
    }
    ... on FanFavorites {
      _id
      __typename
    }
    ... on OurServices {
      _id
      __typename
    }
    ... on AppDownload {
      _id
      __typename
    }
    ... on ScanForRewards {
      _id
      __typename
    }
    ... on RollUpTheRimSection {
      _id
      __typename
    }
    ... on RecentItems {
      _id
      __typename
    }
    ... on LockedOffers {
      _id
      __typename
    }
    ... on RewardsSection {
      _id
      __typename
    }
    ... on GoogleAdSlot {
      _id
      __typename
    }
  }
}
    `;
export const LinkWidgetFragmentFragmentDoc = gql`
    fragment LinkWidgetFragment on LinkWidget {
  _key
  _type
  text {
    locale: en
  }
  link {
    locale: en
  }
}
    `;
export const NavigationLinkFragmentFragmentDoc = gql`
    fragment NavigationLinkFragment on NavigationDesktopLink {
  _key
  hideLinkBasedOnLdFlag {
    launchDarklyFlag
  }
  navLink {
    ... on LinkWidget {
      ...LinkWidgetFragment
    }
  }
  launchDarklyAlternateNavigationLink {
    enabled
    launchDarklyFlagDependency {
      launchDarklyFlag
    }
    navLink {
      ... on LinkWidget {
        ...LinkWidgetFragment
      }
    }
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const NavigationLinksFragmentFragmentDoc = gql`
    fragment NavigationLinksFragment on NavigationDesktop {
  navigationLinks {
    ...NavigationLinkFragment
  }
}
    ${NavigationLinkFragmentFragmentDoc}`;
export const NavigationSectionFragmentFragmentDoc = gql`
    fragment NavigationSectionFragment on NavigationSection {
  name {
    locale: en
  }
  pages {
    ... on StaticPage {
      title
      localeTitle {
        locale: en
      }
      path {
        current
      }
      localePath {
        locale: en {
          current
        }
      }
      redirectUrl {
        locale: en
      }
    }
    ... on NavigationSection {
      name {
        locale: en
      }
      pages {
        ... on StaticPage {
          title
          localeTitle {
            locale: en
          }
          path {
            current
          }
          localePath {
            locale: en {
              current
            }
          }
          redirectUrl {
            locale: en
          }
        }
      }
    }
  }
}
    `;
export const AboutMenuEntriesDesktopFragmentFragmentDoc = gql`
    fragment AboutMenuEntriesDesktopFragment on NavigationDesktop {
  aboutMenuEntries {
    ...NavigationSectionFragment
  }
}
    ${NavigationSectionFragmentFragmentDoc}`;
export const NavigationDesktopFragmentFragmentDoc = gql`
    fragment NavigationDesktopFragment on FeatureNavigation {
  navigationDesktop {
    _key
    _type
    ...NavigationLinksFragment
    ...AboutMenuEntriesDesktopFragment
  }
}
    ${NavigationLinksFragmentFragmentDoc}
${AboutMenuEntriesDesktopFragmentFragmentDoc}`;
export const NavigationTabFragmentFragmentDoc = gql`
    fragment NavigationTabFragment on NavigationMobileTab {
  _key
  _type
  hideLinkBasedOnLdFlag {
    launchDarklyFlag
  }
  tabIcon {
    locale: en {
      ...ImageFragment
    }
  }
  tabIconActive {
    locale: en {
      ...ImageFragment
    }
  }
  tabLink {
    ... on LinkWidget {
      ...LinkWidgetFragment
    }
  }
  launchDarklyAlternateMobileTab {
    _key
    _type
    enabled
    launchDarklyFlagDependency {
      launchDarklyFlag
    }
    tabIcon {
      locale: en {
        ...ImageFragment
      }
    }
    tabIconActive {
      locale: en {
        ...ImageFragment
      }
    }
    tabLink {
      ... on LinkWidget {
        ...LinkWidgetFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}
${LinkWidgetFragmentFragmentDoc}`;
export const NavigationTabsFragmentFragmentDoc = gql`
    fragment NavigationTabsFragment on NavigationMobile {
  navigationTabs {
    ...NavigationTabFragment
  }
}
    ${NavigationTabFragmentFragmentDoc}`;
export const AboutMenuEntriesMobileFragmentFragmentDoc = gql`
    fragment AboutMenuEntriesMobileFragment on NavigationMobile {
  aboutMenuEntries {
    ...NavigationSectionFragment
  }
}
    ${NavigationSectionFragmentFragmentDoc}`;
export const NavigationMobileFragmentFragmentDoc = gql`
    fragment NavigationMobileFragment on FeatureNavigation {
  navigationMobile {
    _key
    _type
    ...NavigationTabsFragment
    ...AboutMenuEntriesMobileFragment
  }
}
    ${NavigationTabsFragmentFragmentDoc}
${AboutMenuEntriesMobileFragmentFragmentDoc}`;
export const NavigationButtonFragmentFragmentDoc = gql`
    fragment NavigationButtonFragment on FeatureNavigation {
  navigationMobileHeaderButton {
    _key
    icon {
      locale: en {
        ...ImageFragment
      }
    }
    iconActive {
      locale: en {
        ...ImageFragment
      }
    }
    link {
      locale: en
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const NutritionItemFragmentFragmentDoc = gql`
    fragment NutritionItemFragment on NutritionItem {
  _type
  nutritionKey
  name {
    locale: en
  }
  unit {
    locale: en
  }
  additionalItems {
    ... on NutritionItem {
      nutritionKey
      name {
        locale: en
      }
      unit {
        locale: en
      }
    }
  }
}
    `;
export const NutritionItemGroupFragmentFragmentDoc = gql`
    fragment NutritionItemGroupFragment on NutritionItemGroup {
  _key
  _type
  mainItem {
    ...NutritionItemFragment
  }
  lineItems {
    ...NutritionItemFragment
  }
}
    ${NutritionItemFragmentFragmentDoc}`;
export const NutritionTableFragmentFragmentDoc = gql`
    fragment NutritionTableFragment on NutritionTable {
  _key
  _type
  title {
    locale: en
  }
  items {
    ... on NutritionItem {
      ...NutritionItemFragment
    }
    ... on NutritionItemGroup {
      ...NutritionItemGroupFragment
    }
  }
}
    ${NutritionItemFragmentFragmentDoc}
${NutritionItemGroupFragmentFragmentDoc}`;
export const RoundingRulesFragmentFragmentDoc = gql`
    fragment RoundingRulesFragment on RoundingRules {
  enabled
  decimalPlaces
  roundingType
}
    `;
export const OffersPageMarketingTileFragmentFragmentDoc = gql`
    fragment OffersPageMarketingTileFragment on OffersPageMarketingTile {
  marketingTileReference {
    ...MarketingTileFragment
  }
  displayPosition
  customPosition
}
    ${MarketingTileFragmentFragmentDoc}`;
export const OnboardingScreenFragmentFragmentDoc = gql`
    fragment OnboardingScreenFragment on ImageWithHeaderAndText {
  image {
    locale: en {
      ...ImageFragment
    }
  }
  imageDescription {
    locale: en
  }
  textContent {
    localeRaw: enRaw
  }
  buttonAction {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const ItemUnavailableModalFragmentFragmentDoc = gql`
    fragment itemUnavailableModalFragment on FeatureStaticMenu {
  itemUnavailableModal {
    _key
    _type
    header {
      locale: en
    }
    body {
      locale: en
    }
    continue {
      locale: en
    }
    selectNew {
      locale: en
    }
    itemNotAvailableForDelivery {
      locale: en
    }
    image {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const CopyrightAndLanguageSelectorFragmentFragmentDoc = gql`
    fragment CopyrightAndLanguageSelectorFragment on CopyrightAndLanguageSelector {
  _type
  copyrightText {
    locale: en
  }
}
    `;
export const HighlightedLinkWidgetFragmentFragmentDoc = gql`
    fragment HighlightedLinkWidgetFragment on HighlightedLinkWidget {
  _key
  _type
  text {
    locale: en
  }
  link {
    locale: en
  }
}
    `;
export const HighlightedVerticalLinkListWidgetFragmentFragmentDoc = gql`
    fragment HighlightedVerticalLinkListWidgetFragment on HighlightedVerticalLinkListWidget {
  _type
  header {
    locale: en
  }
  subheader {
    locale: en
  }
  highlightedLinks {
    ...HighlightedLinkWidgetFragment
  }
}
    ${HighlightedLinkWidgetFragmentFragmentDoc}`;
export const HorizontalLinkListWidgetFragmentFragmentDoc = gql`
    fragment HorizontalLinkListWidgetFragment on HorizontalLinkListWidget {
  _type
  linkWidgets {
    ...LinkWidgetFragment
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const ImageWidgetFragmentFragmentDoc = gql`
    fragment ImageWidgetFragment on ImageWidget {
  _type
  image {
    locale: en {
      ...ImageFragment
    }
  }
  imageDescription {
    locale: en
  }
}
    ${ImageFragmentFragmentDoc}`;
export const SocialIconsWithHeaderWidgetFragmentFragmentDoc = gql`
    fragment SocialIconsWithHeaderWidgetFragment on SocialIconsWithHeaderWidget {
  _type
  header {
    locale: en
  }
  socialIconsWidget {
    ...SocialIconsWidgetFragment
  }
}
    ${SocialIconsWidgetFragmentFragmentDoc}`;
export const TextWidgetFragmentFragmentDoc = gql`
    fragment TextWidgetFragment on TextWidget {
  _type
  text {
    locale: en
  }
}
    `;
export const VerticalLinkListWithHeaderWidgetFragmentFragmentDoc = gql`
    fragment VerticalLinkListWithHeaderWidgetFragment on VerticalLinkListWithHeaderWidget {
  _type
  header {
    locale: en
  }
  linkWidgets {
    ...LinkWidgetFragment
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const VerticalLinkListWidgetFragmentFragmentDoc = gql`
    fragment VerticalLinkListWidgetFragment on VerticalLinkListWidget {
  _type
  linkWidgets {
    ...LinkWidgetFragment
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const WordmarkAndSocialIconsFragmentFragmentDoc = gql`
    fragment WordmarkAndSocialIconsFragment on WordmarkAndSocialIcons {
  _type
  socialIconsWidget {
    ...SocialIconsWidgetFragment
  }
}
    ${SocialIconsWidgetFragmentFragmentDoc}`;
export const GoogleAdSlotFragmentFragmentDoc = gql`
    fragment GoogleAdSlotFragment on GoogleAdSlot {
  _id
  adUnitId
  adSlotSize
}
    `;
export const HeroContentFragmentDoc = gql`
    fragment HeroContent on AppData {
  _id
  mainHeroImageAuthenticatedLocale {
    locale: en {
      ...ImageFragment
    }
  }
  mainHeroImageLocale {
    locale: en {
      ...ImageFragment
    }
  }
  mainHeroMobileImageLocale {
    locale: en {
      ...ImageFragment
    }
  }
  heroTextAuthenticatedLocale {
    locale: en
  }
  heroTextLocale {
    locale: en
  }
  heroTextColor
  heroActionAuthenticated {
    route
    actionText {
      locale: en
    }
  }
  heroAction {
    route
    actionText {
      locale: en
    }
  }
  heroActionLeft {
    actionText {
      locale: en
    }
    route
  }
  heroActionRight {
    actionText {
      locale: en
    }
    route
  }
  heroSuperTextAuthenticated {
    locale: en
  }
  heroSuperText {
    locale: en
  }
  heroSubTextAuthenticated {
    locale: en
  }
  heroSubText {
    locale: en
  }
  heroMaskCards {
    ...HeroMaskCard
  }
  loyaltyHeroAction {
    route
    actionText {
      locale: en
    }
  }
  loyaltyHeroSuperText {
    locale: en
  }
  loyaltyHeroSubText {
    locale: en
  }
  heroActionLeftIcon {
    locale: en {
      ...ImageFragment
    }
  }
  heroActionRightIcon {
    locale: en {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}
${HeroMaskCardFragmentDoc}`;
export const HeroFragmentFragmentDoc = gql`
    fragment HeroFragment on Hero {
  _id
  image {
    locale: en {
      ...ImageFragment
    }
  }
  altImageText {
    locale: en
  }
  header {
    locale: en
  }
  subheader {
    locale: en
  }
  primaryCta {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
  complementaryCta {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
  reversed
  hasTerms
  termsText {
    localeRaw: enRaw
  }
  termsButton {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
}
    ${ImageFragmentFragmentDoc}`;
export const LoadingGraphicsFragmentFragmentDoc = gql`
    fragment LoadingGraphicsFragment on LoadingGraphics {
  cartInitialLoader {
    desktopGraphic {
      ...ref
    }
    mobileGraphic {
      ...ref
    }
    title {
      locale: en
    }
    text {
      locale: en
    }
  }
}
    ${RefFragmentDoc}`;
export const VideoFileFragmentFragmentDoc = gql`
    fragment VideoFileFragment on File {
  asset {
    assetId
    path
    url
  }
}
    `;
export const LocaleVideoFileFragmentFragmentDoc = gql`
    fragment LocaleVideoFileFragment on LocaleFile {
  locale: en {
    ...VideoFileFragment
  }
}
    ${VideoFileFragmentFragmentDoc}`;
export const ClaimPointsScreenContentFragmentFragmentDoc = gql`
    fragment ClaimPointsScreenContentFragment on ClaimPointsScreenContent {
  rewardsIcon {
    locale: en {
      ...ImageFragment
    }
  }
  secondImage {
    locale: en {
      ...ImageFragment
    }
  }
  screenTitle {
    locale: en
  }
  instructionsTextBlock {
    localeRaw: enRaw
  }
  topButtonTitle {
    locale: en
  }
  topButtonUrl {
    locale: en
  }
  bottomButtonTitle {
    locale: en
  }
  bottomButtonUrl {
    locale: en
  }
}
    ${ImageFragmentFragmentDoc}`;
export const ClaimPointsSurveyContentFragmentFragmentDoc = gql`
    fragment ClaimPointsSurveyContentFragment on ClaimPointsSurveyScreenContent {
  rewardsIcon {
    locale: en {
      ...ImageFragment
    }
  }
  secondImage {
    locale: en {
      ...ImageFragment
    }
  }
  screenTitle {
    locale: en
  }
  instructionsTextBlock {
    localeRaw: enRaw
  }
  expirationDateInstructionsTextBlock {
    localeRaw: enRaw
  }
  inputBoxExpirationDatePlaceholder {
    locale: en
  }
  expirationTimeReceipts
  topButtonTitle {
    locale: en
  }
  topButtonUrl {
    locale: en
  }
  bottomButtonTitle {
    locale: en
  }
  bottomButtonUrl {
    locale: en
  }
}
    ${ImageFragmentFragmentDoc}`;
export const ClaimPointsQrCodeContentFragmentFragmentDoc = gql`
    fragment ClaimPointsQrCodeContentFragment on ClaimQrCode {
  title {
    locale: en
  }
  body {
    localeRaw: enRaw
  }
  link {
    ... on LinkWidget {
      ...LinkWidgetFragment
    }
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const ClaimPointsFailedSubmissionContentFragmentFragmentDoc = gql`
    fragment ClaimPointsFailedSubmissionContentFragment on ClaimPointsFailedSubmissionContent {
  screenTitle {
    locale: en
  }
  failureTextBlock {
    localeRaw: enRaw
  }
  buttonTitle {
    locale: en
  }
  buttonUrl {
    locale: en
  }
}
    `;
export const LinkPhysicalCardSectionFragmentFragmentDoc = gql`
    fragment LinkPhysicalCardSectionFragment on LinkCardSection {
  title {
    locale: en
  }
  subtitle {
    locale: en
  }
  image {
    locale: en {
      ...ImageFragment
    }
  }
  imageDescription {
    locale: en
  }
  ctaButtonLabel {
    locale: en
  }
}
    ${ImageFragmentFragmentDoc}`;
export const LinkPhysicalCardFaqFragmentFragmentDoc = gql`
    fragment LinkPhysicalCardFaqFragment on LinkCardFaqSection {
  title {
    locale: en
  }
  subtitle {
    locale: en
  }
  marketingTileList {
    ...MarketingTileListFragment
  }
}
    ${MarketingTileListFragmentFragmentDoc}`;
export const LoyaltyOfferTemplateFragmentDoc = gql`
    fragment LoyaltyOfferTemplate on OfferTemplate {
  _id
  _type
  loyaltyEngineId
  name {
    localeRaw: enRaw
  }
  description {
    localeRaw: enRaw
  }
  backgroundImage {
    ...MenuImageFragment
  }
  localizedImage {
    locale: en {
      ...MenuImagesFragment
    }
  }
}
    ${MenuImageFragmentFragmentDoc}
${MenuImagesFragmentFragmentDoc}`;
export const OptInModalFragmentFragmentDoc = gql`
    fragment OptInModalFragment on OptInModalContent {
  image {
    locale: en {
      ...ImagesFragment
    }
  }
  title {
    locale: en
  }
  description {
    locale: en
  }
  buttonText {
    locale: en
  }
  blockText {
    localeRaw: enRaw
  }
}
    ${ImagesFragmentFragmentDoc}`;
export const ShortCodeConfirmationModalFragmentFragmentDoc = gql`
    fragment ShortCodeConfirmationModalFragment on ShortCodeConfirmationModalContent {
  image {
    locale: en {
      ...ImagesFragment
    }
  }
  header {
    locale: en
  }
  body {
    locale: en
  }
  actionButton {
    buttonText {
      locale: en
    }
    buttonPath {
      locale: en
    }
  }
  dismissButtonText {
    locale: en
  }
}
    ${ImagesFragmentFragmentDoc}`;
export const LoyaltyButtonWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyButtonWidgetFragment on LoyaltyButtonWidget {
  _key
  componentKey
  link {
    ...LinkWidgetFragment
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const LocaleImageFragmentFragmentDoc = gql`
    fragment LocaleImageFragment on LocaleImage {
  locale: en {
    ...ImageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const LoyaltyImageWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyImageWidgetFragment on LoyaltyImageWidget {
  _key
  componentKey
  image {
    ...LocaleImageFragment
  }
}
    ${LocaleImageFragmentFragmentDoc}`;
export const LocaleStringFragmentFragmentDoc = gql`
    fragment LocaleStringFragment on LocaleString {
  locale: en
}
    `;
export const LoyaltyTextWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyTextWidgetFragment on LoyaltyTextWidget {
  _key
  componentKey
  text {
    ...LocaleStringFragment
  }
}
    ${LocaleStringFragmentFragmentDoc}`;
export const LoyaltyTitleWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyTitleWidgetFragment on LoyaltyTitleWidget {
  _key
  componentKey
  title {
    ...LocaleStringFragment
  }
}
    ${LocaleStringFragmentFragmentDoc}`;
export const LoyaltyPaymentMethodWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyPaymentMethodWidgetFragment on LoyaltyPaymentMethodWidget {
  _key
  componentKey
  title {
    ...LocaleStringFragment
  }
}
    ${LocaleStringFragmentFragmentDoc}`;
export const LoyaltyQrScanButtonWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyQRScanButtonWidgetFragment on LoyaltyQRScanButtonWidget {
  _key
  componentKey
  title {
    ...LocaleStringFragment
  }
  subtitle {
    ...LocaleStringFragment
  }
  expirationMessage {
    ...LocaleStringFragment
  }
  link {
    ...LinkWidgetFragment
  }
}
    ${LocaleStringFragmentFragmentDoc}
${LinkWidgetFragmentFragmentDoc}`;
export const LoyaltyQrScanHeaderWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyQRScanHeaderWidgetFragment on LoyaltyQRScanHeaderWidget {
  _key
  componentKey
  title {
    ...LocaleStringFragment
  }
  subtitle {
    ...LocaleStringFragment
  }
  expirationMessage {
    ...LocaleStringFragment
  }
  link {
    ...LinkWidgetFragment
  }
}
    ${LocaleStringFragmentFragmentDoc}
${LinkWidgetFragmentFragmentDoc}`;
export const LoyaltyCartWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyCartWidgetFragment on LoyaltyCartWidget {
  _key
  componentKey
}
    `;
export const LoyaltyShortCodeWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyShortCodeWidgetFragment on LoyaltyShortCodeWidget {
  _key
  componentKey
  defaultCode {
    ...LocaleStringFragment
  }
  title {
    ...LocaleStringFragment
  }
  alternativeTitle {
    ...LocaleStringFragment
  }
  subtitle {
    ...LocaleStringFragment
  }
}
    ${LocaleStringFragmentFragmentDoc}`;
export const LoyaltyQrCodeWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyQRCodeWidgetFragment on LoyaltyQRCodeWidget {
  _key
  componentKey
  title {
    ...LocaleStringFragment
  }
  subtitle {
    ...LocaleStringFragment
  }
  expirationMessage {
    ...LocaleStringFragment
  }
}
    ${LocaleStringFragmentFragmentDoc}`;
export const LoyaltyBasicCardWidgetFragmentFragmentDoc = gql`
    fragment LoyaltyBasicCardWidgetFragment on LoyaltyBasicCardWidget {
  _key
  componentKey
  linkedCard {
    ...MarketingTileBasicFragment
  }
  unlinkedCard {
    ...MarketingTileBasicFragment
  }
}
    ${MarketingTileBasicFragmentFragmentDoc}`;
export const ColorFragmentFragmentDoc = gql`
    fragment ColorFragment on Color {
  alpha
  hex
  hsl {
    _type
    a
    h
    l
    s
  }
  hsv {
    _type
    a
    h
    s
    v
  }
  rgb {
    _type
    a
    b
    g
    r
  }
}
    `;
export const MarketingCardFragmentFragmentDoc = gql`
    fragment MarketingCardFragment on MarketingCard {
  _id
  header {
    locale: en
  }
  description {
    locale: en
  }
  image {
    locale: en {
      ...ImagesFragment
    }
  }
  callToAction {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
  hasCustomColors
  textColor {
    ...ColorFragment
  }
  backgroundColor {
    ...ColorFragment
  }
  buttonTextColor {
    ...ColorFragment
  }
  buttonBackgroundColor {
    ...ColorFragment
  }
  hasTerms
  termsText {
    localeRaw: enRaw
  }
  termsButton {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
}
    ${ImagesFragmentFragmentDoc}
${ColorFragmentFragmentDoc}`;
export const MarketingCardGroupFragmentFragmentDoc = gql`
    fragment MarketingCardGroupFragment on MarketingCardGroup {
  _id
  Cards {
    ... on MarketingCard {
      ...MarketingCardFragment
    }
  }
}
    ${MarketingCardFragmentFragmentDoc}`;
export const MarketingTileCarouselFragmentFragmentDoc = gql`
    fragment MarketingTileCarouselFragment on MarketingTileCarousel {
  _id
  header {
    ...LocaleStringFragment
  }
  tiles {
    ... on MarketingTileBasic {
      ...MarketingTileBasicFragment
    }
  }
}
    ${LocaleStringFragmentFragmentDoc}
${MarketingTileBasicFragmentFragmentDoc}`;
export const NotificationDetailsFragmentFragmentDoc = gql`
    fragment NotificationDetailsFragment on NotificationDetails {
  enabled
  title {
    locale: en
  }
  description {
    localeRaw: enRaw
  }
  image {
    locale: en {
      ...ImageFragment
    }
  }
  path {
    locale: en
  }
}
    ${ImageFragmentFragmentDoc}`;
export const OffersSelectRestaurantCtaFragmentFragmentDoc = gql`
    fragment OffersSelectRestaurantCtaFragment on OffersBrowsingPanel {
  offersSelectRestaurantCta {
    title {
      locale: en
    }
    body {
      locale: en
    }
    ctaButtonText {
      locale: en
    }
    link {
      locale: en
    }
    minimumNumberOfOffers
  }
}
    `;
export const ItemMetaFragmentFragmentDoc = gql`
    fragment ItemMetaFragment on Item {
  _id
  _type
  operationalItem {
    daypart
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${VendorConfigsFragmentFragmentDoc}`;
export const ComboMetaFragmentFragmentDoc = gql`
    fragment ComboMetaFragment on Combo {
  _id
  _type
  mainItem {
    ...ItemMetaFragment
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${ItemMetaFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}`;
export const PickerMetaFragmentFragmentDoc = gql`
    fragment PickerMetaFragment on Picker {
  _id
  _type
  options {
    option {
      ...ItemMetaFragment
      ...ComboMetaFragment
    }
  }
}
    ${ItemMetaFragmentFragmentDoc}
${ComboMetaFragmentFragmentDoc}`;
export const ActivateOfferMetaFragmentFragmentDoc = gql`
    fragment ActivateOfferMetaFragment on OfferActivation {
  _type
}
    `;
export const DiscountOfferMetaFragmentFragmentDoc = gql`
    fragment DiscountOfferMetaFragment on OfferDiscount {
  discountValue
  discountType
  _type
}
    `;
export const AllowRedemptionWithoutLoginFragmentDoc = gql`
    fragment AllowRedemptionWithoutLogin on AllowRedemptionWithoutLogin {
  ruleSetType: _type
}
    `;
export const BetweenDatesFragmentDoc = gql`
    fragment BetweenDates on BetweenDates {
  ruleSetType: _type
  endDate
  startDate
}
    `;
export const BetweenTimesFragmentDoc = gql`
    fragment BetweenTimes on BetweenTimes {
  ruleSetType: _type
  endTime
  startTime
}
    `;
export const CartPropertyFragmentDoc = gql`
    fragment CartProperty on CartProperty {
  ruleSetType: _type
  key
  negated
  operator
  value
}
    `;
export const CoolDownFragmentDoc = gql`
    fragment CoolDown on CoolDown {
  ruleSetType: _type
  minimumElapsedTimeSeconds
}
    `;
export const DayOfWeekBandFragmentDoc = gql`
    fragment DayOfWeekBand on DayOfWeekBand {
  ruleSetType: _type
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
}
    `;
export const FirstOrderOnlyFragmentDoc = gql`
    fragment FirstOrderOnly on FirstOrderOnly {
  ruleSetType: _type
}
    `;
export const LimitFragmentDoc = gql`
    fragment Limit on Limit {
  ruleSetType: _type
  interval
  maximumRedemptions
}
    `;
export const PaymentCardTypeFragmentDoc = gql`
    fragment PaymentCardType on PaymentCardType {
  ruleSetType: _type
  cardType
}
    `;
export const ProductCategoryFragmentFragmentDoc = gql`
    fragment ProductCategoryFragment on ProductCategory {
  ruleSetType: _type
  _id
  name {
    locale: en
  }
  image {
    ...MenuImageFragment
  }
  hierarchyLevel
}
    ${MenuImageFragmentFragmentDoc}`;
export const PurchaseFragmentDoc = gql`
    fragment Purchase on Purchase {
  ruleSetType: _type
  quantity
  sanityId
  option {
    ...ProductCategoryFragment
    ...ComboMetaFragment
    ...ItemMetaFragment
    ...PickerMetaFragment
  }
}
    ${ProductCategoryFragmentFragmentDoc}
${ComboMetaFragmentFragmentDoc}
${ItemMetaFragmentFragmentDoc}
${PickerMetaFragmentFragmentDoc}`;
export const RequiresAssignmentFragmentDoc = gql`
    fragment RequiresAssignment on RequiresAssignment {
  ruleSetType: _type
}
    `;
export const RestaurantGroupRestrictionListFragmentFragmentDoc = gql`
    fragment RestaurantGroupRestrictionListFragment on RestaurantGroupRestrictions {
  ruleSetType: _type
  restaurantGroupRestrictionList {
    restaurants {
      number
    }
  }
}
    `;
export const OrderHistoryFragmentFragmentDoc = gql`
    fragment OrderHistoryFragment on OrderHistory {
  ruleSetType: _type
  rangeType
  from
  to
  lastNSeconds
  isSequential
  ruleSet {
    ... on BetweenTimes {
      ...BetweenTimes
    }
    ... on CartProperty {
      ...CartProperty
    }
    ... on DayOfWeekBand {
      ...DayOfWeekBand
    }
    ... on PaymentCardType {
      ...PaymentCardType
    }
    ... on Purchase {
      ...Purchase
    }
    ... on And {
      ruleSetType: _type
      ruleSet {
        ... on AllowRedemptionWithoutLogin {
          ...AllowRedemptionWithoutLogin
        }
        ... on BetweenDates {
          ...BetweenDates
        }
        ... on BetweenTimes {
          ...BetweenTimes
        }
        ... on CartProperty {
          ...CartProperty
        }
        ... on CoolDown {
          ...CoolDown
        }
        ... on DayOfWeekBand {
          ...DayOfWeekBand
        }
        ... on FirstOrderOnly {
          ...FirstOrderOnly
        }
        ... on Limit {
          ...Limit
        }
        ... on PaymentCardType {
          ...PaymentCardType
        }
        ... on Purchase {
          ...Purchase
        }
        ... on RequiresAssignment {
          ...RequiresAssignment
        }
        ... on RestaurantGroupRestrictions {
          ...RestaurantGroupRestrictionListFragment
        }
      }
    }
    ... on Or {
      ruleSetType: _type
      ruleSet {
        ... on AllowRedemptionWithoutLogin {
          ...AllowRedemptionWithoutLogin
        }
        ... on BetweenDates {
          ...BetweenDates
        }
        ... on BetweenTimes {
          ...BetweenTimes
        }
        ... on CartProperty {
          ...CartProperty
        }
        ... on CoolDown {
          ...CoolDown
        }
        ... on DayOfWeekBand {
          ...DayOfWeekBand
        }
        ... on FirstOrderOnly {
          ...FirstOrderOnly
        }
        ... on Limit {
          ...Limit
        }
        ... on PaymentCardType {
          ...PaymentCardType
        }
        ... on Purchase {
          ...Purchase
        }
        ... on RequiresAssignment {
          ...RequiresAssignment
        }
        ... on RestaurantGroupRestrictions {
          ...RestaurantGroupRestrictionListFragment
        }
      }
    }
  }
}
    ${BetweenTimesFragmentDoc}
${CartPropertyFragmentDoc}
${DayOfWeekBandFragmentDoc}
${PaymentCardTypeFragmentDoc}
${PurchaseFragmentDoc}
${AllowRedemptionWithoutLoginFragmentDoc}
${BetweenDatesFragmentDoc}
${CoolDownFragmentDoc}
${FirstOrderOnlyFragmentDoc}
${LimitFragmentDoc}
${RequiresAssignmentFragmentDoc}
${RestaurantGroupRestrictionListFragmentFragmentDoc}`;
export const OffersFragmentFragmentDoc = gql`
    fragment OffersFragment on Offer {
  _id
  _type
  name {
    localeRaw: enRaw
  }
  headerSuperText {
    locale: en
  }
  description {
    localeRaw: enRaw
  }
  moreInfo {
    localeRaw: enRaw
  }
  howToRedeem {
    localeRaw: enRaw
  }
  backgroundImage {
    ...MenuImageFragment
  }
  offerTags {
    value
    _id
  }
  offerCTA {
    actionText {
      locale: en
    }
    route
  }
  daypart
  forSupport
  redemptionMethod
  offerPrice
  marketPrice {
    ... on Item {
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Combo {
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
  }
  localizedImage {
    locale: en {
      ...MenuImagesFragment
    }
  }
  option {
    ...ComboMetaFragment
    ...ItemMetaFragment
    ...PickerMetaFragment
    ...ActivateOfferMetaFragment
    ...DiscountOfferMetaFragment
  }
  uiPattern
  lockedOffersPanel {
    completedChallengeHeader {
      localeRaw: enRaw
    }
    completedChallengeDescription {
      localeRaw: enRaw
    }
  }
  promoCodePanel {
    promoCodeDescription {
      localeRaw: enRaw
    }
    promoCodeLabel {
      localeRaw: enRaw
    }
    promoCodeLink
  }
  shortCode
  ruleSet {
    ... on AllowRedemptionWithoutLogin {
      ...AllowRedemptionWithoutLogin
    }
    ... on BetweenDates {
      ...BetweenDates
    }
    ... on BetweenTimes {
      ...BetweenTimes
    }
    ... on CartProperty {
      ...CartProperty
    }
    ... on CoolDown {
      ...CoolDown
    }
    ... on DayOfWeekBand {
      ...DayOfWeekBand
    }
    ... on FirstOrderOnly {
      ...FirstOrderOnly
    }
    ... on Limit {
      ...Limit
    }
    ... on OrderHistory {
      ...OrderHistoryFragment
    }
    ... on PaymentCardType {
      ...PaymentCardType
    }
    ... on Purchase {
      ...Purchase
    }
    ... on RequiresAssignment {
      ...RequiresAssignment
    }
    ... on RestaurantGroupRestrictions {
      ...RestaurantGroupRestrictionListFragment
    }
    ... on And {
      ruleSetType: _type
      ruleSet {
        ... on AllowRedemptionWithoutLogin {
          ...AllowRedemptionWithoutLogin
        }
        ... on BetweenDates {
          ...BetweenDates
        }
        ... on BetweenTimes {
          ...BetweenTimes
        }
        ... on CartProperty {
          ...CartProperty
        }
        ... on CoolDown {
          ...CoolDown
        }
        ... on DayOfWeekBand {
          ...DayOfWeekBand
        }
        ... on FirstOrderOnly {
          ...FirstOrderOnly
        }
        ... on Limit {
          ...Limit
        }
        ... on PaymentCardType {
          ...PaymentCardType
        }
        ... on Purchase {
          ...Purchase
        }
        ... on RequiresAssignment {
          ...RequiresAssignment
        }
        ... on RestaurantGroupRestrictions {
          ...RestaurantGroupRestrictionListFragment
        }
      }
    }
    ... on Or {
      ruleSetType: _type
      ruleSet {
        ... on AllowRedemptionWithoutLogin {
          ...AllowRedemptionWithoutLogin
        }
        ... on BetweenDates {
          ...BetweenDates
        }
        ... on BetweenTimes {
          ...BetweenTimes
        }
        ... on CartProperty {
          ...CartProperty
        }
        ... on CoolDown {
          ...CoolDown
        }
        ... on DayOfWeekBand {
          ...DayOfWeekBand
        }
        ... on FirstOrderOnly {
          ...FirstOrderOnly
        }
        ... on Limit {
          ...Limit
        }
        ... on PaymentCardType {
          ...PaymentCardType
        }
        ... on Purchase {
          ...Purchase
        }
        ... on RequiresAssignment {
          ...RequiresAssignment
        }
        ... on RestaurantGroupRestrictions {
          ...RestaurantGroupRestrictionListFragment
        }
      }
    }
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${MenuImageFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}
${MenuImagesFragmentFragmentDoc}
${ComboMetaFragmentFragmentDoc}
${ItemMetaFragmentFragmentDoc}
${PickerMetaFragmentFragmentDoc}
${ActivateOfferMetaFragmentFragmentDoc}
${DiscountOfferMetaFragmentFragmentDoc}
${AllowRedemptionWithoutLoginFragmentDoc}
${BetweenDatesFragmentDoc}
${BetweenTimesFragmentDoc}
${CartPropertyFragmentDoc}
${CoolDownFragmentDoc}
${DayOfWeekBandFragmentDoc}
${FirstOrderOnlyFragmentDoc}
${LimitFragmentDoc}
${OrderHistoryFragmentFragmentDoc}
${PaymentCardTypeFragmentDoc}
${PurchaseFragmentDoc}
${RequiresAssignmentFragmentDoc}
${RestaurantGroupRestrictionListFragmentFragmentDoc}`;
export const OptInSettingBooleanFragmentFragmentDoc = gql`
    fragment OptInSettingBooleanFragment on OptInSettingBoolean {
  _key
  _type
  key
  name {
    locale: en
  }
  description {
    locale: en
  }
}
    `;
export const OptInSettingEmailAndPushFragmentFragmentDoc = gql`
    fragment OptInSettingEmailAndPushFragment on OptInSettingEmailAndPush {
  _key
  _type
  pushKey
  emailKey
  name {
    locale: en
  }
  description {
    locale: en
  }
}
    `;
export const OptInSettingEnumFragmentFragmentDoc = gql`
    fragment OptInSettingEnumFragment on OptInSettingEnum {
  _key
  _type
  key
  enumStrings
  name {
    locale: en
  }
  description {
    locale: en
  }
}
    `;
export const OptInPrivacyPreferencesFragmentFragmentDoc = gql`
    fragment OptInPrivacyPreferencesFragment on OptInPrivacyPreferences {
  _key
  _type
  key
  name {
    locale: en
  }
  description {
    locale: en
  }
  view {
    locale: en
  }
}
    `;
export const PaymentMethodDeletionModalTextFragmentFragmentDoc = gql`
    fragment PaymentMethodDeletionModalTextFragment on FeatureScanAndPay {
  paymentMethodDeletionModalText {
    paymentMethodDeletionModalTextHeader {
      locale: en
    }
    paymentMethodDeletionModalTextBody {
      locale: enRaw
    }
  }
}
    `;
export const ComboFragmentFragmentDoc = gql`
    fragment ComboFragment on Combo {
  _id
  _type
  name {
    locale: en
  }
  image {
    ...MenuImageFragment
  }
  imageDescription {
    locale: en
  }
  mainItem {
    ...ItemFragment
  }
  uiPattern
  hideMainItemDescription
  forceModifiersToBottom
  options {
    name {
      locale: en
    }
    _type
    _id
    uiPattern
    minAmount
    maxAmount
    respectMaximum
    optionVisibilitySettings {
      visibleOptions
      toggleButtonTextClosed {
        locale: en
      }
      toggleButtonTextOpen {
        locale: en
      }
    }
    options {
      _key
      minAmount
      defaultAmount
      isPremium
      option {
        ... on Item {
          ...ItemFragment
        }
        ... on Picker {
          _type
          uiPattern
          pickerAspects {
            name {
              locale: en
            }
            pickerAspectOptions {
              name {
                locale: en
              }
              identifier
            }
          }
        }
      }
    }
  }
  menuObjectSettings {
    limitPerOrder
  }
}
    ${MenuImageFragmentFragmentDoc}
${ItemFragmentFragmentDoc}`;
export const QuickConfigFragmentFragmentDoc = gql`
    fragment QuickConfigFragment on QuickConfig {
  name {
    locale: en
  }
  rules {
    itemOptions {
      value
    }
    modifier {
      value
    }
  }
}
    `;
export const PickerWithVendorConfigFragmentFragmentDoc = gql`
    fragment PickerWithVendorConfigFragment on Picker {
  _id
  _type
  name {
    locale: en
  }
  pickerDefaults {
    _key
    pickerAspect {
      _id
      name {
        locale: en
      }
    }
    pickerAspectValueIdentifier
  }
  pickerAspects {
    _id
    _type
    name {
      locale: en
    }
    uiPattern
    pickerAspectOptions {
      identifier
      name {
        locale: en
      }
      description {
        locale: en
      }
      image {
        ...MenuImageFragment
      }
      imageDescription {
        locale: en
      }
      hideNameInItemPreview
      showInStaticMenu
    }
  }
  pickerAspectItemOptionMappings {
    pickerAspect {
      _id
      name {
        locale: en
      }
    }
    options {
      value
    }
  }
  options {
    type: _type
    _key
    pickerItemMappings {
      pickerAspectValueIdentifier
      pickerAspect {
        _id
      }
    }
    option {
      ... on Combo {
        _key
        _id
        promotion {
          bonusPoints
        }
        vendorConfigs {
          ...VendorConfigsFragment
        }
        ...ComboFragment
      }
      ... on Item {
        _key
        promotion {
          bonusPoints
        }
        vendorConfigs {
          ...VendorConfigsFragment
        }
        ...ItemFragment
      }
    }
    default
  }
  image {
    ...MenuImageFragment
  }
  imageDescription {
    locale: en
  }
  description {
    localeRaw: enRaw
  }
  quickConfigs {
    ...QuickConfigFragment
  }
  channelExclusions {
    delivery
    pickup
    kiosk
    googleFoodOrdering
  }
  uiPattern
  isRealMeal
}
    ${MenuImageFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}
${ComboFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${QuickConfigFragmentFragmentDoc}`;
export const ProductListSectionFragmentFragmentDoc = gql`
    fragment ProductListSectionFragment on Section {
  _id
  _type
  daypart
  name {
    locale: en
  }
  image {
    ...ImageFragment
  }
  uiPattern
  showInStaticMenu
  isRealMeal
  isBurgersForBreakfastSection
  headerText {
    locale: en
  }
  headerSuperText {
    locale: en
  }
  imageDescription {
    locale: en
  }
  carouselImage {
    ...ImageFragment
  }
  options {
    ... on Section {
      _id
      _type
      name {
        locale: en
      }
      image {
        ...ImageFragment
      }
      headerText {
        locale: en
      }
      headerSuperText {
        locale: en
      }
      imageDescription {
        locale: en
      }
      carouselImage {
        ...ImageFragment
      }
      options {
        ... on Item {
          _id
          _type
          name {
            locale: en
          }
          image {
            ...ImageFragment
          }
          showInStaticMenu
        }
        ... on Picker {
          _id
          _type
          name {
            locale: en
          }
          image {
            ...ImageFragment
          }
          uiPattern
          showInStaticMenu
        }
        ... on Combo {
          _id
          _type
          name {
            locale: en
          }
          image {
            ...ImageFragment
          }
          uiPattern
          showInStaticMenu
        }
      }
      uiPattern
      showInStaticMenu
      daypart
      isRealMeal
      isBurgersForBreakfastSection
    }
    ... on Combo {
      _id
      _type
      name {
        locale: en
      }
      image {
        ...ImageFragment
      }
      uiPattern
      showInStaticMenu
    }
    ... on Picker {
      _id
      _type
      name {
        locale: en
      }
      image {
        ...ImageFragment
      }
      uiPattern
      showInStaticMenu
    }
    ... on Item {
      _id
      _type
      name {
        locale: en
      }
      image {
        ...ImageFragment
      }
      showInStaticMenu
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const RewardFragmentFragmentDoc = gql`
    fragment RewardFragment on Reward {
  _id
  loyaltyEngineId
  name {
    locale: en
  }
  incentiveNotInMenu
  description {
    locale: enRaw
  }
  moreInfo {
    enRaw
  }
  howToRedeem {
    enRaw
  }
  backgroundImage {
    ...MenuImageFragment
  }
  image {
    locale: en {
      ...ImageFragment
    }
  }
  imageDescription {
    locale: en
  }
  incentives {
    __typename
    ... on Combo {
      _id
      _type
      mainItem {
        _id
        _type
        operationalItem {
          daypart
        }
      }
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Item {
      _id
      _type
      operationalItem {
        daypart
      }
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Picker {
      _id
      _type
      options {
        option {
          __typename
          ... on Combo {
            _id
            _type
            mainItem {
              _id
              _type
              operationalItem {
                daypart
              }
            }
          }
          ... on Item {
            _id
            _type
            operationalItem {
              daypart
            }
          }
        }
      }
    }
    ... on OfferDiscount {
      _id
      _type
      discountValue
      discountType
    }
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${MenuImageFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}`;
export const RewardsSectionFragmentFragmentDoc = gql`
    fragment RewardsSectionFragment on RewardsSection {
  _id
  rewardsList {
    reward {
      ...RewardFragment
    }
    category {
      label {
        locale: en
      }
      image {
        locale: en {
          ...ImageFragment
        }
      }
    }
  }
}
    ${RewardFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const ComboAvailabilityFragmentFragmentDoc = gql`
    fragment ComboAvailabilityFragment on Combo {
  mainItem {
    ...ItemAvailabilityFragment
  }
  showInStaticMenu
  vendorConfigs {
    ...VendorConfigsFragment
  }
  options {
    vendorConfigs {
      ...VendorConfigsFragment
    }
    minAmount
    options {
      maxAmount
      option {
        ... on Item {
          ...ItemAvailabilityFragment
        }
      }
    }
  }
}
    ${ItemAvailabilityFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}`;
export const PickerAvailabilityFragmentFragmentDoc = gql`
    fragment PickerAvailabilityFragment on Picker {
  showInStaticMenu
  hideCalories
  hideNutritionLegalDisclaimer
  options {
    option {
      ... on Combo {
        ...ComboAvailabilityFragment
      }
      ... on Item {
        ...ItemAvailabilityFragment
      }
    }
  }
}
    ${ComboAvailabilityFragmentFragmentDoc}
${ItemAvailabilityFragmentFragmentDoc}`;
export const SectionAvailabilityFragmentFragmentDoc = gql`
    fragment SectionAvailabilityFragment on Section {
  daypart
  showInStaticMenu
  isBurgersForBreakfastSection
  options {
    ... on Picker {
      ...PickerAvailabilityFragment
    }
    ... on Item {
      ...ItemAvailabilityFragment
    }
    ... on Combo {
      ...ComboAvailabilityFragment
    }
    ... on Section {
      showInStaticMenu
      options {
        ... on Picker {
          ...PickerAvailabilityFragment
        }
        ... on Item {
          ...ItemAvailabilityFragment
        }
        ... on Combo {
          ...ComboAvailabilityFragment
        }
        ... on Section {
          options {
            ... on Picker {
              ...PickerAvailabilityFragment
            }
            ... on Item {
              ...ItemAvailabilityFragment
            }
            ... on Combo {
              ...ComboAvailabilityFragment
            }
          }
        }
      }
    }
  }
}
    ${PickerAvailabilityFragmentFragmentDoc}
${ItemAvailabilityFragmentFragmentDoc}
${ComboAvailabilityFragmentFragmentDoc}`;
export const PickerFragmentFragmentDoc = gql`
    fragment PickerFragment on Picker {
  _id
  _type
  name {
    locale: en
  }
  pickerDefaults {
    _key
    pickerAspect {
      _id
      name {
        locale: en
      }
    }
    pickerAspectValueIdentifier
  }
  pickerAspects {
    _id
    _type
    name {
      locale: en
    }
    uiPattern
    pickerAspectOptions {
      identifier
      name {
        locale: en
      }
      description {
        locale: en
      }
      image {
        ...MenuImageFragment
      }
      imageDescription {
        locale: en
      }
      hideNameInItemPreview
      showInStaticMenu
    }
  }
  pickerAspectItemOptionMappings {
    pickerAspect {
      _id
      name {
        locale: en
      }
    }
    options {
      value
    }
  }
  options {
    type: _type
    _key
    pickerItemMappings {
      pickerAspectValueIdentifier
      pickerAspect {
        _id
      }
    }
    option {
      ... on Combo {
        _key
        _id
        promotion {
          bonusPoints
        }
        ...ComboFragment
      }
      ... on Item {
        _key
        promotion {
          bonusPoints
        }
        ...ItemFragment
      }
    }
    default
  }
  image {
    ...MenuImageFragment
  }
  imageDescription {
    locale: en
  }
  description {
    localeRaw: enRaw
  }
  quickConfigs {
    ...QuickConfigFragment
  }
  channelExclusions {
    delivery
    pickup
    kiosk
    googleFoodOrdering
  }
  uiPattern
  isRealMeal
}
    ${MenuImageFragmentFragmentDoc}
${ComboFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${QuickConfigFragmentFragmentDoc}`;
export const SectionFragmentFragmentDoc = gql`
    fragment SectionFragment on Section {
  _id
  _type
  redirectLink {
    locale: en
  }
  uiPattern
  isRealMeal
  image {
    ...MenuImageFragment
  }
  carouselImage {
    ...ImageFragment
  }
  carouselImageDescription {
    locale: en
  }
  name {
    locale: en
  }
  headerSuperText {
    locale: en
  }
  headerText {
    locale: en
  }
  imageDescription {
    locale: en
  }
  options {
    ... on Picker {
      ...PickerFragment
    }
    ... on Item {
      ...ItemFragment
    }
    ... on Combo {
      ...ComboFragment
    }
    ... on Section {
      _id
      _type
      description {
        localeRaw: enRaw
      }
      redirectLink {
        locale: en
      }
      channelExclusions {
        delivery
        pickup
        kiosk
        googleFoodOrdering
      }
      uiPattern
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      headerSuperText {
        locale: en
      }
      imageDescription {
        locale: en
      }
      options {
        ... on Picker {
          ...PickerFragment
        }
        ... on Item {
          ...ItemFragment
        }
        ... on Combo {
          ...ComboFragment
        }
        ... on Section {
          name {
            locale: en
          }
          _type
          _id
          uiPattern
          options {
            ... on Picker {
              ...PickerFragment
            }
            ... on Item {
              ...ItemFragment
            }
            ... on Combo {
              ...ComboFragment
            }
          }
        }
      }
    }
  }
}
    ${MenuImageFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${PickerFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${ComboFragmentFragmentDoc}`;
export const SkillsTestFragmentFragmentDoc = gql`
    fragment SkillsTestFragment on SkillsTest {
  mathBlock {
    localeRaw: enRaw
  }
  correctAnswer
  answersList
}
    `;
export const SystemwideOffersFragmentFragmentDoc = gql`
    fragment SystemwideOffersFragment on SystemwideOffer {
  _id
  _type
  loyaltyEngineId
  name {
    localeRaw: enRaw
  }
  description {
    localeRaw: enRaw
  }
  moreInfo {
    localeRaw: enRaw
  }
  howToRedeem {
    enRaw
  }
  backgroundImage {
    ...MenuImageFragment
  }
  shortCode
  mobileOrderOnly
  daypart
  redemptionType
  offerPrice
  marketPrice {
    ... on Item {
      _id
      _type
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Combo {
      _id
      _type
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
  }
  localizedImage {
    locale: en {
      ...MenuImagesFragment
    }
  }
  uiPattern
  lockedOffersPanel {
    completedChallengeHeader {
      localeRaw: enRaw
    }
    completedChallengeDescription {
      localeRaw: enRaw
    }
  }
  promoCodePanel {
    promoCodeDescription {
      localeRaw: enRaw
    }
    promoCodeLabel {
      localeRaw: enRaw
    }
    promoCodeLink
  }
  incentives {
    __typename
    ... on Combo {
      _id
      _type
      mainItem {
        _id
        _type
        operationalItem {
          daypart
        }
      }
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Item {
      _id
      _type
      operationalItem {
        daypart
      }
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Picker {
      _id
      _type
      options {
        option {
          __typename
          ... on Combo {
            _id
            _type
            mainItem {
              _id
              _type
              operationalItem {
                daypart
              }
            }
          }
          ... on Item {
            _id
            _type
            operationalItem {
              daypart
            }
          }
        }
      }
    }
    ... on OfferDiscount {
      _id
      _type
      discountValue
      discountType
    }
    ... on OfferActivation {
      _id
      _type
    }
    ... on SwapMapping {
      _type
    }
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${MenuImageFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}
${MenuImagesFragmentFragmentDoc}`;
export const TabDetailContentFragmentFragmentDoc = gql`
    fragment TabDetailContentFragment on TabDetailContent {
  title {
    locale: en
  }
  body {
    locale: en
  }
  image {
    locale: en {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const TitleAndBodyFragmentFragmentDoc = gql`
    fragment TitleAndBodyFragment on TitleAndBody {
  title {
    locale: en
  }
  body {
    locale: en
  }
}
    `;
export const HoursFragmentFragmentDoc = gql`
    fragment HoursFragment on HoursOfOperation {
  _type
  friClose
  friOpen
  monClose
  monOpen
  satClose
  satOpen
  sunClose
  sunOpen
  thrClose
  thrOpen
  tueClose
  tueOpen
  wedClose
  wedOpen
}
    `;
export const ImageAssetFragmentFragmentDoc = gql`
    fragment ImageAssetFragment on SanityImageAsset {
  _id
  label
  title
  url
  source {
    id
    url
  }
  metadata {
    lqip
    palette {
      dominant {
        background
        foreground
      }
    }
  }
}
    `;
export const RestaurantFragmentFragmentDoc = gql`
    fragment RestaurantFragment on Restaurant {
  _id
  environment
  chaseMerchantId
  deliveryHours {
    ...HoursFragment
  }
  diningRoomHours {
    ...HoursFragment
  }
  curbsideHours {
    ...HoursFragment
  }
  driveThruHours {
    ...HoursFragment
  }
  drinkStationType
  driveThruLaneType
  email
  franchiseGroupId
  franchiseGroupName
  frontCounterClosed
  hasBreakfast
  hasBurgersForBreakfast
  hasCurbside
  hasDineIn
  hasCatering
  hasDelivery
  hasDriveThru
  hasLateNightMenu
  hasMobileOrdering
  hasParking
  hasPlayground
  hasTakeOut
  hasWifi
  hasLoyalty
  isDarkKitchen
  isHalal
  latitude
  longitude
  mobileOrderingStatus
  name
  number
  parkingType
  phoneNumber
  playgroundType
  pos {
    _type
    vendor
  }
  physicalAddress {
    _type
    address1
    address2
    city
    country
    postalCode
    stateProvince
  }
  posRestaurantId
  restaurantPosData {
    _id
  }
  status
  restaurantImage {
    hotspot {
      width
      height
      x
      y
    }
    crop {
      top
      bottom
      left
      right
    }
    asset {
      ...ImageAssetFragment
    }
  }
  amenities {
    name {
      locale: en
    }
    icon {
      asset {
        ...ImageAssetFragment
      }
    }
  }
  timezone
  vatNumber
}
    ${HoursFragmentFragmentDoc}
${ImageAssetFragmentFragmentDoc}`;
export const AllFeatureIdsDocument = gql`
    query allFeatureIds {
  allFeatureAccountForms(limit: 1) {
    _id
  }
  allFeatureGeolocationMapMarkers(limit: 1) {
    _id
  }
  allFeatureGeolocationModals(limit: 1) {
    _id
  }
  allFeatureHomePages(limit: 1) {
    _id
  }
  allFeatureOffers(limit: 1) {
    _id
  }
  allFeatureFooters(limit: 1) {
    _id
  }
  allFeatureFooterV2S(limit: 1) {
    _id
  }
  allFeatureNavigations(limit: 1) {
    _id
  }
  allFeatureAccountDeletePages(limit: 1) {
    _id
  }
  allFeatureAccountRequestInfoPages(limit: 1) {
    _id
  }
  allSupportData(limit: 1) {
    _id
  }
  allFeatureStaticMenus(limit: 1) {
    _id
  }
  allFeatureMenus(limit: 1) {
    _id
  }
  allFeatureLayouts(limit: 1) {
    _id
  }
  allFeatureDisclaimers(limit: 1) {
    _id
  }
  allFeatureAccounts(limit: 1) {
    _id
  }
  allFeatureCateringPages(limit: 1) {
    _id
  }
  allLoyaltyUis(limit: 1) {
    _id
  }
  allFeatureNutritions(limit: 1) {
    _id
  }
  allFeatureGifts(limit: 1) {
    _id
  }
  allRewardLists(limit: 1) {
    _id
  }
  allClaimPointsUis(limit: 1) {
    _id
  }
  allFeatureOnboardings(limit: 1) {
    _id
  }
  allFeatureLockers(limit: 1) {
    _id
  }
  allFeatureBeeperModals(limit: 1) {
    _id
  }
  allFeaturePaybacks(limit: 1) {
    _id
  }
  allLinkPhysicalCardUis(limit: 1) {
    _id
  }
}
    `;

/**
 * __useAllFeatureIdsQuery__
 *
 * To run a query within a React component, call `useAllFeatureIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFeatureIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFeatureIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFeatureIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>(AllFeatureIdsDocument, baseOptions);
      }
export function useAllFeatureIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>(AllFeatureIdsDocument, baseOptions);
        }
export type AllFeatureIdsQueryHookResult = ReturnType<typeof useAllFeatureIdsQuery>;
export type AllFeatureIdsLazyQueryHookResult = ReturnType<typeof useAllFeatureIdsLazyQuery>;
export type AllFeatureIdsQueryResult = ApolloReactCommon.QueryResult<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>;
export const AllItemsDocument = gql`
    query allItems($where: ItemFilter) {
  allItems(where: $where) {
    ... on Item {
      ...ItemFragment
      ...ItemAvailabilityFragment
      description {
        localeRaw: enRaw
      }
    }
  }
}
    ${ItemFragmentFragmentDoc}
${ItemAvailabilityFragmentFragmentDoc}`;

/**
 * __useAllItemsQuery__
 *
 * To run a query within a React component, call `useAllItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAllItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAllItemsQuery, IAllItemsQueryVariables>) {
        return ApolloReactHooks.useQuery<IAllItemsQuery, IAllItemsQueryVariables>(AllItemsDocument, baseOptions);
      }
export function useAllItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAllItemsQuery, IAllItemsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IAllItemsQuery, IAllItemsQueryVariables>(AllItemsDocument, baseOptions);
        }
export type AllItemsQueryHookResult = ReturnType<typeof useAllItemsQuery>;
export type AllItemsLazyQueryHookResult = ReturnType<typeof useAllItemsLazyQuery>;
export type AllItemsQueryResult = ApolloReactCommon.QueryResult<IAllItemsQuery, IAllItemsQueryVariables>;
export const GetComboDocument = gql`
    query GetCombo($id: ID!) {
  Combo(id: $id) {
    ...ComboFragment
  }
}
    ${ComboFragmentFragmentDoc}`;

/**
 * __useGetComboQuery__
 *
 * To run a query within a React component, call `useGetComboQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComboQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComboQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetComboQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetComboQuery, IGetComboQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetComboQuery, IGetComboQueryVariables>(GetComboDocument, baseOptions);
      }
export function useGetComboLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetComboQuery, IGetComboQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetComboQuery, IGetComboQueryVariables>(GetComboDocument, baseOptions);
        }
export type GetComboQueryHookResult = ReturnType<typeof useGetComboQuery>;
export type GetComboLazyQueryHookResult = ReturnType<typeof useGetComboLazyQuery>;
export type GetComboQueryResult = ApolloReactCommon.QueryResult<IGetComboQuery, IGetComboQueryVariables>;
export const GetComboWithVendorConfigDocument = gql`
    query GetComboWithVendorConfig($id: ID!) {
  Combo(id: $id) {
    ...ComboFragment
    vendorConfigs {
      ...VendorConfigsFragment
    }
  }
}
    ${ComboFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}`;

/**
 * __useGetComboWithVendorConfigQuery__
 *
 * To run a query within a React component, call `useGetComboWithVendorConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComboWithVendorConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComboWithVendorConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetComboWithVendorConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetComboWithVendorConfigQuery, IGetComboWithVendorConfigQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetComboWithVendorConfigQuery, IGetComboWithVendorConfigQueryVariables>(GetComboWithVendorConfigDocument, baseOptions);
      }
export function useGetComboWithVendorConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetComboWithVendorConfigQuery, IGetComboWithVendorConfigQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetComboWithVendorConfigQuery, IGetComboWithVendorConfigQueryVariables>(GetComboWithVendorConfigDocument, baseOptions);
        }
export type GetComboWithVendorConfigQueryHookResult = ReturnType<typeof useGetComboWithVendorConfigQuery>;
export type GetComboWithVendorConfigLazyQueryHookResult = ReturnType<typeof useGetComboWithVendorConfigLazyQuery>;
export type GetComboWithVendorConfigQueryResult = ApolloReactCommon.QueryResult<IGetComboWithVendorConfigQuery, IGetComboWithVendorConfigQueryVariables>;
export const GetComboAvailabilityDocument = gql`
    query GetComboAvailability($id: ID!) {
  Combo(id: $id) {
    ...ComboAvailabilityFragment
  }
}
    ${ComboAvailabilityFragmentFragmentDoc}`;

/**
 * __useGetComboAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetComboAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComboAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComboAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetComboAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetComboAvailabilityQuery, IGetComboAvailabilityQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetComboAvailabilityQuery, IGetComboAvailabilityQueryVariables>(GetComboAvailabilityDocument, baseOptions);
      }
export function useGetComboAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetComboAvailabilityQuery, IGetComboAvailabilityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetComboAvailabilityQuery, IGetComboAvailabilityQueryVariables>(GetComboAvailabilityDocument, baseOptions);
        }
export type GetComboAvailabilityQueryHookResult = ReturnType<typeof useGetComboAvailabilityQuery>;
export type GetComboAvailabilityLazyQueryHookResult = ReturnType<typeof useGetComboAvailabilityLazyQuery>;
export type GetComboAvailabilityQueryResult = ApolloReactCommon.QueryResult<IGetComboAvailabilityQuery, IGetComboAvailabilityQueryVariables>;
export const FeatureAccountDeletePageDocument = gql`
    query featureAccountDeletePage($featureAccountDeletePageId: ID!) {
  FeatureAccountDeletePage(id: $featureAccountDeletePageId) {
    headerText {
      locale: en
    }
    content {
      locale: enRaw
    }
    confirmButtonText {
      locale: en
    }
    cancelButtonText {
      locale: en
    }
    errorText {
      locale: en
    }
  }
}
    `;

/**
 * __useFeatureAccountDeletePageQuery__
 *
 * To run a query within a React component, call `useFeatureAccountDeletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountDeletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountDeletePageQuery({
 *   variables: {
 *      featureAccountDeletePageId: // value for 'featureAccountDeletePageId'
 *   },
 * });
 */
export function useFeatureAccountDeletePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>(FeatureAccountDeletePageDocument, baseOptions);
      }
export function useFeatureAccountDeletePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>(FeatureAccountDeletePageDocument, baseOptions);
        }
export type FeatureAccountDeletePageQueryHookResult = ReturnType<typeof useFeatureAccountDeletePageQuery>;
export type FeatureAccountDeletePageLazyQueryHookResult = ReturnType<typeof useFeatureAccountDeletePageLazyQuery>;
export type FeatureAccountDeletePageQueryResult = ApolloReactCommon.QueryResult<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>;
export const FeatureAccountFormDocument = gql`
    query featureAccountForm($featureAccountFormId: ID!) {
  FeatureAccountForm(id: $featureAccountFormId) {
    postalOrZipDisclaimer {
      locale: en
    }
    desktopImage {
      locale: en {
        ...ImagesFragment
      }
    }
  }
}
    ${ImagesFragmentFragmentDoc}`;

/**
 * __useFeatureAccountFormQuery__
 *
 * To run a query within a React component, call `useFeatureAccountFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountFormQuery({
 *   variables: {
 *      featureAccountFormId: // value for 'featureAccountFormId'
 *   },
 * });
 */
export function useFeatureAccountFormQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>(FeatureAccountFormDocument, baseOptions);
      }
export function useFeatureAccountFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>(FeatureAccountFormDocument, baseOptions);
        }
export type FeatureAccountFormQueryHookResult = ReturnType<typeof useFeatureAccountFormQuery>;
export type FeatureAccountFormLazyQueryHookResult = ReturnType<typeof useFeatureAccountFormLazyQuery>;
export type FeatureAccountFormQueryResult = ApolloReactCommon.QueryResult<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>;
export const FeatureAccountRequestInfoPageDocument = gql`
    query featureAccountRequestInfoPage($featureAccountRequestInfoPageId: ID!) {
  FeatureAccountRequestInfoPage(id: $featureAccountRequestInfoPageId) {
    headerText {
      locale: en
    }
    content {
      locale: enRaw
    }
    confirmButtonText {
      locale: en
    }
    errorText {
      locale: en
    }
  }
}
    `;

/**
 * __useFeatureAccountRequestInfoPageQuery__
 *
 * To run a query within a React component, call `useFeatureAccountRequestInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountRequestInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountRequestInfoPageQuery({
 *   variables: {
 *      featureAccountRequestInfoPageId: // value for 'featureAccountRequestInfoPageId'
 *   },
 * });
 */
export function useFeatureAccountRequestInfoPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>(FeatureAccountRequestInfoPageDocument, baseOptions);
      }
export function useFeatureAccountRequestInfoPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>(FeatureAccountRequestInfoPageDocument, baseOptions);
        }
export type FeatureAccountRequestInfoPageQueryHookResult = ReturnType<typeof useFeatureAccountRequestInfoPageQuery>;
export type FeatureAccountRequestInfoPageLazyQueryHookResult = ReturnType<typeof useFeatureAccountRequestInfoPageLazyQuery>;
export type FeatureAccountRequestInfoPageQueryResult = ApolloReactCommon.QueryResult<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>;
export const FeatureAccountDocument = gql`
    query featureAccount($featureAccountId: ID!) {
  FeatureAccount(id: $featureAccountId) {
    _id
    emailAndPushOptInSettings {
      ...OptInSettingBooleanFragment
      ...OptInSettingEnumFragment
      ...OptInSettingEmailAndPushFragment
      ...OptInPrivacyPreferencesFragment
    }
  }
}
    ${OptInSettingBooleanFragmentFragmentDoc}
${OptInSettingEnumFragmentFragmentDoc}
${OptInSettingEmailAndPushFragmentFragmentDoc}
${OptInPrivacyPreferencesFragmentFragmentDoc}`;

/**
 * __useFeatureAccountQuery__
 *
 * To run a query within a React component, call `useFeatureAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountQuery({
 *   variables: {
 *      featureAccountId: // value for 'featureAccountId'
 *   },
 * });
 */
export function useFeatureAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAccountQuery, IFeatureAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAccountQuery, IFeatureAccountQueryVariables>(FeatureAccountDocument, baseOptions);
      }
export function useFeatureAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountQuery, IFeatureAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAccountQuery, IFeatureAccountQueryVariables>(FeatureAccountDocument, baseOptions);
        }
export type FeatureAccountQueryHookResult = ReturnType<typeof useFeatureAccountQuery>;
export type FeatureAccountLazyQueryHookResult = ReturnType<typeof useFeatureAccountLazyQuery>;
export type FeatureAccountQueryResult = ApolloReactCommon.QueryResult<IFeatureAccountQuery, IFeatureAccountQueryVariables>;
export const FeatureBeeperDocument = gql`
    query featureBeeper($featureBeeperId: ID!) {
  FeatureBeeperModal(id: $featureBeeperId) {
    beeperModalTitle {
      locale: en
    }
    beeperModalImage {
      locale: en {
        ...ImageFragment
      }
    }
    beeperModalBody {
      locale: en
    }
    beeperButtonText {
      locale: en
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureBeeperQuery__
 *
 * To run a query within a React component, call `useFeatureBeeperQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureBeeperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureBeeperQuery({
 *   variables: {
 *      featureBeeperId: // value for 'featureBeeperId'
 *   },
 * });
 */
export function useFeatureBeeperQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureBeeperQuery, IFeatureBeeperQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureBeeperQuery, IFeatureBeeperQueryVariables>(FeatureBeeperDocument, baseOptions);
      }
export function useFeatureBeeperLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureBeeperQuery, IFeatureBeeperQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureBeeperQuery, IFeatureBeeperQueryVariables>(FeatureBeeperDocument, baseOptions);
        }
export type FeatureBeeperQueryHookResult = ReturnType<typeof useFeatureBeeperQuery>;
export type FeatureBeeperLazyQueryHookResult = ReturnType<typeof useFeatureBeeperLazyQuery>;
export type FeatureBeeperQueryResult = ApolloReactCommon.QueryResult<IFeatureBeeperQuery, IFeatureBeeperQueryVariables>;
export const FeatureCateringPageDocument = gql`
    query featureCateringPage($featureCateringPageId: ID!) {
  FeatureCateringPage(id: $featureCateringPageId) {
    appUnauthenticated {
      ...CateringPageConfigurationFragment
    }
    appAuthenticated {
      ...CateringPageConfigurationFragment
    }
    webUnauthenticated {
      ...CateringPageConfigurationFragment
    }
    webAuthenticated {
      ...CateringPageConfigurationFragment
    }
  }
}
    ${CateringPageConfigurationFragmentFragmentDoc}`;

/**
 * __useFeatureCateringPageQuery__
 *
 * To run a query within a React component, call `useFeatureCateringPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureCateringPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureCateringPageQuery({
 *   variables: {
 *      featureCateringPageId: // value for 'featureCateringPageId'
 *   },
 * });
 */
export function useFeatureCateringPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>(FeatureCateringPageDocument, baseOptions);
      }
export function useFeatureCateringPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>(FeatureCateringPageDocument, baseOptions);
        }
export type FeatureCateringPageQueryHookResult = ReturnType<typeof useFeatureCateringPageQuery>;
export type FeatureCateringPageLazyQueryHookResult = ReturnType<typeof useFeatureCateringPageLazyQuery>;
export type FeatureCateringPageQueryResult = ApolloReactCommon.QueryResult<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>;
export const FeatureLoyaltyClaimPointsContentDocument = gql`
    query featureLoyaltyClaimPointsContent($featureClaimPointsUIId: ID!) {
  ClaimPointsUI(id: $featureClaimPointsUIId) {
    _id
    claimPointsHomeScreenContent {
      ...ClaimPointsScreenContentFragment
    }
    claimQrCode {
      ...ClaimPointsQrCodeContentFragment
    }
    claimPointsSurveyContent {
      ...ClaimPointsSurveyContentFragment
    }
    claimPointsSuccessfulSubmissionScreenContent {
      ...ClaimPointsScreenContentFragment
    }
    claimOnHistory {
      linkText {
        locale: enRaw
      }
    }
    claimPointsPendingContent {
      ...ClaimPointsFailedSubmissionContentFragment
    }
    claimPointsExpiredContent {
      ...ClaimPointsFailedSubmissionContentFragment
    }
    claimPointsInvalidCodeContent {
      ...ClaimPointsFailedSubmissionContentFragment
    }
    claimPointsAlreadyClaimedContent {
      ...ClaimPointsFailedSubmissionContentFragment
    }
    claimPointsTransactionNotFoundContent {
      ...ClaimPointsFailedSubmissionContentFragment
    }
    claimPointsInvalidRestaurantContent {
      ...ClaimPointsFailedSubmissionContentFragment
    }
    claimPointsDailyAmountExceededContent {
      ...ClaimPointsFailedSubmissionContentFragment
    }
    claimPointsDuplicateTransactionId {
      ...ClaimPointsFailedSubmissionContentFragment
    }
    claimPointsTooManyRequests {
      ...ClaimPointsFailedSubmissionContentFragment
    }
  }
}
    ${ClaimPointsScreenContentFragmentFragmentDoc}
${ClaimPointsQrCodeContentFragmentFragmentDoc}
${ClaimPointsSurveyContentFragmentFragmentDoc}
${ClaimPointsFailedSubmissionContentFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyClaimPointsContentQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyClaimPointsContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyClaimPointsContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyClaimPointsContentQuery({
 *   variables: {
 *      featureClaimPointsUIId: // value for 'featureClaimPointsUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyClaimPointsContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>(FeatureLoyaltyClaimPointsContentDocument, baseOptions);
      }
export function useFeatureLoyaltyClaimPointsContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>(FeatureLoyaltyClaimPointsContentDocument, baseOptions);
        }
export type FeatureLoyaltyClaimPointsContentQueryHookResult = ReturnType<typeof useFeatureLoyaltyClaimPointsContentQuery>;
export type FeatureLoyaltyClaimPointsContentLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyClaimPointsContentLazyQuery>;
export type FeatureLoyaltyClaimPointsContentQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>;
export const FeatureDisclaimersDocument = gql`
    query featureDisclaimers($featureDisclaimersId: ID!) {
  FeatureDisclaimers(id: $featureDisclaimersId) {
    _id
    superUpsell {
      localeRaw: enRaw
    }
    calorie {
      localeRaw: enRaw
    }
    price {
      locale: en
    }
    itemAvailability {
      locale: en
    }
    images {
      locale: en
    }
    phoneNumber {
      locale: en
    }
    country {
      locale: en
    }
    offers {
      locale: en
    }
    copyrightAndTrademark {
      locale: en
    }
    reservedRights {
      locale: en
    }
    communicationPreferencesBlock {
      localeRaw: enRaw
    }
    signUpDisclaimers {
      locale: en
    }
    signUpMarketDisclaimers {
      locale: en
    }
    deliveryDisclaimer {
      locale: en
    }
    deliveryLogo {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureDisclaimersQuery__
 *
 * To run a query within a React component, call `useFeatureDisclaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureDisclaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureDisclaimersQuery({
 *   variables: {
 *      featureDisclaimersId: // value for 'featureDisclaimersId'
 *   },
 * });
 */
export function useFeatureDisclaimersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>(FeatureDisclaimersDocument, baseOptions);
      }
export function useFeatureDisclaimersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>(FeatureDisclaimersDocument, baseOptions);
        }
export type FeatureDisclaimersQueryHookResult = ReturnType<typeof useFeatureDisclaimersQuery>;
export type FeatureDisclaimersLazyQueryHookResult = ReturnType<typeof useFeatureDisclaimersLazyQuery>;
export type FeatureDisclaimersQueryResult = ApolloReactCommon.QueryResult<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>;
export const FeatureFooterV2Document = gql`
    query featureFooterV2($featureFooterV2Id: ID!) {
  FeatureFooterV2(id: $featureFooterV2Id) {
    ...FeatureFooterV2Fragment
  }
}
    ${FeatureFooterV2FragmentFragmentDoc}`;

/**
 * __useFeatureFooterV2Query__
 *
 * To run a query within a React component, call `useFeatureFooterV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFooterV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFooterV2Query({
 *   variables: {
 *      featureFooterV2Id: // value for 'featureFooterV2Id'
 *   },
 * });
 */
export function useFeatureFooterV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureFooterV2Query, IFeatureFooterV2QueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureFooterV2Query, IFeatureFooterV2QueryVariables>(FeatureFooterV2Document, baseOptions);
      }
export function useFeatureFooterV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureFooterV2Query, IFeatureFooterV2QueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureFooterV2Query, IFeatureFooterV2QueryVariables>(FeatureFooterV2Document, baseOptions);
        }
export type FeatureFooterV2QueryHookResult = ReturnType<typeof useFeatureFooterV2Query>;
export type FeatureFooterV2LazyQueryHookResult = ReturnType<typeof useFeatureFooterV2LazyQuery>;
export type FeatureFooterV2QueryResult = ApolloReactCommon.QueryResult<IFeatureFooterV2Query, IFeatureFooterV2QueryVariables>;
export const FeatureFooterDocument = gql`
    query featureFooter($featureFooterId: ID!) {
  FeatureFooter(id: $featureFooterId) {
    rows {
      _key
      columns {
        _key
        options {
          ... on CopyrightAndLanguageSelector {
            ...CopyrightAndLanguageSelectorFragment
          }
          ... on HighlightedVerticalLinkListWidget {
            ...HighlightedVerticalLinkListWidgetFragment
          }
          ... on HorizontalLinkListWidget {
            ...HorizontalLinkListWidgetFragment
          }
          ... on ImageWidget {
            ...ImageWidgetFragment
          }
          ... on SocialIconsWithHeaderWidget {
            ...SocialIconsWithHeaderWidgetFragment
          }
          ... on TextWidget {
            ...TextWidgetFragment
          }
          ... on VerticalLinkListWidget {
            ...VerticalLinkListWidgetFragment
          }
          ... on VerticalLinkListWithHeaderWidget {
            ...VerticalLinkListWithHeaderWidgetFragment
          }
          ... on WordmarkAndSocialIcons {
            ...WordmarkAndSocialIconsFragment
          }
        }
      }
    }
  }
}
    ${CopyrightAndLanguageSelectorFragmentFragmentDoc}
${HighlightedVerticalLinkListWidgetFragmentFragmentDoc}
${HorizontalLinkListWidgetFragmentFragmentDoc}
${ImageWidgetFragmentFragmentDoc}
${SocialIconsWithHeaderWidgetFragmentFragmentDoc}
${TextWidgetFragmentFragmentDoc}
${VerticalLinkListWidgetFragmentFragmentDoc}
${VerticalLinkListWithHeaderWidgetFragmentFragmentDoc}
${WordmarkAndSocialIconsFragmentFragmentDoc}`;

/**
 * __useFeatureFooterQuery__
 *
 * To run a query within a React component, call `useFeatureFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFooterQuery({
 *   variables: {
 *      featureFooterId: // value for 'featureFooterId'
 *   },
 * });
 */
export function useFeatureFooterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureFooterQuery, IFeatureFooterQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureFooterQuery, IFeatureFooterQueryVariables>(FeatureFooterDocument, baseOptions);
      }
export function useFeatureFooterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureFooterQuery, IFeatureFooterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureFooterQuery, IFeatureFooterQueryVariables>(FeatureFooterDocument, baseOptions);
        }
export type FeatureFooterQueryHookResult = ReturnType<typeof useFeatureFooterQuery>;
export type FeatureFooterLazyQueryHookResult = ReturnType<typeof useFeatureFooterLazyQuery>;
export type FeatureFooterQueryResult = ApolloReactCommon.QueryResult<IFeatureFooterQuery, IFeatureFooterQueryVariables>;
export const FeatureGeolocationMapMarkersDocument = gql`
    query featureGeolocationMapMarkers($featureGeolocationMapMarkersId: ID!) {
  FeatureGeolocationMapMarkers(id: $featureGeolocationMapMarkersId) {
    _id
    driverIcon {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureGeolocationMapMarkersQuery__
 *
 * To run a query within a React component, call `useFeatureGeolocationMapMarkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureGeolocationMapMarkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureGeolocationMapMarkersQuery({
 *   variables: {
 *      featureGeolocationMapMarkersId: // value for 'featureGeolocationMapMarkersId'
 *   },
 * });
 */
export function useFeatureGeolocationMapMarkersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>(FeatureGeolocationMapMarkersDocument, baseOptions);
      }
export function useFeatureGeolocationMapMarkersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>(FeatureGeolocationMapMarkersDocument, baseOptions);
        }
export type FeatureGeolocationMapMarkersQueryHookResult = ReturnType<typeof useFeatureGeolocationMapMarkersQuery>;
export type FeatureGeolocationMapMarkersLazyQueryHookResult = ReturnType<typeof useFeatureGeolocationMapMarkersLazyQuery>;
export type FeatureGeolocationMapMarkersQueryResult = ApolloReactCommon.QueryResult<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>;
export const FeatureGeolocationModalDocument = gql`
    query featureGeolocationModal($featureGeolocationModalId: ID!) {
  FeatureGeolocationModal(id: $featureGeolocationModalId) {
    header {
      locale: en
    }
    body {
      locale: en
    }
  }
}
    `;

/**
 * __useFeatureGeolocationModalQuery__
 *
 * To run a query within a React component, call `useFeatureGeolocationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureGeolocationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureGeolocationModalQuery({
 *   variables: {
 *      featureGeolocationModalId: // value for 'featureGeolocationModalId'
 *   },
 * });
 */
export function useFeatureGeolocationModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>(FeatureGeolocationModalDocument, baseOptions);
      }
export function useFeatureGeolocationModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>(FeatureGeolocationModalDocument, baseOptions);
        }
export type FeatureGeolocationModalQueryHookResult = ReturnType<typeof useFeatureGeolocationModalQuery>;
export type FeatureGeolocationModalLazyQueryHookResult = ReturnType<typeof useFeatureGeolocationModalLazyQuery>;
export type FeatureGeolocationModalQueryResult = ApolloReactCommon.QueryResult<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>;
export const FeatureGiftDocument = gql`
    query featureGift($featureGiftId: ID!) {
  FeatureGift(id: $featureGiftId) {
    backgroundImage {
      locale: en {
        ...ImagesFragment
      }
    }
    header {
      locale: en
    }
    subHeader {
      locale: enRaw
    }
    legalDisclaimer {
      locale: enRaw
    }
    receptionModalImage {
      locale: en {
        ...ImagesFragment
      }
    }
  }
}
    ${ImagesFragmentFragmentDoc}`;

/**
 * __useFeatureGiftQuery__
 *
 * To run a query within a React component, call `useFeatureGiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureGiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureGiftQuery({
 *   variables: {
 *      featureGiftId: // value for 'featureGiftId'
 *   },
 * });
 */
export function useFeatureGiftQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureGiftQuery, IFeatureGiftQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureGiftQuery, IFeatureGiftQueryVariables>(FeatureGiftDocument, baseOptions);
      }
export function useFeatureGiftLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureGiftQuery, IFeatureGiftQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureGiftQuery, IFeatureGiftQueryVariables>(FeatureGiftDocument, baseOptions);
        }
export type FeatureGiftQueryHookResult = ReturnType<typeof useFeatureGiftQuery>;
export type FeatureGiftLazyQueryHookResult = ReturnType<typeof useFeatureGiftLazyQuery>;
export type FeatureGiftQueryResult = ApolloReactCommon.QueryResult<IFeatureGiftQuery, IFeatureGiftQueryVariables>;
export const FeatureWebHomePageDocument = gql`
    query featureWebHomePage($featureHomePageId: ID!) {
  FeatureHomePage(id: $featureHomePageId) {
    unauthenticated: webUnauthenticated {
      ...HomePageConfigurationFragment
    }
    authenticated: webAuthenticated {
      ...HomePageConfigurationFragment
    }
  }
}
    ${HomePageConfigurationFragmentFragmentDoc}`;

/**
 * __useFeatureWebHomePageQuery__
 *
 * To run a query within a React component, call `useFeatureWebHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureWebHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureWebHomePageQuery({
 *   variables: {
 *      featureHomePageId: // value for 'featureHomePageId'
 *   },
 * });
 */
export function useFeatureWebHomePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureWebHomePageQuery, IFeatureWebHomePageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureWebHomePageQuery, IFeatureWebHomePageQueryVariables>(FeatureWebHomePageDocument, baseOptions);
      }
export function useFeatureWebHomePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureWebHomePageQuery, IFeatureWebHomePageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureWebHomePageQuery, IFeatureWebHomePageQueryVariables>(FeatureWebHomePageDocument, baseOptions);
        }
export type FeatureWebHomePageQueryHookResult = ReturnType<typeof useFeatureWebHomePageQuery>;
export type FeatureWebHomePageLazyQueryHookResult = ReturnType<typeof useFeatureWebHomePageLazyQuery>;
export type FeatureWebHomePageQueryResult = ApolloReactCommon.QueryResult<IFeatureWebHomePageQuery, IFeatureWebHomePageQueryVariables>;
export const FeatureAppHomePageDocument = gql`
    query featureAppHomePage($featureHomePageId: ID!) {
  FeatureHomePage(id: $featureHomePageId) {
    unauthenticated: appUnauthenticated {
      ...HomePageConfigurationFragment
    }
    authenticated: appAuthenticated {
      ...HomePageConfigurationFragment
    }
  }
}
    ${HomePageConfigurationFragmentFragmentDoc}`;

/**
 * __useFeatureAppHomePageQuery__
 *
 * To run a query within a React component, call `useFeatureAppHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAppHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAppHomePageQuery({
 *   variables: {
 *      featureHomePageId: // value for 'featureHomePageId'
 *   },
 * });
 */
export function useFeatureAppHomePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAppHomePageQuery, IFeatureAppHomePageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAppHomePageQuery, IFeatureAppHomePageQueryVariables>(FeatureAppHomePageDocument, baseOptions);
      }
export function useFeatureAppHomePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAppHomePageQuery, IFeatureAppHomePageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAppHomePageQuery, IFeatureAppHomePageQueryVariables>(FeatureAppHomePageDocument, baseOptions);
        }
export type FeatureAppHomePageQueryHookResult = ReturnType<typeof useFeatureAppHomePageQuery>;
export type FeatureAppHomePageLazyQueryHookResult = ReturnType<typeof useFeatureAppHomePageLazyQuery>;
export type FeatureAppHomePageQueryResult = ApolloReactCommon.QueryResult<IFeatureAppHomePageQuery, IFeatureAppHomePageQueryVariables>;
export const MainHeroDocument = gql`
    query mainHero($mainHeroId: ID!) {
  MainHero(id: $mainHeroId) {
    ...MainHeroFragment
  }
}
    ${MainHeroFragmentFragmentDoc}`;

/**
 * __useMainHeroQuery__
 *
 * To run a query within a React component, call `useMainHeroQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainHeroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainHeroQuery({
 *   variables: {
 *      mainHeroId: // value for 'mainHeroId'
 *   },
 * });
 */
export function useMainHeroQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IMainHeroQuery, IMainHeroQueryVariables>) {
        return ApolloReactHooks.useQuery<IMainHeroQuery, IMainHeroQueryVariables>(MainHeroDocument, baseOptions);
      }
export function useMainHeroLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IMainHeroQuery, IMainHeroQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IMainHeroQuery, IMainHeroQueryVariables>(MainHeroDocument, baseOptions);
        }
export type MainHeroQueryHookResult = ReturnType<typeof useMainHeroQuery>;
export type MainHeroLazyQueryHookResult = ReturnType<typeof useMainHeroLazyQuery>;
export type MainHeroQueryResult = ApolloReactCommon.QueryResult<IMainHeroQuery, IMainHeroQueryVariables>;
export const HeroDocument = gql`
    query hero($heroId: ID!) {
  Hero(id: $heroId) {
    ...HeroFragment
  }
}
    ${HeroFragmentFragmentDoc}`;

/**
 * __useHeroQuery__
 *
 * To run a query within a React component, call `useHeroQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeroQuery({
 *   variables: {
 *      heroId: // value for 'heroId'
 *   },
 * });
 */
export function useHeroQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IHeroQuery, IHeroQueryVariables>) {
        return ApolloReactHooks.useQuery<IHeroQuery, IHeroQueryVariables>(HeroDocument, baseOptions);
      }
export function useHeroLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IHeroQuery, IHeroQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IHeroQuery, IHeroQueryVariables>(HeroDocument, baseOptions);
        }
export type HeroQueryHookResult = ReturnType<typeof useHeroQuery>;
export type HeroLazyQueryHookResult = ReturnType<typeof useHeroLazyQuery>;
export type HeroQueryResult = ApolloReactCommon.QueryResult<IHeroQuery, IHeroQueryVariables>;
export const BrazeContentCardsDocument = gql`
    query brazeContentCards($brazeContentCardsId: ID!) {
  BrazeContentCards(id: $brazeContentCardsId) {
    ...BrazeContentCardsFragment
  }
}
    ${BrazeContentCardsFragmentFragmentDoc}`;

/**
 * __useBrazeContentCardsQuery__
 *
 * To run a query within a React component, call `useBrazeContentCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrazeContentCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrazeContentCardsQuery({
 *   variables: {
 *      brazeContentCardsId: // value for 'brazeContentCardsId'
 *   },
 * });
 */
export function useBrazeContentCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IBrazeContentCardsQuery, IBrazeContentCardsQueryVariables>) {
        return ApolloReactHooks.useQuery<IBrazeContentCardsQuery, IBrazeContentCardsQueryVariables>(BrazeContentCardsDocument, baseOptions);
      }
export function useBrazeContentCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IBrazeContentCardsQuery, IBrazeContentCardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IBrazeContentCardsQuery, IBrazeContentCardsQueryVariables>(BrazeContentCardsDocument, baseOptions);
        }
export type BrazeContentCardsQueryHookResult = ReturnType<typeof useBrazeContentCardsQuery>;
export type BrazeContentCardsLazyQueryHookResult = ReturnType<typeof useBrazeContentCardsLazyQuery>;
export type BrazeContentCardsQueryResult = ApolloReactCommon.QueryResult<IBrazeContentCardsQuery, IBrazeContentCardsQueryVariables>;
export const AlertDocument = gql`
    query alert($alertId: ID!) {
  Alert(id: $alertId) {
    ...AlertFrangment
  }
}
    ${AlertFrangmentFragmentDoc}`;

/**
 * __useAlertQuery__
 *
 * To run a query within a React component, call `useAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *   },
 * });
 */
export function useAlertQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAlertQuery, IAlertQueryVariables>) {
        return ApolloReactHooks.useQuery<IAlertQuery, IAlertQueryVariables>(AlertDocument, baseOptions);
      }
export function useAlertLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAlertQuery, IAlertQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IAlertQuery, IAlertQueryVariables>(AlertDocument, baseOptions);
        }
export type AlertQueryHookResult = ReturnType<typeof useAlertQuery>;
export type AlertLazyQueryHookResult = ReturnType<typeof useAlertLazyQuery>;
export type AlertQueryResult = ApolloReactCommon.QueryResult<IAlertQuery, IAlertQueryVariables>;
export const MarketingCardGroupsDocument = gql`
    query marketingCardGroups($where: MarketingCardGroupFilter) {
  allMarketingCardGroups(where: $where) {
    ... on MarketingCardGroup {
      ...MarketingCardGroupFragment
    }
  }
}
    ${MarketingCardGroupFragmentFragmentDoc}`;

/**
 * __useMarketingCardGroupsQuery__
 *
 * To run a query within a React component, call `useMarketingCardGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingCardGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingCardGroupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMarketingCardGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IMarketingCardGroupsQuery, IMarketingCardGroupsQueryVariables>) {
        return ApolloReactHooks.useQuery<IMarketingCardGroupsQuery, IMarketingCardGroupsQueryVariables>(MarketingCardGroupsDocument, baseOptions);
      }
export function useMarketingCardGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IMarketingCardGroupsQuery, IMarketingCardGroupsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IMarketingCardGroupsQuery, IMarketingCardGroupsQueryVariables>(MarketingCardGroupsDocument, baseOptions);
        }
export type MarketingCardGroupsQueryHookResult = ReturnType<typeof useMarketingCardGroupsQuery>;
export type MarketingCardGroupsLazyQueryHookResult = ReturnType<typeof useMarketingCardGroupsLazyQuery>;
export type MarketingCardGroupsQueryResult = ApolloReactCommon.QueryResult<IMarketingCardGroupsQuery, IMarketingCardGroupsQueryVariables>;
export const MarketingTileCarouselDocument = gql`
    query marketingTileCarousel($marketingTileCarouselId: ID!) {
  MarketingTileCarousel(id: $marketingTileCarouselId) {
    ...MarketingTileCarouselFragment
  }
}
    ${MarketingTileCarouselFragmentFragmentDoc}`;

/**
 * __useMarketingTileCarouselQuery__
 *
 * To run a query within a React component, call `useMarketingTileCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingTileCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingTileCarouselQuery({
 *   variables: {
 *      marketingTileCarouselId: // value for 'marketingTileCarouselId'
 *   },
 * });
 */
export function useMarketingTileCarouselQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IMarketingTileCarouselQuery, IMarketingTileCarouselQueryVariables>) {
        return ApolloReactHooks.useQuery<IMarketingTileCarouselQuery, IMarketingTileCarouselQueryVariables>(MarketingTileCarouselDocument, baseOptions);
      }
export function useMarketingTileCarouselLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IMarketingTileCarouselQuery, IMarketingTileCarouselQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IMarketingTileCarouselQuery, IMarketingTileCarouselQueryVariables>(MarketingTileCarouselDocument, baseOptions);
        }
export type MarketingTileCarouselQueryHookResult = ReturnType<typeof useMarketingTileCarouselQuery>;
export type MarketingTileCarouselLazyQueryHookResult = ReturnType<typeof useMarketingTileCarouselLazyQuery>;
export type MarketingTileCarouselQueryResult = ApolloReactCommon.QueryResult<IMarketingTileCarouselQuery, IMarketingTileCarouselQueryVariables>;
export const MarketingTileGroupsDocument = gql`
    query marketingTileGroups($where: MarketingTileGroupFilter) {
  allMarketingTileGroups(where: $where) {
    ... on MarketingTileGroup {
      ...MarketingTileGroupFragment
    }
  }
}
    ${MarketingTileGroupFragmentFragmentDoc}`;

/**
 * __useMarketingTileGroupsQuery__
 *
 * To run a query within a React component, call `useMarketingTileGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingTileGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingTileGroupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMarketingTileGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IMarketingTileGroupsQuery, IMarketingTileGroupsQueryVariables>) {
        return ApolloReactHooks.useQuery<IMarketingTileGroupsQuery, IMarketingTileGroupsQueryVariables>(MarketingTileGroupsDocument, baseOptions);
      }
export function useMarketingTileGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IMarketingTileGroupsQuery, IMarketingTileGroupsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IMarketingTileGroupsQuery, IMarketingTileGroupsQueryVariables>(MarketingTileGroupsDocument, baseOptions);
        }
export type MarketingTileGroupsQueryHookResult = ReturnType<typeof useMarketingTileGroupsQuery>;
export type MarketingTileGroupsLazyQueryHookResult = ReturnType<typeof useMarketingTileGroupsLazyQuery>;
export type MarketingTileGroupsQueryResult = ApolloReactCommon.QueryResult<IMarketingTileGroupsQuery, IMarketingTileGroupsQueryVariables>;
export const TrendingDocument = gql`
    query trending($trendingId: ID!) {
  Trending(id: $trendingId) {
    ...TrendingFragment
  }
}
    ${TrendingFragmentFragmentDoc}`;

/**
 * __useTrendingQuery__
 *
 * To run a query within a React component, call `useTrendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingQuery({
 *   variables: {
 *      trendingId: // value for 'trendingId'
 *   },
 * });
 */
export function useTrendingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ITrendingQuery, ITrendingQueryVariables>) {
        return ApolloReactHooks.useQuery<ITrendingQuery, ITrendingQueryVariables>(TrendingDocument, baseOptions);
      }
export function useTrendingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ITrendingQuery, ITrendingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ITrendingQuery, ITrendingQueryVariables>(TrendingDocument, baseOptions);
        }
export type TrendingQueryHookResult = ReturnType<typeof useTrendingQuery>;
export type TrendingLazyQueryHookResult = ReturnType<typeof useTrendingLazyQuery>;
export type TrendingQueryResult = ApolloReactCommon.QueryResult<ITrendingQuery, ITrendingQueryVariables>;
export const FanFavoritesDocument = gql`
    query fanFavorites($fanFavoritesId: ID!) {
  FanFavorites(id: $fanFavoritesId) {
    ...FanFavoritesFragment
  }
}
    ${FanFavoritesFragmentFragmentDoc}`;

/**
 * __useFanFavoritesQuery__
 *
 * To run a query within a React component, call `useFanFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFanFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFanFavoritesQuery({
 *   variables: {
 *      fanFavoritesId: // value for 'fanFavoritesId'
 *   },
 * });
 */
export function useFanFavoritesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFanFavoritesQuery, IFanFavoritesQueryVariables>) {
        return ApolloReactHooks.useQuery<IFanFavoritesQuery, IFanFavoritesQueryVariables>(FanFavoritesDocument, baseOptions);
      }
export function useFanFavoritesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFanFavoritesQuery, IFanFavoritesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFanFavoritesQuery, IFanFavoritesQueryVariables>(FanFavoritesDocument, baseOptions);
        }
export type FanFavoritesQueryHookResult = ReturnType<typeof useFanFavoritesQuery>;
export type FanFavoritesLazyQueryHookResult = ReturnType<typeof useFanFavoritesLazyQuery>;
export type FanFavoritesQueryResult = ApolloReactCommon.QueryResult<IFanFavoritesQuery, IFanFavoritesQueryVariables>;
export const OurServicesDocument = gql`
    query ourServices($ourServicesId: ID!) {
  OurServices(id: $ourServicesId) {
    ...OurServicesFragment
  }
}
    ${OurServicesFragmentFragmentDoc}`;

/**
 * __useOurServicesQuery__
 *
 * To run a query within a React component, call `useOurServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOurServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOurServicesQuery({
 *   variables: {
 *      ourServicesId: // value for 'ourServicesId'
 *   },
 * });
 */
export function useOurServicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IOurServicesQuery, IOurServicesQueryVariables>) {
        return ApolloReactHooks.useQuery<IOurServicesQuery, IOurServicesQueryVariables>(OurServicesDocument, baseOptions);
      }
export function useOurServicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IOurServicesQuery, IOurServicesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IOurServicesQuery, IOurServicesQueryVariables>(OurServicesDocument, baseOptions);
        }
export type OurServicesQueryHookResult = ReturnType<typeof useOurServicesQuery>;
export type OurServicesLazyQueryHookResult = ReturnType<typeof useOurServicesLazyQuery>;
export type OurServicesQueryResult = ApolloReactCommon.QueryResult<IOurServicesQuery, IOurServicesQueryVariables>;
export const AppDownloadDocument = gql`
    query appDownload($appDownloadId: ID!) {
  AppDownload(id: $appDownloadId) {
    ...AppDownloadFragment
  }
}
    ${AppDownloadFragmentFragmentDoc}`;

/**
 * __useAppDownloadQuery__
 *
 * To run a query within a React component, call `useAppDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppDownloadQuery({
 *   variables: {
 *      appDownloadId: // value for 'appDownloadId'
 *   },
 * });
 */
export function useAppDownloadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAppDownloadQuery, IAppDownloadQueryVariables>) {
        return ApolloReactHooks.useQuery<IAppDownloadQuery, IAppDownloadQueryVariables>(AppDownloadDocument, baseOptions);
      }
export function useAppDownloadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAppDownloadQuery, IAppDownloadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IAppDownloadQuery, IAppDownloadQueryVariables>(AppDownloadDocument, baseOptions);
        }
export type AppDownloadQueryHookResult = ReturnType<typeof useAppDownloadQuery>;
export type AppDownloadLazyQueryHookResult = ReturnType<typeof useAppDownloadLazyQuery>;
export type AppDownloadQueryResult = ApolloReactCommon.QueryResult<IAppDownloadQuery, IAppDownloadQueryVariables>;
export const RewardsSectionDocument = gql`
    query rewardsSection($rewardsSectionId: ID!) {
  RewardsSection(id: $rewardsSectionId) {
    ...RewardsSectionFragment
  }
}
    ${RewardsSectionFragmentFragmentDoc}`;

/**
 * __useRewardsSectionQuery__
 *
 * To run a query within a React component, call `useRewardsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRewardsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRewardsSectionQuery({
 *   variables: {
 *      rewardsSectionId: // value for 'rewardsSectionId'
 *   },
 * });
 */
export function useRewardsSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IRewardsSectionQuery, IRewardsSectionQueryVariables>) {
        return ApolloReactHooks.useQuery<IRewardsSectionQuery, IRewardsSectionQueryVariables>(RewardsSectionDocument, baseOptions);
      }
export function useRewardsSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IRewardsSectionQuery, IRewardsSectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IRewardsSectionQuery, IRewardsSectionQueryVariables>(RewardsSectionDocument, baseOptions);
        }
export type RewardsSectionQueryHookResult = ReturnType<typeof useRewardsSectionQuery>;
export type RewardsSectionLazyQueryHookResult = ReturnType<typeof useRewardsSectionLazyQuery>;
export type RewardsSectionQueryResult = ApolloReactCommon.QueryResult<IRewardsSectionQuery, IRewardsSectionQueryVariables>;
export const GoogleAdSlotsDocument = gql`
    query googleAdSlots($where: GoogleAdSlotFilter) {
  allGoogleAdSlots(where: $where) {
    ... on GoogleAdSlot {
      ...GoogleAdSlotFragment
    }
  }
}
    ${GoogleAdSlotFragmentFragmentDoc}`;

/**
 * __useGoogleAdSlotsQuery__
 *
 * To run a query within a React component, call `useGoogleAdSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleAdSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleAdSlotsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGoogleAdSlotsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGoogleAdSlotsQuery, IGoogleAdSlotsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGoogleAdSlotsQuery, IGoogleAdSlotsQueryVariables>(GoogleAdSlotsDocument, baseOptions);
      }
export function useGoogleAdSlotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGoogleAdSlotsQuery, IGoogleAdSlotsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGoogleAdSlotsQuery, IGoogleAdSlotsQueryVariables>(GoogleAdSlotsDocument, baseOptions);
        }
export type GoogleAdSlotsQueryHookResult = ReturnType<typeof useGoogleAdSlotsQuery>;
export type GoogleAdSlotsLazyQueryHookResult = ReturnType<typeof useGoogleAdSlotsLazyQuery>;
export type GoogleAdSlotsQueryResult = ApolloReactCommon.QueryResult<IGoogleAdSlotsQuery, IGoogleAdSlotsQueryVariables>;
export const FeatureLayoutDocument = gql`
    query featureLayout($featureLayoutId: ID!) {
  FeatureLayout(id: $featureLayoutId) {
    _id
    defaultHeroImage {
      locale: en {
        ...ImageFragment
      }
    }
    recentOrderHeroText {
      locale: en
    }
    loadingGraphics {
      ...LoadingGraphicsFragment
    }
    geolocationModalImage {
      locale: en {
        ...ImageFragment
      }
    }
    appleWalletImage {
      locale: en {
        ...ImageFragment
      }
    }
    googlePayImage {
      locale: en {
        ...ImageFragment
      }
    }
    giftCardImage {
      locale: en {
        ...ImageFragment
      }
    }
    giftCardTextImage {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}
${LoadingGraphicsFragmentFragmentDoc}`;

/**
 * __useFeatureLayoutQuery__
 *
 * To run a query within a React component, call `useFeatureLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLayoutQuery({
 *   variables: {
 *      featureLayoutId: // value for 'featureLayoutId'
 *   },
 * });
 */
export function useFeatureLayoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>(FeatureLayoutDocument, baseOptions);
      }
export function useFeatureLayoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>(FeatureLayoutDocument, baseOptions);
        }
export type FeatureLayoutQueryHookResult = ReturnType<typeof useFeatureLayoutQuery>;
export type FeatureLayoutLazyQueryHookResult = ReturnType<typeof useFeatureLayoutLazyQuery>;
export type FeatureLayoutQueryResult = ApolloReactCommon.QueryResult<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>;
export const FeatureLoyaltyLinkPhysicalCardContentDocument = gql`
    query featureLoyaltyLinkPhysicalCardContent($featureLinkPhysicalCardUIId: ID!) {
  LinkPhysicalCardUi(id: $featureLinkPhysicalCardUIId) {
    _id
    linkCardSectionLinkedState {
      ...LinkPhysicalCardSectionFragment
    }
    linkCardSectionUnlinkedState {
      ...LinkPhysicalCardSectionFragment
    }
    linkCardFaqSection {
      ...LinkPhysicalCardFaqFragment
    }
  }
}
    ${LinkPhysicalCardSectionFragmentFragmentDoc}
${LinkPhysicalCardFaqFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyLinkPhysicalCardContentQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyLinkPhysicalCardContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyLinkPhysicalCardContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyLinkPhysicalCardContentQuery({
 *   variables: {
 *      featureLinkPhysicalCardUIId: // value for 'featureLinkPhysicalCardUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyLinkPhysicalCardContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyLinkPhysicalCardContentQuery, IFeatureLoyaltyLinkPhysicalCardContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyLinkPhysicalCardContentQuery, IFeatureLoyaltyLinkPhysicalCardContentQueryVariables>(FeatureLoyaltyLinkPhysicalCardContentDocument, baseOptions);
      }
export function useFeatureLoyaltyLinkPhysicalCardContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyLinkPhysicalCardContentQuery, IFeatureLoyaltyLinkPhysicalCardContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyLinkPhysicalCardContentQuery, IFeatureLoyaltyLinkPhysicalCardContentQueryVariables>(FeatureLoyaltyLinkPhysicalCardContentDocument, baseOptions);
        }
export type FeatureLoyaltyLinkPhysicalCardContentQueryHookResult = ReturnType<typeof useFeatureLoyaltyLinkPhysicalCardContentQuery>;
export type FeatureLoyaltyLinkPhysicalCardContentLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyLinkPhysicalCardContentLazyQuery>;
export type FeatureLoyaltyLinkPhysicalCardContentQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyLinkPhysicalCardContentQuery, IFeatureLoyaltyLinkPhysicalCardContentQueryVariables>;
export const FeatureLockersDocument = gql`
    query featureLockers($featureLockersId: ID!) {
  FeatureLockers(id: $featureLockersId) {
    lockersPinInstructions {
      locale: enRaw
    }
    lockersTitle {
      locale: en
    }
    lockersModalImage {
      locale: en {
        ...ImageFragment
      }
    }
    lockersDescription {
      locale: enRaw
    }
    lockersViewOrderButtonText {
      locale: en
    }
    lockersHowToUseLockersButtonText {
      locale: en
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureLockersQuery__
 *
 * To run a query within a React component, call `useFeatureLockersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLockersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLockersQuery({
 *   variables: {
 *      featureLockersId: // value for 'featureLockersId'
 *   },
 * });
 */
export function useFeatureLockersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLockersQuery, IFeatureLockersQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLockersQuery, IFeatureLockersQueryVariables>(FeatureLockersDocument, baseOptions);
      }
export function useFeatureLockersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLockersQuery, IFeatureLockersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLockersQuery, IFeatureLockersQueryVariables>(FeatureLockersDocument, baseOptions);
        }
export type FeatureLockersQueryHookResult = ReturnType<typeof useFeatureLockersQuery>;
export type FeatureLockersLazyQueryHookResult = ReturnType<typeof useFeatureLockersLazyQuery>;
export type FeatureLockersQueryResult = ApolloReactCommon.QueryResult<IFeatureLockersQuery, IFeatureLockersQueryVariables>;
export const FeatureLoyaltyBackgroundDocument = gql`
    query featureLoyaltyBackground($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    imageBackground {
      image {
        ...ref
      }
    }
  }
}
    ${RefFragmentDoc}`;

/**
 * __useFeatureLoyaltyBackgroundQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyBackgroundQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyBackgroundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyBackgroundQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyBackgroundQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>(FeatureLoyaltyBackgroundDocument, baseOptions);
      }
export function useFeatureLoyaltyBackgroundLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>(FeatureLoyaltyBackgroundDocument, baseOptions);
        }
export type FeatureLoyaltyBackgroundQueryHookResult = ReturnType<typeof useFeatureLoyaltyBackgroundQuery>;
export type FeatureLoyaltyBackgroundLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyBackgroundLazyQuery>;
export type FeatureLoyaltyBackgroundQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>;
export const FeatureLoyaltyDashboardDocument = gql`
    query featureLoyaltyDashboard($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    loyaltyDashboard {
      widgets {
        __typename
        ... on LoyaltyGreetingWidget {
          _key
          componentKey
        }
        ... on LoyaltyLinkWidget {
          _key
          componentKey
          links {
            _key
            text {
              locale: en
            }
            link {
              locale: en
            }
          }
        }
        ... on LoyaltyHistoryWidget {
          _key
          componentKey
        }
        ... on LoyaltyPointsAndRewardsWidget {
          _key
          componentKey
        }
        ... on LoyaltyLinkWidget {
          _key
          componentKey
        }
        ... on LoyaltyLogoWidget {
          _key
          componentKey
        }
        ... on LoyaltyTiersWidget {
          _key
          componentKey
          sortByPointValue
          title {
            locale: en
          }
        }
        ... on LoyaltyMarketingTileGroupWidget {
          _key
          componentKey
          disclaimer: marketingTileWidgetDisclaimer {
            localeRaw: enRaw
          }
          marketingTileGroup {
            ...MarketingTileGroupFragment
          }
          title: marketingTileWidgetTitle {
            locale: en
          }
        }
        ... on LoyaltyDoubleButtonWidget {
          _key
          componentKey
          leftButtonText {
            locale: en
          }
          leftButtonPath {
            locale: en
          }
          rightButtonText {
            locale: en
          }
          rightButtonPath {
            locale: en
          }
        }
        ... on LoyaltyPointsMeterWidget {
          _key
          componentKey
          imageBackground {
            image {
              ...ImageFragment
            }
          }
          ctaButton {
            buttonPath {
              locale: en
            }
            buttonText {
              locale: en
            }
          }
        }
        ... on LoyaltyNotificationsWidget {
          _key
          componentKey
          title {
            locale: en
          }
          notifications {
            ... on Reward {
              loyaltyEngineId
              notificationDetails {
                ...NotificationDetailsFragment
              }
            }
            ... on SystemwideOffer {
              loyaltyEngineId
              redemptionType
              notificationDetails {
                ...NotificationDetailsFragment
              }
            }
            ... on SystemwidePromotion {
              loyaltyEngineId
              notificationDetails {
                ...NotificationDetailsFragment
              }
            }
          }
        }
        ... on LoyaltyQuestsWidget {
          _key
          componentKey
          title {
            locale: en
          }
        }
        ... on RewardsListWidget {
          _key
          componentKey
        }
      }
    }
  }
}
    ${MarketingTileGroupFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${NotificationDetailsFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyDashboardQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyDashboardQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyDashboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>(FeatureLoyaltyDashboardDocument, baseOptions);
      }
export function useFeatureLoyaltyDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>(FeatureLoyaltyDashboardDocument, baseOptions);
        }
export type FeatureLoyaltyDashboardQueryHookResult = ReturnType<typeof useFeatureLoyaltyDashboardQuery>;
export type FeatureLoyaltyDashboardLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyDashboardLazyQuery>;
export type FeatureLoyaltyDashboardQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>;
export const FeatureEarningCalculationDocument = gql`
    query featureEarningCalculation($id: ID!) {
  EarningCalculation(id: $id) {
    _id
    offerRedemptionCooldownPeriod
  }
}
    `;

/**
 * __useFeatureEarningCalculationQuery__
 *
 * To run a query within a React component, call `useFeatureEarningCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureEarningCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureEarningCalculationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureEarningCalculationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>(FeatureEarningCalculationDocument, baseOptions);
      }
export function useFeatureEarningCalculationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>(FeatureEarningCalculationDocument, baseOptions);
        }
export type FeatureEarningCalculationQueryHookResult = ReturnType<typeof useFeatureEarningCalculationQuery>;
export type FeatureEarningCalculationLazyQueryHookResult = ReturnType<typeof useFeatureEarningCalculationLazyQuery>;
export type FeatureEarningCalculationQueryResult = ApolloReactCommon.QueryResult<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>;
export const FeatureLoyaltyFeaturedRewardsDocument = gql`
    query featureLoyaltyFeaturedRewards($id: ID!) {
  LoyaltyUI(id: $id) {
    _id
    featuredRewards {
      ...RewardsSectionFragment
    }
  }
}
    ${RewardsSectionFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyFeaturedRewardsQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyFeaturedRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyFeaturedRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyFeaturedRewardsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureLoyaltyFeaturedRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyFeaturedRewardsQuery, IFeatureLoyaltyFeaturedRewardsQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyFeaturedRewardsQuery, IFeatureLoyaltyFeaturedRewardsQueryVariables>(FeatureLoyaltyFeaturedRewardsDocument, baseOptions);
      }
export function useFeatureLoyaltyFeaturedRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyFeaturedRewardsQuery, IFeatureLoyaltyFeaturedRewardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyFeaturedRewardsQuery, IFeatureLoyaltyFeaturedRewardsQueryVariables>(FeatureLoyaltyFeaturedRewardsDocument, baseOptions);
        }
export type FeatureLoyaltyFeaturedRewardsQueryHookResult = ReturnType<typeof useFeatureLoyaltyFeaturedRewardsQuery>;
export type FeatureLoyaltyFeaturedRewardsLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyFeaturedRewardsLazyQuery>;
export type FeatureLoyaltyFeaturedRewardsQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyFeaturedRewardsQuery, IFeatureLoyaltyFeaturedRewardsQueryVariables>;
export const FeatureLoyaltyInRestaurantRedemptionDocument = gql`
    query featureLoyaltyInRestaurantRedemption($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    loyaltyInRestaurantRedemption {
      topWidgets {
        ... on LoyaltyImageWidget {
          ...LoyaltyImageWidgetFragment
        }
        ... on LoyaltyTextWidget {
          ...LoyaltyTextWidgetFragment
        }
        ... on LoyaltyTitleWidget {
          ...LoyaltyTitleWidgetFragment
        }
        ... on LoyaltyPaymentMethodWidget {
          ...LoyaltyPaymentMethodWidgetFragment
        }
        ... on LoyaltyButtonWidget {
          ...LoyaltyButtonWidgetFragment
        }
        ... on LoyaltyMarketingTileGroupWidget {
          _key
          componentKey
          marketingTileGroup {
            ...MarketingTileGroupFragment
          }
        }
        ... on LoyaltyQRScanButtonWidget {
          ...LoyaltyQRScanButtonWidgetFragment
        }
        ... on LoyaltyQRScanHeaderWidget {
          ...LoyaltyQRScanHeaderWidgetFragment
        }
        ... on LoyaltyQRCodeWidget {
          ...LoyaltyQRCodeWidgetFragment
        }
        ... on LoyaltyShortCodeWidget {
          ...LoyaltyShortCodeWidgetFragment
        }
        ... on LoyaltyCartWidget {
          ...LoyaltyCartWidgetFragment
        }
        ... on LoyaltyBasicCardWidget {
          ...LoyaltyBasicCardWidgetFragment
        }
      }
      bottomWidgets {
        ... on LoyaltyImageWidget {
          ...LoyaltyImageWidgetFragment
        }
        ... on LoyaltyTextWidget {
          ...LoyaltyTextWidgetFragment
        }
        ... on LoyaltyTitleWidget {
          ...LoyaltyTitleWidgetFragment
        }
        ... on LoyaltyPaymentMethodWidget {
          ...LoyaltyPaymentMethodWidgetFragment
        }
        ... on LoyaltyButtonWidget {
          ...LoyaltyButtonWidgetFragment
        }
        ... on LoyaltyMarketingTileGroupWidget {
          _key
          componentKey
          marketingTileGroup {
            ...MarketingTileGroupFragment
          }
        }
        ... on LoyaltyQRScanButtonWidget {
          ...LoyaltyQRScanButtonWidgetFragment
        }
        ... on LoyaltyQRScanHeaderWidget {
          ...LoyaltyQRScanHeaderWidgetFragment
        }
        ... on LoyaltyQRCodeWidget {
          ...LoyaltyQRCodeWidgetFragment
        }
        ... on LoyaltyShortCodeWidget {
          ...LoyaltyShortCodeWidgetFragment
        }
        ... on LoyaltyCartWidget {
          ...LoyaltyCartWidgetFragment
        }
        ... on LoyaltyBasicCardWidget {
          ...LoyaltyBasicCardWidgetFragment
        }
      }
    }
  }
}
    ${LoyaltyImageWidgetFragmentFragmentDoc}
${LoyaltyTextWidgetFragmentFragmentDoc}
${LoyaltyTitleWidgetFragmentFragmentDoc}
${LoyaltyPaymentMethodWidgetFragmentFragmentDoc}
${LoyaltyButtonWidgetFragmentFragmentDoc}
${MarketingTileGroupFragmentFragmentDoc}
${LoyaltyQrScanButtonWidgetFragmentFragmentDoc}
${LoyaltyQrScanHeaderWidgetFragmentFragmentDoc}
${LoyaltyQrCodeWidgetFragmentFragmentDoc}
${LoyaltyShortCodeWidgetFragmentFragmentDoc}
${LoyaltyCartWidgetFragmentFragmentDoc}
${LoyaltyBasicCardWidgetFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyInRestaurantRedemptionQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyInRestaurantRedemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyInRestaurantRedemptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyInRestaurantRedemptionQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyInRestaurantRedemptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>(FeatureLoyaltyInRestaurantRedemptionDocument, baseOptions);
      }
export function useFeatureLoyaltyInRestaurantRedemptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>(FeatureLoyaltyInRestaurantRedemptionDocument, baseOptions);
        }
export type FeatureLoyaltyInRestaurantRedemptionQueryHookResult = ReturnType<typeof useFeatureLoyaltyInRestaurantRedemptionQuery>;
export type FeatureLoyaltyInRestaurantRedemptionLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyInRestaurantRedemptionLazyQuery>;
export type FeatureLoyaltyInRestaurantRedemptionQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>;
export const FeatureLoyaltyUiNoRewardDocument = gql`
    query featureLoyaltyUINoReward($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    noRewardPoints {
      ...EmptyStateFragment
    }
  }
}
    ${EmptyStateFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyUiNoRewardQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiNoRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiNoRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiNoRewardQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiNoRewardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>(FeatureLoyaltyUiNoRewardDocument, baseOptions);
      }
export function useFeatureLoyaltyUiNoRewardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>(FeatureLoyaltyUiNoRewardDocument, baseOptions);
        }
export type FeatureLoyaltyUiNoRewardQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNoRewardQuery>;
export type FeatureLoyaltyUiNoRewardLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNoRewardLazyQuery>;
export type FeatureLoyaltyUiNoRewardQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>;
export const FeatureLoyaltyNotAvailableAtThisRestaurantDocument = gql`
    query featureLoyaltyNotAvailableAtThisRestaurant($id: ID!) {
  LoyaltyUI(id: $id) {
    _id
    loyaltyNotAvailableAtThisRestaurant {
      image {
        locale: en {
          ...ImagesFragment
        }
      }
      title {
        locale: en
      }
      description {
        locale: en
      }
      firstButtonText {
        locale: en
      }
      firstRedirectPath {
        locale: en
      }
      secondButtonText {
        locale: en
      }
      secondRedirectPath {
        locale: en
      }
    }
  }
}
    ${ImagesFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyNotAvailableAtThisRestaurantQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyNotAvailableAtThisRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyNotAvailableAtThisRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyNotAvailableAtThisRestaurantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureLoyaltyNotAvailableAtThisRestaurantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>(FeatureLoyaltyNotAvailableAtThisRestaurantDocument, baseOptions);
      }
export function useFeatureLoyaltyNotAvailableAtThisRestaurantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>(FeatureLoyaltyNotAvailableAtThisRestaurantDocument, baseOptions);
        }
export type FeatureLoyaltyNotAvailableAtThisRestaurantQueryHookResult = ReturnType<typeof useFeatureLoyaltyNotAvailableAtThisRestaurantQuery>;
export type FeatureLoyaltyNotAvailableAtThisRestaurantLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyNotAvailableAtThisRestaurantLazyQuery>;
export type FeatureLoyaltyNotAvailableAtThisRestaurantQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>;
export const FeatureLoyaltyUiNotEnrolledDocument = gql`
    query featureLoyaltyUINotEnrolled($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    notEnrolledState {
      ...EmptyStateFragment
    }
    notEnrolledStateMobile {
      ...EmptyStateFragment
    }
  }
}
    ${EmptyStateFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyUiNotEnrolledQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiNotEnrolledQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiNotEnrolledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiNotEnrolledQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiNotEnrolledQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>(FeatureLoyaltyUiNotEnrolledDocument, baseOptions);
      }
export function useFeatureLoyaltyUiNotEnrolledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>(FeatureLoyaltyUiNotEnrolledDocument, baseOptions);
        }
export type FeatureLoyaltyUiNotEnrolledQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNotEnrolledQuery>;
export type FeatureLoyaltyUiNotEnrolledLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNotEnrolledLazyQuery>;
export type FeatureLoyaltyUiNotEnrolledQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>;
export const LoyaltyOffersUiIncentiveNotAvailableDocument = gql`
    query loyaltyOffersUIIncentiveNotAvailable($id: ID!) {
  LoyaltyOffersUI(id: $id) {
    _id
    offerNotAvailableModalContent {
      image {
        locale: en {
          ...ImagesFragment
        }
      }
      title {
        locale: en
      }
      description {
        locale: en
      }
      primaryButton {
        buttonText {
          locale: en
        }
        buttonPath {
          locale: en
        }
      }
      secondaryButton {
        buttonText {
          locale: en
        }
        buttonPath {
          locale: en
        }
      }
    }
    rewardNotAvailableModalContent {
      image {
        locale: en {
          ...ImagesFragment
        }
      }
      title {
        locale: en
      }
      description {
        locale: en
      }
      primaryButton {
        buttonText {
          locale: en
        }
        buttonPath {
          locale: en
        }
      }
      secondaryButton {
        buttonText {
          locale: en
        }
        buttonPath {
          locale: en
        }
      }
    }
  }
}
    ${ImagesFragmentFragmentDoc}`;

/**
 * __useLoyaltyOffersUiIncentiveNotAvailableQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersUiIncentiveNotAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersUiIncentiveNotAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersUiIncentiveNotAvailableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyOffersUiIncentiveNotAvailableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>(LoyaltyOffersUiIncentiveNotAvailableDocument, baseOptions);
      }
export function useLoyaltyOffersUiIncentiveNotAvailableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>(LoyaltyOffersUiIncentiveNotAvailableDocument, baseOptions);
        }
export type LoyaltyOffersUiIncentiveNotAvailableQueryHookResult = ReturnType<typeof useLoyaltyOffersUiIncentiveNotAvailableQuery>;
export type LoyaltyOffersUiIncentiveNotAvailableLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersUiIncentiveNotAvailableLazyQuery>;
export type LoyaltyOffersUiIncentiveNotAvailableQueryResult = ApolloReactCommon.QueryResult<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>;
export const FeatureSortedLoyaltyOffersDocument = gql`
    query featureSortedLoyaltyOffers($id: ID!) {
  LoyaltyOffersUI(id: $id) {
    _id
    sortedSystemwideOffers {
      ...SystemwideOffersFragment
    }
  }
}
    ${SystemwideOffersFragmentFragmentDoc}`;

/**
 * __useFeatureSortedLoyaltyOffersQuery__
 *
 * To run a query within a React component, call `useFeatureSortedLoyaltyOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureSortedLoyaltyOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureSortedLoyaltyOffersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureSortedLoyaltyOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>(FeatureSortedLoyaltyOffersDocument, baseOptions);
      }
export function useFeatureSortedLoyaltyOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>(FeatureSortedLoyaltyOffersDocument, baseOptions);
        }
export type FeatureSortedLoyaltyOffersQueryHookResult = ReturnType<typeof useFeatureSortedLoyaltyOffersQuery>;
export type FeatureSortedLoyaltyOffersLazyQueryHookResult = ReturnType<typeof useFeatureSortedLoyaltyOffersLazyQuery>;
export type FeatureSortedLoyaltyOffersQueryResult = ApolloReactCommon.QueryResult<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>;
export const LoyaltyOffersUiLoggedInDocument = gql`
    query loyaltyOffersUILoggedIn($id: ID!) {
  LoyaltyOffersUI(id: $id) {
    _id
    endOfOffersLoggedIn {
      endOfOffersMessage {
        locale: en
      }
      endOfOffersImage {
        locale: en {
          ...ImageFragment
        }
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useLoyaltyOffersUiLoggedInQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersUiLoggedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersUiLoggedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersUiLoggedInQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyOffersUiLoggedInQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>(LoyaltyOffersUiLoggedInDocument, baseOptions);
      }
export function useLoyaltyOffersUiLoggedInLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>(LoyaltyOffersUiLoggedInDocument, baseOptions);
        }
export type LoyaltyOffersUiLoggedInQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedInQuery>;
export type LoyaltyOffersUiLoggedInLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedInLazyQuery>;
export type LoyaltyOffersUiLoggedInQueryResult = ApolloReactCommon.QueryResult<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>;
export const LoyaltyOffersUiLoggedOutDocument = gql`
    query loyaltyOffersUILoggedOut($id: ID!) {
  LoyaltyOffersUI(id: $id) {
    _id
    endOfOffersLoggedOut {
      title {
        locale: en
      }
      body {
        locale: en
      }
      ctaButtonText {
        locale: en
      }
      link {
        locale: en
      }
    }
  }
}
    `;

/**
 * __useLoyaltyOffersUiLoggedOutQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersUiLoggedOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersUiLoggedOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersUiLoggedOutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyOffersUiLoggedOutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>(LoyaltyOffersUiLoggedOutDocument, baseOptions);
      }
export function useLoyaltyOffersUiLoggedOutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>(LoyaltyOffersUiLoggedOutDocument, baseOptions);
        }
export type LoyaltyOffersUiLoggedOutQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedOutQuery>;
export type LoyaltyOffersUiLoggedOutLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedOutLazyQuery>;
export type LoyaltyOffersUiLoggedOutQueryResult = ApolloReactCommon.QueryResult<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>;
export const LoyaltyOffersUiCooldownContentDocument = gql`
    query loyaltyOffersUICooldownContent($id: ID!) {
  LoyaltyOffersUI(id: $id) {
    _id
    globalOfferCooldownContent {
      title {
        locale: en
      }
      image {
        locale: en {
          ...ImageFragment
        }
      }
      description {
        localeRaw: en
      }
      actionButton {
        buttonText {
          locale: en
        }
        buttonPath {
          locale: en
        }
      }
      terms {
        localeRaw: enRaw
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useLoyaltyOffersUiCooldownContentQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersUiCooldownContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersUiCooldownContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersUiCooldownContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyOffersUiCooldownContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>(LoyaltyOffersUiCooldownContentDocument, baseOptions);
      }
export function useLoyaltyOffersUiCooldownContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>(LoyaltyOffersUiCooldownContentDocument, baseOptions);
        }
export type LoyaltyOffersUiCooldownContentQueryHookResult = ReturnType<typeof useLoyaltyOffersUiCooldownContentQuery>;
export type LoyaltyOffersUiCooldownContentLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersUiCooldownContentLazyQuery>;
export type LoyaltyOffersUiCooldownContentQueryResult = ApolloReactCommon.QueryResult<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>;
export const FeatureLoyaltyOffersDocument = gql`
    query featureLoyaltyOffers {
  allSystemwideOffers {
    ...SystemwideOffersFragment
  }
}
    ${SystemwideOffersFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyOffersQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureLoyaltyOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyOffersQuery, IFeatureLoyaltyOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyOffersQuery, IFeatureLoyaltyOffersQueryVariables>(FeatureLoyaltyOffersDocument, baseOptions);
      }
export function useFeatureLoyaltyOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyOffersQuery, IFeatureLoyaltyOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyOffersQuery, IFeatureLoyaltyOffersQueryVariables>(FeatureLoyaltyOffersDocument, baseOptions);
        }
export type FeatureLoyaltyOffersQueryHookResult = ReturnType<typeof useFeatureLoyaltyOffersQuery>;
export type FeatureLoyaltyOffersLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyOffersLazyQuery>;
export type FeatureLoyaltyOffersQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyOffersQuery, IFeatureLoyaltyOffersQueryVariables>;
export const LoyaltySystemwideOffersByEngineIdDocument = gql`
    query LoyaltySystemwideOffersByEngineId($ids: [String!]!) {
  allSystemwideOffers(where: {loyaltyEngineId_in: $ids}) {
    ...SystemwideOffersFragment
  }
}
    ${SystemwideOffersFragmentFragmentDoc}`;

/**
 * __useLoyaltySystemwideOffersByEngineIdQuery__
 *
 * To run a query within a React component, call `useLoyaltySystemwideOffersByEngineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltySystemwideOffersByEngineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltySystemwideOffersByEngineIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltySystemwideOffersByEngineIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltySystemwideOffersByEngineIdQuery, ILoyaltySystemwideOffersByEngineIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltySystemwideOffersByEngineIdQuery, ILoyaltySystemwideOffersByEngineIdQueryVariables>(LoyaltySystemwideOffersByEngineIdDocument, baseOptions);
      }
export function useLoyaltySystemwideOffersByEngineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltySystemwideOffersByEngineIdQuery, ILoyaltySystemwideOffersByEngineIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltySystemwideOffersByEngineIdQuery, ILoyaltySystemwideOffersByEngineIdQueryVariables>(LoyaltySystemwideOffersByEngineIdDocument, baseOptions);
        }
export type LoyaltySystemwideOffersByEngineIdQueryHookResult = ReturnType<typeof useLoyaltySystemwideOffersByEngineIdQuery>;
export type LoyaltySystemwideOffersByEngineIdLazyQueryHookResult = ReturnType<typeof useLoyaltySystemwideOffersByEngineIdLazyQuery>;
export type LoyaltySystemwideOffersByEngineIdQueryResult = ApolloReactCommon.QueryResult<ILoyaltySystemwideOffersByEngineIdQuery, ILoyaltySystemwideOffersByEngineIdQueryVariables>;
export const LoyaltySystemwideOffersByIdsDocument = gql`
    query LoyaltySystemwideOffersByIds($ids: [String!]!) {
  allSystemwideOffers(where: {_id_in: $ids}) {
    ...SystemwideOffersFragment
  }
}
    ${SystemwideOffersFragmentFragmentDoc}`;

/**
 * __useLoyaltySystemwideOffersByIdsQuery__
 *
 * To run a query within a React component, call `useLoyaltySystemwideOffersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltySystemwideOffersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltySystemwideOffersByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltySystemwideOffersByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>(LoyaltySystemwideOffersByIdsDocument, baseOptions);
      }
export function useLoyaltySystemwideOffersByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>(LoyaltySystemwideOffersByIdsDocument, baseOptions);
        }
export type LoyaltySystemwideOffersByIdsQueryHookResult = ReturnType<typeof useLoyaltySystemwideOffersByIdsQuery>;
export type LoyaltySystemwideOffersByIdsLazyQueryHookResult = ReturnType<typeof useLoyaltySystemwideOffersByIdsLazyQuery>;
export type LoyaltySystemwideOffersByIdsQueryResult = ApolloReactCommon.QueryResult<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>;
export const LoyaltyOfferConfigsDocument = gql`
    query LoyaltyOfferConfigs($ids: [String!]!) {
  allConfigOffers(where: {loyaltyEngineId_in: $ids}) {
    ...ConfigOfferFragment
  }
}
    ${ConfigOfferFragmentFragmentDoc}`;

/**
 * __useLoyaltyOfferConfigsQuery__
 *
 * To run a query within a React component, call `useLoyaltyOfferConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOfferConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOfferConfigsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltyOfferConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>(LoyaltyOfferConfigsDocument, baseOptions);
      }
export function useLoyaltyOfferConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>(LoyaltyOfferConfigsDocument, baseOptions);
        }
export type LoyaltyOfferConfigsQueryHookResult = ReturnType<typeof useLoyaltyOfferConfigsQuery>;
export type LoyaltyOfferConfigsLazyQueryHookResult = ReturnType<typeof useLoyaltyOfferConfigsLazyQuery>;
export type LoyaltyOfferConfigsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>;
export const LoyaltyOfferTemplatesDocument = gql`
    query LoyaltyOfferTemplates($ids: [String!]!) {
  allOfferTemplates(where: {loyaltyEngineId_in: $ids}) {
    ...LoyaltyOfferTemplate
  }
}
    ${LoyaltyOfferTemplateFragmentDoc}`;

/**
 * __useLoyaltyOfferTemplatesQuery__
 *
 * To run a query within a React component, call `useLoyaltyOfferTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOfferTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOfferTemplatesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltyOfferTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>(LoyaltyOfferTemplatesDocument, baseOptions);
      }
export function useLoyaltyOfferTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>(LoyaltyOfferTemplatesDocument, baseOptions);
        }
export type LoyaltyOfferTemplatesQueryHookResult = ReturnType<typeof useLoyaltyOfferTemplatesQuery>;
export type LoyaltyOfferTemplatesLazyQueryHookResult = ReturnType<typeof useLoyaltyOfferTemplatesLazyQuery>;
export type LoyaltyOfferTemplatesQueryResult = ApolloReactCommon.QueryResult<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>;
export const FeatureLoyaltyUiOptInModalDocument = gql`
    query featureLoyaltyUIOptInModal($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    optInModal {
      ...OptInModalFragment
    }
    optInModalError {
      ...OptInModalFragment
    }
    optInModalLoading {
      title {
        locale: en
      }
      description {
        locale: en
      }
    }
  }
}
    ${OptInModalFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyUiOptInModalQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiOptInModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiOptInModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiOptInModalQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiOptInModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>(FeatureLoyaltyUiOptInModalDocument, baseOptions);
      }
export function useFeatureLoyaltyUiOptInModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>(FeatureLoyaltyUiOptInModalDocument, baseOptions);
        }
export type FeatureLoyaltyUiOptInModalQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiOptInModalQuery>;
export type FeatureLoyaltyUiOptInModalLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiOptInModalLazyQuery>;
export type FeatureLoyaltyUiOptInModalQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>;
export const FeatureLoyaltyRewardListCategoriesOnlyDocument = gql`
    query featureLoyaltyRewardListCategoriesOnly($featureLoyaltyRewardListCategoriesId: ID!) {
  RewardList(id: $featureLoyaltyRewardListCategoriesId) {
    _id
    rewardCategories {
      _id
      label {
        en
      }
    }
  }
}
    `;

/**
 * __useFeatureLoyaltyRewardListCategoriesOnlyQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyRewardListCategoriesOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyRewardListCategoriesOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyRewardListCategoriesOnlyQuery({
 *   variables: {
 *      featureLoyaltyRewardListCategoriesId: // value for 'featureLoyaltyRewardListCategoriesId'
 *   },
 * });
 */
export function useFeatureLoyaltyRewardListCategoriesOnlyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyRewardListCategoriesOnlyQuery, IFeatureLoyaltyRewardListCategoriesOnlyQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyRewardListCategoriesOnlyQuery, IFeatureLoyaltyRewardListCategoriesOnlyQueryVariables>(FeatureLoyaltyRewardListCategoriesOnlyDocument, baseOptions);
      }
export function useFeatureLoyaltyRewardListCategoriesOnlyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyRewardListCategoriesOnlyQuery, IFeatureLoyaltyRewardListCategoriesOnlyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyRewardListCategoriesOnlyQuery, IFeatureLoyaltyRewardListCategoriesOnlyQueryVariables>(FeatureLoyaltyRewardListCategoriesOnlyDocument, baseOptions);
        }
export type FeatureLoyaltyRewardListCategoriesOnlyQueryHookResult = ReturnType<typeof useFeatureLoyaltyRewardListCategoriesOnlyQuery>;
export type FeatureLoyaltyRewardListCategoriesOnlyLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyRewardListCategoriesOnlyLazyQuery>;
export type FeatureLoyaltyRewardListCategoriesOnlyQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyRewardListCategoriesOnlyQuery, IFeatureLoyaltyRewardListCategoriesOnlyQueryVariables>;
export const FeatureLoyaltyRewardListCategoriesDocument = gql`
    query featureLoyaltyRewardListCategories($featureLoyaltyRewardListCategoriesId: ID!) {
  RewardList(id: $featureLoyaltyRewardListCategoriesId) {
    _id
    rewardCategories {
      label {
        en
      }
      image {
        locale: en {
          ...ImageFragment
        }
      }
      imageDescription {
        locale: en
      }
      rewards {
        _id
        loyaltyEngineId
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyRewardListCategoriesQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyRewardListCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyRewardListCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyRewardListCategoriesQuery({
 *   variables: {
 *      featureLoyaltyRewardListCategoriesId: // value for 'featureLoyaltyRewardListCategoriesId'
 *   },
 * });
 */
export function useFeatureLoyaltyRewardListCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>(FeatureLoyaltyRewardListCategoriesDocument, baseOptions);
      }
export function useFeatureLoyaltyRewardListCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>(FeatureLoyaltyRewardListCategoriesDocument, baseOptions);
        }
export type FeatureLoyaltyRewardListCategoriesQueryHookResult = ReturnType<typeof useFeatureLoyaltyRewardListCategoriesQuery>;
export type FeatureLoyaltyRewardListCategoriesLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyRewardListCategoriesLazyQuery>;
export type FeatureLoyaltyRewardListCategoriesQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>;
export const FeatureLoyaltyShortCodeConfirmationModalDocument = gql`
    query featureLoyaltyShortCodeConfirmationModal($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    shortCodeConfirmationModalContent {
      ...ShortCodeConfirmationModalFragment
    }
  }
}
    ${ShortCodeConfirmationModalFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyShortCodeConfirmationModalQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyShortCodeConfirmationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyShortCodeConfirmationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyShortCodeConfirmationModalQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyShortCodeConfirmationModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>(FeatureLoyaltyShortCodeConfirmationModalDocument, baseOptions);
      }
export function useFeatureLoyaltyShortCodeConfirmationModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>(FeatureLoyaltyShortCodeConfirmationModalDocument, baseOptions);
        }
export type FeatureLoyaltyShortCodeConfirmationModalQueryHookResult = ReturnType<typeof useFeatureLoyaltyShortCodeConfirmationModalQuery>;
export type FeatureLoyaltyShortCodeConfirmationModalLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyShortCodeConfirmationModalLazyQuery>;
export type FeatureLoyaltyShortCodeConfirmationModalQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>;
export const FeatureLoyaltyOverrideShortCodeModalContentDocument = gql`
    query featureLoyaltyOverrideShortCodeModalContent($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    overrideShortCodeModalContent {
      header {
        ...LocaleStringFragment
      }
      body {
        ...LocaleStringFragment
      }
      confirmButton {
        ...LocaleStringFragment
      }
      discardButton {
        ...LocaleStringFragment
      }
    }
  }
}
    ${LocaleStringFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyOverrideShortCodeModalContentQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyOverrideShortCodeModalContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyOverrideShortCodeModalContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyOverrideShortCodeModalContentQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyOverrideShortCodeModalContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>(FeatureLoyaltyOverrideShortCodeModalContentDocument, baseOptions);
      }
export function useFeatureLoyaltyOverrideShortCodeModalContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>(FeatureLoyaltyOverrideShortCodeModalContentDocument, baseOptions);
        }
export type FeatureLoyaltyOverrideShortCodeModalContentQueryHookResult = ReturnType<typeof useFeatureLoyaltyOverrideShortCodeModalContentQuery>;
export type FeatureLoyaltyOverrideShortCodeModalContentLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyOverrideShortCodeModalContentLazyQuery>;
export type FeatureLoyaltyOverrideShortCodeModalContentQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>;
export const FeatureLoyaltySurpriseModalDocument = gql`
    query featureLoyaltySurpriseModal($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    surpriseAndDelightModalContent {
      backgroundImage {
        locale: en {
          ...ImageFragment
        }
      }
      buttonText {
        locale: en
      }
      description {
        locale: en
      }
      noThanksText {
        locale: en
      }
      prompt {
        locale: en
      }
      termsText {
        localeRaw: enRaw
      }
      title {
        locale: en
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltySurpriseModalQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltySurpriseModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltySurpriseModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltySurpriseModalQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltySurpriseModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>(FeatureLoyaltySurpriseModalDocument, baseOptions);
      }
export function useFeatureLoyaltySurpriseModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>(FeatureLoyaltySurpriseModalDocument, baseOptions);
        }
export type FeatureLoyaltySurpriseModalQueryHookResult = ReturnType<typeof useFeatureLoyaltySurpriseModalQuery>;
export type FeatureLoyaltySurpriseModalLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltySurpriseModalLazyQuery>;
export type FeatureLoyaltySurpriseModalQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>;
export const FeatureLoyaltyUiDocument = gql`
    query featureLoyaltyUI($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    rewardsLogo {
      locale: en {
        ...ImageFragment
      }
    }
    rewardsLearnMoreIcon {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyUiQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiQuery, IFeatureLoyaltyUiQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiQuery, IFeatureLoyaltyUiQueryVariables>(FeatureLoyaltyUiDocument, baseOptions);
      }
export function useFeatureLoyaltyUiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiQuery, IFeatureLoyaltyUiQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiQuery, IFeatureLoyaltyUiQueryVariables>(FeatureLoyaltyUiDocument, baseOptions);
        }
export type FeatureLoyaltyUiQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiQuery>;
export type FeatureLoyaltyUiLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiLazyQuery>;
export type FeatureLoyaltyUiQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyUiQuery, IFeatureLoyaltyUiQueryVariables>;
export const FeatureMenuDocument = gql`
    query featureMenu($featureMenuId: ID!) {
  FeatureMenu(id: $featureMenuId) {
    _id
    menuHeroImage {
      locale: en {
        ...ImageFragment
      }
    }
    menuHeroText {
      locale: en
    }
    dayParts {
      key
      endTime
      startTime
      weekDays {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      displayName {
        locale: en
      }
      icon {
        ...ImageFragment
      }
    }
    defaultMenu {
      _id
    }
    cateringMenu {
      _id
    }
    donationTermAndConditionUrl {
      locale: en
    }
    donationItemsAtCheckout {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: enRaw
        }
        vendorConfigs {
          ...VendorConfigsFragment
        }
      }
    }
    upsellItemsAtCheckoutRestaurant {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: enRaw
        }
        vendorConfigs {
          ...VendorConfigsFragment
        }
      }
    }
    upsellItemsAtCheckoutDelivery {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: enRaw
        }
        vendorConfigs {
          ...VendorConfigsFragment
        }
      }
    }
    upsellItemsAtCheckoutCatering {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: enRaw
        }
        vendorConfigs {
          ...VendorConfigsFragment
        }
      }
    }
    cartAddOnSections {
      ...AddOnSectionFragment
    }
    cartAddOnSectionsCatering {
      ...AddOnSectionFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}
${AddOnSectionFragmentFragmentDoc}`;

/**
 * __useFeatureMenuQuery__
 *
 * To run a query within a React component, call `useFeatureMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureMenuQuery({
 *   variables: {
 *      featureMenuId: // value for 'featureMenuId'
 *   },
 * });
 */
export function useFeatureMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureMenuQuery, IFeatureMenuQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureMenuQuery, IFeatureMenuQueryVariables>(FeatureMenuDocument, baseOptions);
      }
export function useFeatureMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureMenuQuery, IFeatureMenuQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureMenuQuery, IFeatureMenuQueryVariables>(FeatureMenuDocument, baseOptions);
        }
export type FeatureMenuQueryHookResult = ReturnType<typeof useFeatureMenuQuery>;
export type FeatureMenuLazyQueryHookResult = ReturnType<typeof useFeatureMenuLazyQuery>;
export type FeatureMenuQueryResult = ApolloReactCommon.QueryResult<IFeatureMenuQuery, IFeatureMenuQueryVariables>;
export const FeatureNavigationDocument = gql`
    query featureNavigation($featureNavigationId: ID!) {
  FeatureNavigation(id: $featureNavigationId) {
    ...NavigationDesktopFragment
    ...NavigationMobileFragment
    ...NavigationButtonFragment
    aboutMenuEntries {
      ...NavigationSectionFragment
    }
  }
}
    ${NavigationDesktopFragmentFragmentDoc}
${NavigationMobileFragmentFragmentDoc}
${NavigationButtonFragmentFragmentDoc}
${NavigationSectionFragmentFragmentDoc}`;

/**
 * __useFeatureNavigationQuery__
 *
 * To run a query within a React component, call `useFeatureNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureNavigationQuery({
 *   variables: {
 *      featureNavigationId: // value for 'featureNavigationId'
 *   },
 * });
 */
export function useFeatureNavigationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>(FeatureNavigationDocument, baseOptions);
      }
export function useFeatureNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>(FeatureNavigationDocument, baseOptions);
        }
export type FeatureNavigationQueryHookResult = ReturnType<typeof useFeatureNavigationQuery>;
export type FeatureNavigationLazyQueryHookResult = ReturnType<typeof useFeatureNavigationLazyQuery>;
export type FeatureNavigationQueryResult = ApolloReactCommon.QueryResult<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>;
export const FeatureNutritionDocument = gql`
    query featureNutrition($featureNutritionId: ID!) {
  FeatureNutrition(id: $featureNutritionId) {
    _id
    nutritionTables {
      ...NutritionTableFragment
    }
    roundingRules {
      ...RoundingRulesFragment
    }
  }
}
    ${NutritionTableFragmentFragmentDoc}
${RoundingRulesFragmentFragmentDoc}`;

/**
 * __useFeatureNutritionQuery__
 *
 * To run a query within a React component, call `useFeatureNutritionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureNutritionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureNutritionQuery({
 *   variables: {
 *      featureNutritionId: // value for 'featureNutritionId'
 *   },
 * });
 */
export function useFeatureNutritionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>(FeatureNutritionDocument, baseOptions);
      }
export function useFeatureNutritionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>(FeatureNutritionDocument, baseOptions);
        }
export type FeatureNutritionQueryHookResult = ReturnType<typeof useFeatureNutritionQuery>;
export type FeatureNutritionLazyQueryHookResult = ReturnType<typeof useFeatureNutritionLazyQuery>;
export type FeatureNutritionQueryResult = ApolloReactCommon.QueryResult<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>;
export const FeatureOffersDocument = gql`
    query featureOffers($featureOffersId: ID!) {
  FeatureOffers(id: $featureOffersId) {
    offersBrowsingPanel {
      endOfOffersMessage {
        locale: en
      }
      endOfOffersImage {
        locale: en {
          ...ImageFragment
        }
      }
      emptyStateTitle {
        locale: en
      }
      emptyStateBody {
        locale: en
      }
      emptyStateImage {
        locale: en {
          ...ImageFragment
        }
      }
      ...OffersSelectRestaurantCtaFragment
    }
    offersDetailsPanel {
      emptyStateTitle {
        locale: en
      }
      emptyStateBody {
        locale: en
      }
      emptyStateImage {
        locale: en {
          ...ImageFragment
        }
      }
      emptyStateAction {
        actionText {
          locale: en
        }
        route
      }
      missingOfferTitle {
        locale: en
      }
      missingOfferBody {
        locale: en
      }
      missingOfferImage {
        locale: en {
          ...ImageFragment
        }
      }
      missingOfferAction {
        actionText {
          locale: en
        }
        route
      }
    }
    defaultBackgroundImage {
      ...ImageFragment
    }
    offersPageMarketingTiles {
      ...OffersPageMarketingTileFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}
${OffersSelectRestaurantCtaFragmentFragmentDoc}
${OffersPageMarketingTileFragmentFragmentDoc}`;

/**
 * __useFeatureOffersQuery__
 *
 * To run a query within a React component, call `useFeatureOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureOffersQuery({
 *   variables: {
 *      featureOffersId: // value for 'featureOffersId'
 *   },
 * });
 */
export function useFeatureOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureOffersQuery, IFeatureOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureOffersQuery, IFeatureOffersQueryVariables>(FeatureOffersDocument, baseOptions);
      }
export function useFeatureOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureOffersQuery, IFeatureOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureOffersQuery, IFeatureOffersQueryVariables>(FeatureOffersDocument, baseOptions);
        }
export type FeatureOffersQueryHookResult = ReturnType<typeof useFeatureOffersQuery>;
export type FeatureOffersLazyQueryHookResult = ReturnType<typeof useFeatureOffersLazyQuery>;
export type FeatureOffersQueryResult = ApolloReactCommon.QueryResult<IFeatureOffersQuery, IFeatureOffersQueryVariables>;
export const FeatureOnboardingDocument = gql`
    query FeatureOnboarding {
  allFeatureOnboardings {
    _id
    channel
    triggerRule
    screens {
      ...OnboardingScreenFragment
    }
  }
}
    ${OnboardingScreenFragmentFragmentDoc}`;

/**
 * __useFeatureOnboardingQuery__
 *
 * To run a query within a React component, call `useFeatureOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureOnboardingQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureOnboardingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureOnboardingQuery, IFeatureOnboardingQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureOnboardingQuery, IFeatureOnboardingQueryVariables>(FeatureOnboardingDocument, baseOptions);
      }
export function useFeatureOnboardingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureOnboardingQuery, IFeatureOnboardingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureOnboardingQuery, IFeatureOnboardingQueryVariables>(FeatureOnboardingDocument, baseOptions);
        }
export type FeatureOnboardingQueryHookResult = ReturnType<typeof useFeatureOnboardingQuery>;
export type FeatureOnboardingLazyQueryHookResult = ReturnType<typeof useFeatureOnboardingLazyQuery>;
export type FeatureOnboardingQueryResult = ApolloReactCommon.QueryResult<IFeatureOnboardingQuery, IFeatureOnboardingQueryVariables>;
export const FeaturePaybackDocument = gql`
    query featurePayback($featurePaybackId: ID!) {
  FeaturePayback(id: $featurePaybackId) {
    paybackMainImage {
      locale: en {
        ...ImageFragment
      }
    }
    paybackLogoImage {
      locale: en {
        ...ImageFragment
      }
    }
    paybackLogoSmallImage {
      locale: en {
        ...ImageFragment
      }
    }
    paybackTitle {
      locale: en
    }
    paybackDescription {
      locale: enRaw
    }
    paybackLinkCardButtonText {
      locale: en
    }
    paybackNeedHelpButtonText {
      locale: en
    }
    paybackRefreshPointsButtonText {
      locale: en
    }
    paybackLoginUrl
    paybackPartnerID
    paybackRedirectUrl
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeaturePaybackQuery__
 *
 * To run a query within a React component, call `useFeaturePaybackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturePaybackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturePaybackQuery({
 *   variables: {
 *      featurePaybackId: // value for 'featurePaybackId'
 *   },
 * });
 */
export function useFeaturePaybackQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeaturePaybackQuery, IFeaturePaybackQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeaturePaybackQuery, IFeaturePaybackQueryVariables>(FeaturePaybackDocument, baseOptions);
      }
export function useFeaturePaybackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeaturePaybackQuery, IFeaturePaybackQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeaturePaybackQuery, IFeaturePaybackQueryVariables>(FeaturePaybackDocument, baseOptions);
        }
export type FeaturePaybackQueryHookResult = ReturnType<typeof useFeaturePaybackQuery>;
export type FeaturePaybackLazyQueryHookResult = ReturnType<typeof useFeaturePaybackLazyQuery>;
export type FeaturePaybackQueryResult = ApolloReactCommon.QueryResult<IFeaturePaybackQuery, IFeaturePaybackQueryVariables>;
export const FeatureQuizDocument = gql`
    query FeatureQuiz($quizId: ID!) {
  FeatureQuiz(id: $quizId) {
    description {
      en
    }
    introPageBackground {
      ...ImageFragment
    }
    questionPageBackground {
      ...ImageFragment
    }
    resultPageBackground {
      ...ImageFragment
    }
    questions {
      _id
      text {
        en
      }
      responses {
        _id
        text {
          en
        }
        image {
          en {
            ...ImageFragment
          }
        }
        resultsValuesDetails {
          result {
            _id
            prefix {
              en
            }
            text {
              en
            }
          }
          value
        }
      }
    }
    results {
      _id
      text {
        en
      }
      image {
        en {
          ...ImageFragment
        }
      }
      description {
        en
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureQuizQuery__
 *
 * To run a query within a React component, call `useFeatureQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureQuizQuery({
 *   variables: {
 *      quizId: // value for 'quizId'
 *   },
 * });
 */
export function useFeatureQuizQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureQuizQuery, IFeatureQuizQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureQuizQuery, IFeatureQuizQueryVariables>(FeatureQuizDocument, baseOptions);
      }
export function useFeatureQuizLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureQuizQuery, IFeatureQuizQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureQuizQuery, IFeatureQuizQueryVariables>(FeatureQuizDocument, baseOptions);
        }
export type FeatureQuizQueryHookResult = ReturnType<typeof useFeatureQuizQuery>;
export type FeatureQuizLazyQueryHookResult = ReturnType<typeof useFeatureQuizLazyQuery>;
export type FeatureQuizQueryResult = ApolloReactCommon.QueryResult<IFeatureQuizQuery, IFeatureQuizQueryVariables>;
export const GetFeatureScanAndPayDocument = gql`
    query GetFeatureScanAndPay($featureScanAndPayId: ID!) {
  FeatureScanAndPay(id: $featureScanAndPayId) {
    _id
    header {
      locale: en
    }
    inactiveStateText {
      locale: enRaw
    }
    addNewPaymentMethodStateText {
      locale: enRaw
    }
    ...PaymentMethodDeletionModalTextFragment
  }
}
    ${PaymentMethodDeletionModalTextFragmentFragmentDoc}`;

/**
 * __useGetFeatureScanAndPayQuery__
 *
 * To run a query within a React component, call `useGetFeatureScanAndPayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureScanAndPayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureScanAndPayQuery({
 *   variables: {
 *      featureScanAndPayId: // value for 'featureScanAndPayId'
 *   },
 * });
 */
export function useGetFeatureScanAndPayQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetFeatureScanAndPayQuery, IGetFeatureScanAndPayQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetFeatureScanAndPayQuery, IGetFeatureScanAndPayQueryVariables>(GetFeatureScanAndPayDocument, baseOptions);
      }
export function useGetFeatureScanAndPayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetFeatureScanAndPayQuery, IGetFeatureScanAndPayQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetFeatureScanAndPayQuery, IGetFeatureScanAndPayQueryVariables>(GetFeatureScanAndPayDocument, baseOptions);
        }
export type GetFeatureScanAndPayQueryHookResult = ReturnType<typeof useGetFeatureScanAndPayQuery>;
export type GetFeatureScanAndPayLazyQueryHookResult = ReturnType<typeof useGetFeatureScanAndPayLazyQuery>;
export type GetFeatureScanAndPayQueryResult = ApolloReactCommon.QueryResult<IGetFeatureScanAndPayQuery, IGetFeatureScanAndPayQueryVariables>;
export const FeatureStaticMenuDocument = gql`
    query featureStaticMenu($featureStaticMenuId: ID!) {
  FeatureStaticMenu(id: $featureStaticMenuId) {
    ...itemUnavailableModalFragment
  }
}
    ${ItemUnavailableModalFragmentFragmentDoc}`;

/**
 * __useFeatureStaticMenuQuery__
 *
 * To run a query within a React component, call `useFeatureStaticMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureStaticMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureStaticMenuQuery({
 *   variables: {
 *      featureStaticMenuId: // value for 'featureStaticMenuId'
 *   },
 * });
 */
export function useFeatureStaticMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>(FeatureStaticMenuDocument, baseOptions);
      }
export function useFeatureStaticMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>(FeatureStaticMenuDocument, baseOptions);
        }
export type FeatureStaticMenuQueryHookResult = ReturnType<typeof useFeatureStaticMenuQuery>;
export type FeatureStaticMenuLazyQueryHookResult = ReturnType<typeof useFeatureStaticMenuLazyQuery>;
export type FeatureStaticMenuQueryResult = ApolloReactCommon.QueryResult<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>;
export const GetItemDocument = gql`
    query GetItem($id: ID!) {
  Item(id: $id) {
    ...ItemFragment
  }
}
    ${ItemFragmentFragmentDoc}`;

/**
 * __useGetItemQuery__
 *
 * To run a query within a React component, call `useGetItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItemQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetItemQuery, IGetItemQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetItemQuery, IGetItemQueryVariables>(GetItemDocument, baseOptions);
      }
export function useGetItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetItemQuery, IGetItemQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetItemQuery, IGetItemQueryVariables>(GetItemDocument, baseOptions);
        }
export type GetItemQueryHookResult = ReturnType<typeof useGetItemQuery>;
export type GetItemLazyQueryHookResult = ReturnType<typeof useGetItemLazyQuery>;
export type GetItemQueryResult = ApolloReactCommon.QueryResult<IGetItemQuery, IGetItemQueryVariables>;
export const GetItemWithVendorConfigDocument = gql`
    query GetItemWithVendorConfig($id: ID!) {
  Item(id: $id) {
    ...ItemFragment
    vendorConfigs {
      ...VendorConfigsFragment
    }
  }
}
    ${ItemFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}`;

/**
 * __useGetItemWithVendorConfigQuery__
 *
 * To run a query within a React component, call `useGetItemWithVendorConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemWithVendorConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemWithVendorConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItemWithVendorConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetItemWithVendorConfigQuery, IGetItemWithVendorConfigQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetItemWithVendorConfigQuery, IGetItemWithVendorConfigQueryVariables>(GetItemWithVendorConfigDocument, baseOptions);
      }
export function useGetItemWithVendorConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetItemWithVendorConfigQuery, IGetItemWithVendorConfigQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetItemWithVendorConfigQuery, IGetItemWithVendorConfigQueryVariables>(GetItemWithVendorConfigDocument, baseOptions);
        }
export type GetItemWithVendorConfigQueryHookResult = ReturnType<typeof useGetItemWithVendorConfigQuery>;
export type GetItemWithVendorConfigLazyQueryHookResult = ReturnType<typeof useGetItemWithVendorConfigLazyQuery>;
export type GetItemWithVendorConfigQueryResult = ApolloReactCommon.QueryResult<IGetItemWithVendorConfigQuery, IGetItemWithVendorConfigQueryVariables>;
export const GetItemAvailabilityDocument = gql`
    query GetItemAvailability($id: ID!) {
  Item(id: $id) {
    ...ItemAvailabilityFragment
  }
}
    ${ItemAvailabilityFragmentFragmentDoc}`;

/**
 * __useGetItemAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetItemAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItemAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetItemAvailabilityQuery, IGetItemAvailabilityQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetItemAvailabilityQuery, IGetItemAvailabilityQueryVariables>(GetItemAvailabilityDocument, baseOptions);
      }
export function useGetItemAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetItemAvailabilityQuery, IGetItemAvailabilityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetItemAvailabilityQuery, IGetItemAvailabilityQueryVariables>(GetItemAvailabilityDocument, baseOptions);
        }
export type GetItemAvailabilityQueryHookResult = ReturnType<typeof useGetItemAvailabilityQuery>;
export type GetItemAvailabilityLazyQueryHookResult = ReturnType<typeof useGetItemAvailabilityLazyQuery>;
export type GetItemAvailabilityQueryResult = ApolloReactCommon.QueryResult<IGetItemAvailabilityQuery, IGetItemAvailabilityQueryVariables>;
export const SingleLoyaltyContentDocument = gql`
    query singleLoyaltyContent {
  allLoyaltyContents(limit: 1) {
    _id
  }
}
    `;

/**
 * __useSingleLoyaltyContentQuery__
 *
 * To run a query within a React component, call `useSingleLoyaltyContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleLoyaltyContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleLoyaltyContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSingleLoyaltyContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>) {
        return ApolloReactHooks.useQuery<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>(SingleLoyaltyContentDocument, baseOptions);
      }
export function useSingleLoyaltyContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>(SingleLoyaltyContentDocument, baseOptions);
        }
export type SingleLoyaltyContentQueryHookResult = ReturnType<typeof useSingleLoyaltyContentQuery>;
export type SingleLoyaltyContentLazyQueryHookResult = ReturnType<typeof useSingleLoyaltyContentLazyQuery>;
export type SingleLoyaltyContentQueryResult = ApolloReactCommon.QueryResult<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>;
export const BirthdayLegalTextDocument = gql`
    query birthdayLegalText($loyaltyContentId: ID!) {
  LoyaltyContent(id: $loyaltyContentId) {
    birthdayLegalText {
      locale: en
    }
  }
}
    `;

/**
 * __useBirthdayLegalTextQuery__
 *
 * To run a query within a React component, call `useBirthdayLegalTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useBirthdayLegalTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBirthdayLegalTextQuery({
 *   variables: {
 *      loyaltyContentId: // value for 'loyaltyContentId'
 *   },
 * });
 */
export function useBirthdayLegalTextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>) {
        return ApolloReactHooks.useQuery<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>(BirthdayLegalTextDocument, baseOptions);
      }
export function useBirthdayLegalTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>(BirthdayLegalTextDocument, baseOptions);
        }
export type BirthdayLegalTextQueryHookResult = ReturnType<typeof useBirthdayLegalTextQuery>;
export type BirthdayLegalTextLazyQueryHookResult = ReturnType<typeof useBirthdayLegalTextLazyQuery>;
export type BirthdayLegalTextQueryResult = ApolloReactCommon.QueryResult<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>;
export const SystemwidePromotionMessageDocument = gql`
    query systemwidePromotionMessage($id: ID!) {
  SystemwidePromotion(id: $id) {
    promoMessage {
      locale: en
    }
  }
}
    `;

/**
 * __useSystemwidePromotionMessageQuery__
 *
 * To run a query within a React component, call `useSystemwidePromotionMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemwidePromotionMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemwidePromotionMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemwidePromotionMessageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISystemwidePromotionMessageQuery, ISystemwidePromotionMessageQueryVariables>) {
        return ApolloReactHooks.useQuery<ISystemwidePromotionMessageQuery, ISystemwidePromotionMessageQueryVariables>(SystemwidePromotionMessageDocument, baseOptions);
      }
export function useSystemwidePromotionMessageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISystemwidePromotionMessageQuery, ISystemwidePromotionMessageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISystemwidePromotionMessageQuery, ISystemwidePromotionMessageQueryVariables>(SystemwidePromotionMessageDocument, baseOptions);
        }
export type SystemwidePromotionMessageQueryHookResult = ReturnType<typeof useSystemwidePromotionMessageQuery>;
export type SystemwidePromotionMessageLazyQueryHookResult = ReturnType<typeof useSystemwidePromotionMessageLazyQuery>;
export type SystemwidePromotionMessageQueryResult = ApolloReactCommon.QueryResult<ISystemwidePromotionMessageQuery, ISystemwidePromotionMessageQueryVariables>;
export const PosDataDocument = gql`
    query posData($id: ID!) {
  RestaurantPosData(id: $id) {
    _id
    disableChickenSandwich
    plus
    deliveryPLUs
  }
}
    `;

/**
 * __usePosDataQuery__
 *
 * To run a query within a React component, call `usePosDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePosDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IPosDataQuery, IPosDataQueryVariables>) {
        return ApolloReactHooks.useQuery<IPosDataQuery, IPosDataQueryVariables>(PosDataDocument, baseOptions);
      }
export function usePosDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IPosDataQuery, IPosDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IPosDataQuery, IPosDataQueryVariables>(PosDataDocument, baseOptions);
        }
export type PosDataQueryHookResult = ReturnType<typeof usePosDataQuery>;
export type PosDataLazyQueryHookResult = ReturnType<typeof usePosDataLazyQuery>;
export type PosDataQueryResult = ApolloReactCommon.QueryResult<IPosDataQuery, IPosDataQueryVariables>;
export const GetOfferByIdDocument = gql`
    query GetOfferById($id: ID!) {
  Offer(id: $id) {
    ...OffersFragment
  }
}
    ${OffersFragmentFragmentDoc}`;

/**
 * __useGetOfferByIdQuery__
 *
 * To run a query within a React component, call `useGetOfferByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>(GetOfferByIdDocument, baseOptions);
      }
export function useGetOfferByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>(GetOfferByIdDocument, baseOptions);
        }
export type GetOfferByIdQueryHookResult = ReturnType<typeof useGetOfferByIdQuery>;
export type GetOfferByIdLazyQueryHookResult = ReturnType<typeof useGetOfferByIdLazyQuery>;
export type GetOfferByIdQueryResult = ApolloReactCommon.QueryResult<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>;
export const GetPickerDocument = gql`
    query GetPicker($id: ID!) {
  Picker(id: $id) {
    ...PickerFragment
  }
}
    ${PickerFragmentFragmentDoc}`;

/**
 * __useGetPickerQuery__
 *
 * To run a query within a React component, call `useGetPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetPickerQuery, IGetPickerQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetPickerQuery, IGetPickerQueryVariables>(GetPickerDocument, baseOptions);
      }
export function useGetPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetPickerQuery, IGetPickerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetPickerQuery, IGetPickerQueryVariables>(GetPickerDocument, baseOptions);
        }
export type GetPickerQueryHookResult = ReturnType<typeof useGetPickerQuery>;
export type GetPickerLazyQueryHookResult = ReturnType<typeof useGetPickerLazyQuery>;
export type GetPickerQueryResult = ApolloReactCommon.QueryResult<IGetPickerQuery, IGetPickerQueryVariables>;
export const GetPickerWithVendorConfigDocument = gql`
    query GetPickerWithVendorConfig($id: ID!) {
  Picker(id: $id) {
    ...PickerWithVendorConfigFragment
  }
}
    ${PickerWithVendorConfigFragmentFragmentDoc}`;

/**
 * __useGetPickerWithVendorConfigQuery__
 *
 * To run a query within a React component, call `useGetPickerWithVendorConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickerWithVendorConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickerWithVendorConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPickerWithVendorConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetPickerWithVendorConfigQuery, IGetPickerWithVendorConfigQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetPickerWithVendorConfigQuery, IGetPickerWithVendorConfigQueryVariables>(GetPickerWithVendorConfigDocument, baseOptions);
      }
export function useGetPickerWithVendorConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetPickerWithVendorConfigQuery, IGetPickerWithVendorConfigQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetPickerWithVendorConfigQuery, IGetPickerWithVendorConfigQueryVariables>(GetPickerWithVendorConfigDocument, baseOptions);
        }
export type GetPickerWithVendorConfigQueryHookResult = ReturnType<typeof useGetPickerWithVendorConfigQuery>;
export type GetPickerWithVendorConfigLazyQueryHookResult = ReturnType<typeof useGetPickerWithVendorConfigLazyQuery>;
export type GetPickerWithVendorConfigQueryResult = ApolloReactCommon.QueryResult<IGetPickerWithVendorConfigQuery, IGetPickerWithVendorConfigQueryVariables>;
export const GetPickerAvailabilityDocument = gql`
    query GetPickerAvailability($id: ID!) {
  Picker(id: $id) {
    ...PickerAvailabilityFragment
  }
}
    ${PickerAvailabilityFragmentFragmentDoc}`;

/**
 * __useGetPickerAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetPickerAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickerAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickerAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPickerAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetPickerAvailabilityQuery, IGetPickerAvailabilityQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetPickerAvailabilityQuery, IGetPickerAvailabilityQueryVariables>(GetPickerAvailabilityDocument, baseOptions);
      }
export function useGetPickerAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetPickerAvailabilityQuery, IGetPickerAvailabilityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetPickerAvailabilityQuery, IGetPickerAvailabilityQueryVariables>(GetPickerAvailabilityDocument, baseOptions);
        }
export type GetPickerAvailabilityQueryHookResult = ReturnType<typeof useGetPickerAvailabilityQuery>;
export type GetPickerAvailabilityLazyQueryHookResult = ReturnType<typeof useGetPickerAvailabilityLazyQuery>;
export type GetPickerAvailabilityQueryResult = ApolloReactCommon.QueryResult<IGetPickerAvailabilityQuery, IGetPickerAvailabilityQueryVariables>;
export const PlaceholderFieldsDocument = gql`
    query PlaceholderFields {
  allPlaceholderFields {
    _id
    formatter
    path
    fieldId
  }
}
    `;

/**
 * __usePlaceholderFieldsQuery__
 *
 * To run a query within a React component, call `usePlaceholderFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaceholderFieldsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>) {
        return ApolloReactHooks.useQuery<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>(PlaceholderFieldsDocument, baseOptions);
      }
export function usePlaceholderFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>(PlaceholderFieldsDocument, baseOptions);
        }
export type PlaceholderFieldsQueryHookResult = ReturnType<typeof usePlaceholderFieldsQuery>;
export type PlaceholderFieldsLazyQueryHookResult = ReturnType<typeof usePlaceholderFieldsLazyQuery>;
export type PlaceholderFieldsQueryResult = ApolloReactCommon.QueryResult<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>;
export const GetProductCategoryDocument = gql`
    query GetProductCategory($id: ID!) {
  ProductCategory(id: $id) {
    ...ProductCategoryFragment
  }
}
    ${ProductCategoryFragmentFragmentDoc}`;

/**
 * __useGetProductCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>(GetProductCategoryDocument, baseOptions);
      }
export function useGetProductCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>(GetProductCategoryDocument, baseOptions);
        }
export type GetProductCategoryQueryHookResult = ReturnType<typeof useGetProductCategoryQuery>;
export type GetProductCategoryLazyQueryHookResult = ReturnType<typeof useGetProductCategoryLazyQuery>;
export type GetProductCategoryQueryResult = ApolloReactCommon.QueryResult<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>;
export const GetMenuSectionsDocument = gql`
    query GetMenuSections($id: ID!) {
  Menu(id: $id) {
    _id
    _type
    name {
      locale: en
    }
    image {
      ...ImageFragment
    }
    options {
      ...ProductListSectionFragment
      ...PickerFragment
    }
    headerText {
      locale: en
    }
    pickerBackgroundImage {
      asset {
        _id
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}
${ProductListSectionFragmentFragmentDoc}
${PickerFragmentFragmentDoc}`;

/**
 * __useGetMenuSectionsQuery__
 *
 * To run a query within a React component, call `useGetMenuSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuSectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMenuSectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetMenuSectionsQuery, IGetMenuSectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetMenuSectionsQuery, IGetMenuSectionsQueryVariables>(GetMenuSectionsDocument, baseOptions);
      }
export function useGetMenuSectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetMenuSectionsQuery, IGetMenuSectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetMenuSectionsQuery, IGetMenuSectionsQueryVariables>(GetMenuSectionsDocument, baseOptions);
        }
export type GetMenuSectionsQueryHookResult = ReturnType<typeof useGetMenuSectionsQuery>;
export type GetMenuSectionsLazyQueryHookResult = ReturnType<typeof useGetMenuSectionsLazyQuery>;
export type GetMenuSectionsQueryResult = ApolloReactCommon.QueryResult<IGetMenuSectionsQuery, IGetMenuSectionsQueryVariables>;
export const GetMenuPickerByIdDocument = gql`
    query GetMenuPickerById($id: ID!) {
  Picker(id: $id) {
    ...PickerFragment
  }
}
    ${PickerFragmentFragmentDoc}`;

/**
 * __useGetMenuPickerByIdQuery__
 *
 * To run a query within a React component, call `useGetMenuPickerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuPickerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuPickerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMenuPickerByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetMenuPickerByIdQuery, IGetMenuPickerByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetMenuPickerByIdQuery, IGetMenuPickerByIdQueryVariables>(GetMenuPickerByIdDocument, baseOptions);
      }
export function useGetMenuPickerByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetMenuPickerByIdQuery, IGetMenuPickerByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetMenuPickerByIdQuery, IGetMenuPickerByIdQueryVariables>(GetMenuPickerByIdDocument, baseOptions);
        }
export type GetMenuPickerByIdQueryHookResult = ReturnType<typeof useGetMenuPickerByIdQuery>;
export type GetMenuPickerByIdLazyQueryHookResult = ReturnType<typeof useGetMenuPickerByIdLazyQuery>;
export type GetMenuPickerByIdQueryResult = ApolloReactCommon.QueryResult<IGetMenuPickerByIdQuery, IGetMenuPickerByIdQueryVariables>;
export const GetMenuComboByIdDocument = gql`
    query GetMenuComboById($id: ID!) {
  Combo(id: $id) {
    ...ComboFragment
  }
}
    ${ComboFragmentFragmentDoc}`;

/**
 * __useGetMenuComboByIdQuery__
 *
 * To run a query within a React component, call `useGetMenuComboByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuComboByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuComboByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMenuComboByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetMenuComboByIdQuery, IGetMenuComboByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetMenuComboByIdQuery, IGetMenuComboByIdQueryVariables>(GetMenuComboByIdDocument, baseOptions);
      }
export function useGetMenuComboByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetMenuComboByIdQuery, IGetMenuComboByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetMenuComboByIdQuery, IGetMenuComboByIdQueryVariables>(GetMenuComboByIdDocument, baseOptions);
        }
export type GetMenuComboByIdQueryHookResult = ReturnType<typeof useGetMenuComboByIdQuery>;
export type GetMenuComboByIdLazyQueryHookResult = ReturnType<typeof useGetMenuComboByIdLazyQuery>;
export type GetMenuComboByIdQueryResult = ApolloReactCommon.QueryResult<IGetMenuComboByIdQuery, IGetMenuComboByIdQueryVariables>;
export const GetMenuItemByIdDocument = gql`
    query GetMenuItemById($id: ID!) {
  Item(id: $id) {
    ...ItemFragment
  }
}
    ${ItemFragmentFragmentDoc}`;

/**
 * __useGetMenuItemByIdQuery__
 *
 * To run a query within a React component, call `useGetMenuItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMenuItemByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetMenuItemByIdQuery, IGetMenuItemByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetMenuItemByIdQuery, IGetMenuItemByIdQueryVariables>(GetMenuItemByIdDocument, baseOptions);
      }
export function useGetMenuItemByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetMenuItemByIdQuery, IGetMenuItemByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetMenuItemByIdQuery, IGetMenuItemByIdQueryVariables>(GetMenuItemByIdDocument, baseOptions);
        }
export type GetMenuItemByIdQueryHookResult = ReturnType<typeof useGetMenuItemByIdQuery>;
export type GetMenuItemByIdLazyQueryHookResult = ReturnType<typeof useGetMenuItemByIdLazyQuery>;
export type GetMenuItemByIdQueryResult = ApolloReactCommon.QueryResult<IGetMenuItemByIdQuery, IGetMenuItemByIdQueryVariables>;
export const GetRestaurantsDocument = gql`
    query GetRestaurants($filter: RestaurantFilter, $limit: Int) {
  allRestaurants(where: $filter, limit: $limit) {
    ...RestaurantFragment
  }
}
    ${RestaurantFragmentFragmentDoc}`;

/**
 * __useGetRestaurantsQuery__
 *
 * To run a query within a React component, call `useGetRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRestaurantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, baseOptions);
      }
export function useGetRestaurantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, baseOptions);
        }
export type GetRestaurantsQueryHookResult = ReturnType<typeof useGetRestaurantsQuery>;
export type GetRestaurantsLazyQueryHookResult = ReturnType<typeof useGetRestaurantsLazyQuery>;
export type GetRestaurantsQueryResult = ApolloReactCommon.QueryResult<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>;
export const GetRestaurantLoyaltyEnabledDocument = gql`
    query GetRestaurantLoyaltyEnabled($storeId: ID!) {
  Restaurant(id: $storeId) {
    hasLoyalty
  }
}
    `;

/**
 * __useGetRestaurantLoyaltyEnabledQuery__
 *
 * To run a query within a React component, call `useGetRestaurantLoyaltyEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantLoyaltyEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantLoyaltyEnabledQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useGetRestaurantLoyaltyEnabledQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>(GetRestaurantLoyaltyEnabledDocument, baseOptions);
      }
export function useGetRestaurantLoyaltyEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>(GetRestaurantLoyaltyEnabledDocument, baseOptions);
        }
export type GetRestaurantLoyaltyEnabledQueryHookResult = ReturnType<typeof useGetRestaurantLoyaltyEnabledQuery>;
export type GetRestaurantLoyaltyEnabledLazyQueryHookResult = ReturnType<typeof useGetRestaurantLoyaltyEnabledLazyQuery>;
export type GetRestaurantLoyaltyEnabledQueryResult = ApolloReactCommon.QueryResult<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>;
export const GetRestaurantFzDetailsDocument = gql`
    query GetRestaurantFzDetails($storeId: ID!) {
  Restaurant(id: $storeId) {
    physicalAddress {
      address1
      address2
      city
      country
      postalCode
      stateProvince
    }
    fzAddress
    fzZipCode
    fzCity
    fzeeGroup
    fzAuthorizedRepresentative
    fzEmail
    fzTelephone
    fzRegistryCourt
    fzHrb
    fzUstNr
  }
}
    `;

/**
 * __useGetRestaurantFzDetailsQuery__
 *
 * To run a query within a React component, call `useGetRestaurantFzDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantFzDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantFzDetailsQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useGetRestaurantFzDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetRestaurantFzDetailsQuery, IGetRestaurantFzDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetRestaurantFzDetailsQuery, IGetRestaurantFzDetailsQueryVariables>(GetRestaurantFzDetailsDocument, baseOptions);
      }
export function useGetRestaurantFzDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetRestaurantFzDetailsQuery, IGetRestaurantFzDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetRestaurantFzDetailsQuery, IGetRestaurantFzDetailsQueryVariables>(GetRestaurantFzDetailsDocument, baseOptions);
        }
export type GetRestaurantFzDetailsQueryHookResult = ReturnType<typeof useGetRestaurantFzDetailsQuery>;
export type GetRestaurantFzDetailsLazyQueryHookResult = ReturnType<typeof useGetRestaurantFzDetailsLazyQuery>;
export type GetRestaurantFzDetailsQueryResult = ApolloReactCommon.QueryResult<IGetRestaurantFzDetailsQuery, IGetRestaurantFzDetailsQueryVariables>;
export const GetRestaurantVrPaymentMerchantIdDocument = gql`
    query GetRestaurantVrPaymentMerchantId($storeId: ID!) {
  Restaurant(id: $storeId) {
    vrPaymentMerchantId
  }
}
    `;

/**
 * __useGetRestaurantVrPaymentMerchantIdQuery__
 *
 * To run a query within a React component, call `useGetRestaurantVrPaymentMerchantIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantVrPaymentMerchantIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantVrPaymentMerchantIdQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useGetRestaurantVrPaymentMerchantIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetRestaurantVrPaymentMerchantIdQuery, IGetRestaurantVrPaymentMerchantIdQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetRestaurantVrPaymentMerchantIdQuery, IGetRestaurantVrPaymentMerchantIdQueryVariables>(GetRestaurantVrPaymentMerchantIdDocument, baseOptions);
      }
export function useGetRestaurantVrPaymentMerchantIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetRestaurantVrPaymentMerchantIdQuery, IGetRestaurantVrPaymentMerchantIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetRestaurantVrPaymentMerchantIdQuery, IGetRestaurantVrPaymentMerchantIdQueryVariables>(GetRestaurantVrPaymentMerchantIdDocument, baseOptions);
        }
export type GetRestaurantVrPaymentMerchantIdQueryHookResult = ReturnType<typeof useGetRestaurantVrPaymentMerchantIdQuery>;
export type GetRestaurantVrPaymentMerchantIdLazyQueryHookResult = ReturnType<typeof useGetRestaurantVrPaymentMerchantIdLazyQuery>;
export type GetRestaurantVrPaymentMerchantIdQueryResult = ApolloReactCommon.QueryResult<IGetRestaurantVrPaymentMerchantIdQuery, IGetRestaurantVrPaymentMerchantIdQueryVariables>;
export const LoyaltyRewardsByEngineIdDocument = gql`
    query LoyaltyRewardsByEngineId($ids: [String!]!) {
  allRewards(where: {loyaltyEngineId_in: $ids}) {
    ...RewardFragment
  }
}
    ${RewardFragmentFragmentDoc}`;

/**
 * __useLoyaltyRewardsByEngineIdQuery__
 *
 * To run a query within a React component, call `useLoyaltyRewardsByEngineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyRewardsByEngineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyRewardsByEngineIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltyRewardsByEngineIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>(LoyaltyRewardsByEngineIdDocument, baseOptions);
      }
export function useLoyaltyRewardsByEngineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>(LoyaltyRewardsByEngineIdDocument, baseOptions);
        }
export type LoyaltyRewardsByEngineIdQueryHookResult = ReturnType<typeof useLoyaltyRewardsByEngineIdQuery>;
export type LoyaltyRewardsByEngineIdLazyQueryHookResult = ReturnType<typeof useLoyaltyRewardsByEngineIdLazyQuery>;
export type LoyaltyRewardsByEngineIdQueryResult = ApolloReactCommon.QueryResult<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>;
export const LoyaltyRewardsDocument = gql`
    query LoyaltyRewards {
  allRewards {
    ...RewardFragment
  }
}
    ${RewardFragmentFragmentDoc}`;

/**
 * __useLoyaltyRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>(LoyaltyRewardsDocument, baseOptions);
      }
export function useLoyaltyRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>(LoyaltyRewardsDocument, baseOptions);
        }
export type LoyaltyRewardsQueryHookResult = ReturnType<typeof useLoyaltyRewardsQuery>;
export type LoyaltyRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyRewardsLazyQuery>;
export type LoyaltyRewardsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>;
export const LoyaltyFeaturedRewardsDocument = gql`
    query LoyaltyFeaturedRewards {
  allRewardsSections(where: {sanityInternalName: "FeatureRewards"}) {
    ...RewardsSectionFragment
  }
}
    ${RewardsSectionFragmentFragmentDoc}`;

/**
 * __useLoyaltyFeaturedRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyFeaturedRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyFeaturedRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyFeaturedRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyFeaturedRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>(LoyaltyFeaturedRewardsDocument, baseOptions);
      }
export function useLoyaltyFeaturedRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>(LoyaltyFeaturedRewardsDocument, baseOptions);
        }
export type LoyaltyFeaturedRewardsQueryHookResult = ReturnType<typeof useLoyaltyFeaturedRewardsQuery>;
export type LoyaltyFeaturedRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyFeaturedRewardsLazyQuery>;
export type LoyaltyFeaturedRewardsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>;
export const GetAllRollUpTheRimsDocument = gql`
    query GetAllRollUpTheRims {
  allRollUpTheRims(limit: 1) {
    _id
    rutwLogo {
      locale: en {
        ...ImagesFragment
      }
    }
    gamePlayHeader {
      localeRaw: enRaw
    }
    unauthenticatedGamePlayHeader {
      localeRaw: enRaw
    }
    gameHeaderText {
      locale: en
    }
    gamePlayTextBlock {
      localeRaw: enRaw
    }
    unauthenticatedgGamePlayTextBlock {
      localeRaw: enRaw
    }
    gameErrorHeaderText {
      locale: en
    }
    gameErrorBlock {
      localeRaw: enRaw
    }
    gameErrorHeaderText {
      locale: en
    }
    gameRollButtonText {
      locale: en
    }
    gamePlayImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopGamePlayImage {
      locale: en {
        ...ImagesFragment
      }
    }
    gamePlayButtonText {
      localeRaw: enRaw
    }
    gamePlayUnauthButtonText {
      locale: en
    }
    gamePlayUnauthButtonVariant
    rollsRemainingText {
      localeRaw: enRaw
    }
    gameplayRollAudio {
      asset {
        url
      }
    }
    gameplayWinAudio {
      asset {
        url
      }
    }
    timelineHeader {
      localeRaw: enRaw
    }
    timelineTextBlock {
      localeRaw: enRaw
    }
    timelineComponents {
      key
      state
      timelineEventType
      headerColor
      timelineHeader {
        locale: en
      }
      description {
        locale: en
      }
      buttonText {
        locale: en
      }
      image {
        locale: en {
          ...ImagesFragment
        }
      }
    }
    timelinePrizeClaimedText {
      locale: en
    }
    timelineRollSharedText {
      locale: en
    }
    timelineConfetti {
      locale: en {
        ...ImagesFragment
      }
    }
    emptyTimelineTextBlock {
      localeRaw: enRaw
    }
    unauthenticatedEmptyTimelineTextBlock {
      localeRaw: enRaw
    }
    emptyTimelineButtonBlock {
      localeRaw: enRaw
    }
    unauthenticatedEmptyTimelineButtonBlock {
      localeRaw: enRaw
    }
    emptyTimelineImage {
      locale: en {
        ...ImagesFragment
      }
    }
    unauthenticatedEmptyTimelineImage {
      locale: en {
        ...ImagesFragment
      }
    }
    timelineButtonText {
      localeRaw: enRaw
    }
    timelineTextLoadMore {
      locale: en
    }
    shareYourRollsLinkText {
      locale: en
    }
    shareHeader {
      localeRaw: enRaw
    }
    shareTextBlock {
      localeRaw: enRaw
    }
    shareButtonText {
      localeRaw: enRaw
    }
    shareImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopShareImage {
      locale: en {
        ...ImagesFragment
      }
    }
    prizesHeader {
      localeRaw: enRaw
    }
    prizesSeparator {
      localeRaw: enRaw
    }
    prizesTextBlock {
      localeRaw: enRaw
    }
    prizesButtonText {
      localeRaw: enRaw
    }
    prizesImage {
      locale: en {
        ...ImagesFragment
      }
    }
    planeImage {
      locale: en {
        ...ImagesFragment
      }
    }
    sponsorTitle {
      locale: en
    }
    sponsorsImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopPrizesImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopSponsorsImage {
      locale: en {
        ...ImagesFragment
      }
    }
    sharedLandingBadLinkButtonBlock {
      localeRaw: enRaw
    }
    sharedLandingBadLinkHeaderBlock {
      localeRaw: enRaw
    }
    sharedLandingBadLinkTextBlock {
      localeRaw: enRaw
    }
    sharedLandingBadLinkImage {
      locale: en {
        ...ImagesFragment
      }
    }
    shareRollTo {
      locale: en
    }
    shareRollYouHave {
      locale: en
    }
    shareRollShare {
      locale: en
    }
    shareRollIncrementText {
      locale: en
    }
    shareRollReclaimButtonText {
      locale: en
    }
    shareRollsDisclaimer {
      localeRaw: enRaw
    }
    winnersHeader {
      localeRaw: enRaw
    }
    winnersTextBlock {
      localeRaw: enRaw
    }
    winnersButtonText {
      localeRaw: enRaw
    }
    reusablesHeader {
      localeRaw: enRaw
    }
    reusablesTextBlock {
      localeRaw: enRaw
    }
    reusablesButtonText {
      localeRaw: enRaw
    }
    reusablesImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopReusablesImage {
      locale: en {
        ...ImagesFragment
      }
    }
    modalTimelineHeader {
      localeRaw: enRaw
    }
    endText {
      localeRaw: enRaw
    }
    countdownText {
      localeRaw: enRaw
    }
    entriesText {
      localeRaw: enRaw
    }
    nextDrawText {
      localeRaw: enRaw
    }
    firstDrawing
    secondDrawing
    thirdDrawing
    fourthDrawing
    moneyStackImage {
      locale: en {
        ...ImagesFragment
      }
    }
    prizes {
      numberAwarded {
        localeRaw: enRaw
      }
      header {
        localeRaw: enRaw
      }
      text {
        localeRaw: enRaw
      }
      image {
        locale: en {
          ...ImagesFragment
        }
      }
      excludeInAlberta
      buttonText {
        localeRaw: enRaw
      }
    }
    rulesLinkText {
      locale: en
    }
    rulesLinkPath {
      locale: en
    }
    rulesLinkPath {
      locale: en
    }
    footerLinks {
      _key
      footerLinkLocalizedPath {
        locale: en
      }
      footerLinkText {
        locale: en
      }
      footerText {
        locale: en
      }
      footerTitle {
        locale: en
      }
    }
    modalWinnersHeader {
      localeRaw: enRaw
    }
    modalWinnersTextBlock {
      localeRaw: enRaw
    }
    gameHeader {
      localeRaw: enRaw
    }
    gameTextBlock {
      localeRaw: enRaw
    }
    gameNeedHelp {
      locale: en
    }
    cupImage {
      locale: en {
        ...ImagesFragment
      }
    }
    gameBackgroundImage {
      locale: en {
        ...ImagesFragment
      }
    }
    gameButtonText {
      localeRaw: enRaw
    }
    rewardsHeaderText {
      locale: en
    }
    rewardsHeaderSubtitleText {
      locale: en
    }
    rewards {
      key
      rewardName {
        locale: en
      }
      rewardLink {
        locale: en
      }
      rewardCodeDescription {
        localeRaw: enRaw
      }
      image {
        locale: en {
          ...ImagesFragment
        }
      }
      requireSkillsQuestion
      rewardYouWonMessageBlock {
        localeRaw: enRaw
      }
      allSetBlurbBlock {
        localeRaw: enRaw
      }
    }
    allSetHeaderText {
      locale: en
    }
    allSetEmailSentText {
      locale: en
    }
    allSetLegalBlock {
      localeRaw: enRaw
    }
    allSetClaimFailedHeaderText {
      locale: en
    }
    errorTimelineText {
      locale: en
    }
    errorTimelineButtonText {
      locale: en
    }
    errorTimelineImage {
      locale: en {
        ...ImagesFragment
      }
    }
    homepageHeader {
      localeRaw: enRaw
    }
    homepageCupImage {
      locale: en {
        ...ImagesFragment
      }
    }
    homepageBackgroundImage {
      locale: en {
        ...ImagesFragment
      }
    }
    enterButtonText {
      localeRaw: enRaw
    }
    rulesText {
      localeRaw: enRaw
    }
    rrrollButtonText {
      localeRaw: enRaw
    }
    shareRollHeader {
      localeRaw: enRaw
    }
    shareRollTextBlock {
      localeRaw: enRaw
    }
    shareRollURL {
      locale: en
    }
    shareRollLinkTitle {
      locale: en
    }
    shareRollReclaimQuestionText {
      locale: en
    }
    shareRollReclaimDescriptionText {
      locale: en
    }
    shareRollsImage {
      locale: en {
        ...ImagesFragment
      }
    }
    shareRollsBackgroundImage {
      locale: en {
        ...ImagesFragment
      }
    }
    howManyTextBlock {
      localeRaw: enRaw
    }
    shareRolluttonText {
      localeRaw: enRaw
    }
    rollupAnimationFrames {
      locale: en {
        ...ImagesFragment
      }
    }
    skillsQuestionHeaderText {
      locale: en
    }
    skillsQuestionsGroup {
      ...SkillsTestFragment
    }
    localeSwitchModalHeaderText {
      locale: en
    }
    localeSwitchModalPrimaryText {
      locale: en
    }
    localeSwitchModalSecondaryText {
      locale: en
    }
    localeSwitchModalDisclaimerText {
      locale: en
    }
    lockoutScreenTextBlock {
      localeRaw: enRaw
    }
    lockoutScreenImage {
      locale: en {
        ...ImagesFragment
      }
    }
    lockoutScreenButtonText {
      locale: en
    }
  }
}
    ${ImagesFragmentFragmentDoc}
${SkillsTestFragmentFragmentDoc}`;

/**
 * __useGetAllRollUpTheRimsQuery__
 *
 * To run a query within a React component, call `useGetAllRollUpTheRimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRollUpTheRimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRollUpTheRimsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRollUpTheRimsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>(GetAllRollUpTheRimsDocument, baseOptions);
      }
export function useGetAllRollUpTheRimsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>(GetAllRollUpTheRimsDocument, baseOptions);
        }
export type GetAllRollUpTheRimsQueryHookResult = ReturnType<typeof useGetAllRollUpTheRimsQuery>;
export type GetAllRollUpTheRimsLazyQueryHookResult = ReturnType<typeof useGetAllRollUpTheRimsLazyQuery>;
export type GetAllRollUpTheRimsQueryResult = ApolloReactCommon.QueryResult<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>;
export const GetSectionDocument = gql`
    query GetSection($id: ID!) {
  Section(id: $id) {
    ...SectionFragment
  }
}
    ${SectionFragmentFragmentDoc}`;

/**
 * __useGetSectionQuery__
 *
 * To run a query within a React component, call `useGetSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSectionQuery, IGetSectionQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSectionQuery, IGetSectionQueryVariables>(GetSectionDocument, baseOptions);
      }
export function useGetSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSectionQuery, IGetSectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSectionQuery, IGetSectionQueryVariables>(GetSectionDocument, baseOptions);
        }
export type GetSectionQueryHookResult = ReturnType<typeof useGetSectionQuery>;
export type GetSectionLazyQueryHookResult = ReturnType<typeof useGetSectionLazyQuery>;
export type GetSectionQueryResult = ApolloReactCommon.QueryResult<IGetSectionQuery, IGetSectionQueryVariables>;
export const GetSectionAvailabilityDocument = gql`
    query GetSectionAvailability($id: ID!) {
  Section(id: $id) {
    ...SectionAvailabilityFragment
  }
}
    ${SectionAvailabilityFragmentFragmentDoc}`;

/**
 * __useGetSectionAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetSectionAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSectionAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSectionAvailabilityQuery, IGetSectionAvailabilityQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSectionAvailabilityQuery, IGetSectionAvailabilityQueryVariables>(GetSectionAvailabilityDocument, baseOptions);
      }
export function useGetSectionAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSectionAvailabilityQuery, IGetSectionAvailabilityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSectionAvailabilityQuery, IGetSectionAvailabilityQueryVariables>(GetSectionAvailabilityDocument, baseOptions);
        }
export type GetSectionAvailabilityQueryHookResult = ReturnType<typeof useGetSectionAvailabilityQuery>;
export type GetSectionAvailabilityLazyQueryHookResult = ReturnType<typeof useGetSectionAvailabilityLazyQuery>;
export type GetSectionAvailabilityQueryResult = ApolloReactCommon.QueryResult<IGetSectionAvailabilityQuery, IGetSectionAvailabilityQueryVariables>;
export const SingleAppDataDocument = gql`
    query singleAppData {
  allAppData(limit: 1) {
    _id
  }
}
    `;

/**
 * __useSingleAppDataQuery__
 *
 * To run a query within a React component, call `useSingleAppDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAppDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAppDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSingleAppDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISingleAppDataQuery, ISingleAppDataQueryVariables>) {
        return ApolloReactHooks.useQuery<ISingleAppDataQuery, ISingleAppDataQueryVariables>(SingleAppDataDocument, baseOptions);
      }
export function useSingleAppDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISingleAppDataQuery, ISingleAppDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISingleAppDataQuery, ISingleAppDataQueryVariables>(SingleAppDataDocument, baseOptions);
        }
export type SingleAppDataQueryHookResult = ReturnType<typeof useSingleAppDataQuery>;
export type SingleAppDataLazyQueryHookResult = ReturnType<typeof useSingleAppDataLazyQuery>;
export type SingleAppDataQueryResult = ApolloReactCommon.QueryResult<ISingleAppDataQuery, ISingleAppDataQueryVariables>;
export const GetSupportDataDocument = gql`
    query GetSupportData($supportDataId: ID!) {
  SupportData(id: $supportDataId) {
    _id
    supportCategoryGroups {
      _id
      name {
        locale: en
      }
      supportSubcategories {
        _id
        name {
          locale: en
        }
        knowledgeForceIssueId
        supportSubcategoryForwardToOrders
        supportSubcategoryServiceModeSelector
        supportSubcategoryFaqs {
          supportFaqTitle {
            locale: en
          }
          supportFaqContent {
            localeRaw: enRaw
          }
          supportFaqMParticleEvent
        }
      }
    }
    deliveryNeverArriveSubcategory {
      _id
      name {
        locale: en
      }
      knowledgeForceIssueId
    }
    deliveryMissingItemsSubcategory {
      _id
      name {
        locale: en
      }
      knowledgeForceIssueId
    }
    orderingIssuesCategoryGroup {
      _id
    }
    supportDataFaqs {
      supportFaqTitle {
        locale: en
      }
      supportFaqContent {
        localeRaw: enRaw
      }
      supportFaqMParticleEvent
    }
  }
}
    `;

/**
 * __useGetSupportDataQuery__
 *
 * To run a query within a React component, call `useGetSupportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportDataQuery({
 *   variables: {
 *      supportDataId: // value for 'supportDataId'
 *   },
 * });
 */
export function useGetSupportDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSupportDataQuery, IGetSupportDataQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSupportDataQuery, IGetSupportDataQueryVariables>(GetSupportDataDocument, baseOptions);
      }
export function useGetSupportDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportDataQuery, IGetSupportDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSupportDataQuery, IGetSupportDataQueryVariables>(GetSupportDataDocument, baseOptions);
        }
export type GetSupportDataQueryHookResult = ReturnType<typeof useGetSupportDataQuery>;
export type GetSupportDataLazyQueryHookResult = ReturnType<typeof useGetSupportDataLazyQuery>;
export type GetSupportDataQueryResult = ApolloReactCommon.QueryResult<IGetSupportDataQuery, IGetSupportDataQueryVariables>;
export const GetSupportSubcategoryDocument = gql`
    query GetSupportSubcategory($id: ID!) {
  SupportSubcategory(id: $id) {
    _id
    _type
    _createdAt
    _key
    _rev
    _updatedAt
    name {
      locale: en
    }
    knowledgeForceIssueId
    supportSubcategoryFaqs {
      supportFaqTitle {
        locale: en
      }
      supportFaqContent {
        localeRaw: enRaw
      }
      supportFaqMParticleEvent
    }
    directTicketProcessingPercentage
    supportSubcategoryFaq {
      supportFaqTitle {
        locale: en
      }
      supportFaqContent {
        localeRaw: enRaw
      }
      supportFaqMParticleEvent
    }
    supportSubcategoryForwardToOrders
    supportSubcategoryServiceModeSelector
    supportSubcategorySubmitToSutherland
  }
}
    `;

/**
 * __useGetSupportSubcategoryQuery__
 *
 * To run a query within a React component, call `useGetSupportSubcategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportSubcategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportSubcategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupportSubcategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>(GetSupportSubcategoryDocument, baseOptions);
      }
export function useGetSupportSubcategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>(GetSupportSubcategoryDocument, baseOptions);
        }
export type GetSupportSubcategoryQueryHookResult = ReturnType<typeof useGetSupportSubcategoryQuery>;
export type GetSupportSubcategoryLazyQueryHookResult = ReturnType<typeof useGetSupportSubcategoryLazyQuery>;
export type GetSupportSubcategoryQueryResult = ApolloReactCommon.QueryResult<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>;
export const GetSupportCategoryGroupDocument = gql`
    query GetSupportCategoryGroup($id: ID!) {
  SupportCategoryGroup(id: $id) {
    _id
    name {
      locale: en
    }
    showRestaurantSelector
    supportSubcategories {
      _id
      name {
        locale: en
      }
      knowledgeForceIssueId
      supportSubcategoryForwardToOrders
      supportSubcategoryServiceModeSelector
      supportSubcategoryFaqs {
        supportFaqTitle {
          locale: en
        }
        supportFaqContent {
          localeRaw: enRaw
        }
        supportFaqMParticleEvent
      }
    }
  }
}
    `;

/**
 * __useGetSupportCategoryGroupQuery__
 *
 * To run a query within a React component, call `useGetSupportCategoryGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportCategoryGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportCategoryGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupportCategoryGroupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>(GetSupportCategoryGroupDocument, baseOptions);
      }
export function useGetSupportCategoryGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>(GetSupportCategoryGroupDocument, baseOptions);
        }
export type GetSupportCategoryGroupQueryHookResult = ReturnType<typeof useGetSupportCategoryGroupQuery>;
export type GetSupportCategoryGroupLazyQueryHookResult = ReturnType<typeof useGetSupportCategoryGroupLazyQuery>;
export type GetSupportCategoryGroupQueryResult = ApolloReactCommon.QueryResult<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>;
import { disableFragmentWarnings } from 'graphql-tag';
disableFragmentWarnings();
